webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({});

// const messageBus = new Vue({
//     methods: {
//         showNotification: function(notificationVisible) {
//             if(notificationVisible) {
//                 this.logConsole("Nofication marked as visible");
//             } else {
//                 this.logConsole("Nofication marked as hidden");
//             }
//         }
//     },
//     created: function () {
//         this.logConsole("Message bus created");
//     }
// })

// Vue.use(messageBus);

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(816)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(768),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\misc\\Loader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Loader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-054a269e", Component.options)
  } else {
    hotAPI.reload("data-v-054a269e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["o"] = hasPermissionChangeAuthority;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOrganizationId;
/* unused harmony export getClaims */
/* unused harmony export getUserClaims */
/* harmony export (immutable) */ __webpack_exports__["B"] = isUserActive;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAuth;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasAdminClaim;
/* harmony export (immutable) */ __webpack_exports__["u"] = hasUserCreateClaim;
/* harmony export (immutable) */ __webpack_exports__["n"] = hasUserResetPasswordClaim;
/* harmony export (immutable) */ __webpack_exports__["v"] = hasLocalUserCreateClaim;
/* harmony export (immutable) */ __webpack_exports__["y"] = hasInvoiceCreateClaim;
/* harmony export (immutable) */ __webpack_exports__["z"] = hasInvoiceReviewClaim;
/* harmony export (immutable) */ __webpack_exports__["p"] = hasInvoiceCancelClaim;
/* harmony export (immutable) */ __webpack_exports__["h"] = hasInvoiceExportClaim;
/* harmony export (immutable) */ __webpack_exports__["w"] = hasNotificationCreateClaim;
/* harmony export (immutable) */ __webpack_exports__["q"] = hasInvoiceAssignClaim;
/* harmony export (immutable) */ __webpack_exports__["l"] = hasRegistrationEditClaim;
/* harmony export (immutable) */ __webpack_exports__["g"] = hasInvoiceReviewAllClaim;
/* unused harmony export hasInvoiceCancelAllClaim */
/* harmony export (immutable) */ __webpack_exports__["r"] = hasInvoiceActivateClaim;
/* harmony export (immutable) */ __webpack_exports__["s"] = hasInvoiceActivateOnceClaim;
/* harmony export (immutable) */ __webpack_exports__["j"] = hasIssueResolveClaim;
/* harmony export (immutable) */ __webpack_exports__["A"] = hasGroupSettlementCreateClaim;
/* harmony export (immutable) */ __webpack_exports__["t"] = hasInvoiceUserSettlementClaim;
/* harmony export (immutable) */ __webpack_exports__["x"] = hasRegistrationReviewAllClaim;
/* harmony export (immutable) */ __webpack_exports__["m"] = getPermissionClaims;
/* harmony export (immutable) */ __webpack_exports__["a"] = accessTokenValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = refreshTokenValid;
/* harmony export (immutable) */ __webpack_exports__["e"] = setCredentials;
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* harmony export (immutable) */ __webpack_exports__["f"] = refreshToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cookie__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(19);





// import Sha256 from 'crypto-js/hmac-sha256'

// Claims
var CLAIMS = ['Claim_User_Create', // 0
'Claim_User_Review', // 1
'Claim_User_Revoke', // 2
'Claim_Local_User_Create', // 3
'Claim_Local_User_Review', // 4
'Claim_Local_User_Revoke', // 5
'Claim_Invoice_Create', // 6
'Claim_Invoice_Cancel', // 7
'Claim_Invoice_Review', // 8
'Claim_Invoice_Settle', // 9
'Claim_Invoice_Export', // 10
'Claim_Notification_Create', // 11
'Claim_Invoice_Assign', // 12
'Claim_Registration_Edit', // 13
'Claim_Invoice_Review_All', // 14
'Claim_Invoice_Cancel_All', // 15
'Claim_Invoice_Activate', // 16
'Claim_Invoice_Activate_Once', // 17
'Claim_Issue_Resolve', // 18
'Claim_Group_Settlement_Create', // 19
'Claim_Invoice_User_Settle', // 20
'Claim_Registration_Review_All' // 21
];

var ADMIN_CLAIM = 'Claim_Admin';

// Public methods

function hasPermissionChangeAuthority(claims) {
  // Allow always for admin
  if (hasAdminClaim()) {
    return true;
  }

  // Allow operators to change all users - except admins
  if (hasUserCreateClaim()) {
    if (claims.constructor === Array) {
      if (claims.indexOf(ADMIN_CLAIM) >= 0) {
        return false;
      }
    } else if (claims.localeCompare(ADMIN_CLAIM) === 0) {
      return false;
    }

    return true;
  }

  // Allow local admin to change users - except admins and operators
  if (hasLocalUserCreateClaim()) {
    if (claims.constructor === Array) {
      if (claims.indexOf(ADMIN_CLAIM) >= 0 || claims.indexOf(CLAIMS[0]) >= 0) {
        return false;
      }
    } else if (claims.localeCompare(ADMIN_CLAIM) === 0 || claims.localeCompare(CLAIMS[0]) === 0) {
      return false;
    }

    return true;
  }

  return false;
}

function getOrganizationId() {
  return getTokenOrganizationId();
}

function getClaims() {
  return CLAIMS;
}

function getUserClaims() {
  return getTokenClaims();
}

function isUserActive() {
  return isAuth() && accessTokenValid();
}

// TODO Check this if it's valid
function isAuth() {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["d" /* getUser */])();
}

function hasAdminClaim() {
  return hasClaim(ADMIN_CLAIM);
}

function hasUserCreateClaim() {
  return hasClaim(CLAIMS[0]);
}

function hasUserResetPasswordClaim() {
  return hasClaim(CLAIMS[1]);
}

function hasLocalUserCreateClaim() {
  return hasClaim(CLAIMS[3]);
}

function hasInvoiceCreateClaim() {
  return hasClaim(CLAIMS[6]);
}

function hasInvoiceReviewClaim() {
  return hasClaim(CLAIMS[8]);
}

function hasInvoiceCancelClaim() {
  return hasClaim(CLAIMS[7]);
}

function hasInvoiceExportClaim() {
  return hasClaim(CLAIMS[10]);
}

function hasNotificationCreateClaim() {
  return hasClaim(CLAIMS[11]);
}

function hasInvoiceAssignClaim() {
  return hasClaim(CLAIMS[12]);
}

function hasRegistrationEditClaim() {
  return hasClaim(CLAIMS[13]);
}

function hasInvoiceReviewAllClaim() {
  return hasClaim(CLAIMS[14]);
}

function hasInvoiceCancelAllClaim() {
  return hasClaim(CLAIMS[15]);
}

function hasInvoiceActivateClaim() {
  return hasClaim(CLAIMS[16]);
}

function hasInvoiceActivateOnceClaim() {
  return hasClaim(CLAIMS[17]);
}

function hasIssueResolveClaim() {
  return hasClaim(CLAIMS[18]);
}

function hasGroupSettlementCreateClaim() {
  return hasClaim(CLAIMS[19]);
}

function hasInvoiceUserSettlementClaim() {
  return hasClaim(CLAIMS[20]);
}

function hasRegistrationReviewAllClaim() {
  return hasClaim(CLAIMS[21]);
}

function getPermissionClaims() {
  return getTokenClaims();
}

function accessTokenValid() {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["a" /* getAccessToken */])();
  return token && !isTokenExpired(token);
}

function refreshTokenValid() {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["b" /* getRefreshToken */])();
  return token && !isTokenExpired(token);
}

function setCredentials(user, accessToken, refreshToken) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["g" /* setUser */])(user);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["c" /* setAccessToken */])(accessToken);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["h" /* setRefreshToken */])(refreshToken);

  // let authorizationKey = Sha256(user, Vue.$config.secret_key)
  // Vue.http.headers.common['From'] = authorizationKey.toString()
  // console.log(Vue.http.headers)
}

function logout() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["i" /* clearCredentials */])();
  // Vue.http.headers.common['From'] = ''
}

function refreshToken(to, from, next) {
  var refreshTokenUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.loginRefresh;
  var isProductionEnvironment = "Ptest".toUpperCase() === 'production'.toUpperCase();

  if (!isProductionEnvironment) {
    console.log('Access token expired - sending refresh access token request from router');
  }

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["b" /* getRefreshToken */])();

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(refreshTokenUrl).then(function (response) {
    if (!isProductionEnvironment) {
      console.log('Access token obtained successfully - redirecting to ' + to.path);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["c" /* setAccessToken */])(response.data.payload.accessToken);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["a" /* getAccessToken */])();
    next({
      path: to.path
    });
  }, function (error) {
    if (!isProductionEnvironment) {
      console.log(error);
    }

    if (error.status === 0) {
      __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
        variant: 'danger',
        message: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('apiStatusCodes.0'),
        errors: []
      });
    }

    next({
      path: '/'
    });
  });
}

// Private methods

function hasClaim(claim) {
  var claims = getTokenClaims();
  if (claims.constructor === Array) {
    return claims.indexOf(claim) >= 0 || claims.indexOf(ADMIN_CLAIM) >= 0;
  }

  return claims.localeCompare(claim) === 0 || claims.localeCompare(ADMIN_CLAIM) === 0;
}

function getTokenClaims() {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["a" /* getAccessToken */])();
  var decodedToken = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(token);

  return decodedToken.cir_claims;
}

function getTokenOrganizationId() {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["a" /* getAccessToken */])();
  var decodedToken = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(token);

  return decodedToken.groupsid;
}

function getTokenExpirationDate(encodedToken) {
  var token = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(encodedToken);
  if (!token.exp) {
    return null;
  }

  var date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sr__ = __webpack_require__(366);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

// Ready translated locale messages
var messages = {
  en: __WEBPACK_IMPORTED_MODULE_2__en__["a" /* default */],
  sr: __WEBPACK_IMPORTED_MODULE_3__sr__["a" /* default */]
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'sr', // set locale
  messages: messages // set locale messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(828)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(781),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\misc\\context-header\\ContextHeader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ContextHeader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-495033fa", Component.options)
  } else {
    hotAPI.reload("data-v-495033fa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRefreshToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAccessToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = setUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = setAccessToken;
/* harmony export (immutable) */ __webpack_exports__["h"] = setRefreshToken;
/* harmony export (immutable) */ __webpack_exports__["i"] = clearCredentials;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDatatableInfo;
/* harmony export (immutable) */ __webpack_exports__["k"] = setDatatableInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = getNotificationInfo;
/* harmony export (immutable) */ __webpack_exports__["e"] = setNotificationInfo;
/* harmony export (immutable) */ __webpack_exports__["o"] = getTabsInfo;
/* harmony export (immutable) */ __webpack_exports__["n"] = setTabsInfo;
/* harmony export (immutable) */ __webpack_exports__["l"] = getSidebarToggleInfo;
/* harmony export (immutable) */ __webpack_exports__["m"] = setSidebarToggleInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

// Cookie keys

var USER_KEY = '_user';
var ACCESS_TOKEN_KEY = '_accessToken';
var REFRESH_TOKEN_KEY = '_refreshToken';
var DATATABLE_INFOS_KEY = '_datatableInfos';
var NOTIFICATION_INFOS_KEY = '_notificationInfos';
var TAB_INFOS_KEY = '_tabInfos';
var TOGGLE_SIDEBAR_KEY = '_toggleSidebar';

// Authentication

function getUser() {
  return __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get(USER_KEY);
}

function getRefreshToken() {
  return __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get(REFRESH_TOKEN_KEY);
}

function getAccessToken() {
  return __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get(ACCESS_TOKEN_KEY);
}

function setUser(user) {
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set(USER_KEY, user);
}

function setAccessToken(token) {
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set(ACCESS_TOKEN_KEY, token);
}

function setRefreshToken(token) {
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set(REFRESH_TOKEN_KEY, token);
}

function clearCredentials() {
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete(USER_KEY);
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete(ACCESS_TOKEN_KEY);
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete(REFRESH_TOKEN_KEY);
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete(DATATABLE_INFOS_KEY);
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete(TAB_INFOS_KEY);
}

// Dictionary Common

function getDictionary(cookieKey) {
  var dictStr = __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get(cookieKey);

  if (dictStr == null) {
    dictStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({});
    __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set(cookieKey, dictStr);
  }

  var dict = JSON.parse(dictStr);
  return dict;
}

function getDictionaryValue(cookieKey, dictKey) {
  var dict = getDictionary(cookieKey);
  return dictKey in dict ? dict[dictKey] : null;
}

function setDictionaryValue(cookieKey, dictKey, dictValue) {
  var dict = getDictionary(cookieKey);
  dict[dictKey] = dictValue;
  var dictStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dict);
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set(cookieKey, dictStr);
}

// Datatables

function getDatatableInfo(key) {
  return getDictionaryValue(DATATABLE_INFOS_KEY, key);
}

function setDatatableInfo(key, info) {
  setDictionaryValue(DATATABLE_INFOS_KEY, key, info);
}

// Notifications

function getNotificationInfo(key) {
  return getDictionaryValue(NOTIFICATION_INFOS_KEY, key);
}

function setNotificationInfo(key, info) {
  setDictionaryValue(NOTIFICATION_INFOS_KEY, key, info);
}

// Tabs

function getTabsInfo(key) {
  return getDictionaryValue(TAB_INFOS_KEY, key);
}

function setTabsInfo(key, info) {
  setDictionaryValue(TAB_INFOS_KEY, key, info);
}

// Sidebar collapse toggle

function getSidebarToggleInfo(key) {
  return getDictionaryValue(TOGGLE_SIDEBAR_KEY, key);
}

function setSidebarToggleInfo(key, info) {
  setDictionaryValue(TOGGLE_SIDEBAR_KEY, key, info);
}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(847)
  __webpack_require__(846)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(802),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a5b31004",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\misc\\datatable\\Datatable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Datatable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a5b31004", Component.options)
  } else {
    hotAPI.reload("data-v-a5b31004", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validationMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validation__ = __webpack_require__(374);



var validationMixin = {
  methods: {
    getValidationErrors: function getValidationErrors(model) {
      var _this = this;

      var alertErrors = [];
      var lang = this.$i18n.locale;

      if (this.$v[model] === undefined) {
        console.error('CIR: Model is undefined. Check if you define it right as getValidationErrors(???) parameter.');
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$v[model].$params).map(function (fieldName) {
        // Go through old params
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.$v[model][fieldName].$params).map(function (rule) {
          if (!_this.$v[model][fieldName][rule]) {
            // WIP
            var ruleParams = _this.$v[model][fieldName].$params[rule];
            delete ruleParams.type;
            //

            var message = '';
            // If custom message exist
            if (__WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].custom[model] && __WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].custom[model][fieldName]) {
              if (__WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].custom[model][fieldName][rule]) {
                message = __WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].custom[model][fieldName][rule];
              }
              // Else get a global message
            } else if (__WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].global[rule]) {
              // TODO Replace min and max
              var replace = __WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].attributes[model + '.' + fieldName] || fieldName;
              message = __WEBPACK_IMPORTED_MODULE_1__utils_validation__["a" /* default */][lang].global[rule].replace('{field}', replace);
            } else {
              console.error('CIR: Validation message for "' + rule + '" rule does not exist.');
            }

            alertErrors.push({
              type: rule,
              msg: message
            });
          }
        });
      });
      return alertErrors;
    }
  }
};



/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grb.731a29f.svg";

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties__);



/*!
 * vuejs-datepicker v1.5.4
 * (c) 2016-2019 Charlie Kassel
 * Released under the MIT License.
 */
var Language = function Language(language, months, monthsAbbr, days) {
  this.language = language;
  this.months = months;
  this.monthsAbbr = monthsAbbr;
  this.days = days;
  this.rtl = false;
  this.ymd = false;
  this.yearSuffix = '';
};

var prototypeAccessors = { language: { configurable: true }, months: { configurable: true }, monthsAbbr: { configurable: true }, days: { configurable: true } };

prototypeAccessors.language.get = function () {
  return this._language;
};

prototypeAccessors.language.set = function (language) {
  if (typeof language !== 'string') {
    throw new TypeError('Language must be a string');
  }
  this._language = language;
};

prototypeAccessors.months.get = function () {
  return this._months;
};

prototypeAccessors.months.set = function (months) {
  if (months.length !== 12) {
    throw new RangeError("There must be 12 months for " + this.language + " language");
  }
  this._months = months;
};

prototypeAccessors.monthsAbbr.get = function () {
  return this._monthsAbbr;
};

prototypeAccessors.monthsAbbr.set = function (monthsAbbr) {
  if (monthsAbbr.length !== 12) {
    throw new RangeError("There must be 12 abbreviated months for " + this.language + " language");
  }
  this._monthsAbbr = monthsAbbr;
};

prototypeAccessors.days.get = function () {
  return this._days;
};

prototypeAccessors.days.set = function (days) {
  if (days.length !== 7) {
    throw new RangeError("There must be 7 days for " + this.language + " language");
  }
  this._days = days;
};

__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties___default()(Language.prototype, prototypeAccessors);

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'])
// eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,
  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }
    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }
    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(date)) !== 'object') {
      throw TypeError('Invalid Type');
    }
    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }
    if ((typeof month === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(month)) === 'object') {
      return months[this.getMonth(month)];
    }
    if (typeof month === 'number') {
      return months[month];
    }
    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }
    if ((typeof month === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(month)) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }
    if (typeof month === 'number') {
      return monthsAbbr[month];
    }
    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return (/8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31
    );
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';
      case 2:
      case 22:
        return 'nd';
      case 3:
      case 23:
        return 'rd';
      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var this$1 = this;

    var dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start = this$1.setDate(new Date(start), this$1.getDate(new Date(start)) + 1);
    }
    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};

var makeDateUtils = function makeDateUtils(useUtc) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, utils, { useUtc: useUtc });
};

var utils$1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, utils)
// eslint-disable-next-line
;

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = "";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();
var DateInput = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: { 'input-group': _vm.bootstrapStyling } }, [_vm.calendarButton ? _c('span', { staticClass: "vdp-datepicker__calendar-button", class: { 'input-group-prepend': _vm.bootstrapStyling }, style: { 'cursor:not-allowed;': _vm.disabled }, on: { "click": _vm.showCalendar } }, [_c('span', { class: { 'input-group-text': _vm.bootstrapStyling } }, [_c('i', { class: _vm.calendarButtonIcon }, [_vm._v(" " + _vm._s(_vm.calendarButtonIconContent) + " "), !_vm.calendarButtonIcon ? _c('span', [_vm._v("…")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('input', { ref: _vm.refName, class: _vm.computedInputClass, attrs: { "type": _vm.inline ? 'hidden' : 'text', "name": _vm.name, "id": _vm.id, "open-date": _vm.openDate, "placeholder": _vm.placeholder, "clear-button": _vm.clearButton, "disabled": _vm.disabled, "required": _vm.required, "readonly": !_vm.typeable, "autocomplete": "off" }, domProps: { "value": _vm.formattedValue }, on: { "click": _vm.showCalendar, "keyup": _vm.parseTypedDate, "blur": _vm.inputBlurred } }), _vm._v(" "), _vm.clearButton && _vm.selectedDate ? _c('span', { staticClass: "vdp-datepicker__clear-button", class: { 'input-group-append': _vm.bootstrapStyling }, on: { "click": function click($event) {
          _vm.clearDate();
        } } }, [_c('span', { class: { 'input-group-text': _vm.bootstrapStyling } }, [_c('i', { class: _vm.clearButtonIcon }, [!_vm.clearButtonIcon ? _c('span', [_vm._v("×")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _vm._t("afterDateInput")], 2);
  }, staticRenderFns: [],
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    inputFormat: {
      type: Function,
      default: Date.parse
    },
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }
      if (this.typedDate) {
        return this.typedDate;
      }
      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },

    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { 'form-control': true }, this.inputClass);
      }
      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = this.inputFormat(this.input.value);
        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(this.inputFormat(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },
    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
  // eslint-disable-next-line
};

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = "";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();
var PickerDay = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.showDayView, expression: "showDayView" }], class: [_vm.calendarClass, 'vdp-datepicker__calendar'], style: _vm.calendarStyle, on: { "mousedown": function mousedown($event) {
          $event.preventDefault();
        } } }, [_vm._t("beforeCalendarHeader"), _vm._v(" "), _c('header', [_c('span', { staticClass: "prev", class: { 'disabled': _vm.isLeftNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
        } } }, [_vm._v("<")]), _vm._v(" "), _c('span', { staticClass: "day__month_btn", class: _vm.allowedToShowView('month') ? 'up' : '', on: { "click": _vm.showMonthCalendar } }, [_vm._v(_vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) + " " + _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName))]), _vm._v(" "), _c('span', { staticClass: "next", class: { 'disabled': _vm.isRightNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
        } } }, [_vm._v(">")])]), _vm._v(" "), _c('div', { class: _vm.isRtl ? 'flex-rtl' : '' }, [_vm._l(_vm.daysOfWeek, function (d) {
      return _c('span', { key: d.timestamp, staticClass: "cell day-header" }, [_vm._v(_vm._s(d))]);
    }), _vm._v(" "), _vm.blankDays > 0 ? _vm._l(_vm.blankDays, function (d) {
      return _c('span', { key: d.timestamp, staticClass: "cell day blank" });
    }) : _vm._e(), _vm._l(_vm.days, function (day) {
      return _c('span', { key: day.timestamp, staticClass: "cell day", class: _vm.dayClasses(day), domProps: { "innerHTML": _vm._s(_vm.dayCellContent(day)) }, on: { "click": function click($event) {
            _vm.selectDate(day);
          } } });
    })], 2)], 2);
  }, staticRenderFns: [],
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      default: function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }
      return this.translation.days;
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }
      return this.utils.getDay(dObj);
    },
    /**
     * @return {Object[]}
     */
    days: function days() {
      var this$1 = this;

      var d = this.pageDate;
      var days = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this$1.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedDate(dObj),
          isDisabled: this$1.isDisabledDate(dObj),
          isHighlighted: this$1.isHighlightedDate(dObj),
          isHighlightStart: this$1.isHighlightStart(dObj),
          isHighlightEnd: this$1.isHighlightEnd(dObj),
          isToday: this$1.utils.compareDates(dObj, new Date()),
          isWeekend: this$1.utils.getDay(dObj) === 0 || this$1.utils.getDay(dObj) === 6,
          isSaturday: this$1.utils.getDay(dObj) === 6,
          isSunday: this$1.utils.getDay(dObj) === 0
        });
        this$1.utils.setDate(dObj, this$1.utils.getDate(dObj) + 1);
      }
      return days;
    },
    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },
    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "" + this.utils.getFullYear(this.pageDate) + yearSuffix;
    },
    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }
      this.$emit('selectDate', date);
    },
    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },
    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },
    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },
    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },
    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },
    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },
    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },
    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },
    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var this$1 = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }
      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }
      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates;
    },
    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var this$1 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },
    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  }
  // eslint-disable-next-line
};

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = "";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();
var PickerMonth = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.showMonthView, expression: "showMonthView" }], class: [_vm.calendarClass, 'vdp-datepicker__calendar'], style: _vm.calendarStyle, on: { "mousedown": function mousedown($event) {
          $event.preventDefault();
        } } }, [_vm._t("beforeCalendarHeader"), _vm._v(" "), _c('header', [_c('span', { staticClass: "prev", class: { 'disabled': _vm.isLeftNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
        } } }, [_vm._v("<")]), _vm._v(" "), _c('span', { staticClass: "month__year_btn", class: _vm.allowedToShowView('year') ? 'up' : '', on: { "click": _vm.showYearCalendar } }, [_vm._v(_vm._s(_vm.pageYearName))]), _vm._v(" "), _c('span', { staticClass: "next", class: { 'disabled': _vm.isRightNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
        } } }, [_vm._v(">")])]), _vm._v(" "), _vm._l(_vm.months, function (month) {
      return _c('span', { key: month.timestamp, staticClass: "cell month", class: { 'selected': month.isSelected, 'disabled': month.isDisabled }, on: { "click": function click($event) {
            $event.stopPropagation();_vm.selectMonth(month);
          } } }, [_vm._v(_vm._s(month.month))]);
    })], 2);
  }, staticRenderFns: [],
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var this$1 = this;

      var d = this.pageDate;
      var months = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: this$1.utils.getMonthName(i, this$1.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedMonth(dObj),
          isDisabled: this$1.isDisabledMonth(dObj)
        });
        this$1.utils.setMonth(dObj, this$1.utils.getMonth(dObj) + 1);
      }
      return months;
    },
    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "" + this.utils.getFullYear(this.pageDate) + yearSuffix;
    },
    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }
      this.$emit('selectMonth', month);
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },
    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }
      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },
    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }
      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates;
    }
  }
  // eslint-disable-next-line
};

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = "";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();
var PickerYear = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.showYearView, expression: "showYearView" }], class: [_vm.calendarClass, 'vdp-datepicker__calendar'], style: _vm.calendarStyle, on: { "mousedown": function mousedown($event) {
          $event.preventDefault();
        } } }, [_vm._t("beforeCalendarHeader"), _vm._v(" "), _c('header', [_c('span', { staticClass: "prev", class: { 'disabled': _vm.isLeftNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
        } } }, [_vm._v("<")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getPageDecade))]), _vm._v(" "), _c('span', { staticClass: "next", class: { 'disabled': _vm.isRightNavDisabled }, on: { "click": function click($event) {
          _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
        } } }, [_vm._v(">")])]), _vm._v(" "), _vm._l(_vm.years, function (year) {
      return _c('span', { key: year.timestamp, staticClass: "cell year", class: { 'selected': year.isSelected, 'disabled': year.isDisabled }, on: { "click": function click($event) {
            $event.stopPropagation();_vm.selectYear(year);
          } } }, [_vm._v(_vm._s(year.year))]);
    })], 2);
  }, staticRenderFns: [],
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var this$1 = this;

      var d = this.pageDate;
      var years = [];
      // set up a new date object to the beginning of the current 'page'7
      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: this$1.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedYear(dObj),
          isDisabled: this$1.isDisabledYear(dObj)
        });
        this$1.utils.setFullYear(dObj, this$1.utils.getFullYear(dObj) + 1);
      }
      return years;
    },
    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return decadeStart + " - " + decadeEnd + yearSuffix;
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }
      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }
      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }
      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }
      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }
      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },
    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;
      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  }
  // eslint-disable-next-line
};

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = ".rtl { direction: rtl; } .vdp-datepicker { position: relative; text-align: left; } .vdp-datepicker * { box-sizing: border-box; } .vdp-datepicker__calendar { position: absolute; z-index: 100; background: #fff; width: 300px; border: 1px solid #ccc; } .vdp-datepicker__calendar header { display: block; line-height: 40px; } .vdp-datepicker__calendar header span { display: inline-block; text-align: center; width: 71.42857142857143%; float: left; } .vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next { width: 14.285714285714286%; float: left; text-indent: -10000px; position: relative; } .vdp-datepicker__calendar header .prev:after, .vdp-datepicker__calendar header .next:after { content: ''; position: absolute; left: 50%; top: 50%; -webkit-transform: translateX(-50%) translateY(-50%); transform: translateX(-50%) translateY(-50%); border: 6px solid transparent; } .vdp-datepicker__calendar header .prev:after { border-right: 10px solid #000; margin-left: -5px; } .vdp-datepicker__calendar header .prev.disabled:after { border-right: 10px solid #ddd; } .vdp-datepicker__calendar header .next:after { border-left: 10px solid #000; margin-left: 5px; } .vdp-datepicker__calendar header .next.disabled:after { border-left: 10px solid #ddd; } .vdp-datepicker__calendar header .prev:not(.disabled), .vdp-datepicker__calendar header .next:not(.disabled), .vdp-datepicker__calendar header .up:not(.disabled) { cursor: pointer; } .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover { background: #eee; } .vdp-datepicker__calendar .disabled { color: #ddd; cursor: default; } .vdp-datepicker__calendar .flex-rtl { display: flex; width: inherit; flex-wrap: wrap; } .vdp-datepicker__calendar .cell { display: inline-block; padding: 0 5px; width: 14.285714285714286%; height: 40px; line-height: 40px; text-align: center; vertical-align: middle; border: 1px solid transparent; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year { cursor: pointer; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover { border: 1px solid #4bd; } .vdp-datepicker__calendar .cell.selected { background: #4bd; } .vdp-datepicker__calendar .cell.selected:hover { background: #4bd; } .vdp-datepicker__calendar .cell.selected.highlighted { background: #4bd; } .vdp-datepicker__calendar .cell.highlighted { background: #cae5ed; } .vdp-datepicker__calendar .cell.highlighted.disabled { color: #a3a3a3; } .vdp-datepicker__calendar .cell.grey { color: #888; } .vdp-datepicker__calendar .cell.grey:hover { background: inherit; } .vdp-datepicker__calendar .cell.day-header { font-size: 75%; white-space: nowrap; cursor: inherit; } .vdp-datepicker__calendar .cell.day-header:hover { background: inherit; } .vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year { width: 33.333%; } .vdp-datepicker__clear-button, .vdp-datepicker__calendar-button { cursor: pointer; font-style: normal; } .vdp-datepicker__clear-button.disabled, .vdp-datepicker__calendar-button.disabled { color: #999; cursor: default; } ";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();
var Datepicker = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "vdp-datepicker", class: [_vm.wrapperClass, _vm.isRtl ? 'rtl' : ''] }, [_c('date-input', { attrs: { "selectedDate": _vm.selectedDate, "resetTypedDate": _vm.resetTypedDate, "format": _vm.format, "inputFormat": _vm.inputFormat, "translation": _vm.translation, "inline": _vm.inline, "id": _vm.id, "name": _vm.name, "refName": _vm.refName, "openDate": _vm.openDate, "placeholder": _vm.placeholder, "inputClass": _vm.inputClass, "typeable": _vm.typeable, "clearButton": _vm.clearButton, "clearButtonIcon": _vm.clearButtonIcon, "calendarButton": _vm.calendarButton, "calendarButtonIcon": _vm.calendarButtonIcon, "calendarButtonIconContent": _vm.calendarButtonIconContent, "disabled": _vm.disabled, "required": _vm.required, "bootstrapStyling": _vm.bootstrapStyling, "use-utc": _vm.useUtc }, on: { "showCalendar": _vm.showCalendar, "closeCalendar": _vm.close, "typedDate": _vm.setTypedDate, "clearDate": _vm.clearDate } }, [_vm._t("afterDateInput", null, { slot: "afterDateInput" })], 2), _vm._v(" "), _vm.allowedToShowView('day') ? _c('picker-day', { attrs: { "pageDate": _vm.pageDate, "selectedDate": _vm.selectedDate, "showDayView": _vm.showDayView, "fullMonthName": _vm.fullMonthName, "allowedToShowView": _vm.allowedToShowView, "disabledDates": _vm.disabledDates, "highlighted": _vm.highlighted, "calendarClass": _vm.calendarClass, "calendarStyle": _vm.calendarStyle, "translation": _vm.translation, "pageTimestamp": _vm.pageTimestamp, "isRtl": _vm.isRtl, "mondayFirst": _vm.mondayFirst, "dayCellContent": _vm.dayCellContent, "use-utc": _vm.useUtc }, on: { "changedMonth": _vm.handleChangedMonthFromDayPicker, "selectDate": _vm.selectDate, "showMonthCalendar": _vm.showMonthCalendar, "selectedDisabled": _vm.selectDisabledDate } }, [_vm._t("beforeCalendarHeader", null, { slot: "beforeCalendarHeader" })], 2) : _vm._e(), _vm._v(" "), _vm.allowedToShowView('month') ? _c('picker-month', { attrs: { "pageDate": _vm.pageDate, "selectedDate": _vm.selectedDate, "showMonthView": _vm.showMonthView, "allowedToShowView": _vm.allowedToShowView, "disabledDates": _vm.disabledDates, "calendarClass": _vm.calendarClass, "calendarStyle": _vm.calendarStyle, "translation": _vm.translation, "isRtl": _vm.isRtl, "use-utc": _vm.useUtc }, on: { "selectMonth": _vm.selectMonth, "showYearCalendar": _vm.showYearCalendar, "changedYear": _vm.setPageDate } }, [_vm._t("beforeCalendarHeader", null, { slot: "beforeCalendarHeader" })], 2) : _vm._e(), _vm._v(" "), _vm.allowedToShowView('year') ? _c('picker-year', { attrs: { "pageDate": _vm.pageDate, "selectedDate": _vm.selectedDate, "showYearView": _vm.showYearView, "allowedToShowView": _vm.allowedToShowView, "disabledDates": _vm.disabledDates, "calendarClass": _vm.calendarClass, "calendarStyle": _vm.calendarStyle, "translation": _vm.translation, "isRtl": _vm.isRtl, "use-utc": _vm.useUtc }, on: { "selectYear": _vm.selectYear, "changedDecade": _vm.setPageDate } }, [_vm._t("beforeCalendarHeader", null, { slot: "beforeCalendarHeader" })], 2) : _vm._e()], 1);
  }, staticRenderFns: [],
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      default: 'dd MMM yyyy'
    },
    inputFormat: {
      type: Function,
      default: Date.parse
    },
    language: {
      type: Object,
      default: function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      default: 'day'
    },
    maximumView: {
      type: String,
      default: 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(value$1) {
      this.setValue(value$1);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },

    translation: function translation() {
      return this.language;
    },

    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }
      this.setPageDate(this.selectedDate);
    },
    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }
      if (this.isOpen) {
        return this.close(true);
      }
      this.setInitialView();
    },
    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;
      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '" + this.initialView + "' cannot be rendered based on minimum '" + this.minimumView + "' and maximum '" + this.maximumView + "'");
      }
      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;
        case 'month':
          this.showMonthCalendar();
          break;
        default:
          this.showDayCalendar();
          break;
      }
    },
    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);

      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },
    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }
      this.close();
      this.showDayView = true;
      return true;
    },
    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }
      this.close();
      this.showMonthView = true;
      return true;
    },
    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }
      this.close();
      this.showYearView = true;
      return true;
    },
    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },
    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },
    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);
      if (!this.isInline) {
        this.close(true);
      }
      this.resetTypedDate = new Date();
    },
    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },
    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);
      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },
    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);
      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },
    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }
      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }
      this.selectedDate = date;
      this.setPageDate(date);
    },
    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }
      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },
    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },
    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },
    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;
      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }
        document.removeEventListener('click', this.clickOutside, false);
      }
    },
    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }
      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
  // eslint-disable-next-line
};

/* harmony default export */ __webpack_exports__["a"] = (Datepicker);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export af */
/* unused harmony export ar */
/* unused harmony export bg */
/* unused harmony export bs */
/* unused harmony export ca */
/* unused harmony export cs */
/* unused harmony export da */
/* unused harmony export de */
/* unused harmony export ee */
/* unused harmony export el */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return en; });
/* unused harmony export es */
/* unused harmony export fa */
/* unused harmony export fi */
/* unused harmony export fo */
/* unused harmony export fr */
/* unused harmony export ge */
/* unused harmony export he */
/* unused harmony export hr */
/* unused harmony export hu */
/* unused harmony export id */
/* unused harmony export is */
/* unused harmony export it */
/* unused harmony export ja */
/* unused harmony export ko */
/* unused harmony export lb */
/* unused harmony export lt */
/* unused harmony export lv */
/* unused harmony export mn */
/* unused harmony export nbNO */
/* unused harmony export nl */
/* unused harmony export pl */
/* unused harmony export ptBR */
/* unused harmony export ro */
/* unused harmony export ru */
/* unused harmony export sk */
/* unused harmony export slSI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return srCYRL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sr; });
/* unused harmony export sv */
/* unused harmony export th */
/* unused harmony export tr */
/* unused harmony export uk */
/* unused harmony export ur */
/* unused harmony export vi */
/* unused harmony export zh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);

var Language = function Language(e, a, r, n) {
  this.language = e, this.months = a, this.monthsAbbr = r, this.days = n, this.rtl = !1, this.ymd = !1, this.yearSuffix = "";
},
    prototypeAccessors = { language: { configurable: !0 }, months: { configurable: !0 }, monthsAbbr: { configurable: !0 }, days: { configurable: !0 } };prototypeAccessors.language.get = function () {
  return this._language;
}, prototypeAccessors.language.set = function (e) {
  if ("string" != typeof e) throw new TypeError("Language must be a string");this._language = e;
}, prototypeAccessors.months.get = function () {
  return this._months;
}, prototypeAccessors.months.set = function (e) {
  if (12 !== e.length) throw new RangeError("There must be 12 months for " + this.language + " language");this._months = e;
}, prototypeAccessors.monthsAbbr.get = function () {
  return this._monthsAbbr;
}, prototypeAccessors.monthsAbbr.set = function (e) {
  if (12 !== e.length) throw new RangeError("There must be 12 abbreviated months for " + this.language + " language");this._monthsAbbr = e;
}, prototypeAccessors.days.get = function () {
  return this._days;
}, prototypeAccessors.days.set = function (e) {
  if (7 !== e.length) throw new RangeError("There must be 7 days for " + this.language + " language");this._days = e;
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Language.prototype, prototypeAccessors);var af = new Language("Afrikaans", ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["So.", "Ma.", "Di.", "Wo.", "Do.", "Vr.", "Sa."]),
    language = new Language("Arabic", ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوڤمبر", "ديسمبر"], ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوڤمبر", "ديسمبر"], ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"]);language.rtl = !0;var bg = new Language("Bulgarian", ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"], ["Ян", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"], ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]),
    bs = new Language("Bosnian", ["Januar", "Februar", "Mart", "April", "Maj", "Juni", "Juli", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"]),
    ca = new Language("Catalan", ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"], ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"], ["Diu", "Dil", "Dmr", "Dmc", "Dij", "Div", "Dis"]),
    cs = new Language("Czech", ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"], ["led", "úno", "bře", "dub", "kvě", "čer", "čec", "srp", "zář", "říj", "lis", "pro"], ["ne", "po", "út", "st", "čt", "pá", "so"]),
    da = new Language("Danish", ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"]),
    de = new Language("German", ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."]),
    ee = new Language("Estonian", ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"], ["Jaan", "Veebr", "Märts", "Apr", "Mai", "Juuni", "Juuli", "Aug", "Sept", "Okt", "Nov", "Dets"], ["P", "E", "T", "K", "N", "R", "L"]),
    el = new Language("Greek", ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάϊος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"], ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"], ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"]),
    en = new Language("English", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]),
    es = new Language("Spanish", ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"], ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]),
    fa = new Language("Persian", ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"], ["فرو", "ارد", "خرد", "تیر", "مرد", "شهر", "مهر", "آبا", "آذر", "دی", "بهم", "اسف"], ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]),
    fi = new Language("Finnish", ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"], ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"], ["su", "ma", "ti", "ke", "to", "pe", "la"]),
    fo = new Language("Faroese", ["Januar", "Februar", "Mars", "Apríl", "Mai", "Juni", "Juli", "August", "Septembur", "Oktobur", "Novembur", "Desembur"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["Sun", "Mán", "Týs", "Mik", "Hós", "Frí", "Ley"]),
    fr = new Language("French", ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"], ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"], ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]),
    ge = new Language("Georgia", ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"], ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"], ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"]),
    language$1 = new Language("Hebrew", ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"], ["ינו", "פבר", "מרץ", "אפר", "מאי", "יונ", "יול", "אוג", "ספט", "אוק", "נוב", "דצמ"], ["א", "ב", "ג", "ד", "ה", "ו", "ש"]);language$1.rtl = !0;var hr = new Language("Croatian", ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"], ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"], ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"]),
    hu = new Language("Hungarian", ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"], ["Jan", "Febr", "Márc", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szept", "Okt", "Nov", "Dec"], ["Vas", "Hét", "Ke", "Sze", "Csü", "Pén", "Szo"]),
    id = new Language("Indonesian", ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"], ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]),
    is = new Language("Icelandic", ["Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"], ["Jan", "Feb", "Mars", "Apr", "Maí", "Jún", "Júl", "Ágú", "Sep", "Okt", "Nóv", "Des"], ["Sun", "Mán", "Þri", "Mið", "Fim", "Fös", "Lau"]),
    it = new Language("Italian", ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"], ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"], ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"]),
    language$2 = new Language("Japanese", ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], ["日", "月", "火", "水", "木", "金", "土"]);language$2.yearSuffix = "年", language$2.ymd = !0;var language$3 = new Language("Korean", ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], ["일", "월", "화", "수", "목", "금", "토"]);language$3.yearSuffix = "년";var lb = new Language("Luxembourgish", ["Januar", "Februar", "Mäerz", "Abrëll", "Mäi", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], ["Jan", "Feb", "Mäe", "Abr", "Mäi", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."]),
    language$4 = new Language("Lithuanian", ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"], ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gru"], ["Sek", "Pir", "Ant", "Tre", "Ket", "Pen", "Šeš"]);language$4.ymd = !0;var lv = new Language("Latvian", ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"]),
    language$5 = new Language("Mongolia", ["1 дүгээр сар", "2 дугаар сар", "3 дугаар сар", "4 дүгээр сар", "5 дугаар сар", "6 дугаар сар", "7 дугаар сар", "8 дугаар сар", "9 дүгээр сар", "10 дугаар сар", "11 дүгээр сар", "12 дугаар сар"], ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"], ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"]);language$5.ymd = !0;var nbNO = new Language("Norwegian Bokmål", ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"]),
    nl = new Language("Dutch", ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"], ["jan", "feb", "maa", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"], ["zo", "ma", "di", "wo", "do", "vr", "za"]),
    pl = new Language("Polish", ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"], ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"], ["Nd", "Pn", "Wt", "Śr", "Czw", "Pt", "Sob"]),
    ptBR = new Language("Brazilian", ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"], ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"], ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]),
    ro = new Language("Romanian", ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"], ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"], ["D", "L", "Ma", "Mi", "J", "V", "S"]),
    ru = new Language("Russian", ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"], ["Янв", "Февр", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"], ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]),
    sk = new Language("Slovakian", ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"], ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"], ["ne", "po", "ut", "st", "št", "pi", "so"]),
    slSI = new Language("Sloveian", ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"]),
    srCYRL = new Language("Serbian in Cyrillic script", ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"], ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"], ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"]),
    sr = new Language("Serbian", ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"]),
    sv = new Language("Swedish", ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"]),
    th = new Language("Thai", ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"], ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."], ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"]),
    tr = new Language("Turkish", ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"], ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"], ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"]),
    uk = new Language("Ukraine", ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"], ["Січ", "Лют", "Бер", "Квіт", "Трав", "Чер", "Лип", "Серп", "Вер", "Жовт", "Лист", "Груд"], ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]),
    language$6 = new Language("Urdu", ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "سپتمبر", "اکتوبر", "نومبر", "دسمبر"], ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "سپتمبر", "اکتوبر", "نومبر", "دسمبر"], ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"]);language$6.rtl = !0;var vi = new Language("Vietnamese", ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"], ["T 01", "T 02", "T 03", "T 04", "T 05", "T 06", "T 07", "T 08", "T 09", "T 10", "T 11", "T 12"], ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"]),
    language$7 = new Language("Chinese", ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], ["日", "一", "二", "三", "四", "五", "六"]);language$7.yearSuffix = "年";

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(836)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(790),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\misc\\autocomplete\\Autocomplete.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Autocomplete.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-695689b4", Component.options)
  } else {
    hotAPI.reload("data-v-695689b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgc3R5bGU9IiI+PHJlY3QgaWQ9ImJhY2tncm91bmRyZWN0IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSIwIiB5PSIwIiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiLz4NCiA8dGl0bGUvPg0KDQogPGcgc3R5bGU9IiI+DQogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4NCiAgPHJlY3QgZmlsbD0ibm9uZSIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjQwMiIgd2lkdGg9IjU4MiIgeT0iLTEiIHg9Ii0xIi8+DQogPC9nPg0KIDxnIHN0eWxlPSIiIGNsYXNzPSJjdXJyZW50TGF5ZXIiPg0KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+DQogIDxwYXRoIGZpbGw9IiNmZmE1MDAiIGlkPSJUcmlhbmdsZSAyOSIgZD0ibTE0LjQyNDIzLDYuMTQ4MzljMC44NzAwNywtMS40MDc2NiAyLjI4MjgsLTEuNDA0MzEgMy4xNTA3OSwwbDEwLjc4NTA5LDE3LjQ0ODk5YzEuMTYxNTMsMS44NzkyMiAwLjMxNTQ0LDMuNDAyNjIgLTEuODg4NywzLjQwMjYybC0yMC45NDM1NiwwYy0yLjIwNDYzLDAgLTMuMDUzOTksLTEuNTE3MzQgLTEuODg4NzEsLTMuNDAyNjJsMTAuNzg1MDksLTE3LjQ0ODk5em0xLjU3NTc3LDEzLjg1MTYxYzAuNTUyMjgsMCAxLC0wLjQ1MzA0IDEsLTAuOTk3MDNsMCwtNi4wMDU5NGMwLC0wLjU1MDY0IC0wLjQ0Mzg2LC0wLjk5NzAzIC0xLC0wLjk5NzAzYy0wLjU1MjI4LDAgLTEsMC40NTMwNCAtMSwwLjk5NzAzbDAsNi4wMDU5NGMwLDAuNTUwNjQgMC40NDM4NiwwLjk5NzAzIDEsMC45OTcwM3ptMCw0YzAuNTUyMjgsMCAxLC0wLjQ0NzcyIDEsLTFjMCwtMC41NTIyOCAtMC40NDc3MiwtMSAtMSwtMWMtMC41NTIyOCwwIC0xLDAuNDQ3NzIgLTEsMWMwLDAuNTUyMjggMC40NDc3MiwxIDEsMXptMCwwIiBjbGFzcz0ic2VsZWN0ZWQiIGZpbGwtb3BhY2l0eT0iMSIvPg0KIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MassInputValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

var MassInputValidator = function MassInputValidator(params) {
  return function (value) {
    var minimumInvoices = 2;
    if (!!params && !!params.minimumInvoices) {
      minimumInvoices = params.minimumInvoices;
    }
    var tempArray = value.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/).map(function (string) {
      return string.trim();
    });
    var retValue = true;
    var isDuplicate = [];
    if (tempArray.length >= minimumInvoices) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(tempArray).forEach(function (row) {
        var temp = row.trim().match(/\S+/g);
        var hasWhitespace = /\s/g.test(row);
        var amount = void 0,
            invoiceId = void 0;
        if (!hasWhitespace) {
          invoiceId = row;
          amount = '';
        } else {
          amount = temp[1];
          invoiceId = temp[0];
        }
        if (invoiceId === '') {
          retValue = false;
        } else if (temp.length > 2) {
          retValue = false;
        } else if (typeof isDuplicate[invoiceId] !== 'undefined') {
          retValue = false;
        } else if (amount !== '' && isNaN(amount) && amount !== 0) {
          retValue = false;
        } else {
          isDuplicate[temp[0]] = true;
        }
      });
    } else {
      retValue = false;
    }
    return retValue;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = ({ MassInputValidator: MassInputValidator });

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return massInputValidationMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

var massInputValidationMixin = {
  methods: {
    getMassInputErrors: function getMassInputErrors(massInput, params) {
      var _this = this;

      var minimumInvoices = 2;
      if (!!params && !!params.minimumInvoices) {
        minimumInvoices = params.minimumInvoices;
      }
      var tempArray = massInput.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/).map(function (string) {
        return string.trim();
      });
      var isDuplicate = [];
      var currentLine = 1;
      var errorList = [];
      if (tempArray.length >= minimumInvoices) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(tempArray).forEach(function (row) {
          var temp = row.trim().match(/\S+/g);
          var hasWhitespace = /\s/g.test(row);
          var amount = void 0,
              invoiceId = void 0;
          if (!hasWhitespace) {
            invoiceId = row;
            amount = '';
          } else {
            amount = temp[1];
            invoiceId = temp[0];
          }
          if (invoiceId === '') {
            errorList.push(_this.$t('groupSettlement.massInputError.malformedLine', [currentLine]));
          } else if (temp.length > 2) {
            errorList.push(_this.$t('groupSettlement.massInputError.malformedLine', [currentLine]));
          } else if (typeof isDuplicate[invoiceId] !== 'undefined') {
            errorList.push(_this.$t('groupSettlement.massInputError.duplicateInvoice', [currentLine]));
          } else if (amount !== '' && isNaN(amount) && amount !== 0) {
            errorList.push(_this.$t('groupSettlement.massInputError.nonNumberAmount', [currentLine]));
          } else {
            isDuplicate[temp[0]] = true;
          }
          currentLine++;
        });
      } else {
        errorList.push(this.$t('groupSettlement.massInputError.emptyOrTooFew'));
      }
      return errorList;
    },
    parseMassInput: function parseMassInput(massInput) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(massInput.trim().replace(/(^[ \t]*\n)/gm, '').split(/\r?\n/)).map(function (string) {
        return string.trim();
      });
    }
  }
};



/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(855)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(810),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eba14a06",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\user-profile\\UserProfile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserProfile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eba14a06", Component.options)
  } else {
    hotAPI.reload("data-v-eba14a06", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(825)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3342773a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\misc\\user-info\\UserInfo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserInfo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3342773a", Component.options)
  } else {
    hotAPI.reload("data-v-3342773a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_cookie__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configuration__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_console__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_helper__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_export__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_translator__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_endpoints__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_polyfill__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(371);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















// import * as Sentry from '@sentry/browser'



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.debug = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.api_root;

// TODO extract into separate file
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  var isTokenRequired = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['REFRESH_TOKEN'] !== 'IN_PROGRESS' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_endpoints__["a" /* endpointRequireToken */])(request.url);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Content-Type'] = 'application/json';
  if (isTokenRequired) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_cookie__["a" /* getAccessToken */])();
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router_auth__["a" /* accessTokenValid */])()) {
      handleInvalidToken(request, next);
      return;
    }
  }
  // continue to next interceptor
  next();
});

function handleInvalidToken(request, next) {
  var isProductionEnvironment = "Ptest".toUpperCase() === 'production'.toUpperCase();
  if (!isProductionEnvironment) {
    console.log('Access token expired - attempting to refresh');
  }
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router_auth__["b" /* refreshTokenValid */])()) {
    if (!isProductionEnvironment) {
      console.log('Refresh token no longer valid');
    }
    __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */].push('/');
    __WEBPACK_IMPORTED_MODULE_6__router_bus__["a" /* EventBus */].$emit('alert', {
      variant: 'danger',
      message: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('errors.token.refreshTokenExpired'),
      errors: []
    });
  } else {
    // REFRESH TOKEN
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['REFRESH_TOKEN'] = 'IN_PROGRESS';
    var refreshTokenUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.loginRefresh;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_cookie__["b" /* getRefreshToken */])();
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(refreshTokenUrl).then(function (response) {
      if (!isProductionEnvironment) {
        console.log('Access token refreshed successfully');
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_cookie__["c" /* setAccessToken */])(response.data.payload.accessToken);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + response.data.payload.accessToken;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['REFRESH_TOKEN'] = 'DONE';
      next();
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['REFRESH_TOKEN'] = 'DONE';
      if (!isProductionEnvironment) {
        console.log('Failed to obtain new access token after refresh: ' + error);
      }
      __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */].push('/');
      var errorMessage = '';
      if (error.status === 0) {
        errorMessage = __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('apiStatusCodes.0');
      } else {
        errorMessage = __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('errors.token.failedToRefreshToken');
      }
      __WEBPACK_IMPORTED_MODULE_6__router_bus__["a" /* EventBus */].$emit('alert', {
        variant: 'danger',
        message: errorMessage,
        errors: []
      });
    });
  }
}

if ("Ptest".toUpperCase() !== 'local'.toUpperCase()) {}
// Sentry.init({
//   dsn: Vue.$config.sentry.dsn,
//   integrations: [new Sentry.Integrations.Vue({ Vue })],
//   release: Vue.$config.app_release
// })


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_16__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'Invoice Registry',
  notFound: 'Page nog found',
  user: {
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm password',
    email: 'E-mail',
    firstTimeLogin: 'First time login',
    passwordForgotten: 'Forgot password?',
    passwordResetLinkSent: 'Password reset link has been sent to your email address'
  },
  general: {
    phone: 'Phone',
    email: 'E-mail',
    changelog: 'Changelog',
    technicalSupport: 'Technical support'
  },
  forms: {
    ok: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    send: 'Send',
    close: 'Close',
    save: 'Save',
    apply: 'Apply',
    edit: 'Edit',
    warning: 'Warning',
    notification: 'Notification',
    load: 'Load',
    saveToFile: 'Save to file',
    saveToDiagnosticFile: 'Save to diagnostics file',
    saveToClipboard: 'Save to clipboard',
    capsLockOn: 'Capslock is on'
  },
  dashboard: {
    welcome: 'Welcome',
    liabilitiesRegisteredTotal: 'No. of invoices registred today',
    liabilitiesRegisteredDebtor: 'As debtor',
    liabilitiesRegisteredCreditor: 'As creditor',
    liabilitiesRegistrationLimit: 'Monthly limit to number of registered invoices'
  },
  sidebar: {
    allInvoices: 'All invoices',
    registerInvoice: 'Register invoice',
    userAdministration: 'User administration',
    userRegistration: 'User registration',
    reportedIssues: 'Issues',
    groupSettlement: 'Group Settlement',
    invoiceSettlement: 'Invoice settlement'
  },
  activation: {
    title: 'User activation',
    success: 'User successfully activated',
    activationSent: 'User activation link has been sent to your email address'
  },
  reset: {
    title: 'Password change',
    success: 'User password set succesfully'
  },
  issues: {
    reportIssue: 'Report an issue',
    reportIssueDetails: 'Issue details',
    reportIssueSuccess: 'Issue reported succesfully',
    reportIssueLiability: 'Invoice registration issue',
    reportIssueSettlement: 'Issue with invoice settlement',
    reportId: 'Id',
    reportSettlementId: 'Settlement Id',
    reportCategories: 'Issue category',
    reportData: 'Additional information',
    reportSettlementAmount: 'Settlement amount',
    reportUserComment: 'User comment',
    reportOperatorComment: 'Operator comment',
    reportColumnCategory: 'Category',
    reportColumnCreationDate: 'Creation Date',
    reportColumnClosingDate: 'Closing date',
    reportColumnData: 'Data',
    reportColumnResourceId: 'ResourceID',
    reportColumnStatus: 'Status',
    reportColumnCompanyNumber: 'Budget Number',
    reportIssueStatus: {
      0: 'All',
      1: 'Active',
      2: 'Canceled',
      3: 'Resolved',
      4: 'Unresolved'
    },
    reportIssueCancel: 'Cancel issue',
    reportIssueResolve: 'Resolve issue',
    reportIssueCancelModal: 'Issue cancel',
    reportIssueCancelModalConfirm: 'Do you want to cancel the issue',
    reportIssueCancelSuccess: 'Issue succesfully canceled',
    reportIssueResolveModal: 'Resolve issue',
    reportIssueResolveSuccess: 'Issue sucessfully resolved',
    reportIssueResolved: 'Mark resolved',
    reportIssueUnresolved: 'Mark as unresolved',
    reportIssueResolveComment: 'Resolve comment',
    reportIssueUserLogin: 'User login',
    reportIssueUserName: 'First and last name',
    reportIssueUserOrganization: 'Organisation',
    reportIssueBank: 'Bank',
    reportIssueBankFeedback: 'Bank has to contain 3 characters',
    reportIssueHelpLink: 'Detialed instructions',
    reportIssues: 'Issues',
    reportIssuesActive: 'Active',
    reportIssuesAll: 'All'
  },
  register: {
    title: 'Registration',
    registrationForbidden: 'Registration not allowed',
    legalEntityInfo: 'Legal entity info',
    legalEntityCheckboxText: 'I\'m legal entity',
    budgetIdNumber: 'Budget ID number',
    budgetIdNumberFootnote: 'Budget ID footnote',
    companyNumber: 'Company number',
    companyNumberShort: 'CRN',
    taxIdNumber: 'Tax ID number',
    parentCompany: 'Parent company',
    companyName: 'Company name',
    legalEntityName: 'Legal entity name',
    address: 'Company address',
    postalCode: 'Postal code',
    treasuryBranch: 'Treasury branch',
    treasuryBranchInfo: 'Treasury branch info',
    treasuryBranchNote: 'Type first several letters of a city/region and system will offer the list',
    email: 'Company e-mail',
    adminInfo: 'Admin info',
    name: 'Name and last name',
    personalIdentityNumber: 'Personal identity number',
    identityNumber: 'Identity number',
    submit: 'Send registration request',
    infoText: 'After successfully completing the request, you will receive an e-mail with details of the registration steps.',
    registrationSuccess: 'Registration succesfull',
    registrationSuccessText: 'Verify that you have received confirmation email from Treasury. Otherwise save your registration form by clicking on \'Print form\'',
    registrationLimitExceeded: 'Registration request limit exceeded',
    printRequestForm: 'Print form',
    printForm: 'Print form',
    ouList: 'List of organizational units',
    editRegistration: 'To edit registration click on Edit registration',
    editRegistrationLine2: 'After you input the changes, save them by pressing the button \'Send registration request\'',
    editRegistrationButton: 'Edit registration',
    editRegistrationToken: 'Edit registration token',
    editRegistrationLoad: 'Load registration data',
    registrationLoad: 'Load registration'
  },
  invoices: {
    invoiceIndex: 'Invoice index - ',
    invoiceReview: 'Review invoices',
    review: 'Review',
    invoiceDetails: 'Invoice details',
    invoiceId: 'Invoice ID',
    settlementDetails: 'Invoice settlements details',
    cancelInvoice: 'Cancel invoice',
    cancelInvoices: 'Cancel invoices',
    cancellationUser: 'Cancellation user',
    cancellationDate: 'Cancellation date',
    cancellationComment: 'Cancellation comment',
    cancellationSuccess: 'Invoices cancelled',
    columnCreditor: 'Creditor',
    columnDebtor: 'Debtor',
    columnId: 'ID',
    columnBudgetIdNumber: 'Budget ID',
    columnInvoiceNumber: 'Invoice number',
    columnInvoiceAmount: 'Amount',
    columnInvoiceAmountFrom: 'From',
    columnInvoiceAmountTo: 'To',
    columnSelected: 'Selected',
    columnSettlementAmount: 'Settlement amount',
    columnSettlementDate: 'Settlement date',
    columnInvoiceStatus: 'Status',
    columnCreditorName: 'Creditor name',
    columnDebtorName: 'Debtor name',
    columnCreditorBudgetIdNumber: 'Budget ID',
    columnCreditorTaxId: 'Creditor Tax ID',
    columnCreditorCompanyNumber: 'Creditor company number',
    columnDueDate: 'Due date',
    columnPreviousDueDate: 'Previous due date',
    columnDueDateRangeFrom: 'Due date from',
    columnDueDateRangeTo: 'Due date to',
    columnCreationDate: 'Creation date',
    columnCreationDateRangeFrom: 'From',
    columnCreationDateRangeTo: 'To',
    columnLifetime: 'Lifetime',
    columnSettlementComments: 'Settlement comments',
    columnSettlementStatus: 'Status',
    columnSettledAmount: 'Settled amount',
    invoiceRegistered: 'Invoice succesfully registered',
    invoicesRegistered: 'Payload of invoices sucesfully registered',
    invoicesPartiallyRegistered: 'Payload of invoices partially registered',
    invoiceExport: 'Export',
    invoiceCancelled: 'Cancelled',
    invoiceCancelFailed: 'Invoice cancellation failed',
    invoiceExportJson: 'Export to JSON',
    invoiceExportCsv: 'Export to CSV',
    invoiceExportFailed: 'Invoice export failed',
    invoiceSettled: 'Settled',
    invoiceStatus: {
      0: 'All',
      1: 'Active',
      2: 'Invalid',
      3: 'Cancelled',
      4: 'Partially Settled',
      5: 'Settled',
      6: 'Assigned',
      7: 'Proinvoice',
      101: 'Open'
    },
    settlementStatus: {
      1: 'Active',
      2: 'Cancelled'
    },
    invoiceLimitExceeded: 'Invoice registration request limit exceeded',
    invoiceCurrency: 'Din',
    invoicesAsDebtor: 'As debtor',
    invoicesAsCreditor: 'As creditor',
    invoicesAsAdministrator: 'As administrator',
    invoiceAssigned: 'Assigned',
    invoiceAssignedName: 'Assigned company name',
    invoiceAssignedBudgetNumber: 'Assigned Budget number',
    invoiceAssignedCompanyNumber: 'Assigned company number',
    invoiceAssignedTaxIdNumber: 'Assigned Tax ID number',
    invoiceAssignment: 'Assign invoice',
    invoiceAssignmentInformation: 'Assignement information',
    invoiceAssignmentContractNumber: 'Assignment contract number',
    invoiceAssignmentModal: 'Assign invoice?',
    invoiceAssignmentCancelModal: 'Cancel invoice assign?',
    invoiceAssignSuccess: 'Assign successful',
    invoiceAssignCancelSuccess: 'Assign cancel successful',
    invoiceAssignCancel: 'Cancel assign',
    invoiceAssignIdf: 'Assigned invoice ID',
    invoiceAssignOriginIdf: 'Assigned invoice ID',
    invoiceAssignValidDebtorWarning: 'Assignation can only be done by a local user that is an invoice debtor :',
    invoiceAmountChange: 'Amount change', // TODO check these
    invoiceAmountChangeAdd: 'Add change', // TODO check these
    invoiceAmountChangeSettle: 'Settle',
    invoiceAmountChangeSuccess: 'Amount change success',
    invoiceDeltaColumnAmount: 'Change amount',
    invoiceDeltaColumnComments: 'Change/cancellation comment',
    invoiceDeltaColumnDate: 'Cancellation/change date',
    invoiceDeltaCancel: 'Cancel change',
    invoiceActivationCancel: 'Cacel activation',
    invoiceNotFound: 'Requested invoice not found',
    invoiceCancelledComment: 'Cancelation comment:',
    expandSections: 'Expand all sextions',
    collapseSections: 'Collapse all sections'
  },
  registerInvoice: {
    invoice: 'Invoice',
    registerSingleInvoice: 'Single entry',
    registerMultipleInvoices: 'Multiple entries',
    invoiceFileInput: 'Choose multiple invoices file',
    invoiceFileBrowse: 'Browse',
    invoiceFileNoSelection: 'No files selected',
    invoiceRegistration: 'Invoice registration',
    debtorBudgetId: 'Debtor Budget ID',
    invoiceNumber: 'Invoice number',
    amount: 'Amount',
    issuePlace: 'Issue place',
    issueDate: 'Issue date',
    comments: 'Comments',
    registerInvoice: 'Register invoice',
    groupInvoiceRegistration: 'Group invoice registration',
    invoiceFileParse: 'Multiple invoice file read failed',
    registerInvoiceConfirmation: 'Register invoice?',
    registerMultipleErrorList: 'Register error list',
    registerMultipleSuccessList: 'List of registred invoices',
    registerMultipleCsvHeaderError: 'Missing or non valid header in CSV file',
    registerProinvoice: 'Proinvoice',
    registerProinvoiceLifetime: 'Lifetime in days',
    registerProinvoiceLifetimeEmpty: 'Lifetime must be between 1 and 90 days',
    registerProinvoiceFootnote: '*Default lifetime value will be used if none is selected'
  },
  groupSettlement: {
    groupSettlementReview: 'Review group settlements',
    columnGroupSettlementNumber: 'Specification #',
    columnCreditor: 'Creditor',
    columnAmount: 'Amount',
    columnAmountFrom: 'From',
    columnAmountTo: 'To',
    columnDebtor: 'Debtor',
    columnCreationDate: 'Creation date',
    columnCreationDateRangeFrom: 'From',
    columnCreationDateRangeTo: 'To',
    columnDueDate: 'Due date',
    columnDueDateRangeFrom: 'From',
    columnDueDateRangeTo: 'To',
    columnSettlementDate: 'Settlement date',
    columnSettlementDateRangeFrom: 'From',
    columnSettlementDateRangeTo: 'To',
    columnStatus: 'Status',
    columnInvoiceErrorCode: 'Status within group settlement',
    columnInvoiceCount: 'Number of invoices',
    groupSettlementCreator: 'Created by',
    groupSettlementAddInvoices: 'Add invoices',
    groupSettlementCancelAddInvoices: 'Cancel',
    groupSettlementStatus: {
      0: 'All',
      1: 'Pending',
      2: 'Active',
      3: 'Settled',
      4: 'Cancelled',
      5: 'Invalid'
    },
    invoiceError: 'Error',
    groupSettlementInvoicesShowTable: 'Show as table',
    groupSettlementInvoicesShowText: 'Show as text',
    groupSettlementInvoicesShowInput: 'Show as text input',
    badgeCancelled: 'Cancelled',
    badgeInvalid: 'Invalid',
    badgeSettled: 'Settled',
    createNew: 'Register new group settlement',
    groupSettlementRegister: 'Group settlement registration',
    invoiceList: 'Specification Invoice List',
    groupSettlementNumber: 'Group settlement number',
    settlementAmount: 'Amount',
    invoiceId: 'Invoice Id',
    groupSettlementSubmit: 'Create',
    groupSettlementConfirmation: 'Create new group settlement?',
    groupSettlementEdit: 'Edit',
    groupSettlementEditSave: 'Save',
    groupSettlementEditConfirmation: 'Edit group settlement specification',
    groupSettlementBack: 'Back',
    groupSettlementEditHeader: 'Edit group settlement',
    groupSettlementSingle: 'Group settlement specification',
    groupSettlementActivate: 'Activate',
    groupSettlementActivateTitle: 'Activate group settlement specification',
    groupSettlementActivateTitleDisabled: 'Can\'t activate a group settlement with invalid invoices',
    groupSettlementDeactivate: 'Deactivate',
    groupSettlementDeactivateTitle: 'Deactivate group settlement specification',
    groupSettlementCancel: 'Cancel',
    groupSettlementCancelTitle: 'Cancel group settlement specification',
    groupSettlementActivationConfirmation: 'Activate group settlement?',
    groupSettlementDeactivationConfirmation: 'Deactivate the group settlement specification',
    groupSettlementCancelationConfirmation: 'Cancel group settlement?',
    groupSettlementActivated: 'Group settlement activated',
    groupSettlementDeactivated: 'Group settlement specification deactivated',
    groupSettlementCanceled: 'Group settlement canceled',
    groupSettlementEdited: 'Group specification activated',
    groupSettlementNoEdit: 'You can not edit an already active or canceled group settlement',
    massInput: 'Invoices with amounts',
    massAdditionalInput: 'Invoices to be added to the group settlement specification',
    invoiceTableHeader: 'Invoices in group settlement specification',
    review: 'Review',
    groupSettlementRegistered: 'Group settlement successfully registered',
    massInputError: {
      tableHeader: 'List of validation errors',
      emptyOrTooFew: 'Group settlement specification has to contain at least two (2) invoices',
      malformedLine: 'Line: {0}, Invalid line',
      nonNumberAmount: 'Line: {0}, amount has to a be a number',
      duplicateInvoice: 'Line: {0}, Invoice is already in the list',
      returnedCodePrefix: 'Invoice error {0}:'
    },
    groupSettlementFetchingData: 'Fetching data from the server',
    groupSettlementFetchingDataFailed: 'There was an error while fetching group settlement specification, please try again later',
    groupSettlementRemoveInvoiceConfirmation: 'Are you sure you want to remove selected invoices from group settlement specification?',
    groupSettlementAddInvoiceConfirmation: 'Are you sure you want to add invocies to the group settlement specification',
    groupSettlementRemoveInvoice: 'Remove selected invoices',
    groupSettlementAddInvoice: 'Add invoices',
    selectInvalidInvoices: 'Select all invalid invoices',
    groupSettlementInvalidBanner: 'Group settlement specification is not valid. Change specification to be able to remove all canceled, settled or assigned invoices.',
    groupSettlementActivateLink: 'Activation information'
  },
  userAdministration: {
    userProfile: 'User profile',
    administration: 'Administration',
    localAdministration: 'Local administrator',
    userDetails: 'User details',
    userDetailsChange: 'User details change',
    userCreate: 'Create new user',
    userNotification: 'Create notification',
    userNotificationCancel: 'Cancel notification',
    details: 'Detals',
    userId: 'User ID',
    userLogin: 'User login',
    userOrganizationName: 'Organization name',
    userName: 'Name',
    userEmail: 'Email',
    userRoles: 'User roles',
    userRoleDescription: 'User role description',
    userClaims: 'User claims',
    userRolesClaims: 'User roles and claims',
    userStatus: 'Status',
    changePassword: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    password: 'Password',
    confirmPassword: 'Confirm password',
    confirmPasswordFail: 'Passwords don\'t match',
    passwordChanged: 'Password changed',
    userChangedId: 'Canceled by a user',
    userLastChangeDate: 'Cancelation date',
    userChangedComments: 'Cancelation comment',
    personalInformationChange: 'Change personal data',
    personalInformationChangeConfirmation: 'Change user data?',
    registrationInformationChangeConfirmation: 'Change registration data?',
    apply: 'Apply',
    userRevoke: 'Revoke',
    userRevokeComments: 'Reason for revoking',
    userRevokeConfirmation: 'Revoke user?',
    userPermissionUpdateConfirmation: 'Update user permissions?',
    userActivate: 'Activate',
    userActivateConfirmation: 'Are you sure you want to activate user?',
    userActiveStatus: 'Active',
    userRevokedStatus: 'Revoked',
    userRevoked: 'User successfully revoked',
    userRestored: 'User successfully restored',
    userPermissionsUpdated: 'User permissions updated',
    userRevokeFailed: 'User revoke failed',
    userRestoreFailed: 'User restore failed',
    userPermissionsUpdateFailed: 'User permission update failed',
    userPermissionsTableFilter: 'Filter',
    userPermissionsTableFilterClear: 'Clear',
    userCreateConfirmation: 'Create new local user?',
    userCreated: 'New user successfully created',
    userUpdated: 'User information updated',
    registrationUpdated: 'Registration information updated',
    notificationId: 'Notification ID',
    notificationCreator: 'Created by',
    notificationText: 'Notification text',
    notificationPriority: 'Priority',
    notificationPriorityStatus: {
      0: 'All',
      1: 'Low priority',
      2: 'Normal priority',
      3: 'High priority'
    },
    notificationValidUntil: 'Valid until',
    notificationCreatedDate: 'Creation date',
    notificationCreate: 'Create notification',
    notificationEdit: 'Edit notification',
    notificationCreated: 'Notification successfully created',
    notificationUpdated: 'Notification successfully updated',
    notificationFailed: 'Notification failed',
    Claim_Admin: 'Administration',
    Claim_User_Create: 'User create',
    Claim_User_Review: 'User review',
    Claim_User_Revoke: 'User revoke',
    Claim_Local_User_Create: 'Local user create',
    Claim_Local_User_Review: 'Local user review',
    Claim_Local_User_Revoke: 'Local user revoke',
    Claim_Invoice_Create: 'Invoice create',
    Claim_Invoice_Cancel: 'Invoice cancel',
    Claim_Invoice_Cancel_All: 'Cancel all invoices',
    Claim_Invoice_Review: 'Invoice review',
    Claim_Invoice_Review_All: 'View all invoices',
    Claim_Invoice_Export: 'Invoice export',
    Claim_Invoice_Settle: 'Invoice settle',
    Claim_Invoice_Assign: 'Invoice assign',
    Claim_Notification_Create: 'Notification create',
    Claim_Registration_Edit: 'Registration change',
    Claim_Invoice_Amount_Change: 'Invoice amount change',
    Claim_Invoice_Activate: 'Change settled invoice amount (multiple)',
    Claim_Invoice_Activate_Once: 'Invoice amount change',
    Claim_Issue_Resolve: 'Close the issue',
    Claim_Group_Settlement_Create: 'Creating group settlement',
    Role_Administrator: 'Administrator',
    Role_Operator: 'Treasury operator',
    Role_Local_Administrator: 'Local administrator',
    Role_Local_User: 'Local user',
    Role_Control: 'Inspection control',
    Role_Jafin_User: 'JAFIN user',
    entityStatuses: {
      0: 'Active',
      3: 'Temporarily inactive',
      9: 'Canceled'
    },
    userStatuses: {
      0: 'All',
      1: 'Active',
      2: 'Inactive',
      3: 'Revoked',
      4: 'Disabled'
    },
    userPasswordRequirement: {
      0: 'Password must contain at least 8 characters',
      1: 'Password must contain numbers',
      2: 'Password must contain uppercase letters',
      3: 'Password must contain symbols'
    },
    userLoginRequirement: {
      0: 'Login can contain latin letters',
      1: 'Login can contain numbers',
      2: 'Login can contain characters \'.\', \'_\' ',
      3: 'Login must start and end with letters or numbers',
      4: 'Login can contain 32 characters'
    },
    ungroupedClaims: 'Ungrouped claims',
    Role_Administrator_Description: 'Administration role description',
    Role_Operator_Description: 'Operator role description',
    Role_Local_Administrator_Description: 'Local administrator role description',
    Role_Local_User_Description: 'Local user role description',
    Role_Control_Description: 'Control user role description',
    Ungrouped_Description: 'Ungrouped claims description'
  },
  userRegistration: {
    registrationHeader: 'Institution registration',
    registrationInstitution: 'Institution information',
    registrationId: 'ID',
    registrationBudgetId: 'Budget ID',
    registrationCompanyNumber: 'Company number',
    registrationCompanyNumberShort: 'CRN',
    registrationTaxIdNumber: 'Tax ID number',
    registrationParentInstitution: 'Parent institution',
    registrationName: 'Name',
    registrationShortName: 'Short Name',
    registrationEmail: 'Email',
    registrationEntityType: 'Budget user type',
    registrationActivity: 'Activity',
    registrationCouncil: 'Council',
    registrationDirectBudgetCode: 'Direct budget code',
    registrationPhoneNumber: 'Phone number',
    registrationPostOfficeNumber: 'Post office number',
    registrationAddress: 'Address',
    registrationAdmin: 'Admin information',
    registrationAdminName: 'Admin name',
    registrationAdminIdentityNumber: 'Admin identity number',
    registrationAdminPersonalIdentityNumber: 'Admin personal identity number',
    registrationAdminEmail: 'Email',
    registrationAdminPhoneNumber: 'Phone number',
    registrationCreationDate: 'Registration request date',
    registrationRegistrationDate: 'Registration date',
    registrationRegistered: 'Registered',
    registrationAdminActivate: 'Administrator account activation',
    registrationApproved: 'Registration approved',
    registrationCancelled: 'Registration cancelled',
    registrationActivate: 'Activate account',
    registrationCancel: 'Cancel account',
    registrationStatus: 'Status',
    registrationStatuses: {
      0: 'All',
      1: 'Pending',
      2: 'Approved',
      3: 'Cancelled'
    },
    registrationApprovedUser: 'Registration approved by',
    registrationCancelledUser: 'Registration cancelled by',
    registrationApprovalDate: 'Approval date',
    registrationCancelConfirmationText: 'Cancel registration?',
    registrationApproveConfirmationText: 'Approve registration?',
    registrationFormTitle: 'User account registration form',
    adminFormTitle: 'Admin account form',
    registrationApprovedDate: 'Registration approved',
    invoiceLimitChangeText: 'Monthly limit for invoice registration',
    noInvoiceLimitText: 'No limit',
    invoiceLimitChangedText: 'Monthly limit for number of invoices registrations sucesfully changed'
  },
  datatable: {
    toggleAll: 'Toggle all',
    filter: 'Filter',
    perPage: 'Per page',
    range: 'Showing {0} to {1} of {2} entries',
    noData: 'No data',
    generateReport: 'Generate report',
    generateReportModalText: 'Generate report?'
  },
  message: {
    title: 'Invoice Registry',
    welcome: 'Welcome',
    login: 'Login',
    documentation: 'Documentation',
    signout: 'Signout',
    profile: 'Profile',
    externalLinks: 'External links'
  },
  apiStatusCodes: {
    0: 'Connection not available',
    400: 'Failed to process request',
    401: 'An error occured during user authorization',
    403: 'No valid authorized claim found',
    404: 'Endpoint not found',
    429: 'Endpoint request limit reached',
    500: 'An error occured during the usage of the service, please contact tehnical support',
    1001: 'Budget ID number is not valid',
    1002: 'Таџ ID number is not valid',
    1003: 'Company number is not valid',
    1004: 'Parent Tax ID number is not valid',
    1005: 'Parent company number is not valid',
    1006: 'Company name is not valid',
    1007: 'Company address is not valid',
    1008: 'Company phone number is not valid',
    1009: 'Company email is not valid',
    1010: 'Treasury branch is not valid',
    1011: 'Administrator name is not valid',
    1012: 'Administrator personal identity number is not valid',
    1013: 'Administrator identity number is not valid',
    1014: 'Administrator email is not valid',
    1015: 'Administrator phone number is not valid',
    1016: 'Inovoice number is not valid',
    1017: 'Amount is not valid',
    1018: 'Issue date is not valid',
    1019: 'Comments is not valid',
    1025: 'Data for monthly limit for number of registered invoices is invalid',
    1101: 'User login is not valid',
    1102: 'User name is not valid',
    1103: 'User email is not valid',
    1104: 'User password is not valid',
    1105: 'User password bad criteria',
    1107: 'Cancellation comment is not valid',
    1200: 'Invoice is not valid',
    1201: 'Invoice number is not valid',
    1202: 'Invoice amount is not valid',
    1203: 'Issue date is not valid',
    1204: 'Comment is not valid',
    1205: 'Budget number ID is not valid',
    1206: 'Issue place is not valid',
    1207: 'Invoice ID is not valid',
    1208: 'Cancel comments is not valid',
    1209: 'Number of invoices exceeds the limit',
    1210: 'Budget number ID is not valid',
    1211: 'Assignment contract number is not valid',
    1212: 'Lifetime not valid or too short',
    1300: 'Settlements is not valid',
    1301: 'Bank code is not valid',
    1302: 'Creditor Tax ID number is not valid',
    1303: 'Creditor company number is not valid',
    1304: 'Settled amount is not valid',
    1305: 'Debtor company number is not valid',
    1306: 'Invoice number is not valid',
    1308: 'Settlement comments are not valid',
    1400: 'Notification is not valid',
    1401: 'Priority is not valid',
    1402: 'Valid until date is not valid',
    1403: 'Notification text is not valid',
    1404: 'Notification status is not valid',
    1501: 'Requested per page number not valid',
    1601: 'Invoice id is not valid',
    1602: 'Change amount is not valid',
    1603: 'Change comment not valid or contains non valid symbols',
    1604: 'Change ID is not valid',
    1605: 'Change cancellation comment is not valid or contains non valid symbols',
    1701: 'CIR resource is not valid',
    1702: 'Resource ID is not valid',
    1703: 'Issue category is not valid',
    1704: 'Additional information about the issue is not valid',
    1705: 'Issue comment is not valid',
    1707: 'Operator comment is not valid',
    1802: 'Group settlement number contains non valid characters',
    2001: 'Registration request body empty',
    2002: 'Public entity not valid',
    2003: 'Legal entity not valid',
    2004: 'Registration request already submited',
    2005: 'Failed to send confirmation email',
    2008: 'Treasury branch not valid',
    2009: 'Missing registration ID for cancellation',
    2011: 'Legal information for budget user are not matching',
    2012: 'Registration token contains invalid data',
    2013: 'Registration is already approved or cancelled',
    2014: 'Attempting to register budget user without ID',
    2901: 'Unknown error trying to retrieve registration data',
    3000: 'Cir user not found',
    3001: 'Invalid password for Cir user',
    3002: 'Token for Cir user is invalid or revoked',
    3003: 'Refresh token for Cir user not found',
    3006: 'User is not currently marked as active',
    3007: 'User has been revoked',
    3008: 'Password length is invalid',
    3009: 'Password must contain numbers',
    3010: 'Password must contain uppercase letters',
    3011: 'Password must contain symbols',
    3012: 'User has been disabled',
    3014: 'Failed login attempts limit reached, please wait',
    3015: 'Invalid user or the user belongs to a wrong organisation',
    3900: 'Unknown error trying to create Cir access token',
    3901: 'Unknown error trying to obtain Cir refresh token',
    3902: 'Unknown error trying to retrieve Cir user',
    4000: 'Valid registration information not found for user',
    4003: 'User is not registered',
    4006: 'Failed to retrieve valid activation token',
    4007: 'User is already active',
    4009: 'Create new user failed',
    4011: 'User is not active',
    4012: 'User inactive or user status change failed',
    4013: 'Invalid permission submitted',
    4017: 'Status self-assign is not allowed',
    4018: 'Cannot update administrative permissions',
    4019: 'Cannot create user without privileges',
    4020: 'Activation of disabled user not allowed',
    4021: 'User information change failed',
    4022: 'Notification priority is not valid',
    4023: 'Notification status is not valid',
    4906: 'Error activating user, please try again',
    4912: 'Unknown error trying to edit user data',
    4905: 'Failed to approve user',
    4915: 'User type Operator is not allowed for the organization',
    4916: 'User claim for type Operator is not allowed for the organization',
    6001: 'Invoice liability validation failed',
    6002: 'Multiple invoice registration failure',
    6003: 'No valid invoices foud',
    6006: 'Invoice is already settled',
    6010: 'Invoice not active or is partially/fully settled',
    6011: 'Invoice has been cancelled',
    6013: 'Multiple invoice registration limit exceeded',
    6018: 'Settled amount tolerance exceeded',
    6019: 'Invoice number must not be empty',
    6020: 'Invoice number has invalid first character',
    6021: 'Invoice number has invalid last character',
    6023: 'Cannot assign already assigned liability',
    6024: 'Attempting to assign liability for invalid debtor',
    6025: 'Cannot re-assign already assigned liability',
    6027: 'Invoice liability assign not cancelled',
    6028: 'Cannot settle already assigned liability',
    6029: 'Invoice number has invalid character',
    6030: 'Registering invoice to self is not permitted',
    6032: 'Invoice number too long - allowed 22 characters',
    6033: 'Budget number not valid or budget user not active',
    6034: 'Budget number cannot be debtor',
    6039: 'Invoice amount change exceedes the invoice settled amount',
    6041: 'Invoice amount change is allowed only to the creditor of the invoice',
    6042: 'You can not assign an invoice to yourself',
    6043: 'Invoice amount can not be be zero after a change',
    6044: 'Budget user number belongs to the user that can not be a debtor',
    6046: 'No valid information found about invoice cancelation',
    6047: 'No valid information \\found about the user that cancelled the invoice',
    6055: 'Issue category does not belong to selected CIR resource',
    6056: 'Selected issue category requiers additional data',
    6057: 'No valid issue found',
    6060: 'Issue is not active or does not belong to an organization',
    6067: 'No valid group settlements found',
    6068: 'Group settlement number empty',
    6069: 'Group settlement number has invalid first character',
    6070: 'Group settlement number has invalid last character',
    6071: 'Group settlement number contains invalid characters',
    6072: 'Group settlement number has invalid length',
    6073: 'Invoice group settlement create request body empty',
    6074: 'Invalid group settlement invoice specification',
    6075: 'Repeated invoices found in specification',
    6076: 'No valid group settlements persisted',
    6077: 'Group settlement invoice specification empty',
    6078: 'No valid group settlement items found',
    6079: 'No valid group settlements updated',
    6080: 'Group settlement specification is cancelled',
    6081: 'Group settlement specification is settled',
    6082: 'Invoice group settlement get request body empty',
    6083: 'Invoice group settlement status change request body empty',
    6084: 'Invalid creditor for group settlement invoice specification',
    6085: 'Invalid amount for group settlement invoice specification',
    6086: 'Invalid group settlement item',
    6087: 'Invalid group settlement status',
    6088: 'Group settlement specification is invalid',
    6089: 'Invoice invalid amount found in specification',
    6090: 'Group settlement specification is active',
    6091: 'Group settlement specification contains one invoice',
    6092: 'Invoice settled amout changed for specified group settlement specification',
    6093: 'Invoice amount is changed for group settlement specification',
    6094: 'Invocie status is changed for the group settlement specification',
    6095: 'Unknown invoice or organization',
    6096: 'Invalid invoiceo debtor',
    6097: 'Maximum number of invoices for group settlement specification exceeded',
    6102: 'Proinvoice lifetime has to be in the future',
    6103: 'Lifetime has has to be between 1 and 90 days range',
    6106: 'Invoice is not registered inside of active group settlement specification',
    6108: 'Monthly limit for number of registered invoices exceeded',
    6901: 'Unknown error trying to register invoice',
    6902: 'Unknown error trying to retrieve invoice',
    6904: 'Invoice cancellation unsuccesful or you are not the invoice creditor',
    6916: 'Unknown error while fetching group settlement specification',
    54100: 'Unable to approve registration',
    54200: 'Unable to update organization hierarchy',
    54300: 'User has already been approved on the system',
    54400: 'Unable to add approved user',
    54500: 'User is already active',
    54600: 'Failed to insert new local user',
    54900: 'Attmpting to insert local user with illegal claims',
    55000: 'Local user count limit reached',
    55100: 'Changes to the user with higher privileges is not allowed',
    56000: 'Unknown error trying to register invoice',
    56100: 'Inserted Budget user ID not valid',
    56200: 'Invoice liabilities already submitted and registered',
    56700: 'Invoice liability already assigned',
    56900: 'Removing invoice assigned status failed',
    57000: 'Assigned invoice cancel failed',
    58200: 'You are not the invoice creditor or te invoice status does not allow changes to the invocie amount',
    58400: 'Amount change does not exist or is already cancelled',
    58500: 'Maximum number of invoice changes has been reached',
    58600: 'Maximum number of invoice activation has been reached',
    71300: 'Invoice or group settlement specification with the same data already registered'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Some errors has occurred. Please check the list below',
    token: {
      refreshTokenExpired: 'Refresh token has expired',
      failedToRefreshToken: 'Failed to obtain new access token after refresh'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Enteret criteria \'{query}\' returns more than {limit} results.  Narrow down the search criteria or continue your search at {url}',
    urlText: 'to the list of budget users'
  },
  notifications: {
    apply: 'Apply',
    title: 'Notificatrions',
    subscribe: 'Subscribe to notifications',
    selectNotificationType: 'Select an event for wich you want to notified',
    subscribedIssueSuccessfully: 'You have successfully subscribed for notifications for the selected issue',
    unsubscribedIssueSuccessfully: 'You have successfully unsubscribed from notifications for the selected issue'
  },
  userSettings: {
    regionalHeader: 'Personal settings',
    regionalSubheader: 'Regional and localization settings',
    dateFormat: 'Date format',
    dateLocalization: 'Date localization',
    decimalFormat: 'Decimal format',
    csvSeparator: '\'CSV\' separator',
    language: 'Language',
    settingsSavedSuccess: 'Regional settings sucesfully changed',
    settingsSavedFail: 'An error occured while trying to save regional settings'
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  title: 'ЦРФ',
  notFound: 'Тражена страница није пронађена',
  user: {
    username: 'Корисничко име',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    email: 'И-мејл',
    firstTimeLogin: 'Пријављујем се први пут',
    passwordForgotten: 'Заборављена лозинка',
    passwordResetLinkSent: 'Линк за поновно постављање лозинке је послат на вашу адресу електронске поште'
  },
  general: {
    phone: 'Број телефона',
    email: 'Адреса електронске поште',
    changelog: 'Информације о верзијама сервиса',
    technicalSupport: 'Пријава проблема',
    integration: 'Инструкције за интеграцију'
  },
  forms: {
    ok: 'У реду',
    cancel: 'Одустани',
    submit: 'Потврди',
    send: 'Пошаљи',
    close: 'Затвори',
    save: 'Сачувај',
    apply: 'Примени',
    edit: 'Измени',
    warning: 'Упозорење',
    notification: 'Обавештење',
    load: 'Учитај',
    saveToFile: 'Сачувај у фајл',
    saveToDiagnosticFile: 'Сачувај у дијагностички фајл',
    saveToClipboard: 'Сачувај у клипборд',
    capsLockOn: 'Укључен је CapsLock'
  },
  dashboard: {
    welcome: 'Добродошли',
    liabilitiesRegisteredTotal: 'Укупно регистрованих фактура данас',
    liabilitiesRegisteredDebtor: 'Као дужник',
    liabilitiesRegisteredCreditor: 'Као поверилац',
    liabilitiesRegistrationLimit: 'Месечни лимит на број регистрованих фактура'
  },
  sidebar: {
    allInvoices: 'Све фактуре',
    registerInvoice: 'Регистрација фактуре',
    userAdministration: 'Администрација',
    userRegistration: 'Регистрација институције',
    reportedIssues: 'Рекламације',
    groupSettlement: 'Спецификација групног плаћања',
    invoiceUserSettlement: 'Корисничко измирење фактура',
    invoiceSettlement: 'Измирење фактуре',
    intervention: 'Интервенције'
  },
  activation: {
    title: 'Активација корисника',
    success: 'Корисник успешно активиран',
    activationSent: 'Линк за активацију корисника је послат на вашу адресу електронске поште'
  },
  reset: {
    title: 'Постављање лозинке',
    success: 'Корисничка лозинка успешно постављена'
  },
  issues: {
    reportIssue: 'Пријава проблема',
    reportIssueDetails: 'Информације о рекламацији',
    reportIssueSuccess: 'Проблем успешно пријављен',
    reportIssueLiability: 'Проблем регистрације фактуре',
    reportIssueSettlement: 'Проблем измирења фактуре',
    reportId: 'Идентификатор',
    reportSettlementId: 'Идентификатор измирења',
    reportCategories: 'Категорија проблема',
    reportData: 'Додатне информације',
    reportSettlementAmount: 'Износ измирења',
    reportUserComment: 'Коментар корисника',
    reportOperatorComment: 'Коментар оператера',
    reportColumnCategory: 'Категорија',
    reportColumnCreationDate: 'Датум креирања',
    reportColumnClosingDate: 'Датум затварања',
    reportColumnData: 'Податак',
    reportColumnResourceId: 'Идентификатор',
    reportColumnStatus: 'Статус',
    reportColumnCompanyNumber: 'ЈБКЈС',
    reportIssueStatus: {
      0: 'Све',
      1: 'Активна',
      2: 'Отказана',
      3: 'Решена',
      4: 'Нерешена'
    },
    reportIssueCancel: 'Откажи рекламацију',
    reportIssueResolve: 'Затвори рекламацију',
    reportIssueCancelModal: 'Откажи рекламацију',
    reportIssueCancelModalConfirm: 'Да ли желите да откажете рекламацију?',
    reportIssueCancelSuccess: 'Рекламација успешно отказана',
    reportIssueResolveModal: 'Затвори рекламацију',
    reportIssueResolveSuccess: 'Рекламација успешно затворена',
    reportIssueResolved: 'Означи као решена',
    reportIssueUnresolved: 'Означи као нерешена',
    reportIssueResolveComment: 'Коментар затварања',
    reportIssueUserLogin: 'Корисничко име',
    reportIssueUserName: 'Име и презиме',
    reportIssueUserOrganization: 'Организација',
    reportIssueBank: 'Банка',
    reportIssueBankFeedback: 'Банка мора садржати 3 карактера',
    reportIssueHelpLink: 'Детаљно упутство',
    reportIssues: 'Рекламације',
    reportIssuesActive: 'Активне',
    reportIssuesAll: 'Све'
  },
  register: {
    title: 'Регистрација',
    registrationForbidden: 'Регистрација правног лица/органа није дозвољена у овом тренутку',
    legalEntityInfo: 'Подаци о правном лицу/органу',
    legalEntityCheckboxText: 'Региструјем се као ПРИВАТНО ПРАВНО ЛИЦЕ',
    budgetIdNumber: 'ЈБКЈС*',
    budgetIdNumberFootnote: '*Попуњава правно лице/орган које има додељен ЈБКЈС',
    companyNumber: 'Матични број',
    companyNumberShort: 'МБ',
    taxIdNumber: 'ПИБ',
    parentCompany: 'Надређена институција',
    companyName: 'Назив правног лица/органа',
    legalEntityName: 'Име јавног предузећа',
    address: 'Адреса седишта',
    postalCode: 'Поштански број',
    treasuryBranchInfo: 'Подаци o организационој јединици Управе за Tрезор',
    treasuryBranch: 'Број организационе јединице',
    treasuryBranchNote: 'укуцајте првих неколико слова града/општине и систем ће приказати предлоге',
    email: 'Адреса електронске поште',
    adminInfo: 'Подаци о администратору',
    name: 'Име и презиме',
    personalIdentityNumber: 'ЈМБГ',
    identityNumber: 'Број идентификационе исправе',
    submit: 'Пошаљи захтев за регистрацију',
    infoText: 'Након успешно попуњеног захтева, добићете и-мејл поруку од Управе за Трезор са детаљима корака регистрације.',
    registrationSuccess: 'Регистрација успешно обављена.',
    registrationSuccessText: 'Проверите да ли сте добили потврдни и-мејл од Управе за Трезор. Уколико потврда није стигла, запишите податке са овог обавештења и преузмите регистрациони налог кликом на дугме \'Преузимање захтева\'',
    registrationLimitExceeded: 'Прекорачили сте број сукцесивних захтева за регистрацију, молимо сачекајте 10 секунди па покушајте поново',
    printRequestForm: 'Преузимање захтева',
    printForm: 'Преузимање потврде',
    ouList: 'Листа организационих јединица',
    editRegistration: 'Уколико желите да измените већ поднету регистрацију, притисните дугме \'Учитај регистрацију\' и унесите токен за измену регистрације како бисте учитали регистроване податке.',
    editRegistrationLine2: 'Након унетих измена, сачувајте их притиском на дугме \'Пошаљи захтев за регистрацију\'',
    editRegistrationButton: 'Измени регистрацију',
    editRegistrationToken: 'Токен за измену регистрације',
    editRegistrationLoad: 'Учитавање података за измену',
    registrationLoad: 'Учитај регистрацију'
  },
  invoices: {
    invoiceIndex: 'Индекс фактуре',
    invoiceReview: 'Преглед фактура',
    review: 'преглед',
    invoiceDetails: 'Информације о фактури',
    invoiceId: 'Идентификатор фактуре',
    settlementDetails: 'Информације о измирењима',
    cancelInvoice: 'Откажи фактуру',
    cancel: 'Откажи',
    cancelSettlement: 'Откажи измирење',
    settleInvoice: 'Измири фактуру',
    settlementPaymentId: 'Идентификатор плаћања',
    settlementAmount: 'Износ измирења',
    settlementCreditAccount: 'Рачун одобрења',
    settlementDebitAccount: 'Рачун задужења',
    cancelInvoices: 'Откажи фактурe',
    cancellationUser: 'Отказао',
    cancellationDate: 'Датум отказивања',
    cancellationComment: 'Разлог отказивања',
    cancellationSuccess: 'Фактуре успешно отказане',
    invoiceUserSettle: 'Измирење фактура',
    bank: 'Банка',
    columnCreditor: 'Поверилац',
    columnDebtor: 'Дужник',
    columnId: 'Идентификатор',
    columnBudgetIdNumber: 'ЈБКЈС дужника',
    columnInvoiceNumber: 'Број фактуре',
    columnInvoiceAmount: 'Износ',
    columnInvoiceAmountFrom: 'Oд',
    columnInvoiceAmountTo: 'До',
    columnSelected: 'Означи',
    columnSettlementAmount: 'Износ за измирење',
    columnSettlementDate: 'Датум измирења',
    columnInvoiceStatus: 'Статус',
    columnCreditorName: 'Назив повериоца',
    columnDebtorName: 'Назив дужника',
    columnCreditorBudgetIdNumber: 'ЈБКЈС повериоца',
    columnCreditorTaxId: 'ПИБ повериоца',
    columnCreditorCompanyNumber: 'МБ повериоца',
    columnDueDate: 'Законски рок измирења',
    columnPreviousDueDate: 'Претходни рок измирења',
    columnDueDateRangeFrom: 'Oд',
    columnDueDateRangeTo: 'До',
    columnCreationDate: 'Датум креирања',
    columnCreationDateRangeFrom: 'Од',
    columnCreationDateRangeTo: 'До',
    columnLifetime: 'Рок важења',
    columnSettlementComments: 'Коментар измирења',
    columnSettlementStatus: 'Статус',
    columnSettledAmount: 'Измирени износ',
    invoiceRegistered: 'Фактура успешно регистрована',
    invoicesRegistered: 'Пакет фактура успешно регистрован',
    invoicesPartiallyRegistered: 'Пакет фактура је делимично регистрован',
    invoiceExport: 'Извоз',
    invoiceCancelled: 'Отказана',
    invoiceInvalid: 'Одбијена',
    invoiceActive: 'Активна',
    invoicePartiallySettled: 'Започета',
    invoiceReportedInvalid: 'Невалидна',
    invoiceCancelFailed: 'Отказивање фактуре није успело',
    invoiceExportJson: 'Извоз у ЈСОН',
    invoiceExportCsv: 'Извоз у ЦСВ',
    invoiceExportFailed: 'Извоз фактура није успео',
    invoiceSettled: 'Измирена',
    invoiceStatus: {
      0: 'Све',
      1: 'Активна',
      2: 'Одбијена',
      3: 'Отказана',
      4: 'Започета',
      5: 'Измирена',
      6: 'Асигнирана',
      7: 'Профактура',
      101: 'Отворена'
    },
    settlementStatus: {
      1: 'Активно',
      2: 'Отказано'
    },
    invoiceLimitExceeded: 'Лимит на број упућених захтева за регистрацију фактуре достигнут',
    invoiceCurrency: 'РСД',
    invoicesAsDebtor: 'Као дужник',
    invoicesAsCreditor: 'Као поверилац',
    invoicesAsAdministrator: 'Све фактуре',
    invoiceAssigned: 'Асигнирана',
    invoiceAssignedName: 'Назив асигнанта',
    invoiceAssignedBudgetNumber: 'ЈБКЈС асигнанта',
    invoiceAssignedCompanyNumber: 'МБ асигнанта',
    invoiceAssignedTaxIdNumber: 'ПИБ асигнанта',
    invoiceAssignment: 'Асигнација фактуре',
    invoiceAssignmentInformation: 'Информације о асигнацији',
    invoiceAssignmentContractNumber: 'Број уговора асигнације',
    invoiceAssignmentModal: 'Да ли желите да извршите асигнацију фактуре?',
    invoiceAssignmentCancelModal: 'Да ли желите да откажете асигнацију фактуре?',
    invoiceAssignSuccess: 'Асигнација успешно обављена',
    invoiceAssignCancelSuccess: 'Отказивање асигнације успешно обављено',
    invoiceAssignCancel: 'Откажи асигнацију',
    invoiceAssignIdf: 'Идентификатор додељене фактуре',
    invoiceAssignOriginIdf: 'Идентификатор асигниране фактуре',
    invoiceAssignValidDebtorWarning: 'Асигнацију може спровести искључиво локални корисник правног лица које је фактуром задужено : ',
    invoiceAmountChange: 'Измена износа',
    invoiceAmountChangeAdd: 'Додај измену',
    invoiceAmountChangeSettle: 'Измири',
    invoiceAmountChangeSuccess: 'Измена износа успешно обављена',
    invoiceAmountChangeComment: 'Број књижног одобрења/број књижног задужења',
    invoiceDeltaColumnAmount: 'Износ измене',
    invoiceDeltaColumnComments: 'Коментар измене/отказа',
    invoiceDeltaColumnDate: 'Датум измене/отказа',
    invoiceDeltaCancel: 'Откажи измену',
    invoiceSettlementCancel: 'Откажи измирење',
    invoiceActivationCancel: 'Откажи активацију',
    invoiceNotFound: 'Тражена фактура није пронађена',
    invoiceCancelledComment: 'Коментар отказа:',
    expandSections: 'Отвори све секције',
    collapseSections: 'Затвори све секције',
    cancelSettlementSuccess: 'Успешно сте отказали измирење',
    registerSettlementSuccess: 'Успешно сте регистровали измирење'
  },
  registerInvoice: {
    invoice: 'Фактура',
    registerSingleInvoice: 'Појединачни унос',
    registerMultipleInvoices: 'Групни унос',
    invoiceFileInput: 'Учитавање фајла за групни унос фактура',
    invoiceFileBrowse: 'Претражи',
    invoiceFileNoSelection: 'Фајл није одабран',
    invoiceRegistration: 'Регистрација фактуре',
    debtorBudgetId: 'ЈБКЈС дужника',
    invoiceNumber: 'Број фактуре / Број профактуре',
    amount: 'Износ',
    issuePlace: 'Место издавања',
    issueDate: 'Датум издавања',
    comments: 'Коментар',
    registerInvoice: 'Региструј фактуру',
    groupInvoiceRegistration: 'Пређи на групни унос',
    invoiceFileParse: 'Фајл за групни унос фактура није синтаксно исправан',
    registerInvoiceConfirmation: 'Да ли сте сигурни да желите да региструјете фактуру?',
    registerMultipleErrorList: 'Списак грешака групног уноса фактура',
    registerMultipleSuccessList: 'Списак регистрованих фактура',
    registerMultipleCsvHeaderError: 'Недостаје или је погрешно заглавље (енг: header) у CSV fajlu',
    registerProinvoice: 'Профактура',
    registerProinvoiceLifetime: 'Рок важења у данима',
    registerProinvoiceFootnote: '*Уколико се не наведе рок важења, биће коришћена подразумевана вредност',
    registerProinvoiceLifetimeEmpty: 'Рок важења мора бити у опсегу од 1 до 90 дана'
  },
  groupSettlement: {
    groupSettlementReview: 'Преглед спецификација групних плаћања',
    columnGroupSettlementNumber: 'Бр. спецификације',
    columnCreditor: 'Поверилац',
    columnAmount: 'Износ',
    columnAmountFrom: 'Од',
    columnAmountTo: 'До',
    columnDebtor: 'Дужник',
    columnCreationDate: 'Датум креирања',
    columnCreationDateRangeFrom: 'Од',
    columnCreationDateRangeTo: 'До',
    columnDueDate: 'Најближи законски рок измирења',
    columnDueDateRangeFrom: 'Од',
    columnDueDateRangeTo: 'До',
    columnSettlementDate: 'Датум измирења',
    columnSettlementDateRangeFrom: 'Од',
    columnSettlementDateRangeTo: 'До',
    columnStatus: 'Статус',
    columnInvoiceErrorCode: 'Статус унутар спецификације',
    columnInvoiceCount: 'Број фактура',
    groupSettlementCreator: 'Креирао',
    groupSettlementAddInvoices: 'Додај фактуре',
    groupSettlementCancelAddInvoices: 'Одустани',
    groupSettlementStatus: {
      0: 'Све',
      1: 'У току',
      2: 'Активна',
      3: 'Измирена',
      4: 'Отказана',
      5: 'Невалидна'
    },
    invoiceError: 'Грешка',
    groupSettlementInvoicesShowTable: 'Прикажи као табелу',
    groupSettlementInvoicesShowText: 'Прикажи као текст',
    groupSettlementInvoicesShowInput: 'Прикажи као текстуални унос',
    badgeCancelled: 'Отказана',
    badgeInvalid: 'Невалидна',
    badgeSettled: 'Измирена',
    createNew: 'Додај нову спецификацију групног плаћања',
    groupSettlementRegister: 'Нова спецификација групног плаћања',
    invoiceList: 'Листа фактура спецификације',
    groupSettlementNumber: 'Број спецификације групног плаћања',
    settlementAmount: 'Износ',
    invoiceId: 'Идентификатор фактуре',
    groupSettlementSubmit: 'Kreiraj',
    groupSettlementConfirmation: 'Креирати нову спецификацију групног плаћања?',
    groupSettlementEdit: 'Измени',
    groupSettlementEditSave: 'Сачувај',
    groupSettlementEditConfirmation: 'Изменити спецификацију групног плаћања?',
    groupSettlementBack: 'Натраг',
    groupSettlementEditHeader: 'Измени спецификацију групног',
    groupSettlementSingle: 'Спецификација групног плаћања',
    groupSettlementActivate: 'Активирај',
    groupSettlementActivateTitle: 'Активирај спецификацију групног плаћања',
    groupSettlementActivateTitleDisabled: 'Није могуће активирату спецификацију која садржи невалидне фактуре',
    groupSettlementDeactivate: 'Деактивирај',
    groupSettlementDeactivateTitle: 'Деактивирај спецификацију групног плаћања',
    groupSettlementCancel: 'Откажи',
    groupSettlementCancelTitle: 'Откажи спецификацију групног плаћања',
    groupSettlementActivationConfirmation: 'Активирај спецификацију групног плаћања?',
    groupSettlementDeactivationConfirmation: 'Деактивирај спецификацију групног плаћања?',
    groupSettlementCancelationConfirmation: 'Откажи спецификацију групног плаћања',
    groupSettlementActivated: 'Групна спецификација успешно активирана',
    groupSettlementDeactivated: 'Групна спецификација успешно деактивирана',
    groupSettlementCanceled: 'Групна спецификација успешно отказана',
    groupSettlementEdited: 'Успешно сте изменили спецификацију групног плаћања',
    groupSettlementNoEdit: 'Не можете да мењате већ активирану или отказану спецификацију групног плаћања',
    massInput: 'Фактуре са износима',
    massAdditionalInput: 'Фактуре за додавање у спецификацију',
    invoiceTableHeader: 'Фактуре у групној спецификацији',
    review: 'преглед',
    groupSettlementRegistered: 'Спецификација групног плаћања је успешно регистрована',
    massInputError: {
      tableHeader: 'Списак грешака приликом валидације',
      emptyOrTooFew: 'Спецификација групног плаћања мора садржати барем две (2) фактуре',
      malformedLine: 'Линија: {0}, Погрешно форматирана линија',
      nonNumberAmount: 'Линија: {0}, Износ мора бити број',
      duplicateInvoice: 'Линија: {0}, Фактура се већ налази у листи',
      returnedCodePrefix: 'Problem sa fakturom {0}:'
    },
    groupSettlementFetchingData: 'Добављам податке са сервера',
    groupSettlementFetchingDataFailed: 'Дошло је до неуспеха приликом добављања групне спецификације, молимо вас покушајте поново нешто касније',
    groupSettlementRemoveInvoiceConfirmation: 'Да ли сте сигурни да желите да уклоните изабране фактуре из спецификације групног плаћања?',
    groupSettlementAddInvoiceConfirmation: 'Да ли сте сигурни да желите да додате фактуре у спецификацију групног плаћања ',
    groupSettlementRemoveInvoice: 'Уклони изабране фактуре',
    groupSettlementAddInvoice: 'Додај фактуре',
    selectInvalidInvoices: 'Означи невалидне фактуре',
    groupSettlementInvalidBanner: 'Спецификација групног плаћања није валидна. Измените спефицикацију како бисте уклонили све отказане, измирене или асигниране фактуре.',
    groupSettlementActivateLink: 'Информације о активацији'
  },
  userAdministration: {
    userProfile: 'Кориснички профил',
    administration: 'Управљање корисницима',
    localAdministration: 'Управљање локалним корисницима',
    userDetails: 'Детаљи корисничког налога',
    userDetailsChange: 'Измена корисничког налога',
    userCreate: 'Креирање новог корисника',
    userNotification: 'Постављање нотификације',
    userNotificationCancel: 'Откажи нотификацију',
    details: 'Детаљи',
    userId: 'Идентификатор',
    userOrganizationName: 'Назив правног лица/органа',
    userOrganizationCompanyNumber: 'МБ/ЈБКЈС',
    userLogin: 'Кориснички налог',
    userName: 'Име и презиме',
    userEmail: 'Електронска пошта',
    userRoles: 'Корисничке улоге',
    userRoleDescription: 'Опис корисничке улоге',
    userClaims: 'Корисничка овлашћења',
    userRolesClaims: 'Корисничке улоге и овлашћења',
    userStatus: 'Статус корисника',
    changePassword: 'Промена шифре',
    oldPassword: 'Стара шифра',
    newPassword: 'Нова шифра',
    confirmNewPassword: 'Потврди нову шифру',
    password: 'Шифра',
    confirmPassword: 'Потврди шифру',
    confirmPasswordFail: 'Нова шифра се не подудара са потврдом шифре',
    passwordChanged: 'Нова шифра успешно постављена',
    userChangedId: 'Опозвао корисник',
    userLastChangeDate: 'Датум опозива',
    userChangedComments: 'Коментар опозива',
    personalInformationChange: 'Промена личних података',
    personalInformationChangeConfirmation: 'Да ли сте сигурни да желите да измените податке корисника?',
    registrationInformationChangeConfirmation: 'Да ли сте сигурни да желите да измените податке о регистрацији?',
    apply: 'Примени',
    userRevoke: 'Опозови',
    userRevokeComments: 'Разлог опозива',
    userRevokeConfirmation: 'Да ли сте сигурни да желите да опозовете корисника?',
    userResetPassword: 'Ресетуј лозинку',
    userResetPasswordConfirmation: 'Да ли сте сигурни да желите да ресетујете креденцијале корисника',
    userPasswordHasBeenReset: 'Успешно сте ресетовали креденцијале корисника',
    userPermissionUpdateConfirmation: 'Уколико је корисник већ пријављен на систем у тренутку доделе нових овлашћења, она ступају на снагу тек када се корисник поново пријави на систем',
    userActivate: 'Активирај',
    userActivateConfirmation: 'Да ли сте сигурни да желите да активирате корисника?',
    userActiveStatus: 'Активан',
    userRevokedStatus: 'Опозван',
    userRevoked: 'Корисник успешно опозван',
    userRestored: 'Корисник успешно активиран',
    userPermissionsUpdated: 'Корисничка овлашћења успешно ажурирана',
    userRevokeFailed: 'Опозив корисника није успео',
    userRestoreFailed: 'Активирање корисника није успело',
    userPermissionsUpdateFailed: 'Ажурирање корисничких овлашћења није успело',
    userPermissionsTableFilter: 'Филтрирај',
    userPermissionsTableFilterClear: 'Уклони филтер',
    userCreateConfirmation: 'Креирати новог локалног корисника?',
    userCreated: 'Нови корисник успешно креиран',
    userUpdated: 'Информације о кориснику успешно измењене',
    registrationUpdated: 'Информације о регистрацији успешно измењене',
    notificationId: 'Идентификатор',
    notificationCreator: 'Поставио',
    notificationText: 'Садржај нотификације',
    notificationPriority: 'Приоритет',
    notificationPriorityStatus: {
      0: 'Све',
      1: 'Низак',
      2: 'Нормалан',
      3: 'Висок'
    },
    notificationValidUntil: 'Датум застаревања',
    notificationCreatedDate: 'Датум постављања',
    notificationCreate: 'Постави нотификацију',
    notificationEdit: 'Измени нотификацију',
    notificationCreated: 'Нотификација успешно постављена',
    notificationUpdated: 'Нотификација успешно измењена',
    notificationFailed: 'Постављање нотификације неуспешно',
    targetPublicUsers: 'Табела обухвата',
    targetPublicUsersAppend: 'Додај корисника',
    targetPublicUsersAppendSuccess: 'Корисник успешно додат у табелу обухвата',
    targetPublicUsersRemove: 'Уклони корисника',
    targetPublicUsersRemoveSuccess: 'Корисник успешно уклоњен из табеле обухвата',
    Claim_Admin: 'Администрација',
    Claim_User_Create: 'Креирање корисника',
    Claim_User_Review: 'Преглед корисника',
    Claim_User_Revoke: 'Опозив корисника',
    Claim_Local_User_Create: 'Креирање локалног корисника',
    Claim_Local_User_Review: 'Преглед локалног корисника',
    Claim_Local_User_Revoke: 'Опозив локалног корисника',
    Claim_Invoice_Create: 'Креирање фактуре',
    Claim_Invoice_Cancel: 'Отказивање фактуре',
    Claim_Invoice_Cancel_All: 'Отказивање свих фактура',
    Claim_Invoice_Review: 'Преглед фактуре',
    Claim_Invoice_Review_All: 'Преглед свих фактура',
    Claim_Invoice_Export: 'Извоз фактуре',
    Claim_Invoice_Assign: 'Асигнација фактуре',
    Claim_Invoice_Settle: 'Поравнање фактуре',
    Claim_Invoice_Invalidate: 'Одбијање фактуре',
    Claim_Invoice_User_Settle: 'Корисничко измирење фактуре',
    Claim_Anonymous_Access: 'Анонимни приступ',
    Claim_Notification_Create: 'Постављање нотификације',
    Claim_Registration_Edit: 'Измена регистрације',
    Claim_Registration_Review: 'Преглед регистрације',
    Claim_Invoice_Amount_Change: 'Измена износа фактуре',
    Claim_Invoice_Activate: 'Измена износа измирене фактуре (вишеструка)',
    Claim_Invoice_Activate_Once: 'Измена износа измирене фактуре',
    Claim_Issue_Resolve: 'Затварање рекламације',
    Claim_Group_Settlement_Create: 'Креирање спецификације групног плаћања',
    Role_Administrator: 'Администратор',
    Role_Operator: 'Оператер трезора',
    Role_Local_Administrator: 'Локални администратор',
    Role_Local_User: 'Локални корисник',
    Role_Local_JPAdministrator: 'Локални администратор ЈП/ЈКП',
    Role_Local_JPUser: 'Локални корисник ЈП/ЈКП',
    Role_Control: 'Инспекцијска контрола',
    Role_Jafin_User: 'Интегративни сервис ЈАФИН',
    entityStatuses: {
      0: 'Активан',
      3: 'Привремено неактиван',
      9: 'Угашен'
    },
    userStatuses: {
      0: 'Сви',
      1: 'Активан',
      2: 'Неактиван',
      3: 'Опозван',
      4: 'Деактивиран'
    },
    userPasswordRequirement: {
      0: 'Шифра мора садржати најмање 8 карактера',
      1: 'Шифра мора садржати бројеве',
      2: 'Шифра мора садржати велика слова',
      3: 'Шифра мора садржати симболе'
    },
    userLoginRequirement: {
      0: 'Кориснични налог може садржати латинична слова енглеске абецеде',
      1: 'Кориснични налог може садржати бројеве',
      2: 'Кориснични налог може садржати симболе \'.\' , \'_\' ',
      3: 'Кориснични налог мора почети и завршити се са словом или бројем',
      4: 'Кориснични налог може садржати максимално 32 карактера'
    },
    ungroupedClaims: 'Остала овлашћења',
    Role_Administrator_Description: 'Администрација са свим привилегијама и овлашћењима',
    Role_Operator_Description: 'Оператер управе за трезор са овлашћењима креирања приступа систему новим правним лицима/органима',
    Role_Local_Administrator_Description: 'Администрација правних лица/органа',
    Role_Local_User_Description: 'Локални корисник правног лица/органа',
    Role_Local_JPAdministrator_Description: 'Администрација ЈП/ЈКП',
    Role_Local_JPUser_Description: 'Локални корисник ЈП/ЈКП',
    Role_Control_Description: 'Инспекцијска контрола са овлашћењима за преглед свих фактура',
    Ungrouped_Description: 'Некатегоризована овлашћења корисничких улога'
  },
  userRegistration: {
    registrationHeader: 'Регистрација правног лица/органа',
    registrationInstitution: 'Подаци о правном лицу/органу',
    registrationId: 'Број захтева',
    registrationBudgetId: 'ЈБКЈС',
    registrationCompanyNumber: 'Матични број',
    registrationCompanyNumberShort: 'MB',
    registrationTaxIdNumber: 'ПИБ',
    registrationParentInstitution: 'Надређена институција',
    registrationName: 'Назив правног лица/органа',
    registrationShortName: 'Назив',
    registrationEmail: 'Електронска пошта',
    registrationEntityType: 'Тип КЈС',
    registrationActivity: 'Активност',
    registrationCouncil: 'Место',
    registrationDirectBudgetCode: 'Шифра директног БК',
    registrationPhoneNumber: 'Телефон',
    registrationPostOfficeNumber: 'Поштански број',
    registrationAddress: 'Адреса',
    registrationAdmin: 'Подаци о администратору',
    registrationAdminName: 'Име и презиме',
    registrationAdminIdentityNumber: 'Број идентификационе исправе',
    registrationAdminPersonalIdentityNumber: 'ЈМБГ',
    registrationAdminEmail: 'Електронска пошта',
    registrationAdminPhoneNumber: 'Број телефона',
    registrationCreationDate: 'Датум подношења захтева',
    registrationRegistrationDate: 'Датум регистрације',
    registrationRegistered: 'Регистрован',
    registrationAdminActivate: 'Активација администраторског налогa',
    registrationApproved: 'Регистрација правног лица/органа успешно одобрена',
    registrationCancelled: 'Регистрација правног лица/органа успешно отказана',
    registrationActivate: 'Активирај налог',
    registrationCancel: 'Откажи налог',
    registrationStatus: 'Статус регистрације',
    registrationStatuses: {
      0: 'Сви',
      1: 'У току',
      2: 'Одобрена',
      3: 'Отказана'
    },
    registrationApprovedUser: 'Регистрацију одобрио',
    registrationCancelledUser: 'Регистрацију отказао',
    registrationApprovalDate: 'Датум одобравања',
    registrationCancelConfirmationText: 'Да ли сте сигурни да желите да откажете регистрацију?',
    registrationApproveConfirmationText: 'Да ли сте сигурни да желите да одобрите регистрацију?',
    registrationFormTitle: 'Захтев за регистрацију',
    adminFormTitle: 'Потврда за предају корисничког налога',
    registrationApprovedDate: 'Регистрација одобрена',
    invoiceLimitChangeText: 'Месечни лимит на број регистрованих фактура',
    addressChangeText: 'Адреса организације',
    nameChangeText: 'Назив организације',
    noInvoiceLimitText: 'Нема лимита',
    invoiceLimitChangedText: 'Месечни лимит на број регистрованих фактура успешно измењен',
    registrationChangedText: 'Подаци о регистрацији успешно измењени',
    entityType: 'Тип корисника'
  },
  datatable: {
    toggleAll: 'Означи све',
    filter: 'Филтрирај',
    perPage: 'Број приказа по страни',
    range: 'Приказ од {0} до {1} од укупно {2} података',
    rangePartial: 'Приказ од {0} до {1} од преко {2} података',
    noData: 'Нема података',
    generateReport: 'Генериши извештај',
    generateReportModalText: 'Да ли сте сигурни да желите да генеришете извештај према тренутним подацима?'
  },
  message: {
    title: 'Регистар Фактура',
    welcome: 'Добродошао',
    login: 'Пријава',
    documentation: 'Документација',
    signout: 'Одјава',
    profile: 'Профил',
    externalLinks: 'Спољни линкови'
  },
  apiStatusCodes: {
    0: 'Није могуће успоставити конекцију, покушајте поново након пар минута',
    400: 'Обрада захтева није успела',
    401: 'Грешка приликом ауторизације корисника',
    403: 'Немате одговарајуће корисничке привилегије',
    404: 'Није пронађена захтевана страна',
    429: 'Лимит на број упућених захтева је достигнут',
    500: 'Грешка приликом употребе сервиса, молимо контактирајте техничку подршку',
    1001: 'Податак ЈБКЈС није исправан',
    1002: 'Податак ПИБ није исправан',
    1003: 'Податак Матични број није исправан',
    1004: 'Податак ПИБ надређене институције није исправан',
    1005: 'Податак Матични број надређене институције није исправан',
    1006: 'Податак Име компаније или јавног предузећа није исправан',
    1007: 'Податак Адреса седишта није исправан',
    1008: 'Податак Број телефона није исправан',
    1009: 'Податак И-мејл компаније није исправан',
    1010: 'Податак Испостава трезора није исправан',
    1011: 'Податак Име и презиме администратора није исправан',
    1012: 'Податак ЈМБГ администратора није исправан',
    1013: 'Податак Број идентификационе исправе администратора није исправан',
    1014: 'Податак И-мејл администратора није исправан',
    1015: 'Податак Број телефона администратора није исправан',
    1016: 'Податак Број фактуре није исправан',
    1017: 'Податак Износ није исправан',
    1018: 'Податак Датум издавања није исправан',
    1019: 'Податак Коментар није исправан',
    1025: 'Податак Месечни лимит на број регистрованих фактура није исправан',
    1101: 'Податак Кориснички налог није исправан',
    1102: 'Податак Име и презиме корисника није исправан',
    1103: 'Податак Електронска пошта корисника није исправан',
    1104: 'Податак Шифра корисника није исправан',
    1105: 'Унета шифра не задовољава критеријум',
    1107: 'Коментар опозива није исправан',
    1200: 'Фактура није исправна',
    1201: 'Број фактуре није исправан',
    1202: 'Износ није исправан',
    1203: 'Датум издавања није исправан',
    1204: 'Коментар није исправан',
    1205: 'ЈБКЈС дужника није исправан',
    1206: 'Место издавања није исправан',
    1207: 'Идентификатор фактуре није исправан',
    1208: 'Разлог отказивања није исправан или садржи недозвољене симболе',
    1209: 'Број унетих фактура превазилази ограничење',
    1210: 'ЈБКЈС дужника није исправан',
    1211: 'Број уговора асигнације није исправан',
    1212: 'Рок важења мора бити у опсегу од 1 до 90 дана',
    1300: 'Измирење није исправно',
    1301: 'Шифра банке није исправна',
    1302: 'ПИБ повериоца није исправан',
    1303: 'МБ повериоца није исправан',
    1304: 'Износ измирења није исправан',
    1305: 'ЈБКЈС дужника није исправан',
    1306: 'Број фактуре није исправан',
    1308: 'Коментар измирења није исправан',
    1311: 'Датум измирења није исправан',
    1312: 'Податак за рекламацију измирења није исправан',
    1313: 'Рачун одобрења измирења није исправан',
    1314: 'Рачун задужења измирења није исправан',
    1400: 'Нотификација није исправна',
    1401: 'Приоритет нотификације није исправан',
    1402: 'Датум застаревања нотификације није исправан',
    1403: 'Садржај нотификације није исправан',
    1404: 'Статус нотификације није исправан',
    1501: 'Тражени број података по страни није исправан',
    1601: 'Идентификатор фактуре није исправан',
    1602: 'Износ измене није исправан',
    1603: 'Коментар измене није исправан или садржи недозвољене симболе',
    1604: 'Идентификатор измене није исправан',
    1605: 'Коментар отказа измене није исправан или садржи недозвољене симболе',
    1701: 'ЦРФ ресурс није исправан',
    1702: 'Идентификатор ресурса није исправан',
    1703: 'Категорија проблема није исправна',
    1704: 'Додатне информације о проблему нису исправне',
    1705: 'Коментар проблема није исправан',
    1707: 'Коментар оператера није исправан',
    1802: 'Број спецификације групног плаћања садржи невалидне карактере',
    2001: 'Захтев за регистрацију не садржи податке',
    2002: 'ЈБКЈС јавног предузећа није валидан',
    2003: 'МБ и ПИБ приватног правног лица нису валидни',
    2004: 'Захтев за регистрацију већ поднет',
    2005: 'Слање конфирмационог имејла није успело',
    2008: 'Наведена испостава трезора није исправна',
    2009: 'Идентификатор регистрације није наведен приликом отказивања',
    2011: 'Наведени МБ и ПИБ не одговарају унетом ЈБКЈС',
    2012: 'Токен за измену регистрације не садржи валидне податке',
    2013: 'Регистрација коју покушавате да измените је одобрена или отказана',
    2014: 'Покушавате да се региструјете без унетог ЈБКЈС који вам је додељен',
    2901: 'Грешка приликом преузимања података о регистрацији. Молимо контактирајте техничку подршку',
    3000: 'Корисник није регистрован у систему или немате одговарајуће корисничке привилегије',
    3001: 'Кориснички креденцијали нису исправни',
    3002: 'Токен корисника није валидан',
    3003: 'Помоћни токен није пронађен',
    3006: 'Корисник још увек није активиран',
    3007: 'Корисник је опозван',
    3008: 'Дужина шифре није валидна',
    3009: 'Шифра мора садржати бројеве',
    3010: 'Шифра мора садржати велика слова',
    3011: 'Шифра мора садржати симболе',
    3012: 'Корисник је деактивиран',
    3014: 'Прекорачен број неуспелих покушаја, пријава блокирана (у секундама)',
    3015: 'Корисник није валидан или припада погрешној организацији',
    3900: 'Непозната грешка приликом креирања приступног токена',
    3901: 'Непозната грешка приликом генерисања помоћног токена',
    3902: 'Непозната грешка приликом добијања података о кориснику',
    4000: 'Нису пронађене валидне информације за регистрацију корисника',
    4003: 'Наведени корисник није регистрован на систему',
    4006: 'Није пронађен валидан активациони токен',
    4007: 'Корисник је већ активан на систему',
    4009: 'Креирање новог корисника није успело',
    4011: 'Наведени корисник није активан на систему',
    4012: 'Промена статуса није успела или немате одгаваруће привилегије',
    4013: 'Покушано је додавање недозвољених привилегија',
    4017: 'Корисник није у могућности да деактивира самог себе',
    4018: 'Ажурирање привилегија администрације није дозвољено',
    4019: 'Није дозвољено креирање корисника без привилегија',
    4020: 'Активација угашеног корисника није дозвољена',
    4021: 'Измена корисничких информација није успела',
    4022: 'Приоритет нотификације није исправан',
    4023: 'Статус нотификације није исправан',
    4906: 'Грешка приликом активације корисника, молимо покушајте поново',
    4912: 'Непозната грешка приликом измене корисничких података',
    4905: 'Одобравање корисника је неуспешно',
    4915: 'Кориснички тип Оператор није дозвољен за организацију',
    4916: 'Корисничко право за тип Оператор није дозвољено за организацију',
    4917: 'Није унета исправна корисничка лозинка',
    6001: 'Грешка у валидацији фактуре',
    6002: 'Вишеструка грешка приликом регистрације фактура',
    6003: 'Једна или више фактура није пронађена, проверите валидност идентификатора фактуре',
    6006: 'Тражена фактура је већ измирена',
    6010: 'Овлашћење за отказивање не постоји или је започето измирење',
    6011: 'Тражена фактура је отказана',
    6013: 'Максималан дозвољен број фактура премашен',
    6018: 'Премашена толеранса за измирени износ',
    6019: 'Број фактуре је обавезан',
    6020: 'Број фактуре садржи невалидан почетни симбол',
    6021: 'Број фактуре садржи невалидан крајњи симбол',
    6023: 'Није могућа асигнација већ асигниране фактуре',
    6024: 'Покушана је асигнација од стране невалидног дужника',
    6025: 'Није могућа поновна асигнација већ асигниране фактуре',
    6027: 'Отказивање асигниране фактуре није успело',
    6028: 'Није могуће измирење на асигнираној фактури',
    6029: 'Број фактуре садржи невалидан симбол',
    6030: 'Регистрација фактуре повериоцу није дозвољена',
    6032: 'Премашена дужина броја фактуре - дозвољено 22 карактера',
    6033: 'Унети ЈБКЈС дужника није исправан или дужник више није активан',
    6034: 'Унети ЈБКЈС припада типу правног лица/органа који не може бити дужник',
    6039: 'Измена износа фактуре премашује вредност измиреног износа',
    6041: 'Измена износа фактуре је дозвољена само повериоцу фактуре',
    6042: 'Асигнација фактуре самом себи није дозвољена',
    6043: 'Износ фактуре након измене не сме бити нула',
    6044: 'Унети ЈБКЈС припада правном лицу/органу који не може бити дужник',
    6046: 'Нису пронађене исправне информације о отказу фактуре',
    6047: 'Нису пронађене исправне информације о кориснику који је отказао фактуру',
    6055: 'Категорија проблема не одговара одабраном ЦРФ ресурсу',
    6056: 'Одабрана категорија проблема захтева додатне информације',
    6057: 'Нису пронађене валидне рекламације',
    6060: 'Рекламација није активна или не припада организацији',
    6067: 'Није пронађена валидна групна спецификациј плаћања',
    6068: 'Број групне спецификације плаћања није пронађен',
    6069: 'Број спецификације групног плаћања има погрeшан први карактер',
    6070: 'Број спецификације групног плаћања има погрeшан последњи карактер',
    6071: 'Број спецификације групног плаћања садржи невалидни карактер',
    6072: 'Број спецификације групног плаћања има невалидну дужину',
    6073: 'Поље за фактуре не садржи податке',
    6074: 'Невалидна фактура за спецификацију груног плаћања',
    6075: 'Спецификација групног плаћања садржи исту фактуру више пута',
    6076: 'Ниједна валидна спецификација групног плаћања није сачувана',
    6077: 'Спецификација групног плаћања је празна',
    6078: 'Нема валидних ставки за спецификацију групног плаћања',
    6079: 'Ниједна валидна спецификација групног плаћања није измењена',
    6080: 'Спецификација групног плаћања је отказана',
    6081: 'Спецификација групног плаћања је измирена',
    6082: 'Захтев за спецификацију групног плаћања нема податке',
    6083: 'Захтев за промену статуса спецификације групног плаћања је празан',
    6084: 'Непознат поверилац за спецификацију групног плаћања',
    6085: 'Невалидан износ за спецификацију групног плаћања',
    6086: 'Невалидна ставка за спецификацију групног плаћања',
    6087: 'Невалидан статус за спецификацију групног плаћања',
    6088: 'Спецификација групног плаћања је невалидна',
    6089: 'Невалидан износ за фактуру унутар спецификације групног плаћања',
    6090: 'Спецификација групног плаћања је активна',
    6091: 'Спецификација групног плаћања садржи једну фактуру',
    6092: 'Измирени износ фактуре је промењен за спецификацију групног плаћања',
    6093: 'Износ фактуре је промењен за спецификацију групног плаћања',
    6094: 'Статус фактуре је промењен за спецификацију групног измирења',
    6095: 'Непознат фактура или организација',
    6096: 'Невалидни дужник фактуре',
    6097: 'Максималан дозвољен број фактура за спецификацију групног плаћања премашен',
    6102: 'Датум важења профактуре мора бити у будућности',
    6103: 'Рок важења мора бити у опсегу од 1 до 90 дана',
    6106: 'Фактура је већ регистрована у активној спецификацији групног плаћања',
    6108: 'Прекорачен је месечни лимит за број регистрованих фактура',
    6128: 'Корисничко измирење фактуре је дозвољено само дужницима дате фактуре са привилегијом за измирење фактуре',
    6131: 'Прекорачен је месечни лимит на број отказаних фактура за организацију',
    6144: 'Вредност филтера мора имати минимум 3 карактера',
    6162: 'Није пронађен валидан платни налог на основу идентификатора плаћања',
    6167: 'Корисничко измирење није дозвољено на нивоу организације',
    6168: 'Корисничко отказивање измирења није дозвољено на дато измирење',
    6170: 'Максималан дозвољени број корисничких измирења је премашен',
    6171: 'Спецификација групног измирења није доступна корисницима ЈП/ЈКП који ручно измирују фактуре',
    6901: 'Непозната грешка приликом регистрације фактуре',
    6902: 'Непозната грешка приликом претраге фактуре',
    6904: 'Отказ фактуре није успео или нисте поверилац фактуре',
    6916: 'Непозната грешка приликом дохватања спецификације групног плаћања',
    54100: 'Регистрацију није могуће одобрити',
    54200: 'Није могуће ажурирати хијерархију корисника',
    54300: 'Корисничко име већ постоји на систему, измените корисничко име па покушајте поново',
    54400: 'Корисника није могуће додати на систем, молимо сачекајте 10 секунди па покушајте поново',
    54500: 'Корисник је већ активан на систему',
    54600: 'Није успело додавање новог локалног корисника',
    54900: 'Покушано је додавање корисника са недозвољеним привилегијама',
    55000: 'Достигнут је максималан број корисника по организацији',
    55100: 'Није дозвољена измена корисника са вишим привилегијама',
    56000: 'Непозната грешка приликом регистрације фактуре',
    56100: 'Унети ЈБКЈС није исправан',
    56200: 'Унета фактура је већ регистрована',
    56700: 'Фактура већ постоји или је већ асигнирана',
    56900: 'Скидање статуса асигнације са фактуре није успело',
    57000: 'Отказивање асигниране фактуре није успело',
    58200: 'Нисте поверилац тражене фактуре или статус фактуре не дозвољава измену износа',
    58400: 'Измена износа не постоји или је већ отказана',
    58500: 'Достигнут је максималан број измена износа фактуре',
    58600: 'Достигнут је максималан број активација фактуре',
    71300: 'Фактура или спецификација групног плаћања са истим подацима је већ регистрована'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Дошло је до грешке. Проверите списак грешака испод',
    token: {
      refreshTokenExpired: 'Обновљиви токен је истекао',
      failedToRefreshToken: 'Грешка приликом добијања приступног токена након освежавања'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Унети критеријум \'{query}\' задовоља више од {limit} резултата. Сузите критеријум или наставите претрагу на {url}',
    urlText: 'spisku KJS'
  },
  notifications: {
    apply: 'Примени',
    title: 'Обавештења',
    subscribe: 'Претплатa на обавештења',
    selectNotificationType: 'Селектујте догађај за који желите да Вас обавештавамо',
    subscribedIssueSuccessfully: 'Успешно сте се претплатили за нотификације за изабрану рекламацију',
    unsubscribedIssueSuccessfully: 'Успешно сте се одјавили са нотификација за изабрану рекламацију'
  },
  userSettings: {
    regionalHeader: 'Лична подешавања',
    regionalSubheader: 'Регионална Подешавања',
    dateFormat: 'Формат датума',
    dateLocalization: 'Локализација датума',
    decimalFormat: 'Децимални формат',
    csvSeparator: '\'CSV\' раздвајач',
    language: 'Језик',
    settingsSavedSuccess: 'Успешно промењена регионална подешавања',
    settingsSavedFail: 'Грешка приликом снимања регионалних подешавања'
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var Console = {
  methods: {
    logConsole: function logConsole(obj) {
      if ("Ptest".toUpperCase() !== 'production'.toUpperCase()) {
        console.log(obj);
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(Console);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    exportRegistration: function exportRegistration(registration, headerImage) {
      __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

      var header = [];
      if (!this.browserIE11()) {
        header.push({
          image: this.getBase64Image(headerImage),
          width: 40,
          height: 65,
          alignment: 'left'
        });
      }
      header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА' + '\n' + 'Управа за трезор', fontSize: 10 });
      header.push({ text: '\n\n' + 'Образац ЦРФ-1' + '\n' + 'Централни регистар фактура', fontSize: 10, alignment: 'right' });

      var docDefinition = {
        content: [{
          columns: header
        }, { text: '\n\n' + __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('userRegistration.registrationFormTitle') + '\n\n\n', style: 'header' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.legalEntityInfo') + '\n\n', style: 'subheader' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.budgetIdNumber') + ' : ', fontSize: 12 }, { text: registration.budgetNumber, style: 'value' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.budgetIdNumberFootnote') + '\n\n', style: 'small' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.companyName') + ' : ', fontSize: 12 }, { text: registration.name + '\n\n', style: 'value' }, {
          columns: [[{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.companyNumber') + ' : ', fontSize: 12 }, { text: registration.companyNumber + '\n\n', style: 'value' }], [{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.taxIdNumber') + ' : ', fontSize: 12 }, { text: registration.taxIdNumber + '\n\n', style: 'value' }]]
        }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.address') + ' : ', fontSize: 12 }, { text: registration.address + '\n\n', style: 'value' }, {
          columns: [[{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.email') + ' : ', fontSize: 12 }, { text: registration.email + '\n\n', style: 'value' }], [{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('general.phone') + ' : ', fontSize: 12 }, { text: registration.phoneNumber + '\n\n\n', style: 'value' }]]
        }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.adminInfo') + '\n\n', style: 'subheader' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.name') + ' : ', fontSize: 12 }, { text: registration.adminName + '\n\n', style: 'value' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.identityNumber') + ' : ', fontSize: 12 }, { text: registration.adminIdentityNumber + '\n\n', style: 'value' }, {
          columns: [[{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.email') + ' : ', fontSize: 12 }, { text: registration.adminEmail + '\n\n', style: 'value' }], [{ text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('general.phone') + ' : ', fontSize: 12 }, { text: registration.adminPhoneNumber + '\n\n\n', style: 'value' }]]
        }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.treasuryBranchInfo') + '\n\n', style: 'subheader' }, { text: __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t('register.treasuryBranch') + ' : ', fontSize: 12 }, { text: registration.treasuryBranch + '\n', style: 'value' }, {
          columns: [{ text: '_____________________________', fontSize: 12, alignment: 'right', margin: [0, 35, 15, 5] }]
        }, {
          columns: [{ text: 'М.П. Потпис одговорног лица' + '\n\n\n', fontSize: 11, alignment: 'right', margin: [0, 0, 15, 0] }]
        }, {
          columns: [{ text: '*Kада је потписник овлашћења привредни субјекат не постоји обавеза овере печатом', alignment: 'left', style: 'small' }]
        }],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          value: {
            fontSize: 12,
            bold: true
          },
          subheader: {
            fontSize: 14,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 9
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('nalog.pdf');
    },
    getBase64Image: function getBase64Image(img) {
      if (this.browserIE11()) {
        return;
      }

      // Create an empty canvas element
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      // Copy the image contents to the canvas
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      return canvas.toDataURL('image/png');
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_cookie__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_papaparse__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  methods: {
    isProductionEnvironment: function isProductionEnvironment() {
      return "Ptest".toUpperCase() === 'production'.toUpperCase();
    },
    formatErrorResponse: function formatErrorResponse(error, limitError) {
      var apiErrorLink = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.help_root + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.apiCodes;
      var errorMessage = '';
      var errorLink = '';
      var multipleErrors = [];
      if (error.status === 422) {
        for (var i = 0; i < error.data.errors.length; i++) {
          var messageItem = {};
          if (error.data.errors[i].code === 1105 || error.data.errors[i].code === 1201 || error.data.errors[i].code === 1212) {
            var message = error.data.errors[i].message.split('-');
            messageItem.msg = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('apiStatusCodes.' + message[0]);
            messageItem.link = apiErrorLink + error.data.errors[i].code;
            multipleErrors.push(messageItem);
          } else {
            messageItem.msg = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('apiStatusCodes.' + error.data.errors[i].code);
            messageItem.link = apiErrorLink + error.data.errors[i].code;
            multipleErrors.push(messageItem);
          }
        }
      } else if (error.status === 429) {
        if (limitError && limitError.length > 0) {
          errorMessage = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t(limitError);
          errorLink = apiErrorLink + error.status;
        } else {
          errorMessage = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('apiStatusCodes.429');
          errorLink = apiErrorLink + error.status;
        }
      } else {
        if (error.data && error.data.status && error.data.status.code) {
          errorMessage = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('apiStatusCodes.' + error.data.status.code);
          errorLink = apiErrorLink + error.data.status.code;
          if (error.data.additionalInformation && error.data.additionalInformation.length > 0) {
            errorMessage += ' : ' + error.data.additionalInformation;
            errorLink = apiErrorLink + error.data.status.code;
          }
        } else {
          errorMessage = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('apiStatusCodes.' + error.status);
          errorLink = apiErrorLink + error.status;
        }
      }
      __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
        variant: 'danger',
        message: errorMessage,
        link: errorLink,
        errors: multipleErrors
      });
    },
    formatDate: function formatDate(date) {
      if (date === null || date === undefined) {
        return '';
      }
      var formattedDate = new Date(date);
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(this.$store.getters.dateFormat) + ' ' + formattedDate.toLocaleTimeString(this.$store.getters.dateLocale);
    },
    formatShortDate: function formatShortDate(date) {
      if (date === null || date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(this.$store.getters.dateFormat);
    },
    formatAmount: function formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return '';
      }
      var decimalSep = this.$store.getters.decimalFormat === ',' ? '.' : ',';
      var val = (amount / 1).toFixed(2);
      if (this.$store.getters.decimalFormat === ',') {
        val = val.replace('.', ',');
      }
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, decimalSep);
    },
    convertCSVseparator: function convertCSVseparator(data) {
      var parsedData = __WEBPACK_IMPORTED_MODULE_6_papaparse___default.a.parse(new TextDecoder('utf-8').decode(data));
      return __WEBPACK_IMPORTED_MODULE_6_papaparse___default.a.unparse(parsedData, { delimiter: this.$store.getters.csvDelimmeter });
    },
    saveToFile: function saveToFile(url, payload, filename, callback) {
      var _this = this;

      var transform = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      this.$http.post(url, payload, { responseType: 'arraybuffer' }).then(function (response) {
        _this.logConsole(response);
        var headers = response.headers;
        var data = response.data;
        if (transform !== false && typeof transform === 'function') {
          data = transform(data);
        }
        var blob = new Blob([data], { type: headers['content-type'] });
        __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, filename);
        callback();
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        callback();
      });
    },
    saveToJson: function saveToJson(data, filename, callback) {
      this.logConsole(data);
      var blob = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)], { type: 'application/json' });
      __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, filename);
      callback();
    },
    saveToText: function saveToText(data, filename, callback) {
      this.logConsole(data);
      var blob = new Blob(data, { type: 'text/plain' });
      __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(blob, filename);
      callback();
    },
    transliterate: function transliterate(word) {
      var answer = '';
      var a = {};

      a['A'] = 'A';a['a'] = 'a';
      a['B'] = 'Б';a['b'] = 'б';
      a['V'] = 'В';a['v'] = 'в';
      a['G'] = 'Г';a['g'] = 'г';
      a['D'] = 'Д';a['d'] = 'д';
      a['Đ'] = 'Ђ';a['đ'] = 'ђ';
      a['E'] = 'Е';a['e'] = 'е';
      a['Ž'] = 'Ж';a['ž'] = 'Ж';
      a['Z'] = 'З';a['z'] = 'з';
      a['I'] = 'И';a['i'] = 'и';
      a['J'] = 'Ј';a['j'] = 'ј';
      a['K'] = 'К';a['k'] = 'к';
      a['L'] = 'Л';a['l'] = 'л';
      a['Lj'] = 'Љ';a['lj'] = 'љ';
      a['M'] = 'М';a['m'] = 'м';
      a['N'] = 'Н';a['n'] = 'н';
      a['NJ'] = 'Њ';a['nj'] = 'њ';
      a['O'] = 'О';a['o'] = 'о';
      a['P'] = 'П';a['p'] = 'п';
      a['R'] = 'Р';a['r'] = 'р';
      a['S'] = 'С';a['s'] = 'с';
      a['T'] = 'Т';a['t'] = 'т';
      a['Ć'] = 'Ћ';a['ć'] = 'ћ';
      a['U'] = 'У';a['u'] = 'у';
      a['F'] = 'Ф';a['f'] = 'ф';
      a['H'] = 'Х';a['h'] = 'х';
      a['C'] = 'Ц';a['c'] = 'ц';
      a['Č'] = 'Ч';a['č'] = 'ч';
      a['DŽ'] = 'Џ';a['dž'] = 'џ';
      a['Š'] = 'Ш';a['š'] = 'ш';

      for (var i in word) {
        if (word.hasOwnProperty(i)) {
          if (a[word[i]] === undefined) {
            answer += word[i];
          } else {
            answer += a[word[i]];
          }
        }
      }
      return answer;
    },
    toBoldLatin: function toBoldLatin(word) {
      var answer = '';
      var a = {};

      a['А'] = 'a';a['а'] = 'a';
      a['Б'] = 'b';a['б'] = 'b';
      a['В'] = 'v';a['в'] = 'v';
      a['Г'] = 'g';a['г'] = 'g';
      a['Д'] = 'd';a['д'] = 'd';
      a['Ђ'] = 'dj';a['ђ'] = 'dj';
      a['Е'] = 'e';a['е'] = 'e';
      a['Ж'] = 'z';a['ж'] = 'z';
      a['З'] = 'z';a['з'] = 'z';
      a['И'] = 'i';a['и'] = 'i';
      a['Ј'] = 'j';a['ј'] = 'j';
      a['К'] = 'k';a['к'] = 'k';
      a['Л'] = 'l';a['л'] = 'l';
      a['Љ'] = 'lj';a['љ'] = 'lj';
      a['М'] = 'm';a['м'] = 'm';
      a['Н'] = 'n';a['н'] = 'n';
      a['Њ'] = 'nj';a['њ'] = 'nj';
      a['О'] = 'o';a['о'] = 'o';
      a['П'] = 'p';a['п'] = 'p';
      a['Р'] = 'r';a['р'] = 'r';
      a['С'] = 's';a['с'] = 's';
      a['Т'] = 't';a['т'] = 't';
      a['Ћ'] = 'c';a['ћ'] = 'c';
      a['У'] = 'u';a['у'] = 'u';
      a['Ф'] = 'f';a['ф'] = 'f';
      a['Х'] = 'h';a['х'] = 'h';
      a['Ц'] = 'c';a['ц'] = 'c';
      a['Ч'] = 'c';a['ч'] = 'c';
      a['Џ'] = 'dz';a['џ'] = 'dz';
      a['Ш'] = 's';a['ш'] = 's';
      a['Č'] = 'c';a['č'] = 'c';
      a['Ć'] = 'c';a['ć'] = 'c';
      a['Š'] = 's';a['š'] = 's';
      a['Đ'] = 'dj';a['đ'] = 'dj';
      a['Ž'] = 'z';a['ž'] = 'z';

      for (var i in word) {
        if (word.hasOwnProperty(i)) {
          if (a[word[i]] === undefined) {
            var letters = /^[0-9a-zA-Z ]+$/;
            if (word[i].match(letters)) {
              answer += word[i];
            }
          } else {
            answer += a[word[i]];
          }
        }
      }
      return answer;
    },
    saveTabState: function saveTabState(tabDescription, tabState) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_cookie__["n" /* setTabsInfo */])(tabDescription, tabState);
    },
    loadTabState: function loadTabState(tabDescription) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_cookie__["o" /* getTabsInfo */])(tabDescription);
    },
    changeTabState: function changeTabState(self, tabRef, tabDescription) {
      var namedTabTitle = '';
      for (var i = 0; i < self.headers.length; i++) {
        if (self.headers[i].value.localeCompare(tabDescription) === 0) {
          namedTabTitle = self.headers[i].title;
          break;
        }
      }

      for (var _i = 0; _i < tabRef.tabs.tabs.length; _i++) {
        if (tabRef.tabs.tabs[_i].title.localeCompare(namedTabTitle) === 0) {
          self.tabIndex = _i;
          break;
        }
      }
    },
    getTabHeader: function getTabHeader(index) {
      var title = this.$refs.tabs.tabs[index].title;
      for (var i = 0; i < this.headers.length; i++) {
        if (this.headers[i].title.localeCompare(title) === 0) {
          return this.headers[i];
        }
      }
    },
    browserIE11: function browserIE11() {
      return false || !!document.documentMode;
    },
    browserFirefox: function browserFirefox() {
      return typeof InstallTrigger !== 'undefined';
    },
    helpLink: function helpLink(linkRoute) {
      return (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.help_root + '/' + linkRoute).replace(/([^:]\/)\/+/g, '$1');
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(19);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  created: function created() {
    this.$translate = function (key) {
      return __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].te(key) ? __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].t(key) : key;
    };
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StartPage__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StartPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StartPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFoundPage__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFoundPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NotFoundPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_Register__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_register_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activation_Activation__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activation_Activation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_activation_Activation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_activation_Reset__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_activation_Reset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_activation_Reset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_Home__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_invoices_Invoices__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_home_invoices_Invoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_home_invoices_Invoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_home_invoices_single_invoice_SingleInvoice__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_home_invoices_single_invoice_SingleInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_home_invoices_single_invoice_SingleInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_home_dashboard_Dashboard__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_home_dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_home_dashboard_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_home_settlement_SettleInvoice__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_home_settlement_SettleInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_home_settlement_SettleInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_home_user_settlements_UserSettlements__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_home_user_settlements_UserSettlements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_home_user_settlements_UserSettlements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_home_user_administration_UserAdministration__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_home_user_administration_UserAdministration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_home_user_administration_UserAdministration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_home_user_registration_UserRegistration__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_home_user_registration_UserRegistration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_home_user_registration_UserRegistration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_home_user_registration_user_approval_UserApproval__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_home_user_registration_user_approval_UserApproval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_home_user_registration_user_approval_UserApproval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_home_user_administration_user_management_user_information_UserInformation__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_home_user_administration_user_management_user_information_UserInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_home_user_administration_user_management_user_information_UserInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_home_user_administration_local_user_management_local_user_information_LocalUserInformation__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_home_user_administration_local_user_management_local_user_information_LocalUserInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_home_user_administration_local_user_management_local_user_information_LocalUserInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_home_user_administration_user_profile_UserProfile__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_home_user_administration_user_profile_UserProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_home_user_administration_user_profile_UserProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_home_issues_ReportedIssues__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_home_issues_ReportedIssues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_home_issues_ReportedIssues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_home_issues_single_issue_SingleIssue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_home_issues_single_issue_SingleIssue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_home_issues_single_issue_SingleIssue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_home_group_settlement_GroupSettlement__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_home_group_settlement_GroupSettlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_home_group_settlement_GroupSettlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_home_group_settlement_single_group_settlement_SingleGroupSettlement__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_home_group_settlement_single_group_settlement_SingleGroupSettlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_home_group_settlement_single_group_settlement_SingleGroupSettlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_home_group_settlement_register_group_settlement_RegisterGroupSettlement__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_home_group_settlement_register_group_settlement_RegisterGroupSettlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_home_group_settlement_register_group_settlement_RegisterGroupSettlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_home_group_settlement_list_group_settlement_ListGroupSettlement__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_home_group_settlement_list_group_settlement_ListGroupSettlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_home_group_settlement_list_group_settlement_ListGroupSettlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_home_intervention_Interventions__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_home_intervention_Interventions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_home_intervention_Interventions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__auth__ = __webpack_require__(14);












// import RegisterInvoice from '@/components/home/register-invoice/RegisterInvoice'

















var $t = __WEBPACK_IMPORTED_MODULE_27__i18n__["a" /* default */].messages[__WEBPACK_IMPORTED_MODULE_27__i18n__["a" /* default */].locale];



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    name: 'start-page',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_StartPage___default.a
  }, {
    name: 'notfound-page',
    path: '/not-found',
    component: __WEBPACK_IMPORTED_MODULE_4__components_NotFoundPage___default.a
  }, {
    name: 'register',
    path: '/register',
    component: __WEBPACK_IMPORTED_MODULE_5__components_register_Register___default.a,
    meta: {
      title: $t.register.title
    }
  }, {
    name: 'activation',
    path: '/activation',
    component: __WEBPACK_IMPORTED_MODULE_6__components_activation_Activation___default.a
  }, {
    name: 'reset',
    path: '/reset-password',
    component: __WEBPACK_IMPORTED_MODULE_7__components_activation_Reset___default.a
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_8__components_home_Home___default.a,
    meta: { requiresAuth: true },
    children: [{
      path: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_11__components_home_dashboard_Dashboard___default.a,
      meta: {
        title: 'Dashboard'
      }
    }, {
      path: 'reported-issues',
      component: __WEBPACK_IMPORTED_MODULE_20__components_home_issues_ReportedIssues___default.a,
      meta: {
        title: $t.sidebar.reportedIssues
      }
    }, {
      path: 'invoices',
      component: __WEBPACK_IMPORTED_MODULE_9__components_home_invoices_Invoices___default.a,
      meta: {
        title: $t.invoices.invoiceReview
      }
    },
    // {
    //   path: 'register-invoice',
    //   component: RegisterInvoice,
    //   meta: {
    //     title: $t.sidebar.registerInvoice
    //   }
    // },
    {
      path: 'user-administration',
      component: __WEBPACK_IMPORTED_MODULE_14__components_home_user_administration_UserAdministration___default.a,
      meta: {
        title: $t.sidebar.userAdministration
      }
    }, {
      path: 'user-registration',
      component: __WEBPACK_IMPORTED_MODULE_15__components_home_user_registration_UserRegistration___default.a,
      meta: {
        title: $t.sidebar.userRegistration
      }
    }, {
      path: 'settle-invoice',
      component: __WEBPACK_IMPORTED_MODULE_12__components_home_settlement_SettleInvoice___default.a,
      meta: {
        title: $t.sidebar.userRegistration
      }
    }, {
      path: 'user-settlements',
      component: __WEBPACK_IMPORTED_MODULE_13__components_home_user_settlements_UserSettlements___default.a,
      meta: {
        title: $t.sidebar.invoiceUserSettlement
      }
    }, {
      path: 'invoices/:invoiceId',
      name: 'singleInvoiceRoute',
      component: __WEBPACK_IMPORTED_MODULE_10__components_home_invoices_single_invoice_SingleInvoice___default.a,
      meta: {
        title: $t.sidebar.registerInvoice
      }
    }, {
      path: 'user-registration/approval/:registrationId',
      component: __WEBPACK_IMPORTED_MODULE_16__components_home_user_registration_user_approval_UserApproval___default.a,
      name: 'approvedUserPage'
    }, {
      path: 'user-administration/local-user/:userId',
      name: 'userInfoPage',
      component: __WEBPACK_IMPORTED_MODULE_18__components_home_user_administration_local_user_management_local_user_information_LocalUserInformation___default.a
    }, {
      path: 'user-administration/user/:userId',
      component: __WEBPACK_IMPORTED_MODULE_17__components_home_user_administration_user_management_user_information_UserInformation___default.a,
      name: 'userInformationPage'
    }, {
      path: 'user-administration/profile',
      component: __WEBPACK_IMPORTED_MODULE_19__components_home_user_administration_user_profile_UserProfile___default.a
    }, {
      path: 'reported-issues/:issueId',
      component: __WEBPACK_IMPORTED_MODULE_21__components_home_issues_single_issue_SingleIssue___default.a,
      meta: {
        title: $t.sidebar.reportedIssues
      }
    }, {
      path: 'group-settlement',
      meta: {
        title: $t.sidebar.groupSettlement
      },
      component: __WEBPACK_IMPORTED_MODULE_22__components_home_group_settlement_GroupSettlement___default.a,
      children: [{
        path: 'register',
        name: 'registerGroupSettlementRoute',
        component: __WEBPACK_IMPORTED_MODULE_24__components_home_group_settlement_register_group_settlement_RegisterGroupSettlement___default.a
      }, {
        path: ':groupSettlementId',
        name: 'singleGroupSettlementRoute',
        component: __WEBPACK_IMPORTED_MODULE_23__components_home_group_settlement_single_group_settlement_SingleGroupSettlement___default.a
      }, {
        path: '',
        name: 'listGroupSettlementRoute',
        component: __WEBPACK_IMPORTED_MODULE_25__components_home_group_settlement_list_group_settlement_ListGroupSettlement___default.a
      }]
    }, {
      path: 'intervention',
      component: __WEBPACK_IMPORTED_MODULE_26__components_home_intervention_Interventions___default.a,
      meta: {
        title: $t.sidebar.intervention
      }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_27__i18n__["a" /* default */].locale = router.app.$store.getters.language === 'English' ? 'en' : 'sr';

  // Site title
  var siteName = $t.title;
  var pageName = void 0;

  if (to.name === 'start-page') {
    pageName = siteName;
  } else {
    pageName = to.meta.title ? to.meta.title + ' - ' + siteName : siteName;
  }

  document.title = pageName;

  if (!to.matched.length) {
    next('/not-found');
  }

  var isProductionEnvironment = "Ptest".toUpperCase() === 'production'.toUpperCase();
  // Authorization
  if (!isProductionEnvironment) {
    console.log('Executing authorization guard for ' + to.path);
  }

  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__auth__["a" /* accessTokenValid */])()) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__auth__["b" /* refreshTokenValid */])()) {
        if (!isProductionEnvironment) {
          console.log('Tokens expired - routing not authorized');
        }
        next({
          path: '/',
          query: { redirect: to.fullPath }
        });
      } else {
        if (!isProductionEnvironment) {
          console.log('Refreshing access token');
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__auth__["f" /* refreshToken */])(to, from, next);
      }
    } else {
      if (!isProductionEnvironment) {
        console.log('Routing authorized for: ' + to.path + ' | Route Name: ' + to.name);
      }
      next();
    }
  } else {
    if (!isProductionEnvironment) {
      console.log('No authorization required for ' + to.path);
    }
    next(); // make sure to always call next()!
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist_dist_umd__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist_dist_umd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist_dist_umd__);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var vuexPersist = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist_dist_umd___default.a({
  key: 'crf-storage',
  storage: localStorage
});

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    language: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.language_default,
    dateLocale: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.date_locale_default,
    dateFormat: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.date_format_default,
    decimalFormat: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.decimal_format_default,
    csvDelimmeter: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.CSV_separator_default
  },
  mutations: {
    language: function language(state, _language) {
      state.language = _language;
      if (_language === 'English') {
        state.dateLocale = 'en';
      } else {
        state.dateLocale = 'sr-cyrl';
      }
    },
    dateFormat: function dateFormat(state, _dateFormat) {
      state.dateFormat = _dateFormat;
    },
    decimalFormat: function decimalFormat(state, _decimalFormat) {
      state.decimalFormat = _decimalFormat;
    },
    csvDelimmeter: function csvDelimmeter(state, _csvDelimmeter) {
      state.csvDelimmeter = _csvDelimmeter;
    }
  },
  actions: {
    regional: function regional(_ref, payload) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('language', payload.language);
        commit('dateFormat', payload.dateFormat);
        commit('decimalFormat', payload.decimalFormat);
        commit('csvDelimmeter', payload.csvDelimmeter);
        resolve();
      });
    }
  },
  getters: {
    language: function language(state) {
      return state.language;
    },
    dateLocale: function dateLocale(state) {
      return state.dateLocale;
    },
    dateFormat: function dateFormat(state) {
      return state.dateFormat;
    },
    decimalFormat: function decimalFormat(state) {
      return state.decimalFormat;
    },
    csvDelimmeter: function csvDelimmeter(state) {
      return state.csvDelimmeter;
    }
  },
  plugins: [vuexPersist.plugin]
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endpointRequireToken;
function endpointRequireToken(url) {
  if (!url) {
    return true;
  }
  var reLoginRefresh = /[/]?login\/refresh[/]?/;
  var reLogin = /[/]?login[/]?$/;
  var reAccRegistration = /[/]?accountregistration/;
  var reAccActivation = /[/]?administration\/activate-registered-user/;
  var reAccTokenValidation = /[/]?administration\/validate-activation-token/;
  var reAccUserActivation = /[/]?administration\/activate-user/;
  var reTreasuryBranchAutocomplete = /[/]?registry\/treasury-branches/;

  var reAccReset = /[/]?administration\/reset-password/;
  var reAccTokenResetValidation = /[/]?administration\/validate-reset-token/;
  var reAccUserReset = /[/]?administration\/reset-user/;

  // return reLoginRefresh.test(url) || !(reLogin.test(url) || reAccRegistration.test(url))
  return !(reLogin.test(url) || reLoginRefresh.test(url) || reAccRegistration.test(url) || reAccActivation.test(url) || reAccTokenValidation.test(url) || reAccUserActivation.test(url) || reTreasuryBranchAutocomplete.test(url) || reAccReset.test(url) || reAccTokenResetValidation.test(url) || reAccUserReset.test(url));
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  en: {
    global: {
      required: 'The {field} field is required.',
      email: 'E-mail is not valid',
      between: 'Number {field} has to be between {min} and {max}'
    },
    custom: {},
    attributes: {
      'invoiceLiability.DebtorCompanyNumber': 'Budget Id Number',
      'invoiceLiability.InvoiceNumber': 'Invoice Number',
      'invoiceLiability.Amount': 'Amount',
      'invoiceLiability.IssueDate': 'Issue Date',
      'invoiceSettlement.InvoiceId': 'Invoice ID',
      'invoiceSettlement.ExternalId': 'Payment ID',
      'invoiceSettlement.SettlementDate': 'Settlement date',
      'invoiceSettlement.Bank': 'Bank',
      'register.companyNumber': 'Company Number',
      'register.parentInstitutionTaxIdNumber': 'Parent Company Tax Id Number',
      'register.parentInstitutionCompanyNumber': 'Parent Company Number',
      'register.taxIdNumber': 'Tax Id Number',
      'register.name': 'Company Name',
      'register.companyName': 'Company / Legal Entity Name',
      'register.legalEntityName': 'Legal Entity Name',
      'register.address': 'Address',
      'register.treasuryBranch': 'Treasury Branch',
      'register.email': 'Company e-mail',
      'register.phoneNumber': 'Company phone',
      'register.adminName': 'Name and last name',
      'register.adminPersonalIdentityNumber': 'Personal identity number',
      'register.adminIdentityNumber': 'Identity number',
      'register.adminEmail': 'Admin Email',
      'register.adminPhoneNumber': 'Admin Phone',
      'user.login': 'User login',
      'user.name': 'User name',
      'user.email': 'User email',
      'groupSettlement.groupSettlementNumber': 'Group settlement number'
    }
  },
  sr: {
    global: {
      required: '{field} је обавезно поље.',
      requiredIf: '{field} је обавезно поље.',
      email: 'Имејл адреса није валидна.',
      between: '{field} мора бити између {min} и {max}.'
    },
    custom: {
      form: {
        name: {
          required: 'Upisi ime',
          minLength: 'Ime mora imati najmanje 5 karaktera'
        }
      }
    },
    attributes: {
      'form.surname': 'Prezime',
      'invoiceLiability.DebtorCompanyNumber': 'ЈББК дужника',
      'invoiceLiability.InvoiceNumber': 'Број фактуре',
      'invoiceLiability.Amount': 'Износ',
      'invoiceLiability.IssueDate': 'Датум издавања',
      'invoiceSettlement.InvoiceId': 'Идентификатор фактуре',
      'invoiceSettlement.ExternalId': 'Идентификатор плаћања',
      'invoiceSettlement.ReferenceNumber': 'Идентификатор плаћања',
      'invoiceSettlement.SettledAmount': 'Износ измирења',
      'invoiceSettlement.SettlementDate': 'Датум измирења',
      'invoiceSettlement.CreditAccount': 'Рачун одобрења',
      'invoiceSettlement.DebitAccount': 'Рачун задужења',
      'invoiceSettlement.Bank': 'Банка',
      'register.companyNumber': 'Матични број',
      'register.parentInstitutionTaxIdNumber': 'ПИБ надређене институције',
      'register.parentInstitutionCompanyNumber': 'Матични број надређене институције',
      'register.taxIdNumber': 'ПИБ',
      'register.name': 'Име компаније / јавног предузећа',
      'register.companyName': 'Име компаније',
      'register.legalEntityName': 'Име јавног предузећа',
      'register.address': 'Адреса седишта',
      'register.treasuryBranch': 'Испостава трезора',
      'register.email': 'Име компаније',
      'register.phoneNumber': 'Телефон компаније',
      'register.adminName': 'Име и презиме',
      'register.adminIdentityNumber': 'Број личне карте',
      'register.adminEmail': 'Админ и-мејл',
      'register.adminPhoneNumber': 'Админ телефон',
      'user.login': 'Кориснички налог',
      'user.name': 'Име и презиме',
      'user.email': 'Имејл корисника',
      'groupSettlement.groupSettlementNumber': 'Број спецификације групног плаћања'
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_Header_vue__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_Header_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      isAuth: false,
      username: ''
    };
  },

  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_0__components_header_Header_vue___default.a
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound-page',
  created: function created() {
    this.changelogPath = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/changelog/').replace(/([^:]\/)\/+/g, '$1');
    this.supportPath = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/support/').replace(/([^:]\/)\/+/g, '$1');
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'startpage',
  data: function data() {
    return {
      user: {},
      loginVisibility: 'none',
      loginError: false,
      connectionError: false,
      changelogPath: '',
      supportPath: '',
      integrationPath: ''
    };
  },
  created: function created() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["B" /* isUserActive */])()) {
      this.$router.push('/dashboard');
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["c" /* logout */])();
      __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('logged-out', '');
    }

    this.changelogPath = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/changelog/').replace(/([^:]\/)\/+/g, '$1');
    this.supportPath = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/support/').replace(/([^:]\/)\/+/g, '$1');
    this.integrationPath = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/integration/').replace(/([^:]\/)\/+/g, '$1');
  },

  methods: {
    register: function register(e) {
      this.$router.push('/register');
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'activation',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      token: '',
      user: {},
      tokenValid: false
    };
  },
  created: function created() {
    var _this = this;

    this.logConsole('Activation request received');
    this.token = this.$route.query.token;
    var activationToken = { activationToken: this.token };

    this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.validateActivationTokenPost, activationToken).then(function (response) {
      _this.logConsole(response);
      _this.tokenValid = true;
      _this.user = response.body.payload;
    }, function (error) {
      _this.logConsole(error);
      _this.tokenValid = false;
      _this.formatErrorResponse(error);
    });
  },

  methods: {
    activateUser: function activateUser() {
      var _this2 = this;

      this.logConsole('Activating user');
      if (this.user.password === this.user.newPassword) {
        this.load = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.activateUserPost + '?token=' + this.token, this.user).then(function (response) {
          _this2.logConsole(response);
          _this2.load = false;
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this2.$translate('activation.success'),
            errors: []
          });
          _this2.$refs.activateUserForm.reset();
          _this2.user.password = _this2.user.newPassword = null;
        }, function (error) {
          _this2.logConsole(error);
          _this2.formatErrorResponse(error);
          _this2.load = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('userAdministration.confirmPasswordFail'),
          errors: []
        });
      }
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'activation',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      token: '',
      user: {},
      tokenValid: false
    };
  },
  created: function created() {
    var _this = this;

    this.logConsole('Reset request received');
    this.token = this.$route.query.token;
    var activationToken = { activationToken: this.token };

    this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.validateResetTokenPost, activationToken).then(function (response) {
      _this.logConsole(response);
      _this.tokenValid = true;
      _this.user = response.body.payload;
    }, function (error) {
      _this.logConsole(error);
      _this.tokenValid = false;
      __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
        variant: 'danger',
        message: _this.$translate('apiStatusCodes.' + error.data.status.code),
        errors: []
      });
    });
  },

  methods: {
    resetUser: function resetUser() {
      var _this2 = this;

      this.logConsole('Resetting user');
      if (this.user.password === this.user.newPassword) {
        this.load = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.resetUserPost + '?token=' + this.token, this.user).then(function (response) {
          _this2.logConsole(response);
          _this2.load = false;
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this2.$translate('reset.success'),
            errors: []
          });
          _this2.$refs.resetUserForm.reset();
          _this2.user.password = _this2.user.newPassword = null;
        }, function (error) {
          _this2.logConsole(error);
          _this2.formatErrorResponse(error);
          _this2.load = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('userAdministration.confirmPasswordFail'),
          errors: []
        });
      }
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_Login_vue__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_cookie__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert_container_AlertContainer_vue__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert_container_AlertContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__alert_container_AlertContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notification_container_NotificationContainer_vue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notification_container_NotificationContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__notification_container_NotificationContainer_vue__);
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {
      environment: "Ptest",
      isAuth: false,
      username: '',
      externalLinks: [],
      registrationAllowed: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.registration_allowed
    };
  },

  computed: {
    headerClass: function headerClass() {
      return 'header-' + this.environment.toLowerCase();
    },
    isDevelopment: function isDevelopment() {
      return !this.isProductionEnvironment();
    },
    documentationPath: function documentationPath() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root;
    }
  },
  methods: {
    logout: function logout() {
      this.logConsole('Logging out');

      __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('notification-close');
      this.userIsLoggedOut();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["c" /* logout */])();
      this.$router.push('/');
    },
    userIsLoggedIn: function userIsLoggedIn() {
      this.isAuth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["d" /* isAuth */])();
      this.username = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_cookie__["d" /* getUser */])();
    },
    userIsLoggedOut: function userIsLoggedOut() {
      this.isAuth = false;
      this.username = '';
    },
    isStaging: function isStaging() {
      return true;
    },
    isDevel: function isDevel() {
      return false;
    }
  },
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_1__login_Login_vue___default.a,
    AlertContainer: __WEBPACK_IMPORTED_MODULE_5__alert_container_AlertContainer_vue___default.a,
    NotificationContainer: __WEBPACK_IMPORTED_MODULE_6__notification_container_NotificationContainer_vue___default.a
  },
  created: function created() {
    var _this = this;

    this.userIsLoggedIn();
    __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$on('logged-in', function () {
      _this.userIsLoggedIn();
    });
    __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$on('logged-out', function () {
      _this.userIsLoggedOut();
    });

    this.externalLinks = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.external_links;
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_bus__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function defaultData() {
  return {
    show: false,
    showList: false,
    variant: 'info',
    message: '',
    link: null,
    linkDescription: null,
    items: null
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return defaultData();
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__router_bus__["a" /* EventBus */].$on('alert', function (data) {
      _this.show = true;
      _this.variant = data.variant;
      _this.message = data.message;
      _this.link = data.link;
      _this.linkDescription = data.linkDescription;
      _this.showList = data.errors.length > 0;
      _this.items = data.errors;
    });

    __WEBPACK_IMPORTED_MODULE_0__router_bus__["a" /* EventBus */].$on('notification-close', function () {
      _this.disposeNotification();
    });
  },

  methods: {
    disposeNotification: function disposeNotification() {
      this.show = false;
      this.items = [];
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      user: {},
      loginError: {
        show: false,
        message: ''
      },
      load: false
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader___default.a
  },
  mounted: function mounted() {
    if (this.$route.query.redirect) {
      this.$refs.login_modal.show();
    }
  },

  methods: {
    hideModal: function hideModal() {
      this.$refs.login_modal.hide();
      this.$refs.initial_login_modal.hide();
      this.$refs.password_reset_modal.hide();
      this.load = false;
    },
    login: function login(e) {
      var _this = this;

      this.load = true;
      this.loginError['show'] = false;

      var loginUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.login;

      this.user.login = this.$refs.login_modal_input.$el.value;

      this.logConsole('Sending login request for user : ' + this.user.login);
      this.$http.post(loginUrl, this.user).then(function (response) {
        // get body data
        var data = response.data;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["e" /* setCredentials */])(_this.user.login, data.payload.accessToken, data.payload.refreshToken);
        _this.hideModal();
        _this.gotoInitialPage();
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('logged-in', 'asd');
      }, function (error) {
        _this.logConsole(error);
        _this.load = false;
        _this.loginError['show'] = true;

        if (error.status === 0) {
          _this.loginError['message'] = _this.$t('apiStatusCodes.0');
        } else if (error.status === 422) {
          _this.loginError['message'] = _this.$t('apiStatusCodes.' + error.data.errors[0].code);
        } else {
          _this.loginError['message'] = _this.$t('apiStatusCodes.' + error.data.status.code);
        }

        if (error.data.additionalInformation) {
          _this.loginError['message'] += ' : ' + error.data.additionalInformation;
        }
      });
      if (typeof e.cancel !== 'undefined' && typeof e.cancel === 'function') {
        return e.cancel();
      }
    },
    initialLogin: function initialLogin() {
      var _this2 = this;

      this.load = true;
      this.logConsole('Sending initial login request');

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.activateRegisteredUserPost, this.user).then(function (response) {
        _this2.logConsole(response);
        _this2.hideModal();

        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$translate('activation.activationSent'),
          errors: []
        });
      }, function (error) {
        _this2.logConsole(error);
        _this2.load = false;
        _this2.loginError['show'] = true;

        var statusCode = 0;
        if (error.status !== 0) {
          statusCode = error.data.status.code;
        }

        _this2.loginError['message'] = _this2.$translate('apiStatusCodes.' + statusCode);
      });
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      this.load = true;
      this.logConsole('Sending password reset request');

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.resetUserPasswordPost, this.user).then(function (response) {
        _this3.logConsole(response);
        _this3.hideModal();

        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$translate('user.passwordResetLinkSent'),
          errors: []
        });
      }, function (error) {
        _this3.logConsole(error);
        _this3.load = false;
        _this3.loginError['show'] = true;

        var statusCode = 0;
        if (error.status !== 0) {
          statusCode = error.data.status.code;
        }

        _this3.loginError['message'] = _this3.$translate('apiStatusCodes.' + statusCode);
      });
    },
    initialLoginModal: function initialLoginModal() {
      this.logConsole('initial login');
      this.hideModal();

      this.$refs.initial_login_modal.show();
    },
    passwordResetModal: function passwordResetModal() {
      this.logConsole('reset password');
      this.hideModal();

      this.$refs.password_reset_modal.show();
    },
    gotoInitialPage: function gotoInitialPage() {
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else {
        this.$router.push('/dashboard');
      }
    },
    onPasswordInput: function onPasswordInput(e) {
      if (e.key) {
        var s = e.key;
        if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
          this.$refs.capsLockTooltip.$emit('enable');
          this.$refs.capsLockTooltip.$emit('open');
        } else {
          this.$refs.capsLockTooltip.$emit('close');
          this.$refs.capsLockTooltip.$emit('disable');
        }
      }
    },
    clearLoginData: function clearLoginData() {
      this.$refs.loginModalForm.reset();
      this.clearData();
      this.$refs.login_modal_input.focus();
    },
    clearInitialLoginData: function clearInitialLoginData() {
      this.$refs.initialLoginModalForm.reset();
      this.clearData();
      this.$refs.initial_login_modal_input.focus();
    },
    clearPasswordResetData: function clearPasswordResetData() {
      this.$refs.passwordResetModalForm.reset();
      this.clearData();
      this.$refs.password_reset_modal_input.focus();
    },
    clearData: function clearData() {
      this.loginError['show'] = false;
      this.user.login = null;
      this.user.password = null;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookie__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      priorityVariant: ['info', 'warning', 'danger'],
      show: false,
      showList: false,
      items: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__router_bus__["a" /* EventBus */].$on('notification', function (data) {
      // Filter incoming data to get only non-dismissed items
      _this.items = _this.getNondismissed(data);
      if (_this.items.length === 0) {
        return;
      }

      _this.show = true;
    });
    __WEBPACK_IMPORTED_MODULE_0__router_bus__["a" /* EventBus */].$on('notification-close', function () {
      _this.show = false;
      _this.items = [];
    });
  },

  methods: {
    dismiss: function dismiss() {
      this.show = false;
      this.updateDismissed();
      this.items = [];
    },
    updateDismissed: function updateDismissed() {
      var notificationInfo = this.getCurrentNotificationInfo();

      for (var i = 0; i < this.items.length; i++) {
        notificationInfo.push(this.items[i].notificationId);
      }
      this.setCurrentNotificationInfo(notificationInfo);
    },
    setCurrentNotificationInfo: function setCurrentNotificationInfo(info) {
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["d" /* getUser */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["e" /* setNotificationInfo */])(key, info);
    },
    getNondismissed: function getNondismissed(data) {
      var notificationInfo = this.getCurrentNotificationInfo();
      var nondismissed = [];
      for (var i = 0; i < data.length; i++) {
        if (!notificationInfo.includes(data[i].notificationId)) {
          nondismissed.push(data[i]);
        }
      }
      return nondismissed;
    },
    getCurrentNotificationInfo: function getCurrentNotificationInfo() {
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["d" /* getUser */])();
      var notificationInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["f" /* getNotificationInfo */])(key);

      if (notificationInfo == null) {
        notificationInfo = [];
        // setNotificationInfo(key, notificationInfo)
      }

      return notificationInfo;
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__side_nav_SideNav_vue__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__side_nav_SideNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__side_nav_SideNav_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    'side-nav': __WEBPACK_IMPORTED_MODULE_0__side_nav_SideNav_vue___default.a
  },
  data: function data() {
    return {
      user: {},
      alertType: 'danger',
      alertMessage: 'Empty',
      dismissCountDown: null
    };
  },

  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  },
  created: function created() {
    this.logConsole('Main panel created');
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_auth__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: {
    ContextHeader: __WEBPACK_IMPORTED_MODULE_0__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      isAdmin: false,
      user: null,
      registration: null,
      liabilitiesTotal: null,
      organizationLink: '',
      organizationId: null
    };
  },

  computed: {
    isPublicEntity: function isPublicEntity() {
      if (!this.registration || !this.registration.companyNumber) {
        return false;
      }
      return this.registration.companyNumber.length === 5;
    },
    isPrivateEntity: function isPrivateEntity() {
      if (!this.registration || !this.registration.companyNumber) {
        return false;
      }
      return this.registration.companyNumber.length === 8;
    }
  },
  created: function created() {
    var _this = this;

    this.logConsole('Dashboard created');
    this.organizationId = parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__router_auth__["i" /* getOrganizationId */])());
    this.isAdmin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__router_auth__["k" /* hasAdminClaim */])();

    this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.summaryInfoGet).then(function (response) {
      _this.logConsole(response);
      var summary = response.data.payload;
      _this.user = summary.user;
      _this.registration = summary.registration;
      _this.organizationLink = '/user-registration/approval/' + _this.user.organizationId;
      _this.createLiabilitySummary(summary.liabilities);

      var notifications = summary.notifications;
      if (notifications.length > 0) {
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('notification', notifications);
      }
    }, function (error) {
      _this.logConsole(error);
      _this.formatErrorResponse(error);
    });
  },

  methods: {
    createLiabilitySummary: function createLiabilitySummary(liabilities) {
      this.liabilitiesTotal = liabilities;
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'groupSettlement'
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_auth__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'listGroupSettlement',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader___default.a,
    Datatable: __WEBPACK_IMPORTED_MODULE_2__components_misc_datatable_Datatable___default.a
  },
  data: function data() {
    return {
      load: false,
      groupSettlementStatus: {
        PENDING: 1,
        ACTIVE: 2,
        SETTLED: 3,
        CANCELLED: 4,
        INVALID: 5
      },
      tOptions: {
        sortable: true,
        filter: true,
        checkboxes: false,
        payloadsTotalPropertyName: 'additionalInformation', // Name of the the payload property that returns total num of rows (total, count,..)
        per_page_options: [5, 10, 15, 25, 50], // overrriden in created method
        per_page_default: 5, // overrriden in created method
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return [statuses.INVALID, statuses.CANCELLED].includes(row['groupSettlementStatus']);
          }
        },
        highlightedRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['groupSettlementStatus'] === statuses.INVALID;
          }
        },
        altHighlightedRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['groupSettlementStatus'] === statuses.ACTIVE;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return '/group-settlement/' + row['groupSettlementId'];
          }
        }
      }
    };
  },

  watch: {},
  computed: {
    tColumns: function tColumns() {
      var retVal = [{
        columnName: 'formattedGroupSettlementNumber',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnGroupSettlementNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.groupSettlementNumber;
        }
      }, {
        columnName: 'creditorName',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnCreditor'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.creditorName;
        }
      }, {
        columnName: 'amount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnAmountFrom'),
          value: 'amount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnAmountTo'),
          value: 'amount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: false,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'creationDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnCreationDateRangeFrom'),
          value: 'creationDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnCreationDateRangeTo'),
          value: 'creationDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnCreationDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'dueDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnDueDateRangeFrom'),
          value: 'dueDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnDueDateRangeTo'),
          value: 'dueDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnDueDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'settlementDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnSettlementDateRangeFrom'),
          value: 'settlementDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnSettlementDateRangeTo'),
          value: 'settlementDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnSettlementDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'groupSettlementStatus',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnStatus'),
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.4'), value: 4 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.groupSettlementStatus.5'), value: 5 }],
        cell: function cell(row) {
          return null;
        }
      }];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["g" /* hasInvoiceReviewAllClaim */])()) {
        retVal.push({
          columnName: 'debtorName',
          title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('groupSettlement.columnDebtor'),
          filterType: 'input',
          align: 'center',
          cell: function cell(row) {
            return null;
          }
        });
      }
      return retVal;
    }
  },
  created: function created() {
    this.groupSettlementsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.groupSettlementsGet;
    this.tOptions.statuses = this.groupSettlementStatus;
    if (!!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements && !!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements.per_page_options) {
      this.tOptions.per_page_options = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements.per_page_options;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements && !!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements.per_page_defaultOption) {
      this.tOptions.per_page_default = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.group_settlements.per_page_default;
    }
  },

  methods: {}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validators__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validators_mixin__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_misc_Loader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_validation__["a" /* validationMixin */], __WEBPACK_IMPORTED_MODULE_6__validators_mixin__["a" /* massInputValidationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_7__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      load: false,
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      errorList: [],
      groupSettlement: {
        groupSettlementNumber: '',
        groupSettlementItems: []
      },
      massInput: '',
      registerGroupSettlementLink: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.registerGroupSettlementPost
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList && this.errorList.length > 0;
    }
  },
  methods: {
    validateAndSubmit: function validateAndSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('groupSettlement')
        });
        if (this.$v.massInput.$invalid) {
          this.errorList = this.getMassInputErrors(this.massInput);
        }
      } else {
        this.errorList = [];
        this.submitGroupSettlement();
      }
    },

    submitGroupSettlement: function submitGroupSettlement(e) {
      var _this = this;

      this.logConsole('Submitting Group Settlement');
      this.load = true;
      this.parseMassInput(this.massInput).forEach(function (row) {
        if (row === '') {
          return;
        }
        var temp = row.match(/\S+/g);
        var invoiceId = temp[0];
        var amount = temp[1] ? Number(temp[1]) : 0;
        _this.groupSettlement.groupSettlementItems.push({ InvoiceId: invoiceId, SettlementAmount: amount });
      });
      this.$http.post(this.registerGroupSettlementLink, this.groupSettlement).then(function (response) {
        _this.logConsole(response);
        var responseData = response.data.payload.groupSettlement;
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('groupSettlement.groupSettlementRegistered') + ' - ',
          link: '/group-settlement/' + responseData.groupSettlementId,
          linkDescription: responseData.groupSettlementNumber,
          errors: []
        });
        _this.$nextTick(function () {
          document.body.scrollTop = 0; // safari
          document.documentElement.scrollTop = 0; // chrome, ie, ff
        });
        _this.groupSettlement.groupSettlementItems = [];
        _this.groupSettlement.groupSettlementNumber = '';
        _this.massInput = '';
        _this.$refs.registerGroupSettlementForm.reset();
        _this.$v.$reset();
      }, function (error) {
        if (typeof error.body.payload !== 'undefined' && error.body.payload !== null) {
          if (typeof error.body.payload.groupSettlementItems !== 'undefined') {
            var _errorList;

            var localErrorList = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(error.body.payload.groupSettlementItems).forEach(function (row) {
              if (typeof row.groupSettlementItemError !== 'undefined') {
                var errorPrefix = _this.$t('groupSettlement.massInputError.returnedCodePrefix', [row.groupSettlementItem.invoiceId]);
                var errorMsg = _this.$t('apiStatusCodes.' + row.groupSettlementItemError.code);
                if (row.groupSettlementItem.groupSettlementId) {
                  errorMsg += ' - ' + row.groupSettlementItem.groupSettlementId;
                }
                localErrorList.push(errorPrefix + ' ' + errorMsg);
              }
            });
            (_errorList = _this.errorList).push.apply(_errorList, localErrorList);
          }
        }
        _this.load = false;
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.groupSettlement.groupSettlementItems = [];
      });
    }
  },
  validations: {
    massInput: {
      MassInputValidator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__validators__["a" /* MassInputValidator */])({ minimumInvoices: 2 })
    },
    groupSettlement: {
      groupSettlementNumber: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validators__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validators_mixin__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_money__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_v_money__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_validation__["a" /* validationMixin */], __WEBPACK_IMPORTED_MODULE_12__validators_mixin__["a" /* massInputValidationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default.a,
    Money: __WEBPACK_IMPORTED_MODULE_14_v_money__["Money"]
  },
  created: function created() {
    this.fetchData();
    this.organizationId = parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__router_auth__["i" /* getOrganizationId */])());
  },
  data: function data() {
    return {
      load: false,
      hasInvoiceReviewAllClaim: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__router_auth__["g" /* hasInvoiceReviewAllClaim */])(),
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      IssueCategory: [{ DESCRIPTION: 'InvoiceLiability', ID: 1 }, { DESCRIPTION: 'InvoiceSettlement', ID: 2 }],
      groupSettlementStatus: {
        PENDING: 1,
        ACTIVE: 2,
        SETTLED: 3,
        CANCELLED: 4,
        INVALID: 5,
        FLAGGED: 6
      },
      invoiceStatus: {
        ACTIVE: 1, // ignore when looking at line errors
        INVALID: 2,
        CANCELLED: 3,
        PARTIALLY_SETTLED: 4, // ignore when looking at line errors
        SETTLED: 5,
        ASSIGNED: 6,
        PROINVOICE: 7
      },
      errorList: [],
      additionalErrorList: [],
      invoiceErrors: [],
      tableItems: [],
      showTable: true,
      groupSettlement: {
        groupSettlementNumber: '',
        groupSettlementItems: []
      },
      organizationId: 0,
      currentIssueReport: {},
      currentIssue: null,
      currentIssueCategories: null,
      currentIssueCategory: null,
      selectedCategory: null,
      formattedIssueCategories: null,
      currentIssueAmount: 0,
      currentIssueSettlementId: null,
      NotificationTypes: {
        IssueProcessed: 5
      },
      massInput: '',
      massAdditionInput: '',
      showMassAdditionInput: false,
      dataFetched: false,
      hasErrorWhenFetchingData: false,
      groupSettlementGetLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.groupSettlementGet + '/' + this.$route.params.groupSettlementId,
      groupSettlementActivateLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.activateGroupSettlementPost,
      groupSettlementDeactivateLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.deactivateGroupSettlementPost,
      groupSettlementCancelLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.cancelGroupSettlementPost,
      editGroupSettlementLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.updateGroupSettlementPost,
      activationDocumentationLink: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$config.help_root + '/' + 'group-settlement/group-settlement-information/#aktivacija'
    };
  },

  computed: {
    invoiceTableFields: function invoiceTableFields() {
      var retVal = [{ key: 'invoiceId', label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('invoices.columnInvoiceNumber'), sortable: true, sortDirection: 'desc' }, { key: 'settlementAmount', label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('invoices.columnSettlementAmount'), sortable: true }, { key: 'status', label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('invoices.columnInvoiceStatus'), sortable: true }];
      if (this.invoiceErrors.length > 0 && ![this.groupSettlementStatus.SETTLED, this.groupSettlementStatus.CANCELLED].includes(this.groupSettlement.groupSettlementStatus)) {
        retVal.unshift({ key: 'errorCode', label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('groupSettlement.columnInvoiceErrorCode'), sortble: true, class: 'small-column' });
      }
      if (this.isGroupSettlementEditable) {
        retVal.unshift({ key: 'selected', label: ' ', sortable: false, class: 'tiny-column' });
      }
      return retVal;
    },
    invalidInvoiceStatuses: function invalidInvoiceStatuses() {
      return [this.invoiceStatus.CANCELLED, this.invoiceStatus.INVALID, this.invoiceStatus.SETTLED];
    },
    isDevelopment: function isDevelopment() {
      return !this.isProductionEnvironment();
    },
    selectedInvoices: function selectedInvoices() {
      var retVal = this.tableItems.filter(function (item) {
        return item.selected === true;
      });
      return retVal;
    },
    hasInvalidInvoices: function hasInvalidInvoices() {
      var _this = this;

      var conditionOne = this.groupSettlement.groupSettlementItems.filter(function (item) {
        return _this.invalidInvoiceStatuses.includes(item.status);
      }).length > 0;
      var conditionTwo = this.tableItems.filter(function (item) {
        return item.errorCode !== null;
      }).length > 0;
      return conditionOne || conditionTwo;
    },
    showActivateButton: function showActivateButton() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.PENDING;
    },
    showDeactivateButton: function showDeactivateButton() {
      return [this.groupSettlementStatus.ACTIVE, this.groupSettlementStatus.INVALID, this.groupSettlementStatus.FLAGGED].includes(this.groupSettlement.groupSettlementStatus);
    },
    showCancelButton: function showCancelButton() {
      return [this.groupSettlementStatus.PENDING, this.groupSettlementStatus.ACTIVE, this.groupSettlementStatus.INVALID, this.groupSettlementStatus.FLAGGED].includes(this.groupSettlement.groupSettlementStatus);
    },
    isGroupSettlementEditable: function isGroupSettlementEditable() {
      return [this.groupSettlementStatus.PENDING].includes(this.groupSettlement.groupSettlementStatus);
    },
    canRemoveInvocie: function canRemoveInvocie() {
      return this.selectedInvoices.length > 0;
    },
    showFooter: function showFooter() {
      return this.showActivateButton || this.showCancelButton || this.isGroupSettlementEditable || this.showDeactivateButton;
    },
    groupSettlementCancelled: function groupSettlementCancelled() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.CANCELLED;
    },
    groupSettlementActive: function groupSettlementActive() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.ACTIVE;
    },
    groupSettlementInvalid: function groupSettlementInvalid() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.INVALID;
    },
    groupSettlementSettled: function groupSettlementSettled() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.SETTLED;
    },
    groupSettlementFlagged: function groupSettlementFlagged() {
      return this.groupSettlement.groupSettlementStatus === this.groupSettlementStatus.FLAGGED;
    },
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    },
    showAdditionalErrorContainer: function showAdditionalErrorContainer() {
      return this.additionalErrorList.length > 0;
    },
    isCurrentUserDebtor: function isCurrentUserDebtor() {
      return this.groupSettlement.debtorId && this.groupSettlement.debtorId === this.organizationId;
    },
    canReportIssue: function canReportIssue() {
      return this.isCurrentUserCreditor || this.isCurrentUserDebtor;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      this.load = true;
      this.$http.get(this.groupSettlementGetLink).then(function (response) {
        _this2.load = false;
        _this2.dataFetched = true;
        _this2.setSettlement(response.body.payload);
      }, function (error) {
        _this2.load = false;
        _this2.hasErrorWhenFetchingData = true;
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
      });
    },
    selectInvalidInvoices: function selectInvalidInvoices() {
      var _this3 = this;

      this.tableItems.forEach(function (item) {
        if (_this3.invalidInvoiceStatuses.includes(item.status)) {
          item.selected = true;
        }
        if (item.errorCode !== null) {
          item.selected = true;
        }
      });
    },
    setSettlement: function setSettlement(payload) {
      var _this4 = this;

      this.groupSettlement = payload.groupSettlement;
      this.setMassInput();
      this.tableItems = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.groupSettlement.groupSettlementItems));
      this.invoiceErrors = [];
      if (payload.groupSettlementItems) {
        this.invoiceErrors = payload.groupSettlementItems;
      }
      this.tableItems.forEach(function (item) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, 'errorCode', null);
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, 'selected', false);
        var doStyle = ![_this4.groupSettlementStatus.SETTLED, _this4.groupSettlementStatus.CANCELLED].includes(_this4.groupSettlement.groupSettlementStatus);
        if (doStyle) {
          if (_this4.invalidInvoiceStatuses.includes(item.status)) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_rowVariant', 'danger');
          }
          if (_this4.invoiceStatus.SETTLED === item.status) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_rowVariant', 'success');
          }
        }
        var invoiceError = _this4.invoiceErrors.find(function (errorEntry) {
          return item.invoiceId === errorEntry.groupSettlementItem.invoiceId;
        });
        if (typeof invoiceError !== 'undefined') {
          if (![_this4.invoiceStatus.ACTIVE, _this4.invoiceStatus.PARTIALLY_SETTLED].includes(item.status)) {
            if (doStyle) {
              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_rowVariant', 'danger');
            }
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, 'errorCode', invoiceError.groupSettlementItemError.code);
          }
        }
      });
    },
    setMassInput: function setMassInput() {
      this.massInput = this.groupSettlement.groupSettlementItems.map(function (item) {
        return item.invoiceId + ' ' + item.settlementAmount;
      }).join('\n');
    },
    showAddInvoicesInput: function showAddInvoicesInput() {
      this.showMassAdditionInput = true;
      this.additionalErrorList = [];
    },
    hideAddInvoicesInput: function hideAddInvoicesInput() {
      this.showMassAdditionInput = false;
      this.massAdditionInput = '';
    },
    groupSettlementStatusChange: function groupSettlementStatusChange(endpointLink, successMessage) {
      var _this5 = this;

      this.load = true;
      this.$http.post(endpointLink, { groupSettlementId: this.groupSettlement.groupSettlementId }).then(function (response) {
        _this5.load = false;
        // The response to the change status call does not return proper line errors,
        // We have to do another call, or just change the status of the settlement
        // this.setSettlement(response.data.payload)
        _this5.fetchData();
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: successMessage,
          errors: []
        });
      }, function (error) {
        _this5.load = false;
        _this5.logConsole(error);
        _this5.formatErrorResponse(error);
      });
    },
    groupSettlementActivate: function groupSettlementActivate() {
      this.groupSettlementStatusChange(this.groupSettlementActivateLink, this.$t('groupSettlement.groupSettlementActivated'));
    },
    groupSettlementDeactivate: function groupSettlementDeactivate() {
      this.groupSettlementStatusChange(this.groupSettlementDeactivateLink, this.$t('groupSettlement.groupSettlementDeactivated'));
    },
    groupSettlementRemoveInvoice: function groupSettlementRemoveInvoice() {
      var _this6 = this;

      this.load = true;
      var payload = {};
      var slectedArray = this.tableItems.filter(function (item) {
        return item.selected;
      });
      slectedArray = slectedArray.map(function (o) {
        return o['id'];
      });
      payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.groupSettlement));
      payload.groupSettlementItems = payload.groupSettlementItems.filter(function (item) {
        return !slectedArray.includes(item.id);
      });
      this.$http.post(this.editGroupSettlementLink, payload).then(function (response) {
        _this6.load = false;
        // we don't do this for know because the response is malformed,
        // this.setSettlement(response.data.payload.groupSettlement)
        // instead we just re-fetch the data
        _this6.fetchData();
      }, function (error) {
        _this6.load = false;
        _this6.logConsole(error);
        _this6.formatErrorResponse(error);
      });
    },
    groupSettlementAddInvoice: function groupSettlementAddInvoice() {
      var _this7 = this;

      this.$v.massAdditionInput.$touch();
      if (this.$v.massAdditionInput.$invalid) {
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('groupSettlement')
        });
        this.additionalErrorList = this.getMassInputErrors(this.massAdditionInput, { minimumInvoices: 1 });
      } else {
        this.additionalErrorList = [];
        this.load = true;
        var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.groupSettlement));
        this.parseMassInput(this.massAdditionInput).forEach(function (row) {
          if (row === '') {
            return;
          }
          var temp = row.match(/\S+/g);
          var invoiceId = temp[0];
          var amount = temp[1] ? Number(temp[1]) : 0;
          payload.groupSettlementItems.push({ InvoiceId: invoiceId, SettlementAmount: amount });
        });
        this.$http.post(this.editGroupSettlementLink, payload).then(function (response) {
          _this7.load = false;
          _this7.massAdditionInput = '';
          _this7.showMassAdditionInput = false;
          _this7.fetchData();
        }, function (error) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(error.body.payload) !== undefined && error.body.payload !== null) {
            if (typeof error.body.payload.groupSettlementItems !== 'undefined') {
              var _additionalErrorList;

              var localErrorList = [];
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(error.body.payload.groupSettlementItems).forEach(function (row) {
                if (typeof row.groupSettlementItemError !== 'undefined') {
                  var errorPrefix = _this7.$t('groupSettlement.massInputError.returnedCodePrefix', [row.groupSettlementItem.invoiceId]);
                  var errorMsg = _this7.$t('apiStatusCodes.' + row.groupSettlementItemError.code);
                  if (row.groupSettlementItem.groupSettlementId) {
                    errorMsg += ' - ' + row.groupSettlementItem.groupSettlementId;
                  }
                  localErrorList.push(errorPrefix + ' ' + errorMsg);
                }
              });
              (_additionalErrorList = _this7.additionalErrorList).push.apply(_additionalErrorList, localErrorList);
            }
          }
          _this7.load = false;
          _this7.logConsole(error);
          _this7.formatErrorResponse(error);
        });
      }
    },
    groupSettlementCancel: function groupSettlementCancel() {
      this.groupSettlementStatusChange(this.groupSettlementCancelLink, this.$t('groupSettlement.groupSettlementCanceled'));
    },
    toggleShowTable: function toggleShowTable() {
      if (this.showTable) {
        // this.setMassInput() // is this expensive?
      }
      this.showTable = !this.showTable;
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      this.$v.$touch();
      if (this.$v.massInput.$invalid) {
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('groupSettlement')
        });
        this.errorList = this.getMassInputErrors(this.massInput);
      } else {
        this.errorList = [];
        this.submitGroupSettlement();
      }
    },

    submitGroupSettlement: function submitGroupSettlement(e) {
      var _this8 = this;

      this.logConsole('Submitting Group Settlement');
      this.load = true;
      this.groupSettlement.groupSettlementItems = [];
      this.parseMassInput(this.massInput).forEach(function (row) {
        if (row === '') {
          return;
        }
        var temp = row.match(/\S+/g);
        var invoiceId = temp[0];
        var amount = temp[1] ? Number(temp[1]) : 0;
        _this8.groupSettlement.groupSettlementItems.push({ InvoiceId: invoiceId, SettlementAmount: amount });
      });
      this.$http.post(this.editGroupSettlementLink, this.groupSettlement).then(function (response) {
        _this8.load = false;
        _this8.logConsole(response);
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this8.$t('groupSettlement.groupSettlementEdited'),
          errors: []
        });
        _this8.$nextTick(function () {
          document.body.scrollTop = 0; // safari
          document.documentElement.scrollTop = 0; // chrome, ie, ff
        });
        _this8.showTable = true;
        _this8.fetchData();
      }, function (error) {
        _this8.load = false;
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(error.body.payload) !== undefined && error.body.payload !== null) {
          if (typeof error.body.payload.groupSettlementItems !== 'undefined') {
            var _errorList;

            var localErrorList = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(error.body.payload.groupSettlementItems).forEach(function (row) {
              if (typeof row.groupSettlementItemError !== 'undefined') {
                var errorPrefix = _this8.$t('groupSettlement.massInputError.returnedCodePrefix', [row.groupSettlementItem.invoiceId]);
                var errorMsg = _this8.$t('apiStatusCodes.' + row.groupSettlementItemError.code);
                localErrorList.push(errorPrefix + ' ' + errorMsg);
              }
            });
            (_errorList = _this8.errorList).push.apply(_errorList, localErrorList);
          }
        }
        _this8.logConsole(error);
        _this8.formatErrorResponse(error);
      });
    },
    reportSettlementIssue: function reportSettlementIssue() {
      var _this9 = this;

      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.issueCategoriesGet + '/' + this.IssueCategory[1].DESCRIPTION).then(function (response) {
        _this9.logConsole(response);
        _this9.selectedCategory = null;
        _this9.currentIssueCategory = null;
        _this9.formattedIssueCategories = null;
        _this9.currentIssueSettlementId = null;
        _this9.currentIssueReport = {};
        _this9.currentIssue = _this9.IssueCategory[1];
        _this9.currentIssueCategories = response.data.payload;
        _this9.currentIssueReport.resourceId = _this9.groupSettlement.groupSettlementId;
        _this9.currentIssueAmount = _this9.groupSettlement.amount;
        _this9.formatReportCategories(response.data.payload);

        _this9.$refs.reportIssueModal.show();
        _this9.load = false;
      }, function (error) {
        _this9.logConsole(error);
        _this9.formatErrorResponse(error);
        _this9.load = false;
      });
    },
    categoryChanged: function categoryChanged() {
      for (var i = 0; i < this.currentIssueCategories.length; i++) {
        if (this.currentIssueCategories[i].id === this.selectedCategory) {
          this.currentIssueCategory = this.currentIssueCategories[i];
          return;
        }
      }
    },
    formatReportCategories: function formatReportCategories(categories) {
      this.formattedIssueCategories = [];
      for (var i = 0; i < categories.length; i++) {
        if (categories[i].id === 4) {
          if (!this.hasInvoiceSettlements) {
            continue;
          }
        }
        if (categories[i].id === 5) {
          continue;
        }
        var category = {
          text: categories[i].categoryCyr,
          value: categories[i].id
        };
        if (this.isCurrentUserDebtor) {
          this.formattedIssueCategories.push(category);
        }
      }
    },
    submitIssueReport: function submitIssueReport() {
      var _this10 = this;

      this.currentIssueReport.resource = this.currentIssue.ID;

      if (this.currentIssueCategory) {
        this.currentIssueReport.category = this.currentIssueCategory.category;
        this.currentIssueReport.requiresData = this.currentIssueCategory.requiresData;
        this.currentIssueReport.categoryId = this.currentIssueCategory.id;
      }

      if (this.currentIssue.ID === this.IssueCategory[1].ID) {
        if (this.currentIssueCategory && this.currentIssueCategory.id === 3) {
          if (this.currentIssueReport.data && this.currentIssueReport.data) {
            this.currentIssueReport.data = this.currentIssueAmount + ' ' + this.currentIssueReport.data;
          }
        } else if (this.currentIssueCategory && this.currentIssueCategory.id === 4) {
          if (this.currentIssueSettlementId && this.currentIssueReport.data && this.currentIssueReport.data) {
            this.currentIssueReport.data = this.currentIssueSettlementId + ' ' + this.currentIssueAmount + ' ' + this.currentIssueReport.data;
          }
        }
      }

      var report = [];
      report.push(this.currentIssueReport);

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.issueRegisterPost, report).then(function (response) {
        _this10.logConsole(response);
        _this10.load = false;

        var reportedIssue = response.data.payload[0];
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this10.$t('issues.reportIssueSuccess') + ' - ',
          link: '/reported-issues/' + reportedIssue.id,
          linkDescription: reportedIssue.id,
          errors: []
        });
        _this10.subscribeToIssueProcessedNotifications(reportedIssue.id);
      }, function (error) {
        _this10.logConsole(error);
        _this10.formatErrorResponse(error);
        _this10.load = false;
      });
    },
    subscribeToIssueProcessedNotifications: function subscribeToIssueProcessedNotifications(issueId) {
      this.subscribeToIssueProcessedNotificationType(issueId);
    },
    subscribeToIssueProcessedNotificationType: function subscribeToIssueProcessedNotificationType(issueId) {
      var _this11 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$apiConfig.notificationSubcribe, { notificationTypes: [this.NotificationTypes.IssueProcessed], resourceId: issueId, resourceType: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$config.issueResourceType }).then(function (response) {
        _this11.logConsole(response);
        _this11.subscribeToEmailSink();
      }, function (error) {
        _this11.logConsole(error);
      });
    }
  },
  validations: {
    massInput: {
      MassInputValidator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators__["a" /* MassInputValidator */])({ minimumInvoices: 2 })
    },
    massAdditionInput: {
      MassInputValidator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__validators__["a" /* MassInputValidator */])({ minimumInvoices: 1 })
    },
    groupSettlement: {
      groupSettlementNumber: {
        required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__activate_invoice_ActivateInvoice__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__activate_invoice_ActivateInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__activate_invoice_ActivateInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__closed_org_settlement_ClosedOrgSettlement__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__closed_org_settlement_ClosedOrgSettlement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__closed_org_settlement_ClosedOrgSettlement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__move_invoices_MoveInvoices__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__move_invoices_MoveInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__move_invoices_MoveInvoices__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default.a,
    Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"],
    ActivateInvoice: __WEBPACK_IMPORTED_MODULE_5__activate_invoice_ActivateInvoice___default.a,
    ClosedOrgSettlement: __WEBPACK_IMPORTED_MODULE_6__closed_org_settlement_ClosedOrgSettlement___default.a,
    MoveInvoices: __WEBPACK_IMPORTED_MODULE_7__move_invoices_MoveInvoices___default.a
  },
  data: function data() {
    return {
      settleByIdf: false,
      load: false,
      errorList: [],
      invoiceSettlement: {
        InvoiceNumber: '',
        DebtorCompanyNumber: '',
        CreditorCompanyNumber: '',
        CreditorTaxIdNumber: '',
        Bank: '',
        SettledAmount: 0
      },
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    }
  },
  methods: {
    submitSettlement: function submitSettlement(e) {
      var _this = this;

      this.logConsole('Submitting invoice settlement');
      this.load = true;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.registerSettlementsPost, [this.invoiceSettlement]).then(function (response) {
        _this.errorList = [];
        _this.logConsole(response);
        _this.load = false;
        // get body data
        if (!!response.data && Array.isArray(response.data.payload)) {
          response.data.payload.forEach(function (element) {
            if (element.settlementError) {
              _this.errorList.push(element);
            }
          });
        }
        if (_this.errorList.length === 0) {
          var invoice = response.data;
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: 'Успешно измирен износ' + ' - ' + invoice.payload[0].settlement.settledAmount,
            errors: []
          });
        }
        _this.$refs.registerSettlementForm.reset();
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        _this.load = false;
      });
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      errorList: [],
      invoiceIds: null
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    }
  },
  methods: {
    submitActivation: function submitActivation(e) {
      var _this = this;

      var parsedData = [];
      this.invoiceIds.split(/\r?\n/).forEach(function (element) {
        var invoiceId = element.trim();
        if (invoiceId) {
          parsedData.push({ invoiceId: invoiceId });
        }
      });

      if (!parsedData.length) {
        return;
      }

      this.load = true;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.activateInvoicesPost, parsedData).then(function (response) {
        _this.errorList = [];
        _this.logConsole(response);
        _this.load = false;
        // get body data
        if (!!response.data && Array.isArray(response.data.payload)) {
          response.data.payload.forEach(function (element) {
            if (element.liabilityError) {
              _this.errorList.push(element.liability.invoiceId + ' : ' + element.liabilityError.description);
            }
          });
        }
        if (_this.errorList.length === 0) {
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: 'Фактуре успешно активиране',
            errors: []
          });
        }
        _this.$refs.registerSettlementForm.reset();
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        _this.load = false;
      }).finally(function (response) {
        _this.invoiceIds = null;
      });
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      errorList: [],
      invoiceIds: null,
      settlementMessage: null
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    }
  },
  methods: {
    submitActivation: function submitActivation(e) {
      var _this = this;

      var parsedData = [];
      this.invoiceIds.split(/\r?\n/).forEach(function (element) {
        var invoiceId = element.trim();
        if (invoiceId) {
          parsedData.push({ invoiceId: invoiceId });
        }
      });

      if (!parsedData.length) {
        return;
      }

      var input = {
        liabilities: parsedData,
        SettlementMessage: this.settlementMessage.trim()
      };

      this.load = true;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.closedOrganizationSettlementPost, input).then(function (response) {
        _this.errorList = [];
        _this.logConsole(response);
        _this.load = false;
        // get body data
        if (!!response.data && Array.isArray(response.data.payload)) {
          response.data.payload.forEach(function (element) {
            if (element.liabilityError) {
              _this.errorList.push(element.liability.invoiceId + ' : ' + element.liabilityError.description);
            }
          });
        }
        if (_this.errorList.length === 0) {
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: 'Фактуре успешно измирене',
            errors: []
          });
        }
        _this.$refs.registerSettlementForm.reset();
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        _this.load = false;
      }).finally(function (response) {
        _this.invoiceIds = null;
      });
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_autocomplete_Autocomplete__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_autocomplete_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_autocomplete_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader___default.a,
    Autocomplete: __WEBPACK_IMPORTED_MODULE_2__components_misc_autocomplete_Autocomplete___default.a
  },
  data: function data() {
    return {
      load: false,
      errorList: [],
      invoiceIds: null,
      autoCompleteUrl_organization: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.organizationAutocompleteGet,
      transferredInvoices: [],
      sourceOrganization: {
        id: null,
        companyNumber: null,
        taxIdNumber: null,
        name: null
      },
      targetOrganization: {
        id: null,
        companyNumber: null,
        taxIdNumber: null,
        name: null
      }
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.transferredInvoices.length > 0;
    }
  },
  methods: {
    submitActivation: function submitActivation() {
      var _this = this;

      this.transferredInvoices = [];

      var payload = {
        sourceOrganizationId: this.sourceOrganization.id,
        targetOrganizationId: this.targetOrganization.id,
        targetOrganizationCompanyNumber: this.targetOrganization.companyNumber,
        targetOrganizationTaxIdNumber: this.targetOrganization.taxIdNumber,
        targetOrganizationName: this.targetOrganization.name
      };

      this.load = true;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.moveInvoicesPost, payload).then(function (response) {
        _this.transferredInvoices = response.data.payload.transferredInvoices;
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: 'Фактуре успешно пренете',
          errors: []
        });
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        _this.load = false;
      }).finally(function () {
        _this.sourceOrganization.companyNumber = null;
        _this.targetOrganization.companyNumber = null;
      });
    },
    prepareResponseData: function prepareResponseData(data) {
      return data.payload;
    },
    sourceOrganizationResolved: function sourceOrganizationResolved(organization) {
      if (!organization) {
        return;
      }
      this.sourceOrganization.id = organization.id;
      this.sourceOrganization.companyNumber = organization.companyNumber;
      this.sourceOrganization.taxIdNumber = organization.taxIdNumber;
      this.sourceOrganization.name = organization.name;
    },
    targetOrganizationResolved: function targetOrganizationResolved(organization) {
      if (!organization) {
        return;
      }
      this.targetOrganization.id = organization.id;
      this.targetOrganization.companyNumber = organization.companyNumber;
      this.targetOrganization.taxIdNumber = organization.taxIdNumber;
      this.targetOrganization.name = organization.name;
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sides_CreditorInvoices__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sides_CreditorInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sides_CreditorInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sides_DebtorInvoices__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sides_DebtorInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sides_DebtorInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sides_AdminInvoices__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sides_AdminInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sides_AdminInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_auth__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoices',
  components: {
    ContextHeader: __WEBPACK_IMPORTED_MODULE_1__components_misc_context_header_ContextHeader___default.a,
    CreditorInvoices: __WEBPACK_IMPORTED_MODULE_2__sides_CreditorInvoices___default.a,
    DebtorInvoices: __WEBPACK_IMPORTED_MODULE_3__sides_DebtorInvoices___default.a,
    AdminInvoices: __WEBPACK_IMPORTED_MODULE_4__sides_AdminInvoices___default.a
  },
  data: function data() {
    return {
      isAdmin: false,
      headers: [{ title: this.$t('invoices.invoicesAsCreditor'), value: 'creditor', help_value: 'list' }, { title: this.$t('invoices.invoicesAsDebtor'), value: 'debtor', help_value: 'list' }, { title: this.$t('invoices.invoicesAsAdministrator'), value: 'all', help_value: 'list-admin' }],
      query: {},
      tabIndex: 0,
      namedTab: '',
      stateTab: ''
    };
  },

  watch: {
    '$route.query.side': function $routeQuerySide() {
      this.setInvoiceSide();
    }
    // '$route.query' (event) {
    //   this.handleQueryFilterChange(event)
    // }

  },
  created: function created() {
    this.isAdmin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["k" /* hasAdminClaim */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["g" /* hasInvoiceReviewAllClaim */])();
  },
  mounted: function mounted() {
    this.setInvoiceSide();
  },

  methods: {
    setInvoiceSide: function setInvoiceSide() {
      var side = this.$route.query.side;
      var header = null;
      if (side && side.length > 0) {
        header = this.getTabValue(side);
        this.changeTabState(this, this.$refs, side);
      } else {
        var state = this.loadTabState(this.$route.path);
        if (state && state.length > 0) {
          header = this.getTabValue(state);
          // Go to route
          this.$router.push({ path: this.$route.path, query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { side: state }) });
        } else {
          header = this.getTabHeader(0);
          this.changeTabState(this, this.$refs, header.value);
        }
      }
      this.namedTab = header.help_value;
    },
    tabChanged: function tabChanged() {
      var header = this.getTabHeader(this.tabIndex);
      if (header) {
        var param = header.value;

        // Save to cookie
        this.saveTabState(this.$route.path, param);
        this.$router.push({ path: this.$route.path, query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { side: param }) });
      }
    },
    getTabValue: function getTabValue(value) {
      for (var i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value.localeCompare(value) === 0) {
          return this.headers[i];
        }
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin-invoices',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      InvoiceStatus: {
        ACTIVE: 1,
        INVALID: 2,
        CANCELLED: 3,
        PARTIALLY_SETTLED: 4,
        SETTLED: 5,
        ASSIGNED: 6,
        PROINVOICE: 7,
        OPEN: 101
      },
      tOptions: {
        sortable: true, // Show sortable arrows
        filter: true, // Show filter fields
        checkboxes: true, // Show checkboxes
        checkboxValue: 'invoiceId', // Which value should checkboxes use
        checkboxesPersist: false, // Should checked values persists after new request
        per_page_options: [5, 10, 15, 25, 50], // Values that will be shown i the select list
        per_page_default: 5,
        payloadsTotalPropertyName: 'additionalInformation', // Name of the the payload property that returns total num of rows (total, count,..)
        additionalQueryParameter: 'side=creditor',
        statuses: this.InvoiceStatus,
        partialCount: true,
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.CANCELLED || row['status'] === statuses.INVALID;
          }
        },
        highlightedRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.ASSIGNED;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'invoices/' + row['invoiceId'];
          }
        }
      },
      tColumns: [{
        columnName: 'formattedInvoiceNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.invoiceNumber;
        }
      }, {
        columnName: 'creditorName',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreditor'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.creditorName;
        }
      }, {
        columnName: 'debtorCompanyNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnBudgetIdNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.debtorCompanyNumber;
        }
      }, {
        columnName: 'debtorName',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDebtor'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.debtorName;
        }
      }, {
        columnName: 'amount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'amount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'amount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'settledAmount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'settledAmount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'settledAmount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnSettledAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'creationDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeFrom'),
          value: 'creationDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeTo'),
          value: 'creationDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'dueDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'dueDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'dueDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceStatus'),
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.4'), value: 4 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.5'), value: 5 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.6'), value: 6 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.7'), value: 7 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.101'), value: 101 }],
        cell: function cell(row) {
          return null;
        }
      }],
      optionsVisible: false,
      cancelComments: '',
      selectedInvoices: [],
      liabilitiesUrl: '',
      liabilitiesReportsUrl: '',
      hasInvoiceCancelClaim: false,
      hasInvoiceExportClaim: false
    };
  },

  created: function created() {
    this.liabilitiesUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedInvoiceLiabilitiesGet;
    this.liabilitiesReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateInvoiceLiabilitiesReport;

    this.hasInvoiceCancelClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["p" /* hasInvoiceCancelClaim */])();
    this.hasInvoiceExportClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["h" /* hasInvoiceExportClaim */])();
    this.tOptions.statuses = this.InvoiceStatus;
  },
  methods: {
    onChecked: function onChecked(checkedValues) {
      this.selectedInvoices = checkedValues;
      this.optionsVisible = checkedValues.length > 0;
    },

    cancelInvoices: function cancelInvoices(e) {
      var _this = this;

      this.load = true;
      var request = [];

      for (var i = 0; i < this.selectedInvoices.length; i++) {
        request.push({ InvoiceId: this.selectedInvoices[i], CancelComments: this.cancelComments });
      }

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.cancelInvoicesPost, request).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('invoices.cancellationSuccess'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    exportToCsv: function exportToCsv() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceCsv, this.selectedInvoices, 'export.csv', this.stopLoader, this.convertCSVseparator);
    },
    exportToJson: function exportToJson() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceJson, this.selectedInvoices, 'export.json', this.stopLoader);
    },
    stopLoader: function stopLoader() {
      this.load = false;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'creditor-invoices',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      InvoiceStatus: {
        ACTIVE: 1,
        INVALID: 2,
        CANCELLED: 3,
        PARTIALLY_SETTLED: 4,
        SETTLED: 5,
        ASSIGNED: 6,
        PROINVOICE: 7,
        OPEN: 101
      },
      tOptions: {
        sortable: true, // Show sortable arrows
        filter: true, // Show filter fields
        checkboxes: true, // Show checkboxes
        checkboxValue: 'invoiceId', // Which value should checkboxes use
        checkboxesPersist: false, // Should checked values persists after new request
        per_page_options: [5, 10, 15, 25, 50], // Values that will be shown i the select list
        per_page_default: 5,
        payloadsTotalPropertyName: 'additionalInformation', // Name of the the payload property that returns total num of rows (total, count,..)
        additionalQueryParameter: 'side=creditor',
        partialCount: true,
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.CANCELLED || row['status'] === statuses.INVALID;
          }
        },
        hiddenRowMarker: {
          criteria: function criteria(row) {
            return row['assignedInvoiceId'] && row['assignedInvoiceId'].length > 0;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'invoices/' + row['invoiceId'];
          }
        }
      },
      tColumns: [{
        columnName: 'formattedInvoiceNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.invoiceNumber;
        }
      }, {
        columnName: 'debtorCompanyNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnBudgetIdNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.debtorCompanyNumber;
        }
      }, {
        columnName: 'debtorName',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDebtor'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.debtorName;
        }
      }, {
        columnName: 'amount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'amount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'amount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'settledAmount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'settledAmount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'settledAmount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnSettledAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'creationDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeFrom'),
          value: 'creationDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeTo'),
          value: 'creationDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'dueDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'dueDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'dueDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceStatus'),
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.4'), value: 4 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.5'), value: 5 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.6'), value: 6 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.7'), value: 7 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.101'), value: 101 }],
        cell: function cell(row) {
          return null;
        }
      }],
      tabIndex: null,
      optionsVisible: false,
      cancelComments: '',
      selectedInvoices: [],
      liabilitiesUrl: '',
      hasInvoiceCancelClaim: false,
      hasInvoiceExportClaim: false
    };
  },

  created: function created() {
    this.liabilitiesUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedInvoiceLiabilitiesGet;
    this.liabilitiesReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateInvoiceLiabilitiesReport;

    this.hasInvoiceCancelClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["p" /* hasInvoiceCancelClaim */])();
    this.hasInvoiceExportClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["h" /* hasInvoiceExportClaim */])();
    this.tOptions.statuses = this.InvoiceStatus;
  },
  methods: {
    onChecked: function onChecked(checkedValues) {
      this.selectedInvoices = checkedValues;
      this.optionsVisible = checkedValues.length > 0;
    },

    cancelInvoices: function cancelInvoices(e) {
      var _this = this;

      this.load = true;
      var request = [];

      for (var i = 0; i < this.selectedInvoices.length; i++) {
        request.push({ InvoiceId: this.selectedInvoices[i], CancelComments: this.cancelComments });
      }

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.cancelInvoicesPost, request).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('invoices.cancellationSuccess'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    exportToCsv: function exportToCsv() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceCsv, this.selectedInvoices, 'export.csv', this.stopLoader, this.convertCSVseparator);
    },
    exportToJson: function exportToJson() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceJson, this.selectedInvoices, 'export.json', this.stopLoader);
    },
    stopLoader: function stopLoader() {
      this.load = false;
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'debtor-invoices',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      InvoiceStatus: {
        ACTIVE: 1,
        INVALID: 2,
        CANCELLED: 3,
        PARTIALLY_SETTLED: 4,
        SETTLED: 5,
        ASSIGNED: 6,
        PROINVOICE: 7,
        OPEN: 101
      },
      tOptions: {
        sortable: true, // Show sortable arrows
        filter: true, // Show filter fields
        checkboxes: true, // Show checkboxes
        checkboxValue: 'invoiceId', // Which value should checkboxes use
        checkboxesPersist: false, // Should checked values persists after new request
        per_page_options: [5, 10, 15, 25, 50], // Values that will be shown i the select list
        per_page_default: 5,
        payloadsTotalPropertyName: 'additionalInformation', // Name of the the payload property that returns total num of rows (total, count,..)
        additionalQueryParameter: 'side=debtor',
        partialCount: true,
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.CANCELLED || row['status'] === statuses.INVALID;
          }
        },
        highlightedRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.ASSIGNED;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'invoices/' + row['invoiceId'];
          }
        }
      },
      tColumns: [{
        columnName: 'formattedInvoiceNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.invoiceNumber;
        }
      }, {
        columnName: 'creditorName',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreditor'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.creditorName;
        }
      }, {
        columnName: 'debtorCompanyNumber',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnBudgetIdNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.debtorCompanyNumber;
        }
      }, {
        columnName: 'amount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'amount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'amount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'settledAmount',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountFrom'),
          value: 'settledAmount-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceAmountTo'),
          value: 'settledAmount-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnSettledAmount'),
        filterType: 'rangeMoney',
        hideFilter: true,
        showSummary: true,
        align: 'left',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'creationDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeFrom'),
          value: 'creationDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDateRangeTo'),
          value: 'creationDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnCreationDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'dueDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'dueDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'dueDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnDueDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.columnInvoiceStatus'),
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.4'), value: 4 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.5'), value: 5 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.6'), value: 6 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.7'), value: 7 }, { key: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t('invoices.invoiceStatus.101'), value: 101 }],
        cell: function cell(row) {
          return null;
        }
      }],
      optionsVisible: false,
      cancelComments: '',
      selectedInvoices: [],
      liabilitiesUrl: '',
      hasInvoiceCancelClaim: false,
      hasInvoiceExportClaim: false
    };
  },

  created: function created() {
    this.liabilitiesUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedInvoiceLiabilitiesGet;
    this.liabilitiesReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateInvoiceLiabilitiesReport;

    this.hasInvoiceCancelClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["p" /* hasInvoiceCancelClaim */])();
    this.hasInvoiceExportClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__router_auth__["h" /* hasInvoiceExportClaim */])();
    this.tOptions.statuses = this.InvoiceStatus;
  },
  methods: {
    onChecked: function onChecked(checkedValues) {
      this.selectedInvoices = checkedValues;
      this.optionsVisible = checkedValues.length > 0;
    },

    cancelInvoices: function cancelInvoices(e) {
      var _this = this;

      this.load = true;
      var request = [];

      for (var i = 0; i < this.selectedInvoices.length; i++) {
        request.push({ InvoiceId: this.selectedInvoices[i], CancelComments: this.cancelComments });
      }

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.cancelInvoicesPost, request).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('invoices.cancellationSuccess'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    exportToCsv: function exportToCsv() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceCsv, this.selectedInvoices, 'export.csv', this.stopLoader, this.convertCSVseparator);
    },
    exportToJson: function exportToJson() {
      this.logConsole('Exporting invoices' + this.selectedInvoices);
      this.load = true;
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.exportInvoiceJson, this.selectedInvoices, 'export.json', this.stopLoader);
    },
    stopLoader: function stopLoader() {
      this.load = false;
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_autocomplete_Autocomplete__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_autocomplete_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_autocomplete_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_datepicker___ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);


//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'single-invoice',
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_validation__["a" /* validationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default.a,
    Autocomplete: __WEBPACK_IMPORTED_MODULE_3__components_misc_autocomplete_Autocomplete___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader___default.a,
    Money: __WEBPACK_IMPORTED_MODULE_9_v_money__["Money"],
    Datepicker: __WEBPACK_IMPORTED_MODULE_12__utils_datepicker___["a" /* default */]
  },
  data: function data() {
    return {
      load: false,
      dateFormat: this.$store.getters.dateFormat,
      dateLocale: __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__["a" /* srCYRL */],
      IssueCategory: [{ DESCRIPTION: 'InvoiceLiability', ID: 1 }, { DESCRIPTION: 'InvoiceSettlement', ID: 2 }],
      IssueCategories: {
        VALIDITY: 'Validity'
      },
      DeltaStatus: {
        ACTIVE: 1,
        CANCELLED: 2,
        ACTIVATION: 3
      },
      InvoiceStatus: {
        ACTIVE: 1,
        INVALID: 2,
        CANCELLED: 3,
        PARTIALLY_SETTLED: 4,
        SETTLED: 5,
        ASSIGNED: 6,
        PROINVOICE: 7
      },
      SettlementStatus: {
        ACTIVE: 1,
        CANCELLED: 2
      },
      IssueCategoryVisibility: {
        EVERYONE: 1,
        CREDITOR: 2,
        DEBTOR: 3
      },
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      invoiceId: this.$route.params.invoiceId,
      invoice: {},
      invoiceDelta: {},
      settlementUrl: '',
      fields: [{
        key: 'id',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnId')
      }, {
        key: 'settledAmount',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnSettledAmount')
      }, {
        key: 'settlementDate',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnSettlementDate')
      }, {
        key: 'settlementComments',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnSettlementComments')
      }, {
        key: 'settlementStatus',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnSettlementStatus')
      }, {
        key: 'cancelSettlement',
        label: ' '
      }],
      settlements: [],
      deltaFields: [{
        key: 'amount',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.invoiceDeltaColumnAmount')
      }, {
        key: 'creationDate',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.invoiceDeltaColumnDate')
      }, {
        key: 'comments',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.invoiceDeltaColumnComments')
      }, {
        key: 'previousDueDate',
        label: __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('invoices.columnPreviousDueDate')
      }, {
        key: 'cancelSlot',
        label: ' '
      }],
      invoiceDeltas: [],
      invoiceSettlementIDs: [],
      hasInvoiceCancelClaim: false,
      hasInvoiceExportClaim: false,
      hasInvoiceAssignClaim: false,
      hasInvoiceActivateClaim: false,
      hasInvoiceActivateOnceClaim: false,
      hasInvoiceUserSettlementClaim: false,
      hasAdminClaim: false,
      autoCompleteUrl_budgetId: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.budgetRegistryGet,
      invoiceLink: '',
      assignationLink: '',
      settlementDeltaSelected: false,
      selectedAmountDeltaId: 0,
      selectedAmountDeltaAmount: 0,
      assignedDebtorCompanyNumber: null,
      assignedDebtorName: null,
      assignedDebtorTaxIdNumber: null,
      debtorLink: '',
      creditorLink: '',
      organizationId: 0,
      currentIssue: null,
      currentIssueCategories: null,
      formattedIssueCategories: null,
      currentIssueCategory: null,
      selectedCategory: null,
      currentIssueReport: {},
      currentIssueAmount: 0,
      currentIssueSettlementId: null,
      invoiceFields: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoice_fields,
      activeIssues: [],
      reportedIssues: 0,
      reportedActiveIssues: 0,
      showCollapse: {
        invoice_settlements: false,
        invoice_assignment: false,
        amount_change: false
      },
      Sinks: {
        Email: 1
      },
      NotificationTypes: {
        IssueProcessed: 5
      },
      invoiceSettlement: {
        settlementId: null,
        cancelComments: null,
        IsCompensationSettlement: false
      }
    };
  },

  computed: {
    invoiceActive: function invoiceActive() {
      return this.invoice.status === this.InvoiceStatus.ACTIVE;
    },
    invoiceProinvoice: function invoiceProinvoice() {
      return this.invoice.status === this.InvoiceStatus.PROINVOICE;
    },
    invoiceCancelled: function invoiceCancelled() {
      return this.invoice.status === this.InvoiceStatus.CANCELLED;
    },
    invoiceInvalid: function invoiceInvalid() {
      return this.invoice.status === this.InvoiceStatus.INVALID;
    },
    invoiceSettled: function invoiceSettled() {
      return this.invoice.status === this.InvoiceStatus.SETTLED;
    },
    invoicePartiallySettled: function invoicePartiallySettled() {
      return this.invoice.status === this.InvoiceStatus.PARTIALLY_SETTLED;
    },
    invoiceAssignedFrom: function invoiceAssignedFrom() {
      return this.invoice.assignedInvoiceId && this.invoice.assignedInvoiceId.length > 0;
    },
    invoiceAssignedTo: function invoiceAssignedTo() {
      return this.invoice.status === this.InvoiceStatus.ASSIGNED;
    },
    invoiceReportedInvalid: function invoiceReportedInvalid() {
      var _this = this;

      return this.activeIssues.filter(function (ai) {
        return ai.category === _this.IssueCategories.VALIDITY;
      }).length !== 0;
    },
    exportDisabled: function exportDisabled() {
      return !this.hasInvoiceExportClaim || this.load;
    },
    cancelDisabled: function cancelDisabled() {
      return !this.hasInvoiceCancelClaim || // User doesn't have cancel claim
      this.invoiceSettled || // Invoice is settled
      this.invoicePartiallySettled || // Invoice is partially settled
      this.load; // Loading state
    },
    canCancelInvoice: function canCancelInvoice() {
      return this.invoice.creditorId === this.organizationId && !this.invoiceCancelled && !this.invoiceInvalid;
    },
    canAssignInvoice: function canAssignInvoice() {
      return this.hasInvoiceAssignClaim && // User has assignation claim
      !this.invoiceAssignedTo && // Invoice is not already assigned to
      !this.invoiceAssignedFrom && // Invoice is not already assigned from
      !this.invoiceCancelled && // Invoice is not cancelled
      !this.invoiceInvalid && // Invoice is not invalid
      !this.invoicePartiallySettled && // Invoice is not partially settled
      !this.invoiceSettled; // Invoice is not settled
    },
    canViewAssignement: function canViewAssignement() {
      return this.invoiceAssignedFrom || this.invoiceAssignedTo;
    },
    assignDisabled: function assignDisabled() {
      return this.invoiceCancelled || // Invoice is cancelled
      !this.invoice.debtorId || this.invoice.debtorId !== this.organizationId || // User is not direct debtor
      !this.hasInvoiceAssignClaim || // User doesn't have assignation claim
      this.load; // Loading state
    },
    isPublicEntity: function isPublicEntity() {
      return this.assignedDebtorCompanyNumber && this.assignedDebtorCompanyNumber.length === 5;
    },
    isPrivateEntity: function isPrivateEntity() {
      return this.assignedDebtorCompanyNumber && this.assignedDebtorCompanyNumber.length === 8;
    },
    canActivateInvoice: function canActivateInvoice() {
      return this.hasInvoiceActivateClaim || this.hasInvoiceActivateOnceClaim;
    },
    canSettleInvoice: function canSettleInvoice() {
      return !this.invoiceSettled && this.hasInvoiceUserSettlementClaim && this.invoice.debtorId === this.organizationId;
    },
    canCancelSettlement: function canCancelSettlement() {
      return this.hasInvoiceUserSettlementClaim && this.invoice.debtorId === this.organizationId;
    },
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      return this.hasAdminClaim;
    },
    isCurrentUserDebtor: function isCurrentUserDebtor() {
      return this.invoice.debtorId && this.invoice.debtorId === this.organizationId;
    },
    isCurrentUserCreditor: function isCurrentUserCreditor() {
      return this.invoice.creditorId && this.invoice.creditorId === this.organizationId;
    },
    hasInvoiceSettlements: function hasInvoiceSettlements() {
      return this.settlements && this.settlements.length > 0;
    },
    canReportIssue: function canReportIssue() {
      return this.isCurrentUserCreditor || this.isCurrentUserDebtor;
    },
    lastActiveSettlement: function lastActiveSettlement() {
      var _this2 = this;

      var activeSettlements = this.settlements.filter(function (settlement) {
        return settlement.status === _this2.SettlementStatus.ACTIVE;
      });
      if (activeSettlements.length === 0) {
        return null;
      }
      var retVal = activeSettlements[0].settlementDate;

      activeSettlements.forEach(function (settlement) {
        if (new Date(settlement.settlementDate) > new Date(retVal)) {
          retVal = settlement.settlementDate;
        }
      });
      return retVal;
    },
    collapseAllDisabled: function collapseAllDisabled() {
      return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.showCollapse).includes(true);
    },
    expandAllDisabled: function expandAllDisabled() {
      return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.showCollapse).includes(false);
    }
  },
  mounted: function mounted() {
    switch (this.$store.getters.dateLocale) {
      case 'sr-cyrl':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__["a" /* srCYRL */];
        break;
      case 'sr':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__["b" /* sr */];
        break;
      case 'en':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__["c" /* en */];
        break;
      default:
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_13__utils_datepicker_locale__["a" /* srCYRL */];
    }
  },
  created: function created() {
    this.hasInvoiceCancelClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["p" /* hasInvoiceCancelClaim */])();
    this.hasInvoiceExportClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["h" /* hasInvoiceExportClaim */])();
    this.hasInvoiceAssignClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["q" /* hasInvoiceAssignClaim */])();
    this.hasInvoiceActivateClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["r" /* hasInvoiceActivateClaim */])();
    this.hasInvoiceActivateOnceClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["s" /* hasInvoiceActivateOnceClaim */])();
    this.hasInvoiceUserSettlementClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["t" /* hasInvoiceUserSettlementClaim */])();
    this.organizationId = parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["i" /* getOrganizationId */])());
    this.hasAdminClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["k" /* hasAdminClaim */])();
    this.loadInvoice();
  },
  methods: {
    invoiceEmpty: function invoiceEmpty() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.invoice).length === 0 && this.invoice.constructor === Object;
    },
    loadInvoice: function loadInvoice() {
      var _this3 = this;

      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.invoice + '/' + this.invoiceId).then(function (response) {
        _this3.load = false;
        _this3.logConsole(response);
        var invoiceResponse = response.data.payload;
        _this3.invoice = invoiceResponse.liability;
        _this3.settlements = invoiceResponse.settlements;
        _this3.invoiceDeltas = invoiceResponse.liabilityDeltas;
        _this3.assignedDebtorCompanyNumber = invoiceResponse.assignedDebtorCompanyNumber;
        _this3.assignedDebtorTaxIdNumber = invoiceResponse.assignedDebtorTaxIdNumber;
        _this3.assignedDebtorName = invoiceResponse.assignedDebtorName;
        _this3.reportedIssues = invoiceResponse.issues.length;
        for (var i = 0; i < invoiceResponse.issues.length; i++) {
          if (invoiceResponse.issues[i].status === 1) {
            _this3.reportedActiveIssues++;
            _this3.activeIssues.push(invoiceResponse.issues[i]);
          }
        }

        for (var _i = 0; _i < _this3.settlements.length; _i++) {
          _this3.invoiceSettlementIDs.push(_this3.settlements[_i].id);
        }

        _this3.invoiceLink = '/invoices/' + _this3.invoice.assignedInvoiceId;
        _this3.assignationLink = '/invoices/' + _this3.invoice.comments;

        _this3.debtorLink = '/user-registration/approval/' + _this3.invoice.debtorId;
        _this3.creditorLink = '/user-registration/approval/' + _this3.invoice.creditorId;

        if (!!__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices && !!__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse).forEach(function (key) {
            if (_this3.showCollapse.hasOwnProperty(key)) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this3.showCollapse, key, __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse[key].value);
              if (__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse[key].collapse_if_faulty) {
                if (Array.isArray(_this3[__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse[key].collapse_if_faulty])) {
                  if (!_this3[__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse[key].collapse_if_faulty].length) {
                    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this3.showCollapse, key, false);
                  }
                } else if (_this3[__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.invoices.show_collapse[key].collapse_if_faulty] === false) {
                  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this3.showCollapse, key, false);
                }
              }
            }
          });
        }
      }, function (error) {
        _this3.logConsole(error);

        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: _this3.$t('invoices.invoiceNotFound') + ' : ' + _this3.invoiceId,
          errors: []
        });

        _this3.load = false;
      });
    },
    validateBeforeSettle: function validateBeforeSettle() {
      this.invoiceSettlement.InvoiceId = this.invoice.invoiceId;
      this.$v.$touch();
      if (this.$v.$invalid) {
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('invoiceSettlement')
        });
        return;
      }
      this.settleInvoice();
    },
    settleInvoice: function settleInvoice() {
      var _this4 = this;

      this.load = true;
      this.$refs['settleInvoiceModal'].hide();
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.registerUserSettlementPost, [this.invoiceSettlement]).then(function (response) {
        _this4.logConsole(response);
        _this4.load = false;
        var responseData = response.data.payload[0];
        var invoice = responseData.settlement;
        var error = responseData.settlementError;
        _this4.load = false;
        if (error === null) {
          __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this4.$t('invoices.registerSettlementSuccess') + ' - ',
            link: '/invoices/' + invoice.invoiceId,
            linkDescription: invoice.invoiceId,
            errors: []
          });
          _this4.invoiceSettlement.SettledAmount = 0;
          _this4.invoiceSettlement.Bank = null;
          _this4.invoiceSettlement.ReferenceNumber = null;
          _this4.invoiceSettlement.DebitAccount = null;
          _this4.invoiceSettlement.CreditAccount = null;
          _this4.invoiceSettlement.SettlementDate = null;
          _this4.invoiceSettlement.IsCompensationSettlement = false;
          _this4.$v.$reset();
          _this4.loadInvoice();
        } else {
          __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'danger',
            message: _this4.$t('apiStatusCodes.' + error.code),
            errors: []
          });
        }
      }, function (error) {
        _this4.logConsole(error);
        _this4.formatErrorResponse(error);
        _this4.load = false;
      });
    },
    validateBeforeCancel: function validateBeforeCancel(settlementId) {
      this.invoiceSettlement.settlementId = settlementId.toString();
      this.$refs['cancelSettlementModal'].show();
    },
    cancelSettlement: function cancelSettlement() {
      var _this5 = this;

      this.logConsole('Cancelling settlement');
      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.cancelUserSettlementPost, this.invoiceSettlement).then(function (response) {
        _this5.logConsole(response);
        _this5.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this5.$t('invoices.cancelSettlementSuccess'),
          errors: []
        });
        _this5.invoiceSettlement.settlementId = null;
        _this5.invoiceSettlement.cancelComments = null;
        _this5.loadInvoice();
      }, function (error) {
        _this5.logConsole(error);
        _this5.formatErrorResponse(error);
        _this5.load = false;
      });
      this.$refs['cancelSettlementModal'].hide();
    },

    cancelInvoice: function cancelInvoice(e) {
      var _this6 = this;

      this.logConsole('Cancelling invoice');
      this.load = true;
      var cancelInvoice = [{ InvoiceId: this.invoice.invoiceId, CancelComments: this.invoice.cancelComments }];
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.cancelInvoicesPost, cancelInvoice).then(function (response) {
        _this6.logConsole(response);
        _this6.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this6.$t('invoices.cancellationSuccess'),
          errors: []
        });
        _this6.invoice.status = _this6.InvoiceStatus.CANCELLED;
      }, function (error) {
        _this6.logConsole(error);
        _this6.formatErrorResponse(error);
        _this6.load = false;
      });
    },
    assignInvoice: function assignInvoice() {
      var _this7 = this;

      this.logConsole('Assigning invoice');
      this.load = true;
      var invoiceAssignment = {
        InvoiceId: this.invoice.invoiceId,
        AssignmentContractNumber: this.invoice.AssignmentContractNumber,
        DebtorCompanyNumber: this.invoice.DebtorCompanyNumber,
        DebtorTaxIdNumber: this.invoice.DebtorTaxIdNumber
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.assignInvoicePost, invoiceAssignment).then(function (response) {
        _this7.logConsole(response);
        _this7.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this7.$t('invoices.invoiceAssignSuccess'),
          errors: []
        });

        _this7.loadInvoice();
      }, function (error) {
        _this7.logConsole(error);
        _this7.formatErrorResponse(error);
        _this7.load = false;
      });
    },
    cancelInvoiceAssign: function cancelInvoiceAssign() {
      var _this8 = this;

      this.logConsole('Assigning invoice');
      this.load = true;
      var invoiceAssignment = { InvoiceId: this.invoice.invoiceId };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.cancelAssignInvoicePost, invoiceAssignment).then(function (response) {
        _this8.logConsole(response);
        _this8.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this8.$t('invoices.invoiceAssignCancelSuccess'),
          errors: []
        });
        _this8.invoice.status = _this8.InvoiceStatus.ACTIVE;
      }, function (error) {
        _this8.logConsole(error);
        _this8.formatErrorResponse(error);
        _this8.load = false;
      });
    },
    addInvoiceAmountDelta: function addInvoiceAmountDelta() {
      var _this9 = this;

      this.load = true;
      this.invoiceDelta.invoiceId = this.invoice.invoiceId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.changeInvoiceAmountPost, this.invoiceDelta).then(function (response) {
        _this9.logConsole(response);
        _this9.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this9.$t('invoices.invoiceAmountChangeSuccess'),
          errors: []
        });

        setTimeout(function () {
          _this9.loadInvoice();
        }, 300);
        _this9.invoice.amount += _this9.invoiceDelta.amount;
        _this9.invoiceDelta.comments = '';
        _this9.invoiceDelta.amount = 0;
      }, function (error) {
        _this9.logConsole(error);
        _this9.formatErrorResponse(error);
        _this9.load = false;
      });
    },
    cancelInvoiceDeltaSelected: function cancelInvoiceDeltaSelected(id, amount) {
      this.selectedAmountDeltaId = id;
      this.selectedAmountDeltaAmount = amount;
      this.$refs.cancelInvoiceDeltaModal.show();
    },
    cancelInvoiceAmountDelta: function cancelInvoiceAmountDelta() {
      var _this10 = this;

      this.load = true;
      this.invoiceDelta.id = this.selectedAmountDeltaId;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.cancelInvoiceAmountChangePost, this.invoiceDelta).then(function (response) {
        _this10.logConsole(response);
        _this10.load = false;
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this10.$t('invoices.invoiceAmountChangeSuccess'),
          errors: []
        });

        setTimeout(function () {
          _this10.loadInvoice();
        }, 300);
        _this10.invoice.amount -= _this10.selectedAmountDeltaAmount;
        _this10.invoiceDelta.cancelComments = '';
      }, function (error) {
        _this10.logConsole(error);
        _this10.formatErrorResponse(error);
        _this10.load = false;
      });
    },
    getInvoiceAmountDeltas: function getInvoiceAmountDeltas() {
      var _this11 = this;

      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.invoiceAmountChangesGet + '/' + this.invoiceId).then(function (response) {
        _this11.logConsole(response);
        _this11.load = false;
        var invoiceResponse = response.data.payload;
        _this11.invoiceDeltas = invoiceResponse;
      }, function (error) {
        _this11.logConsole(error);
        _this11.formatErrorResponse(error);
        _this11.load = false;
      });
    },

    exportToCsv: function exportToCsv() {
      this.logConsole('Exporting invoice to CSV ');
      this.load = true;
      var request = [];
      request.push(this.invoice.invoiceId);
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.exportInvoiceCsv, request, 'export.csv', this.stopLoader, this.convertCSVseparator);
    },
    exportToJson: function exportToJson() {
      this.logConsole('Exporting invoice to JSON');
      this.load = true;
      var request = [];
      request.push(this.invoice.invoiceId);
      this.saveToFile(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.exportInvoiceJson, request, 'export.json', this.stopLoader);
    },
    stopLoader: function stopLoader() {
      this.load = false;
    },
    calculateSettlementsDelta: function calculateSettlementsDelta() {
      if (!this.browserFirefox()) {
        if (this.settlementDeltaSelected) {
          this.invoiceDelta.amount = this.invoice.settledAmount - this.invoice.amount;
        } else {
          this.invoiceDelta.amount = 0;
        }
      }
    },
    calculateSettlementsDeltaChange: function calculateSettlementsDeltaChange() {
      if (this.browserFirefox()) {
        if (this.settlementDeltaSelected) {
          this.invoiceDelta.amount = this.invoice.settledAmount - this.invoice.amount;
        } else {
          this.invoiceDelta.amount = 0;
        }
      }
    },
    reportLiabilityIssue: function reportLiabilityIssue() {
      var _this12 = this;

      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.issueCategoriesGet + '/' + this.IssueCategory[0].DESCRIPTION).then(function (response) {
        _this12.logConsole(response);
        _this12.selectedCategory = null;
        _this12.currentIssueCategory = null;
        _this12.formattedIssueCategories = null;
        _this12.currentIssueReport = {};
        _this12.currentIssue = _this12.IssueCategory[0];
        _this12.currentIssueCategories = response.data.payload;
        _this12.currentIssueReport.resourceId = _this12.invoice.invoiceId;
        _this12.formatReportCategories(response.data.payload);

        _this12.$refs.reportIssueModal.show();
        _this12.load = false;
      }, function (error) {
        _this12.logConsole(error);
        _this12.formatErrorResponse(error);
        _this12.load = false;
      });
    },
    reportSettlementIssue: function reportSettlementIssue() {
      var _this13 = this;

      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.issueCategoriesGet + '/' + this.IssueCategory[1].DESCRIPTION).then(function (response) {
        _this13.logConsole(response);
        _this13.selectedCategory = null;
        _this13.currentIssueCategory = null;
        _this13.formattedIssueCategories = null;
        _this13.currentIssueSettlementId = null;
        _this13.currentIssueReport = {};
        _this13.currentIssue = _this13.IssueCategory[1];
        _this13.currentIssueCategories = response.data.payload;
        _this13.currentIssueReport.resourceId = _this13.invoice.invoiceId;
        _this13.formatReportCategories(response.data.payload);
        if (_this13.formattedIssueCategories && _this13.formattedIssueCategories.length > 0) {
          _this13.$refs.reportIssueModal.show();
        }
        _this13.load = false;
      }, function (error) {
        _this13.logConsole(error);
        _this13.formatErrorResponse(error);
        _this13.load = false;
      });
    },
    formatReportCategories: function formatReportCategories(categories) {
      this.formattedIssueCategories = [];
      for (var i = 0; i < categories.length; i++) {
        if (categories[i].id === 3) {
          if (this.invoiceSettled) {
            continue;
          }
        }
        if (categories[i].id === 4) {
          if (!this.hasInvoiceSettlements) {
            continue;
          }
        }
        if (categories[i].id === 5) {
          if (!this.hasInvoiceSettlements) {
            continue;
          }

          var jpSettlement = false;
          for (var _i2 = 0; _i2 < this.settlements.length; _i2++) {
            if (this.settlements[_i2].settlementComments && this.settlements[_i2].settlementComments.startsWith('JP#')) {
              jpSettlement = true;
            }
          }

          if (!jpSettlement) {
            continue;
          }
        }
        var category = {
          text: categories[i].categoryCyr,
          value: categories[i].id
        };
        if (categories[i].categoryVisibility === this.IssueCategoryVisibility.CREDITOR && this.isCurrentUserCreditor || categories[i].categoryVisibility === this.IssueCategoryVisibility.DEBTOR && this.isCurrentUserDebtor || categories[i].categoryVisibility === this.IssueCategoryVisibility.EVERYONE) {
          this.formattedIssueCategories.push(category);
        }
      }
    },
    categoryChanged: function categoryChanged() {
      for (var i = 0; i < this.currentIssueCategories.length; i++) {
        if (this.currentIssueCategories[i].id === this.selectedCategory) {
          this.currentIssueCategory = this.currentIssueCategories[i];
          return;
        }
      }
    },
    submitIssueReport: function submitIssueReport() {
      var _this14 = this;

      this.currentIssueReport.resource = this.currentIssue.ID;

      if (this.currentIssueCategory) {
        this.currentIssueReport.category = this.currentIssueCategory.category;
        this.currentIssueReport.requiresData = this.currentIssueCategory.requiresData;
        this.currentIssueReport.categoryId = this.currentIssueCategory.id;
      }

      if (this.currentIssue.ID === this.IssueCategory[1].ID) {
        if (this.currentIssueCategory && this.currentIssueCategory.id === 3) {
          if (this.currentIssueReport.data && this.currentIssueReport.data) {
            this.currentIssueReport.data = this.currentIssueAmount + ' ' + this.currentIssueReport.data;
          }
        } else if (this.currentIssueCategory && this.currentIssueCategory.id === 4) {
          if (this.currentIssueSettlementId && this.currentIssueReport.data && this.currentIssueReport.data) {
            this.currentIssueReport.data = this.currentIssueSettlementId + ' ' + this.currentIssueAmount + ' ' + this.currentIssueReport.data;
          }
        }
      }

      if (this.currentIssue.ID === this.IssueCategory[0].ID) {
        if (this.currentIssueCategory && this.currentIssueCategory.id === 2) {
          this.currentIssueReport.affectedOrganizationId = this.invoice.creditorId;
        }
      }

      var report = [];
      report.push(this.currentIssueReport);

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.issueRegisterPost, report).then(function (response) {
        _this14.logConsole(response);
        _this14.load = false;

        var reportedIssue = response.data.payload[0];
        __WEBPACK_IMPORTED_MODULE_4__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this14.$t('issues.reportIssueSuccess') + ' - ',
          link: '/reported-issues/' + reportedIssue.id,
          linkDescription: reportedIssue.id,
          errors: []
        });
        _this14.subscribeToIssueProcessedNotifications(reportedIssue.id);
      }, function (error) {
        _this14.logConsole(error);
        _this14.formatErrorResponse(error);
        _this14.load = false;
      });
    },
    subscribeToIssueProcessedNotifications: function subscribeToIssueProcessedNotifications(issueId) {
      this.subscribeToIssueProcessedNotificationType(issueId);
    },
    subscribeToEmailSink: function subscribeToEmailSink() {
      var _this15 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.sinksSubscribe, { sinks: [this.Sinks.Email] }).then(function (response) {
        _this15.logConsole(response);
      }, function (error) {
        _this15.logConsole(error);
      });
    },
    subscribeToIssueProcessedNotificationType: function subscribeToIssueProcessedNotificationType(issueId) {
      var _this16 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.notificationSubcribe, { notificationTypes: [this.NotificationTypes.IssueProcessed], resourceId: issueId, resourceType: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.issueResourceType }).then(function (response) {
        _this16.logConsole(response);
        _this16.subscribeToEmailSink();
      }, function (error) {
        _this16.logConsole(error);
      });
    },
    customFormatter: function customFormatter(date) {
      __WEBPACK_IMPORTED_MODULE_14_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).format(this.dateFormat);
    },
    inputFormat: function inputFormat(date) {
      __WEBPACK_IMPORTED_MODULE_14_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, this.dateFormat).valueOf();
    }
  },
  validations: {
    invoiceSettlement: {
      ReferenceNumber: {
        required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
      },
      CreditAccount: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["requiredIf"])(function (invoiceSettlement) {
          return !invoiceSettlement.IsCompensationSettlement;
        })
      },
      DebitAccount: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["requiredIf"])(function (invoiceSettlement) {
          return !invoiceSettlement.IsCompensationSettlement;
        })
      },
      SettledAmount: {
        required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
      },
      SettlementDate: {},
      Bank: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["requiredIf"])(function (invoiceSettlement) {
          return !invoiceSettlement.IsCompensationSettlement;
        })
      }
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_auth__ = __webpack_require__(14);
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reported-issues',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_3__components_misc_datatable_Datatable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      load: false,
      IssueStatus: {
        ACTIVE: 1,
        CANCELLED: 2,
        RESOLVED: 3,
        UNRESOLVED: 4
      },
      pagedIssuesUrl: '',
      issuesReportsUrl: '',
      statuses: this.IssueStatus,
      issueCategories: [],
      tOptions: {
        checkboxes: false,
        payloadsTotalPropertyName: 'additionalInformation',
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.CANCELLED || row['status'] === statuses.UNRESOLVED;
          }
        },
        highlightedRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.RESOLVED;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'reported-issues/' + row['id'];
          }
        }
      }
    };
  },

  computed: {
    tColumns: function tColumns() {
      return [{
        columnName: 'resourceId',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnResourceId'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.resourceId;
        }
      }, {
        columnName: 'companyNumber',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnCompanyNumber'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.companyNumber;
        }
      }, {
        columnName: 'organizationName',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.userOrganizationName'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.organizationName;
        }
      }, {
        columnName: 'username',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.userName'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.username;
        }
      }, {
        columnName: 'categoryCyr',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnCategory'),
        hideSort: true,
        filterType: 'select',
        filterSelectOptions: this.issueCategories,
        cell: function cell(row) {
          return row.categoryCyr;
        }
      }, {
        columnName: 'data',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnData'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.data;
        }
      }, {
        columnName: 'creationDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'creationDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'creationDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnCreationDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'closingDate',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'closingDate-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'closingDate-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnClosingDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportColumnStatus'),
        hideSort: true,
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.4'), value: 4 }],
        cell: function cell(row) {
          return null;
        }
      }];
    }
  },
  created: function created() {
    var _this = this;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_auth__["j" /* hasIssueResolveClaim */])()) {
      this.issuesReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateIssuesReport;
    }
    this.pagedIssuesUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedIssueReportsGet;
    this.tOptions.statuses = this.IssueStatus;

    this.load = true;
    this.$http.get(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.issueCategoriesGet + '/' + 'all').then(function (response) {
      _this.logConsole(response);
      var payload = response.data.payload;
      _this.issueCategories.push({ key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('issues.reportIssueStatus.0'), value: '' });
      for (var i = 0; i < payload.length; i++) {
        _this.issueCategories.push({ key: payload[i].categoryCyr, value: payload[i].categoryCyr });
      }
      _this.load = false;
    }, function (error) {
      _this.logConsole(error);
      _this.formatErrorResponse(error);
      _this.load = false;
    });
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      this.logConsole('Creating user notification');

      // validate first
      this.createNotification();
    },
    onRowSelected: function onRowSelected(row) {
      this.selectedNotification = row;
      this.$refs.reviewNotificationModal.show();
    },
    createNotification: function createNotification() {
      var _this2 = this;

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userNotificationsCreatePost, this.notification).then(function (response) {
        _this2.logConsole(response);
        _this2.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('userAdministration.notificationCreated'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    updateNotification: function updateNotification(cancelNotification) {
      var _this3 = this;

      this.load = true;
      if (cancelNotification) {
        this.selectedNotification.status = this.NotificationStatus.CANCELLED;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userNotificationsUpdatePost, this.selectedNotification).then(function (response) {
        _this3.logConsole(response);
        _this3.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$t('userAdministration.notificationUpdated'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error);
        _this3.load = false;
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_cookie__ = __webpack_require__(34);

//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'single-issue',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      load: false,
      IssueStatus: {
        ACTIVE: 1,
        CANCELLED: 2,
        RESOLVED: 3,
        UNRESOLVED: 4
      },
      issueReport: {},
      issueUser: {},
      issueId: this.$route.params.issueId,
      hasInvoiceCancelClaim: false,
      resolveOptions: [{ text: this.$t('issues.reportIssueResolved'), value: 3 }, { text: this.$t('issues.reportIssueUnresolved'), value: 4 }],
      resolveStatus: 3,
      resolveComment: null,
      resourceLink: '',
      formattedNotificationTypes: null,
      selectedNotificationTypes: [],
      sinks: {
        Email: 1
      }
    };
  },

  computed: {
    issueActive: function issueActive() {
      return this.issueReport.status === this.IssueStatus.ACTIVE;
    },
    issueCancelled: function issueCancelled() {
      return this.issueReport.status === this.IssueStatus.CANCELLED;
    },
    issueResolved: function issueResolved() {
      return this.issueReport.status === this.IssueStatus.RESOLVED;
    },
    issueUnresolved: function issueUnresolved() {
      return this.issueReport.status === this.IssueStatus.UNRESOLVED;
    },
    isDevelopment: function isDevelopment() {
      return !this.isProductionEnvironment();
    }
  },
  created: function created() {
    this.hasIssueResolveClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router_auth__["j" /* hasIssueResolveClaim */])();

    this.loadIssue();
  },
  methods: {
    loadIssue: function loadIssue() {
      var _this = this;

      this.load = true;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_cookie__["a" /* getAccessToken */])();
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.issueReportGet + '/' + this.issueId).then(function (response) {
        _this.logConsole(response);
        var issue = response.data.payload;
        _this.issueReport = issue.issueReport;
        _this.issueUser = issue.user;

        if (_this.issueReport.resourceId.startsWith('i')) {
          _this.resourceLink = '/group-settlement/' + _this.issueReport.resourceId;
        } else {
          _this.resourceLink = '/invoices/' + _this.issueReport.resourceId;
        }
        _this.load = false;
      }, function (error) {
        _this.formatErrorResponse(error);
        _this.logConsole(error);
        _this.load = false;
      });
    },
    cancelIssueReport: function cancelIssueReport() {
      var _this2 = this;

      this.logConsole('Cancelling issue report');
      this.load = true;
      this.issueReport.organizationId = null;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.issueReportCancelPost, this.issueReport).then(function (response) {
        _this2.logConsole(response);
        _this2.load = false;
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('issues.reportIssueCancelSuccess'),
          errors: []
        });
        _this2.$nextTick(function () {
          this.issueReport.status = this.IssueStatus.CANCELLED;
        });
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    resolveIssueReport: function resolveIssueReport() {
      var _this3 = this;

      this.logConsole('Resolving issue report');
      var issueResolveObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.issueReport);
      issueResolveObject.status = this.resolveStatus;
      issueResolveObject.operatorComment = this.resolveComment;
      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.issueReportResolvePost, issueResolveObject).then(function (response) {
        _this3.logConsole(response);
        _this3.load = false;
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$t('issues.reportIssueResolveSuccess'),
          errors: []
        });
        _this3.$nextTick(function () {
          this.issueReport.status = this.resolveStatus;
          this.issueReport.operatorComment = this.resolveComment;
        });
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error);
        _this3.load = false;
      });
    },
    submitNotificationSubscription: function submitNotificationSubscription() {
      this.subscribeToSelectedNotificationTypes();
    },
    subscribeToEmailSink: function subscribeToEmailSink() {
      var _this4 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.sinksSubscribe, { sinks: [this.sinks.Email] }).then(function (response) {
        _this4.logConsole(response);
      }, function (error) {
        _this4.logConsole(error);
      });
    },
    subscribeToSelectedNotificationTypes: function subscribeToSelectedNotificationTypes() {
      var _this5 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.notificationSubcribe, { notificationTypes: this.selectedNotificationTypes, resourceId: this.issueId, resourceType: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.issueResourceType }).then(function (response) {
        _this5.logConsole(response);
        _this5.subscribeToEmailSink();
        _this5.load = false;
        if (_this5.selectedNotificationTypes.length > 0) {
          __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this5.$t('notifications.subscribedIssueSuccessfully'),
            errors: []
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this5.$t('notifications.unsubscribedIssueSuccessfully'),
            errors: []
          });
        }
      }, function (error) {
        _this5.logConsole(error);
        _this5.formatErrorResponse(error);
        _this5.load = false;
      });
    },
    subscribeToNotification: function subscribeToNotification() {
      var _this6 = this;

      this.$refs.subscribeToNotification.show();
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.notification_api_root + '/' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.notificationTypes + '?resourceId=' + this.issueReport.id + '&resourceType=' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.issueResourceType).then(function (response) {
        _this6.formatNotificationTypes(response.data.payload);
        _this6.logConsole(response);
        _this6.load = false;
      }, function (error) {
        _this6.logConsole(error);
        _this6.formatErrorResponse(error);
        _this6.load = false;
      });
    },
    formatNotificationTypes: function formatNotificationTypes(notificationTypes) {
      this.formattedNotificationTypes = [];
      this.selectedNotificationTypes = [];
      for (var i = 0; i < notificationTypes.length; i++) {
        var notificationType = {
          text: notificationTypes[i].name,
          value: notificationTypes[i].notificationTypeId
        };
        this.formattedNotificationTypes.push(notificationType);
        if (notificationTypes[i].subscribed) {
          this.selectedNotificationTypes.push(notificationType.value);
        }
      }
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_3__components_misc_context_header_ContextHeader___default.a,
    Money: __WEBPACK_IMPORTED_MODULE_4_v_money__["Money"]
  },
  data: function data() {
    return {
      settleByIdf: false,
      load: false,
      errorList: [],
      invoiceSettlement: {
        InvoiceNumber: '',
        DebtorCompanyNumber: '',
        CreditorCompanyNumber: '',
        CreditorTaxIdNumber: '',
        Bank: '',
        SettledAmount: 0
      },
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    }
  },
  methods: {
    submitSettlement: function submitSettlement(e) {
      var _this = this;

      this.logConsole('Submitting invoice settlement');
      this.load = true;

      // const settlements = [
      //   {
      //     InvoiceId: '1VFG',
      //     Bank: '840',
      //     SettledAmount: 1
      //   },
      //   {
      //     InvoiceId: '1VEF',
      //     Bank: '840',
      //     SettledAmount: 1
      //   },
      //   {
      //     InvoiceId: '1VCD',
      //     Bank: '840',
      //     SettledAmount: 1
      //   }
      // ]

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.registerSettlementsPost, [this.invoiceSettlement]).then(function (response) {
        _this.errorList = [];
        _this.logConsole(response);
        _this.load = false;
        // get body data
        if (!!response.data && Array.isArray(response.data.payload)) {
          response.data.payload.forEach(function (element) {
            if (element.settlementError) {
              _this.errorList.push(element);
            }
          });
        }
        if (_this.errorList.length === 0) {
          var invoice = response.data;
          __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: 'Успешно измирен износ' + ' - ' + invoice.payload[0].settlement.settledAmount,
            errors: []
          });
        }
        _this.$refs.registerSettlementForm.reset();
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        _this.load = false;
      });
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cookie__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function getCurrentSidebarToggleInfo(self) {
  var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["d" /* getUser */])();
  var sidebarToggleInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["l" /* getSidebarToggleInfo */])(key);
  // if user has not set token, toggle value should be true
  if (sidebarToggleInfo == null) {
    sidebarToggleInfo = true;
  }
  return sidebarToggleInfo;
}

function setCurrentSidebarToggleInfo(self, sidebarInfo) {
  var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["d" /* getUser */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["m" /* setSidebarToggleInfo */])(key, sidebarInfo);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isTestEnvironment: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.test_env,
      hasAdminClaim: false,
      hasUserCreateClaim: false,
      hasLocalUserCreateClaim: false,
      hasInvoiceCreateClaim: false,
      hasInvoiceReviewClaim: false,
      hasGroupSettlementCreateClaim: false,
      hasInvoiceReviewAllClaim: false,
      hasInvoiceUserSettlementClaim: false,
      showCollapse: true
    };
  },

  computed: {
    hasAdministrativePrivileges: function hasAdministrativePrivileges() {
      return this.hasUserCreateClaim || this.hasLocalUserCreateClaim;
    },
    buttonLabel: function buttonLabel() {
      return this.showCollapse ? 'keyboard_arrow_left' : 'keyboard_arrow_right';
    }
  },
  created: function created() {
    this.hasAdminClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["k" /* hasAdminClaim */])();
    this.hasUserCreateClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["u" /* hasUserCreateClaim */])();
    this.hasLocalUserCreateClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["v" /* hasLocalUserCreateClaim */])();
    this.hasInvoiceCreateClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["y" /* hasInvoiceCreateClaim */])();
    this.hasInvoiceReviewClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["z" /* hasInvoiceReviewClaim */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["g" /* hasInvoiceReviewAllClaim */])();
    this.hasGroupSettlementCreateClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["A" /* hasGroupSettlementCreateClaim */])();
    this.hasInvoiceReviewAllClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["g" /* hasInvoiceReviewAllClaim */])();
    this.hasInvoiceUserSettlementClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__router_auth__["t" /* hasInvoiceUserSettlementClaim */])();
    this.showCollapse = getCurrentSidebarToggleInfo(this);
  },

  methods: {
    hideNavigation: function hideNavigation() {
      this.$root.$emit('bv::toggle::collapse', this.$refs.sidenav_id);
    },
    toggle: function toggle() {
      this.showCollapse = !this.showCollapse;
      setCurrentSidebarToggleInfo(this, this.showCollapse);
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_profile_UserProfile_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_profile_UserProfile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_profile_UserProfile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_management_UserManagement_vue__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_management_UserManagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__user_management_UserManagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_user_management_LocalUserManagement_vue__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__local_user_management_LocalUserManagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__local_user_management_LocalUserManagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_create_UserCreate_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_create_UserCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__user_create_UserCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_notification_UserNotification_vue__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_notification_UserNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__user_notification_UserNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__target_public_users_TargetPublicUsers_vue__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__target_public_users_TargetPublicUsers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__target_public_users_TargetPublicUsers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-administration',
  components: {
    ContextHeader: __WEBPACK_IMPORTED_MODULE_8__components_misc_context_header_ContextHeader___default.a,
    'user-profile': __WEBPACK_IMPORTED_MODULE_1__user_profile_UserProfile_vue___default.a,
    'user-management': __WEBPACK_IMPORTED_MODULE_2__user_management_UserManagement_vue___default.a,
    'local-user-management': __WEBPACK_IMPORTED_MODULE_3__local_user_management_LocalUserManagement_vue___default.a,
    'user-create': __WEBPACK_IMPORTED_MODULE_4__user_create_UserCreate_vue___default.a,
    'user-notification': __WEBPACK_IMPORTED_MODULE_5__user_notification_UserNotification_vue___default.a,
    'target-public-users': __WEBPACK_IMPORTED_MODULE_6__target_public_users_TargetPublicUsers_vue___default.a
  },
  data: function data() {
    return {
      headers: [{ title: this.$t('userAdministration.localAdministration'), value: 'local-administration' }, { title: this.$t('userAdministration.administration'), value: 'administration' }, { title: this.$t('userAdministration.userCreate'), value: 'user-create' }, { title: this.$t('userAdministration.userNotification'), value: 'user-notification' }, { title: this.$t('userAdministration.targetPublicUsers'), value: 'target-public-users' }],
      tabIndex: 0,
      namedTab: ''
    };
  },

  watch: {
    '$route.query.type': function $routeQueryType() {
      var type = this.$route.query.type;
      if (type && type.length > 0) {
        this.changeTabState(this, this.$refs, type);
        this.namedTab = type;
      } else {
        var tabHeader = this.getTabHeader(0).value;
        this.changeTabState(this, this.$refs, tabHeader);
        this.namedTab = tabHeader;
      }
    }
  },
  created: function created() {
    this.hasUserCreatePermission = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__router_auth__["u" /* hasUserCreateClaim */])();
    this.hasLocalUserCreatePermission = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__router_auth__["v" /* hasLocalUserCreateClaim */])();
    this.hasNotificationPermissions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__router_auth__["w" /* hasNotificationCreateClaim */])();
    this.hasRegistrationReviewAllPermissions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__router_auth__["x" /* hasRegistrationReviewAllClaim */])();
  },
  mounted: function mounted() {
    var type = this.$route.query.type;
    if (type && type.length > 0) {
      this.changeTabState(this, this.$refs, type);
      this.namedTab = type;
    } else {
      var state = this.loadTabState(this.$route.path);
      if (state && state.length > 0) {
        // Go to route
        this.$router.replace({ path: this.$route.path, query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { type: state }) });
      } else {
        this.namedTab = this.getTabHeader(0).value;
      }
    }
  },

  methods: {
    tabChanged: function tabChanged() {
      var header = this.getTabHeader(this.tabIndex);
      if (header) {
        var param = header.value;

        // Save to cookie
        this.saveTabState(this.$route.path, param);
        // Go to route
        this.$router.replace({ path: this.$route.path, query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { type: param }) });
      }
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'local-user-management',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        REVOKED: 3,
        DISABLED: 4
      },
      tOptions: {
        checkboxValue: 'userId',
        payloadsTotalPropertyName: 'additionalInformation',
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] !== statuses.ACTIVE;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'user-administration/local-user/' + row['userId'];
          }
        }
      },
      tColumns: [{
        columnName: 'name',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userName'),
        filterType: 'input',
        cell: function cell(row) {
          return row.name;
        }
      }, {
        columnName: 'login',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userLogin'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.login;
        }
      }, {
        columnName: 'email',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userEmail'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.email;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatus'),
        hideSort: true,
        align: 'center',
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.4'), value: 4 }],
        cell: function cell(row) {
          return null;
        }
      }],
      usersUrl: '',
      selectedUsers: [],
      optionsVisible: false
    };
  },

  created: function created() {
    this.usersUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedLocalUsersInformationGet;
    this.tOptions.statuses = this.UserStatus;
  },
  methods: {
    onChecked: function onChecked(checkedValues) {
      this.selectedUsers = checkedValues;
      this.optionsVisible = checkedValues.length > 0;
    },
    revokeUsers: function revokeUsers() {
      var _this = this;

      this.logConsole('Revoking users ' + this.selectedUSers);
      this.load = true;
      var request = [];
      for (var i = 0; i < this.selectedUsers.length; i++) {
        var user = {};
        user.userId = Number(this.selectedUsers[i]);
        request.push(user);
      }

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userRevokePost, request).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('userAdministration.userRevoked'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_user_info_UserInfo__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_user_info_UserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_user_info_UserInfo__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'local-user-information',
  components: {
    UserInfo: __WEBPACK_IMPORTED_MODULE_1__components_misc_user_info_UserInfo___default.a
  },
  data: function data() {
    return {
      userInformationUrl: '',
      updateUserPermissionsUrl: '',
      revokeUserUrl: '',
      restoreUserUrl: '',
      userId: this.$route.params.userId
    };
  },
  created: function created() {
    this.userInformationUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.localUserInformationGet;
    this.updateUserPermissionsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.updateLocalUserPermissionsPost;
    this.revokeUserUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userRevokePost;
    this.restoreUserUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userRestorePost;
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_datepicker___ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_misc_autocomplete_Autocomplete__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_misc_autocomplete_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_misc_autocomplete_Autocomplete__);
//
//
//













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'target-public-users',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_validation__["a" /* validationMixin */]],
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_8__components_misc_datatable_Datatable___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_3__utils_datepicker___["a" /* default */],
    Autocomplete: __WEBPACK_IMPORTED_MODULE_10__components_misc_autocomplete_Autocomplete___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_9__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      dateFormat: this.$store.getters.dateFormat,
      autoCompleteUrl_budgetId: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.budgetRegistryGet,
      targetPublicUsersReportsUrl: '',
      autoCompletePopover: false,
      autoCompletePopoverItem: {},
      dateLocale: __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__["a" /* srCYRL */],
      load: false,
      targetPublicUsersUrl: '',
      targetPublicUserModel: {
        BudgetUserId: null,
        Name: null
      },
      options: [{
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.1'),
        value: 1
      }, {
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.2'),
        value: 2
      }, {
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.3'),
        value: 3
      }],
      tOptions: {
        checkboxes: false,
        payloadsTotalPropertyName: 'additionalInformation'
      },
      tColumns: [{
        columnName: 'budgetUserId',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userRegistration.registrationBudgetId'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.budgetUserId;
        }
      }, {
        columnName: 'name',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userRegistration.registrationName'),
        filterType: 'input',
        align: 'right',
        cell: function cell(row) {
          return row.name;
        }
      }]
    };
  },
  created: function created() {
    this.targetPublicUsersUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedTargetPublicUsersGet;
    this.targetPublicUsersReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateTargetPublicUsersReports;
  },
  mounted: function mounted() {
    switch (this.$store.getters.dateLocale) {
      case 'sr-cyrl':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__["a" /* srCYRL */];
        break;
      case 'sr':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__["b" /* sr */];
        break;
      case 'en':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__["c" /* en */];
        break;
      default:
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_7__utils_datepicker_locale__["a" /* srCYRL */];
    }
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      this.logConsole('Creating user notification');

      // validate first
      this.createNotification();
    },
    onRowSelected: function onRowSelected(row) {
      this.targetPublicUserModel.BudgetUserId = row.budgetUserId;
      this.targetPublicUserModel.Name = row.name;
      this.$refs.removeTargetBudgetUserModal.show();
    },
    appendTargetBudgetUser: function appendTargetBudgetUser() {
      var _this = this;

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.targetPublicUsersPost, this.targetPublicUserModel).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('userAdministration.targetPublicUsersAppendSuccess'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    removeTargetBudgetUser: function removeTargetBudgetUser() {
      var _this2 = this;

      this.load = true;
      this.$http.patch(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.targetPublicUsersPatch, this.targetPublicUserModel).then(function (response) {
        _this2.logConsole(response);
        _this2.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('userAdministration.targetPublicUsersRemoveSuccess'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    budgetNumberResolved: function budgetNumberResolved(item) {
      this.targetPublicUserModel.Name = item.cyrilicName;
    },
    autocompleteErrorClass: function autocompleteErrorClass() {
      return this.$v.targetPublicUserModel.BudgetUserId.$error ? 'error' : null;
    }
  },
  validations: {
    targetPublicUserModel: {
      BudgetUserId: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__);


//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-create',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_validation__["a" /* validationMixin */]],
  data: function data() {
    return {
      load: false,
      availableRoles: [],
      selectedRoles: [],
      availableClaims: [],
      selectedClaims: [],
      user: {
        login: '',
        name: '',
        email: ''
      }
    };
  },

  created: function created(e) {
    // let roles = Vue.$config.user_roles

    // for (let i = 0; i < roles.length; i++) {
    //   let role = {}
    //   role.text = this.$t('userAdministration.' + roles[i])
    //   role.value = roles[i]
    //   this.availableRoles.push(role)
    // }

    this.retrieveRoles();
    // let claims = Vue.$config.user_claims

    // for (let i = 0; i < claims.length; i++) {
    //   let claim = {}
    //   claim.text = this.$t('userAdministration.' + claims[i])
    //   claim.value = claims[i]
    //   this.availableClaims.push(claim)
    // }
  },
  methods: {
    retrieveRoles: function retrieveRoles() {
      var _this = this;

      this.load = true;

      this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.userPermissionHierarchyGet).then(function (response) {
        var permissionHierarchy = response.data.payload;
        _this.availableRoles = _this.getAvailableRoles(permissionHierarchy);
        var invalidRole = _this.availableRoles.find(function (element) {
          return !element.valid_role;
        });
        _this.availableClaims = invalidRole ? invalidRole.claims : [];
        _this.selectedRoles.push(_this.availableRoles[1].name);
        _this.load = false;
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    validateBeforeCreateUser: function validateBeforeCreateUser() {
      this.logConsole(this.user);
      this.$v.$touch();
      if (this.$v.$invalid) {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('user')
        });
        return;
      }
      this.createUser();
      this.logConsole('Submitted');
    },
    createUser: function createUser() {
      var _this2 = this;

      this.load = true;
      this.user.creationRoles = this.selectedRoles;
      this.user.creationClaims = this.selectedClaims;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.createLocalUserPost, this.user).then(function (response) {
        _this2.logConsole(response);
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('userAdministration.userCreated'),
          errors: []
        });
        _this2.$refs.createUserForm.reset();
        _this2.load = false;
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    getAvailableRoles: function getAvailableRoles(permissionHierarchy) {
      var _this3 = this;

      var roles = [];
      var availableRoles = [];
      if (Array.isArray(permissionHierarchy)) {
        // ES6 distinct
        availableRoles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(permissionHierarchy.map(function (item) {
          return item.roleDescription;
        }))));
        availableRoles.forEach(function (availableRole) {
          var isNull = !availableRole;
          roles.push({
            name: isNull ? _this3.$t('userAdministration.ungroupedClaims') : availableRole,
            localized_name: isNull ? _this3.$t('userAdministration.ungroupedClaims') : _this3.$t('userAdministration.' + availableRole),
            description: isNull ? _this3.$t('userAdministration.Ungrouped_Description') : _this3.$t('userAdministration.' + availableRole + '_Description'),
            valid_role: !isNull,
            claims: []
          });
        });
        permissionHierarchy.forEach(function (item) {
          var roleSearchCriteria = item.roleDescription === null ? _this3.$t('userAdministration.ungroupedClaims') : item.roleDescription;
          var result = roles.filter(function (obj) {
            return obj.name.localeCompare(roleSearchCriteria) === 0;
          });
          if (result && result[0]) {
            result[0].claims.push({
              text: _this3.$t('userAdministration.' + item.claimDescription),
              value: item.claimDescription,
              id: item.claimId
            });
          }
        });
      }
      return roles;
    }
  },
  validations: {
    user: {
      login: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      name: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      load: false,
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        REVOKED: 3,
        DISABLED: 4
      },
      tOptions: {
        checkboxValue: 'userId',
        payloadsTotalPropertyName: 'additionalInformation',
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] !== statuses.ACTIVE;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'user-administration/user/' + row['userId'];
          }
        }
      },
      tColumns: [{
        columnName: 'organizationName',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userOrganizationName'),
        filterType: 'input',
        highlight: true,
        cell: function cell(row) {
          return row.organizationName;
        }
      }, {
        columnName: 'organizationCompanyNumber',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userOrganizationCompanyNumber'),
        filterType: 'input',
        highlight: true,
        cell: function cell(row) {
          return row.organizationCompanyNumber;
        }
      }, {
        columnName: 'name',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userName'),
        filterType: 'input',
        cell: function cell(row) {
          return row.name;
        }
      }, {
        columnName: 'login',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userLogin'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.login;
        }
      }, {
        columnName: 'email',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userEmail'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.email;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatus'),
        hideSort: true,
        filterType: 'select',
        align: 'center',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.3'), value: 3 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userAdministration.userStatuses.4'), value: 4 }],
        cell: function cell(row) {
          return null;
        }
      }],
      usersUrl: '',
      selectedUsers: [],
      optionsVisible: false
    };
  },

  created: function created() {
    this.usersUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedUsersInformationGet;
    this.tOptions.statuses = this.UserStatus;
  },
  methods: {
    onChecked: function onChecked(checkedValues) {
      this.selectedUsers = checkedValues;
      this.optionsVisible = checkedValues.length > 0;
    },
    revokeUsers: function revokeUsers() {
      var _this = this;

      this.logConsole('Revoking users ' + this.selectedUSers);
      this.load = true;
      var request = [];
      for (var i = 0; i < this.selectedUsers.length; i++) {
        var user = {};
        user.userId = Number(this.selectedUsers[i]);
        request.push(user);
      }

      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userDisablePost, request).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('userAdministration.userRevoked'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_2__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_user_info_UserInfo__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_user_info_UserInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_user_info_UserInfo__);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-information',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_misc_Loader___default.a,
    UserInfo: __WEBPACK_IMPORTED_MODULE_2__components_misc_user_info_UserInfo___default.a
  },
  data: function data() {
    return {
      userInformationUrl: '',
      updateUserPermissionsUrl: '',
      revokeUserUrl: '',
      restoreUserUrl: '',
      userId: this.$route.params.userId
    };
  },

  created: function created() {
    this.userInformationUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userInformationGet;
    this.updateUserPermissionsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.updateUserPermissionsPost;
    this.revokeUserUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userDisablePost;
    this.restoreUserUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userEnablePost;
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_datepicker___ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_Loader__);
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-notification',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_5__components_misc_datatable_Datatable___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_3__utils_datepicker___["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      dateFormat: this.$store.getters.dateFormat,
      dateLocale: __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__["a" /* srCYRL */],
      load: false,
      NotificationStatus: {
        ACTIVE: 1,
        CANCELLED: 2
      },
      Priority: {
        LOW: 1,
        NORMAL: 2,
        HIGH: 3
      },
      notification: {},
      selectedNotification: [],
      selected: null,
      notificationsUrl: '',
      options: [{
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.1'),
        value: 1
      }, {
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.2'),
        value: 2
      }, {
        text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.3'),
        value: 3
      }],
      tOptions: {
        checkboxes: false,
        payloadsTotalPropertyName: 'additionalInformation',
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            var validUntil = new Date(row['validUntil']);
            return row['status'] !== statuses.ACTIVE || validUntil < Date.now();
          },
          detailsLink: {
            createLink: function createLink(row) {
              return null;
            }
          }
        }
      },
      tColumns: [{
        columnName: 'creator',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationCreator'),
        filterType: 'input',
        align: 'center',
        cell: function cell(row) {
          return row.creator;
        }
      }, {
        columnName: 'text',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationText'),
        filterType: 'input',
        align: 'right',
        cell: function cell(row) {
          return row.text;
        }
      }, {
        columnName: 'created',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'created-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'created-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationCreatedDate'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'validUntil',
        columnRange: [{
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeFrom'),
          value: 'validUntil-from'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('invoices.columnDueDateRangeTo'),
          value: 'validUntil-to'
        }],
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationValidUntil'),
        filterType: 'date-range',
        hideFilter: true,
        align: 'center',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'priority',
        title: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriority'),
        hideSort: true,
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].t('userAdministration.notificationPriorityStatus.3'), value: 3 }],
        cell: function cell(row) {
          return null;
        }
      }]
    };
  },
  created: function created() {
    this.notificationsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedNotificationsGet;
    this.tOptions.statuses = this.NotificationStatus;
  },
  mounted: function mounted() {
    switch (this.$store.getters.dateLocale) {
      case 'sr-cyrl':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__["a" /* srCYRL */];
        break;
      case 'sr':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__["b" /* sr */];
        break;
      case 'en':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__["c" /* en */];
        break;
      default:
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_4__utils_datepicker_locale__["a" /* srCYRL */];
    }
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      this.logConsole('Creating user notification');

      // validate first
      this.createNotification();
    },
    onRowSelected: function onRowSelected(row) {
      this.selectedNotification = row;
      this.$refs.reviewNotificationModal.show();
    },
    createNotification: function createNotification() {
      var _this = this;

      this.load = true;
      this.notification.status = this.NotificationStatus.ACTIVE;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userNotificationsCreatePost, this.notification).then(function (response) {
        _this.logConsole(response);
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this.$t('userAdministration.notificationCreated'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error);
        _this.load = false;
      });
    },
    updateNotification: function updateNotification(cancelNotification) {
      var _this2 = this;

      this.load = true;
      if (cancelNotification) {
        this.selectedNotification.status = this.NotificationStatus.CANCELLED;
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.userNotificationsUpdatePost, this.selectedNotification).then(function (response) {
        _this2.logConsole(response);
        _this2.load = false;
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('userAdministration.notificationUpdated'),
          errors: []
        });
        __WEBPACK_IMPORTED_MODULE_1__router_bus__["a" /* EventBus */].$emit('refresh-table');
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    customFormatter: function customFormatter(date) {
      __WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format(this.dateFormat);
    },
    inputFormat: function inputFormat(date) {
      __WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, this.dateFormat).valueOf();
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_validation__ = __webpack_require__(46);

//
//










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-profile',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_validation__["a" /* validationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      load: false,
      hasAdminClaim: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["k" /* hasAdminClaim */])(),
      usedTocauseFatal: {},
      password: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      personal: {
        language: {
          value: this.$store.getters.language,
          options: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.language_options
        },
        dateLocale: {
          value: this.$store.getters.dateLocale,
          options: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.date_locale_options
        },
        dateFormat: {
          value: this.$store.getters.dateFormat,
          options: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.date_format_options
        },
        decimalFormat: {
          value: this.$store.getters.decimalFormat,
          options: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.decimal_format_options
        },
        csvDelimmeter: {
          value: this.$store.getters.csvDelimmeter,
          options: __WEBPACK_IMPORTED_MODULE_1_vue__["default"].$config.user_settings.CSV_separator_options
        }
      },
      register: {
        name: '',
        address: '',
        phoneNumber: '',
        email: '',
        treasuryBranch: '',
        adminName: '',
        adminIdentityNumber: '',
        adminEmail: '',
        adminPhoneNumber: ''
      },
      user: {},
      permissionClaims: [],
      canEditRegistration: false
    };
  },

  created: function created(e) {
    var _this = this;

    this.canEditRegistration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["l" /* hasRegistrationEditClaim */])();

    var claims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["m" /* getPermissionClaims */])();
    if (claims.constructor === Array) {
      this.permissionClaims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_auth__["m" /* getPermissionClaims */])();
    } else {
      this.permissionClaims.push(claims);
    }

    this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.userInformationGet).then(function (response) {
      _this.logConsole(response);
      // get body data
      _this.user = response.data.payload;
    }, function (error) {
      _this.logConsole(error);
      _this.formatErrorResponse(error);
    });
  },
  computed: {
    hasValidPasswords: function hasValidPasswords() {
      return this.password.oldPassword.length === 0 || this.password.newPassword.length === 0 || this.password.confirmNewPassword.length === 0;
    }
  },
  methods: {
    causeFatal: function causeFatal() {
      this.usedTocauseFatal.nonExistant();
    },

    changeUserPassword: function changeUserPassword() {
      var _this2 = this;

      if (this.password.newPassword === this.password.confirmNewPassword) {
        this.user.password = this.password.oldPassword;
        this.user.newPassword = this.password.newPassword;
        this.load = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.userPasswordChangePost, this.user).then(function (response) {
          _this2.logConsole(response);
          __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: _this2.$t('userAdministration.passwordChanged'),
            errors: []
          });
          _this2.load = false;
        }, function (error) {
          _this2.logConsole(error);
          _this2.formatErrorResponse(error);
          _this2.load = false;
        });
        this.$refs.changePasswordForm.reset();
        this.password.password = this.password.newPassword = this.password.confirmNewPassword = '';
      } else {
        this.logConsole('Confirm-old not valid');
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('userAdministration.confirmPasswordFail'),
          errors: []
        });
      }
    },
    validateRegistrationInformation: function validateRegistrationInformation() {
      this.$v.$touch();
      var registerValidationErrors = this.getValidationErrors('register');
      if (registerValidationErrors && registerValidationErrors.length > 0) {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('register')
        });

        this.$nextTick(function () {
          document.body.scrollTop = 0;
        });
        return;
      }
      this.editRegistrationInformation();
    },
    editRegistrationInformation: function editRegistrationInformation() {
      var _this3 = this;

      this.load = true;
      this.logConsole(this.register);
      window.scrollTo(0, 0);

      var tempRegistration = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.register));
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(tempRegistration, 'invoiceLimit');
      tempRegistration.treasuryBranch = this.register.treasuryBranch.toString();
      console.log(tempRegistration);
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.editRegistrationPost, tempRegistration).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$t('userAdministration.registrationUpdated'),
          errors: []
        });
        _this3.load = false;
        _this3.$v.$reset();
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error, 'register.registrationLimitExceeded');
        _this3.load = false;
      });
    },
    editRegistrationShown: function editRegistrationShown() {
      var _this4 = this;

      if (this.register && this.register.companyNumber) {
        return;
      }
      this.load = true;
      this.$http.get(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.registrationInformationGet).then(function (response) {
        _this4.logConsole(response);
        // get body data
        var registration = response.data.payload;
        _this4.register = registration;
        _this4.load = false;
      }, function (error) {
        _this4.logConsole(error);
        _this4.formatErrorResponse(error);
        _this4.load = false;
      });
    },
    validateUserInformation: function validateUserInformation() {
      this.logConsole(this.user);
      this.$v.$touch();
      var userValidationErrors = this.getValidationErrors('user');
      if (userValidationErrors && userValidationErrors.length > 0) {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('user')
        });
        return;
      }
      this.editUser();
    },
    editUser: function editUser() {
      var _this5 = this;

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].$apiConfig.updateUserInformationPost, this.user).then(function (response) {
        _this5.logConsole(response);
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this5.$t('userAdministration.userUpdated'),
          errors: []
        });
        _this5.load = false;
        _this5.$v.$reset();
      }, function (error) {
        _this5.logConsole(error);
        _this5.formatErrorResponse(error);
        _this5.load = false;
      });
    },
    saveRegional: function saveRegional() {
      var _this6 = this;

      this.$store.dispatch('regional', {
        language: this.personal.language.value,
        dateFormat: this.personal.dateFormat.value,
        // dateLocale: this.personal.dateLocale.value,
        decimalFormat: this.personal.decimalFormat.value,
        csvDelimmeter: this.personal.csvDelimmeter.value
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this6.$t('userSettings.settingsSavedSuccess'),
          errors: []
        });
      }).catch(function (error) {
        _this6.logConsole(error);
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: _this6.$t('userSettings.settingsSavedFail'),
          errors: []
        });
      });
    }
  },
  validations: {
    register: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["email"]
      },
      adminName: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      adminIdentityNumber: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      adminEmail: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["email"]
      },
      adminPhoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      }
    },
    user: {
      login: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      name: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_cookie__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-registration',
  components: {
    Datatable: __WEBPACK_IMPORTED_MODULE_1__components_misc_datatable_Datatable___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_2__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      RegistrationStatus: {
        PENDING: 1,
        APPROVED: 2,
        CANCELLED: 3
      },
      tOptions: {
        checkboxes: false,
        payloadsTotalPropertyName: 'additionalInformation',
        invalidRowMarker: {
          criteria: function criteria(row, statuses) {
            return row['status'] === statuses.CANCELLED;
          }
        },
        detailsLink: {
          createLink: function createLink(row) {
            return 'user-registration/approval/' + row['id'];
          }
        }
      },
      tColumns: [{
        columnName: 'id',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationId'),
        filterType: 'input',
        cell: function cell(row) {
          return row.id;
        }
      }, {
        columnName: 'companyNumber',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationBudgetId') + ' / ' + __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationCompanyNumber'),
        filterType: 'input',
        cell: function cell(row) {
          return row.companyNumber;
        }
      }, {
        columnName: 'name',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationName'),
        filterType: 'input',
        cell: function cell(row) {
          return row.name;
        }
      }, {
        columnName: 'adminName',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationAdminName'),
        filterType: 'input',
        cell: function cell(row) {
          return row.adminName;
        }
      }, {
        columnName: 'adminEmail',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationAdminEmail'),
        filterType: 'input',
        cell: function cell(row) {
          return row.adminEmail;
        }
      }, {
        columnName: 'entityType',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.entityType'),
        align: 'center',
        filterType: 'input',
        cell: function cell(row) {
          return null;
        }
      }, {
        columnName: 'status',
        title: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationStatus'),
        hideSort: true,
        align: 'center',
        filterType: 'select',
        filterSelectOptions: [{ key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationStatuses.0'), value: '' }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationStatuses.1'), value: 1 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationStatuses.2'), value: 2 }, { key: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('userRegistration.registrationStatuses.3'), value: 3 }],
        cell: function cell(row) {
          return null;
        }
      }],
      registrationsUrl: '',
      registrationsReportsUrl: ''
    };
  },

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_cookie__["a" /* getAccessToken */])();
    this.registrationsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.pagedPendingRegistrationsGet;
    this.registrationsReportsUrl = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.reporting_api_root + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$apiConfig.generateRegistrationsReport;
    this.tOptions.statuses = this.RegistrationStatus;
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cookie__ = __webpack_require__(34);


//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-approval',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      priorityVariant: ['secondary', 'success', 'danger'],
      RegistrationStatus: {
        PENDING: 1,
        APPROVED: 2,
        CANCELLED: 3
      },
      registrationId: Number(this.$route.params.registrationId),
      registration: {},
      user: {},
      invoiceLimit: null,
      companyAddress: null,
      companyName: null,
      load: false
    };
  },

  computed: {
    isPublicEntity: function isPublicEntity() {
      if (!this.registration || !this.registration.companyNumber) {
        return false;
      }
      return this.registration.companyNumber.length === 5;
    },
    isPrivateEntity: function isPrivateEntity() {
      if (!this.registration || !this.registration.companyNumber) {
        return false;
      }
      return this.registration.companyNumber.length === 8;
    },
    registrationCancelled: function registrationCancelled() {
      return this.registration.status === this.RegistrationStatus.CANCELLED;
    },
    registrationApproved: function registrationApproved() {
      return this.registration.status === this.RegistrationStatus.APPROVED;
    },
    registrationPending: function registrationPending() {
      return this.registration.status === this.RegistrationStatus.PENDING;
    }
  },
  created: function created() {
    var _this = this;

    // Unknown issue - bearer token removed for his query
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cookie__["a" /* getAccessToken */])();
    this.$http.get(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.pendingRegistrationsGet + '/' + this.registrationId).then(function (response) {
      _this.logConsole(response);
      _this.registration = response.data.payload;
      _this.companyAddress = _this.registration.address;
      _this.companyName = _this.registration.name;
      if (!_this.registrationApproved) {
        _this.registration.adminLogin = _this.formatInitialLogin();
      }
    }, function (error) {
      _this.logConsole(error);
    });
  },
  methods: {
    validateAccountApproval: function validateAccountApproval() {
      this.approveAccount();
    },
    approveAccount: function approveAccount() {
      var _this2 = this;

      this.load = true;
      var tempRegistration = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.registration));
      tempRegistration.treasuryBranch = this.registration.treasuryBranch.toString();
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(tempRegistration, 'invoiceLimit');
      this.user.registration = tempRegistration;
      this.user.OrganizationId = this.registrationId;
      this.user.login = this.registration.adminLogin;
      this.user.name = this.registration.adminName;
      this.user.email = this.registration.adminEmail;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.approveRegisteredUserPost, this.user).then(function (response) {
        _this2.logConsole(response);
        _this2.load = false;
        // get body data
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this2.$t('userRegistration.registrationApproved'),
          errors: []
        });
        _this2.$refs.accountApprovalForm.reset();
        _this2.registration.status = _this2.RegistrationStatus.APPROVED;
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
        _this2.load = false;
      });
    },
    cancelAccount: function cancelAccount() {
      var _this3 = this;

      this.load = true;
      var tempRegistration = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.registration));
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(tempRegistration, 'invoiceLimit');
      tempRegistration.treasuryBranch = this.registration.treasuryBranch.toString();
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.cancelRegisteredUserPost, tempRegistration).then(function (response) {
        _this3.logConsole(response);
        _this3.load = false;
        // get body data
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$t('userRegistration.registrationCancelled'),
          errors: []
        });
        _this3.registration.status = _this3.RegistrationStatus.CANCELLED;
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error);
        _this3.load = false;
      });
    },
    printAdminForm: function printAdminForm() {
      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
      var publicCompanyNumber = this.isPublicEntity ? this.registration.companyNumber : '';
      var privateCompanyNumber = this.isPrivateEntity ? this.registration.companyNumber : this.registration.budgetCompanyNumber;

      var header = [];
      if (!this.browserIE11()) {
        header.push({
          image: this.getBase64Image(this.$refs.imgToExport),
          width: 40,
          height: 65,
          alignment: 'left'
        });
      }
      header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА' + '\n' + 'Управа за трезор', fontSize: 10 });
      header.push({ text: '\n\n' + 'Образац ЦРФ-2' + '\n' + 'Централни регистар фактура', fontSize: 10, alignment: 'right' });

      var docDefinition = {
        content: [{
          columns: header
        }, { text: '\n\n' + this.$t('userRegistration.adminFormTitle') + '\n\n\n', style: 'header' }, { text: this.$t('register.legalEntityInfo') + '\n\n', style: 'subheader' }, { text: this.$t('register.budgetIdNumber') + ' : ', fontSize: 12 }, { text: publicCompanyNumber, style: 'value' }, { text: this.$t('register.budgetIdNumberFootnote') + '\n\n', style: 'small' }, { text: this.$t('register.companyName') + ' : ', fontSize: 12 }, { text: this.registration.name + '\n\n', style: 'value' }, {
          columns: [[{ text: this.$t('register.companyNumber') + ' : ', fontSize: 12 }, { text: privateCompanyNumber + '\n\n', style: 'value' }], [{ text: this.$t('register.taxIdNumber') + ' : ', fontSize: 12 }, { text: this.registration.taxIdNumber + '\n\n', style: 'value' }]]
        }, { text: this.$t('register.address') + ' : ', fontSize: 12 }, { text: this.registration.address + '\n\n', style: 'value' }, { text: this.$t('register.adminInfo') + '\n\n', style: 'subheader' }, { text: this.$t('userAdministration.userLogin') + ' : ', fontSize: 12 }, { text: this.registration.adminLogin + '\n\n', style: 'value' }, { text: this.$t('register.name') + ' : ', fontSize: 12 }, { text: this.registration.adminName + '\n\n', style: 'value' }, { text: this.$t('register.email') + ' : ', fontSize: 12 }, { text: this.registration.adminEmail + '\n\n', style: 'value' }, {
          columns: [{ text: '__________________________', fontSize: 12, alignment: 'left', margin: [15, 100, 0, 5] }, { text: '_____________________________', fontSize: 12, alignment: 'right', margin: [0, 100, 15, 5] }]
        }, {
          columns: [{ text: 'Предао у Управи за трезор', fontSize: 11, alignment: 'left', margin: [15, 0, 0, 0] }, { text: 'Примио за правно лице/орган', fontSize: 11, alignment: 'right', margin: [0, 0, 15, 0] }]
        }],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          value: {
            fontSize: 12,
            bold: true
          },
          subheader: {
            fontSize: 14,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 8
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('nalog.pdf');
    },
    printRegistrationForm: function printRegistrationForm() {
      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
      var registrationToExport = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.registration);
      registrationToExport.budgetNumber = this.isPublicEntity ? this.registration.companyNumber : '';
      registrationToExport.companyNumber = this.isPrivateEntity ? this.registration.companyNumber : this.registration.budgetCompanyNumber;

      this.exportRegistration(registrationToExport, this.$refs.imgToExport);
    },
    getBase64Image: function getBase64Image(img) {
      if (this.browserIE11()) {
        return;
      }

      // Create an empty canvas element
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      // Copy the image contents to the canvas
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      // Get the data-URL formatted image
      // Firefox supports PNG and JPEG. You could check img.src to
      // guess the original format, but be aware the using "image/jpg"
      // will re-encode the image.
      return canvas.toDataURL('image/png');

      // return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
    },
    formatInitialLogin: function formatInitialLogin() {
      var transliterated = this.toBoldLatin(this.registration.adminName);
      return transliterated.trim().replace(/ +/g, '.').toLowerCase();
    },
    editInvoiceLimit: function editInvoiceLimit() {
      this.registration.invoiceLimit = this.invoiceLimit;
      this.editRegistration();
    },
    editAddress: function editAddress() {
      this.registration.address = this.companyAddress;
      this.editRegistration();
    },
    editRegistration: function editRegistration() {
      var _this4 = this;

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.editRegisteredUserInformation, this.registration).then(function (response) {
        _this4.logConsole(response);
        _this4.load = false;
        _this4.registration.invoiceLimit = response.data.payload.invoiceLimit;
        // get body data
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this4.$t('userRegistration.registrationChangedText'),
          errors: []
        });
      }, function (error) {
        _this4.logConsole(error);
        _this4.formatErrorResponse(error);
        _this4.load = false;
      });
    },
    editName: function editName() {
      var _this5 = this;

      this.load = true;
      this.registration.name = this.companyName;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.editRegisteredUserName, this.registration).then(function (response) {
        _this5.logConsole(response);
        _this5.load = false;
        _this5.registration.name = response.data.payload.name;
        // get body data
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this5.$t('userRegistration.registrationChangedText'),
          errors: []
        });
      }, function (error) {
        _this5.logConsole(error);
        _this5.formatErrorResponse(error);
        _this5.load = false;
      });
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_papaparse__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_papaparse__);


//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_5__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      settleByIdf: false,
      load: false,
      errorList: [],
      settlementData: null,
      loadedSettlementData: null,
      parsedSettlementData: null
    };
  },

  computed: {
    showErrorContainer: function showErrorContainer() {
      return this.errorList.length > 0;
    }
  },
  methods: {
    fileLoaded: function fileLoaded(e) {
      this.errorList = [];
      var file = e.target.files[0];
      if (file && file.type === 'text/csv') {
        this.readAndParseCSV(file);
      } else if (file && file.type === 'application/json') {
        this.readJSON(file);
      }
    },
    readAndParseCSV: function readAndParseCSV(file) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_papaparse___default.a.parse(file, {
        preview: 1200,
        header: true,
        skipEmptyLines: true,
        complete: function complete(results) {
          if (results.data.length > 1000) {
            __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
              variant: 'danger',
              message: 'Величина ЈСОН фајла превазилази 1000 редова',
              errors: []
            });
            return;
          }
          _this.loadedSettlementData = results.data;
          _this.parsedSettlementData = _this.csvToJson(_this.loadedSettlementData);
        },
        error: function error(_error) {
          _this.logConsole('Error parsing CSV: ', [_error.message]());
        }
      });
    },
    readJSON: function readJSON(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var text;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return file.text();

              case 3:
                text = _context.sent;

                _this2.loadedSettlementData = JSON.parse(text);
                if (_this2.loadedSettlementData.length > 1000) {
                  __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
                    variant: 'danger',
                    message: 'Величина ЈСОН фајла превазилази 1000 редова',
                    errors: []
                  });
                }
                _this2.parsedSettlementData = _this2.csvToJson(_this2.loadedSettlementData);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this2.logConsole('Error parsing JSON: ', _context.t0);
                __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
                  variant: 'danger',
                  message: 'Грешка у формату ЈСОН фајла: ' + _context.t0,
                  errors: []
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 9]]);
      }))();
    },

    csvToJson: function csvToJson(csv) {
      var result = [];

      for (var i = 0; i < csv.length; i++) {
        var currentline = csv[i];

        result.push({
          invoiceId: currentline['IDF'],
          settledAmount: currentline['IzmireniIznos'],
          settlementDate: currentline['DatumIzmirenja'],
          bank: currentline['Banka'],
          creditAccount: currentline['RacunOdobrenja'],
          debitAccount: currentline['RacunZaduzenja'],
          referenceNumber: currentline['IdentifikatorPlacanja'],
          isCompensationSettlement: currentline['Kompenzacija'] === '1'
        });
      }

      return result;
    },
    confirmSettlement: function confirmSettlement() {
      this.$refs.settleInvoiceModal.show();
    },

    submitSettlement: function submitSettlement(validate) {
      var _this3 = this;

      if (this.parsedSettlementData === null) {
        return;
      }
      var url = validate ? __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.registerUserSettlementPost + '?validateSettlement=true' : __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.registerUserSettlementPost;
      this.load = true;
      this.$http.post(url, this.parsedSettlementData).then(function (response) {
        _this3.errorList = [];
        _this3.logConsole(response);
        _this3.load = false;
        // get body data
        if (!!response.data && Array.isArray(response.data.payload)) {
          response.data.payload.forEach(function (element) {
            if (element.settlementError) {
              _this3.errorList.push(element);
            }
          });
        }
        if (_this3.errorList.length === 0) {
          var message = validate ? 'Све достављене фактуре су исправне' : 'Успешно сте регистровали измирења фактура';
          if (!validate) {
            _this3.loadedSettlementData = null;
            _this3.settlementData = null;
          }

          __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
            variant: 'success',
            message: message,
            errors: []
          });
        }
      }, function (error) {
        _this3.logConsole(error);
        if (!!error.data && Array.isArray(error.data.errors)) {
          error.data.errors.forEach(function (element) {
            if (element && element.field) {
              var startIndex = element.field.indexOf('[') + 1;
              var endIndex = element.field.indexOf(']');
              var match = element.field.substring(startIndex, endIndex);
              _this3.errorList.push({
                settlement: _this3.parsedSettlementData[match],
                settlementError: element
              });
            }
          });
        } else {
          _this3.formatErrorResponse(error, 'invoices.invoiceLimitExceeded');
        }
        _this3.load = false;
      });
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loader',
  cls: '',
  data: function data() {
    return {
      showLoader: this.show
    };
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    setType: function setType() {
      this.cls = this.type;
    }
  },
  watch: {
    show: function show() {
      var _this = this;

      if (this.show === true) {
        setTimeout(function () {
          if (_this.show === true) {
            _this.showLoader = true;
          }
        }, 300);
      } else {
        this.showLoader = false;
      }
    }
  },
  created: function created() {
    this.setType();
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'autocomplete',
  data: function data() {
    return {
      items: [],
      query: '',
      searchDescription: '',
      current: -1,
      loading: false,
      cancelSearch: false,
      itemSelected: false,
      data: {},
      limit: 5,
      minChars: 1,
      selectFirst: true,
      queryParamName: 'search'
    };
  },

  props: {
    value: {
      type: String
    },
    inputClass: {
      type: String
    },
    name: {
      type: String
    },
    url: {
      type: String
    },
    criteria: {
      type: String
    },
    description: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    prepareResponseData: {
      type: Function
    },
    label: {
      type: String
    }
  },
  computed: {
    isEmpty: function isEmpty() {
      return !this.query;
    },
    isDirty: function isDirty() {
      return !!this.query;
    }
  },
  methods: {
    updateTimeout: function updateTimeout() {
      var _this = this;

      clearTimeout(this.sendFilter);
      this.sendFilter = setTimeout(function () {
        _this.update();
      }, 300);
    },
    isFunction: function isFunction(functionToCheck) {
      return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    },
    update: function update() {
      var _this2 = this;

      this.cancel();
      this.itemSelected = false;

      if (this.cancelSearch) {
        return;
      }

      if (!this.query) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return;
      }

      this.$emit('input', this.query);
      this.loading = true;

      this.fetch().then(function (response) {
        if (response && _this2.query) {
          var data = response.data;
          data = _this2.isFunction(_this2.prepareResponseData) ? _this2.prepareResponseData(data) : _this2.prepareResponseDataDefault(data);
          _this2.items = _this2.limit ? data.slice(0, _this2.limit) : data;
          _this2.current = -1;
          _this2.loading = false;
          if (_this2.selectFirst) {
            _this2.down();
          }
        }
      });
    },
    fetch: function fetch() {
      var _this3 = this;

      var url = this.queryParamName ? this.url : this.url + this.query;

      var params = this.queryParamName ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.queryParamName, this.query), this.data) : this.data;

      var cancel = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        return _this3.cancel = resolve;
      });
      var request = this.$http.get(url, { params: params });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.race([cancel, request]);
    },
    cancel: function cancel() {
      // used to 'cancel' previous searches
    },
    reset: function reset() {
      if (this.itemSelected) {
        return;
      }

      if (!this.cancelSearch) {
        this.resetField();
      }
    },
    resetField: function resetField() {
      this.items = [];
      this.loading = false;
      this.searchDescription = '';
      this.$emit('resolved', null);
    },
    resetContents: function resetContents() {
      this.query = '';
      this.resetField();
    },
    setContents: function setContents(contents) {
      this.query = contents;
    },
    setActive: function setActive(index) {
      this.current = index;
      // this.cancelSearch = true
      this.query = this.items[index][this.criteria];
      this.$emit('resolved', this.items[index]);
    },
    activeClass: function activeClass(index) {
      return {
        'indigo lighten-1 white--text': this.current === index
      };
    },
    up: function up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.items.length - 1;
      } else {
        this.current = -1;
      }
    },
    down: function down() {
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },
    onInputSelect: function onInputSelect() {
      this.cancelSearch = false;
    },
    onSelect: function onSelect() {
      if (this.current !== -1) {
        // this.cancelSearch = true
        this.$emit('resolved', this.items[this.current]);
        this.query = this.items[this.current][this.criteria] + '';
        this.searchDescription = this.items[this.current][this.description] + '';
        this.items = [];

        this.$emit('input', this.query);
        this.itemSelected = true;
      }
    },
    prepareResponseDataDefault: function prepareResponseDataDefault(data) {
      return data;
    },
    validate: function validate() {
      this.$validator.validateAll().then(function (result) {
        if (result) {}
      });
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'context-header',
  data: function data() {
    return {
      showLoader: this.show
    };
  },

  computed: {
    contextPath: function contextPath() {
      if (this.alternativeRoute.length > 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + '/' + this.alternativeRoute + '/' + this.tab).replace(/([^:]\/)\/+/g, '$1');
      }
      return (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].$config.help_root + this.$route.path + '/' + this.tab).replace(/([^:]\/)\/+/g, '$1');
    }
  },
  props: {
    title: {
      type: String,
      default: 'default'
    },
    alternativeRoute: {
      type: String,
      default: ''
    },
    tab: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cookie__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_datepicker___ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_money__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_v_money__);



//
//













var uuid = 0;

function getCurrentDatatableKey(self) {
  if (self.$options.propsData['name'] && self.$options.propsData['name'].length > 0) {
    return self.$options.propsData['name'];
  }
  return self.$options.propsData['url'];
}

function getCurrentDatatableInfo(self) {
  var key = getCurrentDatatableKey(self);
  var dataTableInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cookie__["j" /* getDatatableInfo */])(key);
  return dataTableInfo;
}

function setCurrentDatatableInfo(self, dataTableInfo) {
  var key = getCurrentDatatableKey(self);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cookie__["k" /* setDatatableInfo */])(key, dataTableInfo);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datatable',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_10__utils_datepicker___["a" /* default */],
    Money: __WEBPACK_IMPORTED_MODULE_13_v_money__["Money"]
  },
  data: function data() {
    return {
      // TODO: Move to proprs
      dateFormat: this.$store.getters.dateFormat,
      // TODO: Move to proprs
      dateLocale: __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__["a" /* srCYRL */],
      currentPage: 1,
      totalRows: 0,
      checkboxAll: false,
      checked: {},
      load: false,
      data: [],
      sortBy: null,
      sortDesc: null,
      paginationText: null,
      perPage: 0,
      filterModel: {},
      defaultOptions: {
        sortable: true,
        filter: true,
        filterDelay: 500,
        checkboxValue: 'id',
        per_page_options: [5, 10, 15, 25, 50],
        per_page_default: 5,
        checkboxes: true,
        payloadsTotalPropertyName: 'count',
        additionalQueryParameter: '',
        statuses: null,
        invalidRowMarker: null,
        hiddenRowMarker: null,
        highlightedRowMarker: null,
        altHighlightedRowMarker: null,
        detailsLink: null,
        partialCount: false
      },
      sendNoCount: false,
      query: {
        parameters: {
          filter: {}
        }
      },
      // TODO: put this in a prop
      currency: {
        decimal: this.$store.getters.decimalFormat,
        thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      sendFilter: '',
      hasInvoiceExportClaim: false
    };
  },

  watch: {
    /**
     * Watch for a change on a pagination, then send a request
     */
    currentPage: function currentPage() {
      this.pushModelToUrl();
      this.getCurrentPage();
    },
    '$route': function $route() {
      this.pushUrlToModel();
    },

    /**
     * This is fired whenever any of the filters is changed,
     * here we need to set those new values into the url's queryString
     * WITHOUT firing a changedevent, that is why we use replace() instead
     * of push() at the end line
     */
    filterModel: {
      handler: function handler() {
        this.pushModelToUrl();
      },
      deep: true
    },
    totalRows: {
      handler: function handler() {
        this.createPaginationText();
      },
      deep: true
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    reportsUrl: {
      type: String,
      default: ''
    },
    hasRowDetails: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    opt: function opt() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.defaultOptions, this.options);
    },
    generateReportVisible: function generateReportVisible() {
      return this.reportsUrl && this.reportsUrl.length > 0;
    }
  },
  methods: {
    pushUrlToModel: function pushUrlToModel() {
      var _this = this;

      if (this.dontFireModelToUrl) {
        this.dontFireModelToUrl = false;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.query).forEach(function (key) {
        if (key === 'currentPageSize') {
          _this.perPage = parseInt(_this.$route.query[key]);
        } else if (key === 'currentPage') {
          _this.currentPage = parseInt(_this.$route.query[key]);
        } else {
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this.filterModel, key, _this.$route.query[key]);
        }
      });
    },
    getCurrentPage: function getCurrentPage() {
      this.query.parameters.page = this.currentPage;

      var dataTableInfo = getCurrentDatatableInfo(this);
      if (!dataTableInfo) {
        dataTableInfo = {};
      }
      dataTableInfo.currentPage = this.currentPage;
      dataTableInfo.currentPageSize = this.perPage;
      setCurrentDatatableInfo(this, dataTableInfo);
      // TODO: change currentPage and currentPAgeSize to url's QS
      this.sendRequest();
    },
    isRowInvalid: function isRowInvalid(row) {
      if (!this.opt.invalidRowMarker) {
        return false;
      }

      return this.opt.invalidRowMarker.criteria(row, this.opt.statuses);
    },
    isRowHidden: function isRowHidden(row) {
      if (!this.opt.hiddenRowMarker) {
        return false;
      }

      return this.opt.hiddenRowMarker.criteria(row);
    },
    isRowHighlighted: function isRowHighlighted(row) {
      if (!this.opt.highlightedRowMarker) {
        return false;
      }

      return this.opt.highlightedRowMarker.criteria(row, this.opt.statuses);
    },
    isRowAltHighlighted: function isRowAltHighlighted(row) {
      if (!this.opt.altHighlightedRowMarker) {
        return false;
      }

      return this.opt.altHighlightedRowMarker.criteria(row, this.opt.statuses);
    },
    rowDetailsLink: function rowDetailsLink(row) {
      if (!this.opt.detailsLink) {
        return '#';
      }
      return this.opt.detailsLink.createLink(row);
    },
    filter: function filter(event) {
      var _this2 = this;

      if (event && [37, 38, 39, 40].includes(event.keyCode)) {
        return;
      } else {
        clearTimeout(this.sendFilter);
        this.sendFilter = setTimeout(function () {
          _this2.sendFilterRequest();
        }, this.opt.filterDelay);
      }
    },
    sendFilterRequest: function sendFilterRequest() {
      this.query.parameters.page = 1;
      this.sendNoCount = false;
      this.sendRequest();
    },

    /**
     * This will run after selecting different option in the list
     */
    changePerPage: function changePerPage() {
      this.query.parameters['perPage'] = this.perPage;
      this.pushModelToUrl();
      this.getCurrentPage();
    },

    /**
     * Returns values in array of checked boxes
     * @returns []
     */
    arrayOfChecked: function arrayOfChecked() {
      var ids = this.checked;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ids).forEach(function (key) {
        if (!ids[key]) delete ids[key];
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ids);
    },

    /**
     * Emit event on every single check.
     */
    checkedSingle: function checkedSingle() {
      this.$emit('checked', this.arrayOfChecked());
    },

    /**
     * It'll check/uncheck all chekboxes.
     *
     * This method will be called after clicking on
     * checkbox at the top of the column.
     */
    checkAll: function checkAll() {
      var checkboxes = document.querySelectorAll('.chk');
      var state = this.checkboxAll;
      var checked = {};

      for (var i = 0; i < checkboxes.length; i++) {
        checked[checkboxes[i].value] = state;
      }
      // checkboxes.forEach((el) => {
      //   checked[el.value] = state
      // })
      this.checked = checked;
      this.$emit('checked', this.arrayOfChecked());
    },

    /**
     * This will uncheck all boxes include the checkAll box.
     * It will also clear checked property and set checkboxAll to false.
     */
    resetCheckboxes: function resetCheckboxes() {
      if (this.opt.checkboxesPersist === false) {
        this.checked = {};
        this.checkboxAll = false;
      }
    },

    /**
     * Defines a heading column content.
     * @param column
     * @returns {*}
     */
    columnTitle: function columnTitle(column) {
      return column.title;
    },

    /**
     * Defines classes for sort icon.
     * @param column
     * @returns {string}
     */
    sortIconClasses: function sortIconClasses(column) {
      var classes = '';
      var sortActive = this.sortBy === column.columnName;
      var sortActiveClass = sortActive ? 'active' : '';
      var sortIconClass = this.sortDesc === true && sortActive ? 'down' : 'up';
      classes = sortActiveClass + ' ' + sortIconClass;
      return classes;
    },

    /**
     * Sort change.
     */
    sort: function sort(column) {
      this.sortDesc = this.sortDesc === null || this.sortBy !== column.columnName && (this.sortDesc === null || this.sortDesc === false) ? this.sortDesc = false : this.sortDesc = !this.sortDesc;
      this.sortBy = column.columnName;
      this.query.parameters['sortBy'] = this.sortBy;
      this.query.parameters['sortDesc'] = this.sortDesc;
      this.sendRequest();
    },

    /**
     * URL query builder.
     * @returns {string}
     */
    buildQuery: function buildQuery() {
      var params = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query.parameters));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params.filter).forEach(function (key) {
        if (!params.filter[key]) {
          delete params.filter[key];
        }
      });
      var query = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(params);
      if (this.opt.additionalQueryParameter && this.opt.additionalQueryParameter.length > 0) {
        if (this.opt.additionalQueryParameter !== 'noCount') {
          query += '&' + this.opt.additionalQueryParameter;
        }
      }
      if (this.sendNoCount) {
        query += '&noCount';
      }
      return query.length === 0 ? '' : '?' + query;
    },
    prepareFromRangeValue: function prepareFromRangeValue(column) {
      this.query.parameters.filter[column.columnRange[0].value] = this.flattenDecimal(this.query.parameters.filter[column.columnRange[0].value]);
      this.sendRequest();
    },
    prepareToRangeValue: function prepareToRangeValue(column) {
      this.query.parameters.filter[column.columnRange[1].value] = this.flattenDecimal(this.query.parameters.filter[column.columnRange[1].value]);
      this.sendRequest();
    },
    flattenDecimal: function flattenDecimal(decimal) {
      var commaIndex = decimal.indexOf(',');
      var dotIndex = decimal.indexOf('.');
      if (commaIndex >= 0 && dotIndex >= 0) {
        return decimal.replace('.', '').replace(',', '.');
      } else if (commaIndex >= 0) {
        return decimal.replace(',', '.');
      }

      return decimal;
    },

    /**
     * Send a http request.
     */
    sendRequest: function sendRequest() {
      var _this3 = this;

      this.load = true;
      var url = this.url + this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cookie__["a" /* getAccessToken */])();
      this.logConsole(url);
      return this.$http.get(url).then(function (response) {
        _this3.data = response.data.payload;
        _this3.load = false;
        if (response.data[_this3.opt.payloadsTotalPropertyName]) {
          _this3.totalRows = response.data[_this3.opt.payloadsTotalPropertyName];
          _this3.sendNoCount = true;
        }
        _this3.resetCheckboxes();
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error);
        _this3.load = false;
      });
    },
    rowSelected: function rowSelected(row) {
      this.$emit('rowSelected', row);
    },
    calculateSummary: function calculateSummary(columnName) {
      if (columnName) {
        var summary = 0;
        for (var i = 0; i < this.data.length; i++) {
          if (!this.isRowHidden(this.data[i])) {
            summary += this.data[i][columnName];
          }
        }
        return this.formatAmount(summary);
      }
    },
    generateReport: function generateReport() {
      var _this4 = this;

      this.load = true;
      var url = this.reportsUrl + this.buildQuery();
      this.logConsole(url);
      return this.$http.get(url, { responseType: 'arraybuffer' }).then(function (response) {
        _this4.load = false;
        var headers = response.headers;
        var blob = new Blob([response.data], { type: headers['content-type'] });
        __WEBPACK_IMPORTED_MODULE_8_file_saver___default.a.saveAs(blob, 'report.xlsx');
      }, function (error) {
        _this4.logConsole(error);
        _this4.formatErrorResponse(error);
        _this4.load = false;
      });
    },
    customFormatter: function customFormatter(date) {
      __WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format(this.dateFormat);
    },
    inputFormat: function inputFormat(date) {
      __WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale(this.$store.getters.dateLocale);
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, this.dateFormat).valueOf();
    },
    pushModelToUrl: function pushModelToUrl() {
      var params = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filterModel));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (!params[key]) {
          delete params[key];
        }
      });
      if (this.currentPage) {
        params.currentPage = this.currentPage;
      }
      if (this.perPage) {
        params.currentPageSize = this.perPage;
      }
      var queryStr = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(params);
      this.dontFireModelToUrl = true;
      this.$router.replace({ path: this.$route.path + '?' + queryStr });
    },
    applyFilterInput: function applyFilterInput(target) {
      this.$refs[target][0].hide(true);
      this.sendFilterRequest();
    },
    retrieveCount: function retrieveCount() {
      this.query.parameters.countAll = 1;
      this.defaultOptions.partialCount = false;
      this.sendNoCount = false;
      this.sendRequest();
    },
    createPaginationText: function createPaginationText() {
      var to = this.perPage * (this.currentPage - 1) + this.perPage;
      to = to > this.totalRows ? this.totalRows : to;
      this.paginationText = this.$t(!this.defaultOptions.partialCount || this.totalRows < 100 ? 'datatable.range' : 'datatable.rangePartial', [this.perPage * (this.currentPage - 1) + 1, to, this.totalRows]);
    }
  },
  beforeCreate: function beforeCreate() {
    this.uuid = uuid.toString();
    uuid += 1;
  },
  created: function created() {
    var _this5 = this;

    this.query.parameters.filter = this.filterModel;
    this.hasInvoiceExportClaim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__router_auth__["h" /* hasInvoiceExportClaim */])();

    // Allow on-demand table refresh
    __WEBPACK_IMPORTED_MODULE_6__router_bus__["a" /* EventBus */].$on('refresh-table', function () {
      _this5.sendRequest();
    });

    this.pushUrlToModel();
    this.pushModelToUrl();

    // Set perPage model and query parameter.
    this.perPage = this.query.parameters['perPage'] = this.opt.per_page_default;

    // Set current page from cache
    var datatableInfo = getCurrentDatatableInfo(this);
    if (datatableInfo) {
      this.currentPage = datatableInfo.currentPage;
      this.perPage = this.query.parameters['perPage'] = datatableInfo.currentPageSize ? datatableInfo.currentPageSize : this.opt.per_page_default;
    } // Send initial request.

    this.sendRequest();
  },
  mounted: function mounted() {
    this.createPaginationText();
    var elements = document.querySelectorAll('[id^="dropdown-"]');
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove('dropdown-toggle');
      elements[i].classList.add('p-0');
    }

    this.pushUrlToModel();
    this.pushModelToUrl();
    switch (this.$store.getters.dateLocale) {
      case 'sr-cyrl':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__["a" /* srCYRL */];
        break;
      case 'sr':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__["b" /* sr */];
        break;
      case 'en':
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__["c" /* en */];
        break;
      default:
        this.dateLocale = __WEBPACK_IMPORTED_MODULE_11__utils_datepicker_locale__["a" /* srCYRL */];
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_auth__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_validation__ = __webpack_require__(46);


//
//









__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-info',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_validation__["a" /* validationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_misc_Loader___default.a
  },
  data: function data() {
    return {
      priorityVariant: ['success', 'secondary', 'danger', 'danger'],
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        REVOKED: 3,
        DISABLED: 4
      },
      roleFields: [{
        key: 'selected_role',
        label: ' ',
        sortable: false
      }, {
        key: 'localized_name',
        label: this.$t('userAdministration.userRoles'),
        sortable: false
      }, {
        key: 'description',
        label: this.$t('userAdministration.userRoleDescription'),
        sortable: false
      }, {
        key: 'details',
        label: ' ',
        sortable: false
      }],
      roleItems: [],
      user: {},
      selectedRoles: [],
      selectedClaims: [],
      load: false,
      canChangeAuthority: false,
      editModeActive: false,
      filter: null,
      organizationLink: '',
      userChangedLink: '',
      hasUserResetPasswordClaim: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router_auth__["n" /* hasUserResetPasswordClaim */])()
    };
  },

  props: {
    userInformationUrl: {
      type: String
    },
    revokeUserUrl: {
      type: String
    },
    restoreUserUrl: {
      type: String
    },
    updateUserPermissionsUrl: {
      type: String
    },
    globalUser: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$route.params.userId': function $routeParamsUserId() {
      this.retrieveUserInfo(this.$route.params.userId);
    }
  },
  computed: {
    userRevoked: function userRevoked() {
      return this.user.status === this.UserStatus.REVOKED || this.user.status === this.UserStatus.DISABLED;
    },
    userRevokedLink: function userRevokedLink() {
      return 'user-administration/local-user/' + this.user.changedId;
    },
    indeterminate: function indeterminate() {
      var _this = this;

      var retVal = [];
      this.roleItems.forEach(function (item) {
        var itemObject = {};
        if (_this.containsSomeClaims(item.claims, _this.selectedClaims)) {
          itemObject[item.name] = true;
          retVal.push(itemObject);
        } else {
          itemObject[item.name] = false;
          retVal.push(itemObject);
        }
      });
      return retVal;
    }
  },
  created: function created() {
    this.retrieveUserInfo(this.$route.params.userId);
  },
  methods: {
    retrieveUserInfo: function retrieveUserInfo(userId) {
      var _this2 = this;

      this.$http.get(this.userInformationUrl + '/' + userId).then(function (response) {
        _this2.logConsole(response);
        _this2.user = response.data.payload;

        _this2.canChangeAuthority = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router_auth__["o" /* hasPermissionChangeAuthority */])(_this2.user.creationClaims);
        _this2.organizationLink = '/user-registration/approval/' + _this2.user.organizationId;
        _this2.userChangedLink = '/user-administration/local-user/' + _this2.user.changedId;
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error);
      });
    },
    revokeUser: function revokeUser(evt) {
      var _this3 = this;

      this.logConsole('Revoking user ' + this.user);
      this.load = true;
      var request = [];
      request.push(this.user);

      this.$http.post(this.revokeUserUrl, request).then(function (response) {
        _this3.logConsole(response);
        _this3.load = false;
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this3.$t('userAdministration.userRevoked'),
          errors: []
        });
        _this3.user.status = _this3.UserStatus.REVOKED;
      }, function (error) {
        _this3.logConsole(error);
        _this3.formatErrorResponse(error);
        _this3.load = false;
      });
    },
    restoreUser: function restoreUser(evt) {
      var _this4 = this;

      this.logConsole('Restoring user ' + this.user);
      this.load = true;
      var request = [];
      request.push(this.user);

      this.$http.post(this.restoreUserUrl, request).then(function (response) {
        _this4.logConsole(response);
        _this4.load = false;
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this4.$t('userAdministration.userRestored'),
          errors: []
        });
        _this4.user.status = _this4.UserStatus.ACTIVE;
      }, function (error) {
        _this4.logConsole(error);
        _this4.formatErrorResponse(error);
        _this4.load = false;
      });
    },
    editRoles: function editRoles() {
      this.roleItems = this.getAvailableRoles(this.user.availableClaims);
      this.selectRoles();
      this.editModeActive = true;
    },
    selectRoles: function selectRoles() {
      if (Array.isArray(this.user.creationRoles)) {
        for (var i = 0; i < this.user.creationRoles.length; i++) {
          this.addRole(this.user.creationRoles[i]);
        }
      } else {
        this.addRole(this.user.creationRoles);
      }

      if (Array.isArray(this.user.creationClaims)) {
        for (var j = 0; j < this.user.creationClaims.length; j++) {
          this.addClaim(this.user.creationClaims[j]);
        }
      } else {
        this.addClaim(this.user.creationClaims);
      }

      for (var _i = 0; _i < this.roleItems.length; _i++) {
        // Select role if user has all containing claims
        if (this.containsAllClaims(this.roleItems[_i].claims, this.user.creationClaims)) {
          this.addRole(this.roleItems[_i].name);
        }
      }
    },
    getAvailableRoles: function getAvailableRoles(permissionHierarchy) {
      var _this5 = this;

      var roles = [];
      var availableRoles = [];
      if (Array.isArray(permissionHierarchy)) {
        // ES6 distinct
        availableRoles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(permissionHierarchy.map(function (item) {
          return item.roleDescription;
        }))));
        availableRoles.forEach(function (availableRole) {
          var isNull = !availableRole;
          roles.push({
            name: isNull ? _this5.$t('userAdministration.ungroupedClaims') : availableRole,
            localized_name: isNull ? _this5.$t('userAdministration.ungroupedClaims') : _this5.$t('userAdministration.' + availableRole),
            description: isNull ? _this5.$t('userAdministration.Ungrouped_Description') : _this5.$t('userAdministration.' + availableRole + '_Description'),
            valid_role: !isNull,
            claims: []
          });
        });
        permissionHierarchy.forEach(function (item) {
          var roleSearchCriteria = item.roleDescription === null ? _this5.$t('userAdministration.ungroupedClaims') : item.roleDescription;
          var result = roles.filter(function (obj) {
            return obj.name.localeCompare(roleSearchCriteria) === 0;
          });
          if (result && result[0]) {
            result[0].claims.push({
              text: _this5.$t('userAdministration.' + item.claimDescription),
              value: item.claimDescription,
              id: item.claimId
            });
          }
        });
      }
      return roles;
    },
    cancelEditRoles: function cancelEditRoles() {
      this.editModeActive = false;
    },
    saveEditRoles: function saveEditRoles() {
      var _this6 = this;

      this.load = true;
      var ungroupedIndex = this.selectedRoles.indexOf(this.$t('userAdministration.ungroupedClaims'));
      if (ungroupedIndex >= 0) {
        this.selectedRoles.splice(ungroupedIndex, 1);
      }

      this.user.creationRoles = this.selectedRoles;
      this.user.creationClaims = this.selectedClaims;
      this.$http.post(this.updateUserPermissionsUrl, this.user).then(function (response) {
        _this6.logConsole(response);
        _this6.load = false;
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this6.$t('userAdministration.userPermissionsUpdated'),
          errors: []
        });

        _this6.editModeActive = false;
      }, function (error) {
        _this6.logConsole(error);
        _this6.formatErrorResponse(error);
        _this6.load = false;
      });
    },
    roleSelected: function roleSelected(role) {
      var index = this.selectedRoles.indexOf(role.name);
      if (index < 0) {
        this.selectedRoles.push(role.name);
      } else {
        this.selectedRoles.splice(index, 1);
      }

      for (var j = 0; j < role.claims.length; j++) {
        var claimIndex = this.selectedClaims.indexOf(role.claims[j].value);
        if (claimIndex >= 0 && index >= 0) {
          this.selectedClaims.splice(claimIndex, 1);
        } else if (claimIndex < 0 && index < 0) {
          this.addClaim(role.claims[j].value);
        }
        this.claimChanged(role.claims[j].value);
      }
    },
    claimSelected: function claimSelected(claim) {
      var index = this.selectedClaims.indexOf(claim.value);
      if (index < 0) {
        this.selectedClaims.push(claim.value);
      } else {
        this.selectedClaims.splice(index, 1);
      }

      this.claimChanged(claim);
    },
    claimChanged: function claimChanged(claim) {
      for (var i = 0; i < this.roleItems.length; i++) {
        if (this.containsAllClaims(this.roleItems[i].claims, this.selectedClaims)) {
          this.addRole(this.roleItems[i].name);
        } else {
          this.removeRole(this.roleItems[i].name);
        }
      }
    },
    containsAllClaims: function containsAllClaims(role, claims) {
      var containsAllClaims = true;

      for (var i = 0; i < role.length; i++) {
        if (Array.isArray(claims)) {
          if (claims.indexOf(role[i].value) >= 0) {
            containsAllClaims &= true;
          } else {
            return false;
          }
        } else {
          if (claims.localeCompare(role[i].value) === 0) {
            containsAllClaims &= true;
          } else {
            return false;
          }
        }
      }
      return containsAllClaims;
    },

    // Check's to see if role contains some claims but not all
    containsSomeClaims: function containsSomeClaims(role, claims) {
      var numberOfClaims = 0;
      for (var i = 0; i < role.length; i++) {
        if (Array.isArray(claims)) {
          if (claims.indexOf(role[i].value) >= 0) {
            numberOfClaims += 1;
          }
        } else {
          if (claims.localeCompare(role[i].value) === 0) {
            numberOfClaims += 1;
          }
        }
      }
      return numberOfClaims > 0 && numberOfClaims < role.length;
    },
    roleModelChanged: function roleModelChanged(role) {
      var index = this.selectedRoles.indexOf(role);
      if (index < 0) {
        this.selectedRoles.push(role);
      } else {
        this.selectedRoles.splice(index, 1);
      }
    },
    addRole: function addRole(role) {
      if (this.selectedRoles.indexOf(role) < 0) {
        this.selectedRoles.push(role);
      }
    },
    removeRole: function removeRole(role) {
      var index = this.selectedRoles.indexOf(role);
      if (this.selectedRoles.indexOf(role) >= 0) {
        this.selectedRoles.splice(index, 1);
      }
    },
    claimModelChanged: function claimModelChanged(claim) {
      var index = this.selectedClaims.indexOf(claim);
      if (index < 0) {
        this.selectedClaims.push(claim);
      } else {
        this.selectedClaims.splice(index, 1);
      }
    },
    addClaim: function addClaim(claim) {
      if (this.selectedClaims.indexOf(claim) < 0) {
        this.selectedClaims.push(claim);
      }
    },
    validateUserInformation: function validateUserInformation() {
      this.logConsole(this.user);
      this.$v.$touch();
      var userValidationErrors = this.getValidationErrors('user');
      if (userValidationErrors && userValidationErrors.length > 0) {
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('user')
        });
        return;
      }
      this.editUser();
    },
    updateChangedPermissions: function updateChangedPermissions() {
      this.$refs.permissionUpdateConfirmationModal.show();
    },
    editUser: function editUser() {
      var _this7 = this;

      this.load = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.updateLocalUserInformationPost, this.user).then(function (response) {
        _this7.logConsole(response);
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this7.$t('userAdministration.userUpdated'),
          errors: []
        });
        _this7.load = false;
        _this7.$v.$reset();
      }, function (error) {
        _this7.logConsole(error);
        _this7.formatErrorResponse(error);
        _this7.load = false;
      });
    },
    resetUserPassword: function resetUserPassword() {
      var _this8 = this;

      this.load = true;
      this.$http.patch(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.resetLocalUserPasswordPatch, [{ userId: this.user.userId }]).then(function (response) {
        _this8.logConsole(response);
        __WEBPACK_IMPORTED_MODULE_5__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'success',
          message: _this8.$t('userAdministration.userPasswordHasBeenReset'),
          errors: []
        });
        _this8.load = false;
        _this8.$v.$reset();
      }, function (error) {
        _this8.logConsole(error);
        _this8.formatErrorResponse(error);
        _this8.load = false;
      });
    }
  },
  validations: {
    user: {
      login: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      name: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_misc_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_validation__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_autocomplete_Autocomplete__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_misc_autocomplete_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_misc_autocomplete_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_context_header_ContextHeader__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_misc_context_header_ContextHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_misc_context_header_ContextHeader__);


//
//
//










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_validation__["a" /* validationMixin */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_misc_Loader___default.a,
    Autocomplete: __WEBPACK_IMPORTED_MODULE_8__components_misc_autocomplete_Autocomplete___default.a,
    ContextHeader: __WEBPACK_IMPORTED_MODULE_9__components_misc_context_header_ContextHeader___default.a
  },
  data: function data() {
    return {
      load: false,
      registrationAllowed: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.registration_allowed,
      register: {
        isPublicEntity: false,
        budgetNumber: '',
        taxIdNumber: '',
        companyNumber: '',
        parentInstitutionTaxIdNumber: '',
        parentInstitutionCompanyNumber: '',
        name: '',
        address: '',
        phoneNumber: '',
        email: '',
        treasuryBranch: '',
        adminName: '',
        adminIdentityNumber: '',
        adminEmail: '',
        adminPhoneNumber: '',
        registrationToken: null
      },
      registrationToExport: null,
      registrationConfirmation: null,
      pplCompanyNumber: '',
      treasuryBranchUrl: '',
      autoCompleteUrl_branches: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.treasuryBranchesGet,
      ouLink: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$config.help_root + '/_files/UTOJ.xls',
      registrationToken: null
    };
  },
  created: function created() {
    this.treasuryBranchUrl = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root + '/' + __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.treasuryBranchesGet;
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        __WEBPACK_IMPORTED_MODULE_3__router_bus__["a" /* EventBus */].$emit('alert', {
          variant: 'danger',
          message: this.$t('errors.someErrorsOccuredCheckListBelow'),
          errors: this.getValidationErrors('register')
        });

        this.$nextTick(function () {
          document.body.scrollTop = 0;
        });
        return;
      }
      this.submit();
    },
    submit: function submit() {
      var _this = this;

      this.load = true;
      this.logConsole(this.register);
      window.scrollTo(0, 0);

      var tempRegistration = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.register));
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(tempRegistration, 'invoiceLimit');

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.registerEntity, tempRegistration).then(function (response) {
        _this.load = false;
        _this.$v.$reset();
        _this.registrationToExport = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.register);
        _this.register.isPublicEntity = false;
        _this.register.budgetNumber = '';
        _this.register.taxIdNumber = '';
        _this.register.companyNumber = '';
        _this.register.parentInstitutionTaxIdNumber = '';
        _this.register.parentInstitutionCompanyNumber = '';
        _this.register.name = '';
        _this.register.address = '';
        _this.register.phoneNumber = '';
        _this.register.email = '';
        _this.register.treasuryBranch = '';
        _this.register.adminName = '';
        _this.register.adminIdentityNumber = '';
        _this.register.adminEmail = '';
        _this.register.adminPhoneNumber = '';
        _this.registrationConfirmation = response.data.payload.registrationConfirmation;
        _this.$refs.registerConfirmationModal.show();
        setTimeout(function () {
          _this.$refs.registerForm.reset();
          _this.$refs.treasuryBranchAutocomplete.resetContents();
          _this.registrationToken = _this.register.registrationToken = null;
        }, 1);
      }, function (error) {
        _this.logConsole(error);
        _this.formatErrorResponse(error, 'register.registrationLimitExceeded');
        _this.load = false;
      });
    },
    autocompleteErrorClass: function autocompleteErrorClass() {
      return this.$v.register.treasuryBranch.$error ? 'error' : null;
    },
    printRegistration: function printRegistration() {
      this.exportRegistration(this.registrationToExport, this.$refs.imgToExport);
    },
    sendRegistrationToken: function sendRegistrationToken() {
      var _this2 = this;

      this.load = true;

      var registrationToken = {
        registrationToken: this.registrationToken.trim()
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$apiConfig.registrationTokenPost, registrationToken).then(function (response) {
        _this2.load = false;
        _this2.registrationToExport = null;
        var registration = response.data.payload;

        _this2.register = registration;
        _this2.register.registrationToken = _this2.registrationToken;
        _this2.register.treasuryBranch = registration.treasuryBranch.toString();
        _this2.$refs.treasuryBranchAutocomplete.setContents(registration.treasuryBranch.toString());
        if (registration.budgetCompanyNumber && registration.budgetCompanyNumber.length > 0) {
          _this2.register.budgetNumber = registration.companyNumber;
          _this2.register.companyNumber = registration.budgetCompanyNumber;
        } else {
          _this2.register.budgetNumber = '';
          _this2.register.companyNumber = registration.companyNumber;
        }
        _this2.$refs.editRegistrationModalRef.hide();
      }, function (error) {
        _this2.logConsole(error);
        _this2.formatErrorResponse(error, 'register.registrationLimitExceeded');
        _this2.$refs.editRegistrationModalRef.hide();
        _this2.load = false;
      });
    },
    closeConfirmationModal: function closeConfirmationModal() {
      this.$refs.registerConfirmationModal.hide();
    },
    legalInformationEditable: function legalInformationEditable() {
      return this.register.registrationToken && this.register.registrationToken.length > 0;
    }
  },
  validations: function validations() {
    var rules = {};

    rules.parentInstitutionTaxIdNumber = {};
    rules.parentInstitutionCompanyNumber = {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rules, {
      companyNumber: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      taxIdNumber: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      name: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["email"]
      },
      treasuryBranch: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      adminName: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      adminIdentityNumber: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      },
      adminEmail: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["email"]
      },
      adminPhoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    });

    return {
      register: rules
    };
  }
});

/***/ }),
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.container[data-v-02ad1aff] {\n  padding: 0px;\n}\n@media (min-width: 1400px) {\n.container[data-v-02ad1aff] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-02ad1aff] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-02ad1aff] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-02ad1aff] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-02ad1aff] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-02ad1aff] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n.invalid-notification[data-v-02ad1aff] {\n  background-color: #f8d7da !important;\n}\n", ""]);

// exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.loader {\n  display: inline-block;\n  width: 0;\n  height: 16px;\n  position: relative;\n  transition: width .3s;\n}\n.loader::after {\n    content: '';\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    animation: loader;\n    animation-duration: 1s;\n    animation-iteration-count: infinite;\n}\n.loader.default {\n    width: 16px;\n}\n.loader.button {\n    width: 16px;\n    margin-left: 15px;\n    top: 2px;\n}\n.loader.cover {\n    position: absolute;\n    z-index: 999;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n    width: 100%;\n    height: 100%;\n}\n.loader.cover::after {\n      top: calc(50% - 16px);\n      left: calc(50% - 16px);\n      width: 32px;\n      height: 32px;\n}\n@keyframes loader {\n0% {\n    transform: rotateY(0deg);\n    background-color: white;\n}\n50% {\n    background-color: rgba(255, 255, 255, 0.3);\n}\n100% {\n    transform: rotateY(180deg);\n    background-color: white;\n}\n}\n", ""]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nhtml, body {\n  height: 100% !important;\n  background-color: white !important;\n}\n.clearfix::after, .cf::after {\n  content: ' ';\n  display: block;\n  clear: both;\n}\n.options-button {\n  background-color: #822023;\n  border: 1px solid #822023;\n}\n.options-button:hover {\n    opacity: .9;\n    cursor: pointer;\n}\n.generic-link {\n  cursor: pointer;\n}\n.form-control.error {\n  border-color: #d9534f;\n}\n.b-dropdown-form {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\nbody {\n  font-family: 'Open Sans', sans-serif;\n}\n", ""]);

// exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.notification-top[data-v-11a3b220] {\n  position: absolute;\n  top: 64px;\n  z-index: 100;\n  border-radius: 0;\n  margin-left: 5px;\n  width: calc(100% - 10px);\n}\n.notification-item[data-v-11a3b220] {\n  margin-right: 4rem !important;\n}\n.danger-notification-icon[data-v-11a3b220] {\n  width: 28px;\n  height: 28px;\n  line-height: 32px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.warning-notification-icon[data-v-11a3b220] {\n  width: 30px;\n  height: 30px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.info-notification-icon[data-v-11a3b220] {\n  width: 28px;\n  height: 28px;\n  margin: 0px;\n  margin-right: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nmain {\n  height: 100%;\n  position: relative;\n  z-index: 0;\n}\nmain::before {\n    content: '';\n    display: block;\n    width: 250px;\n    position: fixed;\n    left: 0;\n    top: 56px;\n    bottom: 0;\n    z-index: 0;\n    background-color: white;\n}\n@media (max-width: 800px) {\n.main-left {\n    float: none !important;\n    width: 100% !important;\n}\n}\n.main-left {\n  position: relative;\n  z-index: 1;\n  float: left;\n}\n@media (max-width: 800px) {\n.main-right {\n    float: none !important;\n    width: 100% !important;\n}\n}\n.main-right {\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\n.modal-dialog {\n  margin-top: 85px !important;\n}\n.nav-pills .nav-link.active, .show > .nav-pills .nav-link.active {\n  color: #eee !important;\n  background-color: #455769 !important;\n}\n.alert-right {\n  position: relative;\n  z-index: 1;\n  margin-left: 250px;\n}\n", ""]);

// exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.container[data-v-1c501716] {\n  padding: 0px;\n}\n@media (min-width: 1400px) {\n.container[data-v-1c501716] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-1c501716] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-1c501716] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-1c501716] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-1c501716] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-1c501716] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.user-info-label[data-v-1eb7ca44] {\n  font-weight: 600;\n}\n.user-revoked-card[data-v-1eb7ca44] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.user-approved-card[data-v-1eb7ca44] {\n  background-color: rgba(40, 167, 69, 0.1) !important;\n}\na label[data-v-1eb7ca44]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nheader[data-v-1f865bd7] {\n  font-size: 12pt;\n  position: relative;\n  min-height: 56px;\n  background-color: #455769;\n}\nheader .header-username-link[data-v-1f865bd7] {\n    font-weight: bold;\n    color: rgba(238, 238, 238, 0.9);\n}\n.header-development[data-v-1f865bd7] {\n  background-color: #6387AA !important;\n}\n.header-staging[data-v-1f865bd7] {\n  background-color: #fa9a4b !important;\n}\n.header-production[data-v-1f865bd7] {\n  background-color: #455769 !important;\n}\n.header-ptest[data-v-1f865bd7] {\n  background-color: #780303 !important;\n}\n.heavier-text[data-v-1f865bd7] {\n  font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-211b1af0] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.list-container[data-v-211b1af0] {\n  height: 320px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 11pt;\n}\n", ""]);

// exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-32dae221] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-32dae221] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-32dae221] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-32dae221] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-32dae221] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.user-info-label[data-v-3342773a] {\n  font-weight: 600;\n}\n.bg-primary[data-v-3342773a] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-3342773a] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.user-revoked-card[data-v-3342773a] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.contents-highlight[data-v-3342773a] {\n  font-weight: 600;\n  font-size: 11pt;\n  cursor: pointer;\n}\n.contents-highlight[data-v-3342773a]:hover {\n    color: #822023;\n}\n", ""]);

// exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-3c557185] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.list-container[data-v-3c557185] {\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 11pt;\n}\n", ""]);

// exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.container[data-v-464e84b0] {\n  padding: 0px;\n}\n@media (min-width: 1400px) {\n.container[data-v-464e84b0] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-464e84b0] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-464e84b0] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-464e84b0] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-464e84b0] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-464e84b0] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n.invalid-notification[data-v-464e84b0] {\n  background-color: #f8d7da !important;\n}\n", ""]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.context-help-header {\n  cursor: pointer;\n  opacity: 0.7;\n  width: 28px;\n  height: 28px;\n  margin: 0px;\n}\n.context-help-header:hover {\n    opacity: 1.0;\n}\n", ""]);

// exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-4b62da23] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-4b62da23] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoiceModal[data-v-4b62da23] {\n  margin-top: 60px;\n}\n.property-label[data-v-4b62da23] {\n  font-size: 11pt;\n  font-weight: 400;\n}\n.property-label-caption[data-v-4b62da23] {\n  font-size: 12pt;\n  font-weight: 600;\n}\n.full-width[data-v-4b62da23] {\n  width: 100%;\n}\n.issue-cancelled-card[data-v-4b62da23] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.issue-resolved-card[data-v-4b62da23] {\n  background-color: rgba(40, 167, 69, 0.1) !important;\n}\n.issue-unresolved-card[data-v-4b62da23] {\n  background-color: rgba(250, 154, 75, 0.1) !important;\n}\n.report-image[data-v-4b62da23] {\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n}\n", ""]);

// exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nh4[data-v-5009dc17] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.treasury-logo {\n  height: 75px;\n  width: 260px;\n  margin: 0 auto;\n}\n.treasury-logo img {\n    width: 55px;\n    height: 75px;\n}\n.treasury-logo label {\n    display: block;\n    font-size: 8pt;\n    font-weight: 600;\n    margin: 0px;\n}\n.danger-notification-icon {\n  width: 28px;\n  height: 28px;\n  line-height: 32px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.not-found-label {\n  color: #455769;\n  font-weight: 600;\n  font-size: 13pt;\n}\n", ""]);

// exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-58862c20] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-58862c20] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoicesModal[data-v-58862c20] {\n  margin-top: 85px !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-58862c20] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-58862c20] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-58862c20] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-58862c20] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-58862c20] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-58862c20] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.narrow-container[data-v-58fd4992] {\n  width: 800px;\n}\n.activation-info-label[data-v-58fd4992] {\n  font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "/*@import '../assets/css/login.scss';*/\n.treasury-logo {\n  height: 75px;\n  width: 260px;\n  margin: 0 auto;\n}\n.treasury-logo img {\n    width: 55px;\n    height: 75px;\n}\n.treasury-logo label {\n    display: block;\n    font-size: 8pt;\n    font-weight: 600;\n    margin: 0px;\n}\n.heavy-text {\n  font-weight: 800 !important;\n}\n.heavier-text {\n  font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-62de2e97] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.monospace-input[data-v-62de2e97] {\n  font-family: monospace;\n}\n", ""]);

// exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.autocomplete-container {\n  position: relative;\n}\n.autocomplete-container .fa-times {\n    cursor: pointer;\n}\n.autocomplete-container i {\n    float: right;\n    position: relative;\n    top: 30px;\n    right: 29px;\n    opacity: 0.4;\n}\n.autocomplete-container ul {\n    position: absolute;\n    padding: 0;\n    margin-top: -20px;\n    min-width: 100%;\n    background-color: #fff;\n    list-style: none;\n    border-radius: 4px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n    z-index: 1000;\n}\n.autocomplete-container ul li {\n      padding: 10px 16px;\n      border-bottom: 1px solid #ccc;\n      cursor: pointer;\n}\n.autocomplete-container ul li:first-child {\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n}\n.autocomplete-container ul li:last-child {\n      border-bottom-left-radius: 4px;\n      border-bottom-right-radius: 4px;\n      border-bottom: 0;\n}\n.autocomplete-container .auto-label {\n    font-size: 14px;\n    font-weight: 400;\n}\n.autocomplete-container span {\n    display: block;\n}\n.autocomplete-container .name {\n    font-weight: 400;\n    font-size: 12px;\n}\n.autocomplete-container .screen-name {\n    font-style: italic;\n}\n", ""]);

// exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-6b0d36d6] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-6b0d36d6] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoicesModal[data-v-6b0d36d6] {\n  margin-top: 85px !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-6b0d36d6] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-6b0d36d6] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-6b0d36d6] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-6b0d36d6] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-6b0d36d6] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-6b0d36d6] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-73f00188] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-751ffc9f] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-751ffc9f] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoiceModal[data-v-751ffc9f] {\n  margin-top: 60px;\n}\n.property-label[data-v-751ffc9f] {\n  font-size: 11pt;\n  font-weight: 400;\n}\n.property-label-caption[data-v-751ffc9f] {\n  font-size: 12pt;\n  font-weight: 600;\n}\n.full-width[data-v-751ffc9f] {\n  width: 100%;\n}\n.invoice-cancelled-card[data-v-751ffc9f] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.invoice-settled-card[data-v-751ffc9f] {\n  background-color: rgba(40, 167, 69, 0.1) !important;\n}\n.invoice-partially-settled-card[data-v-751ffc9f] {\n  background-color: rgba(23, 162, 184, 0.1) !important;\n}\n.invoice-assigned-card[data-v-751ffc9f] {\n  background-color: rgba(250, 154, 75, 0.1) !important;\n}\n.settle-input[data-v-751ffc9f] {\n  margin-right: 5px;\n}\n.field-description[data-v-751ffc9f] {\n  margin-top: .25rem;\n  font-size: .875rem;\n  color: #dc3545;\n}\n.report-image[data-v-751ffc9f] {\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n}\n.accordion-controls button[data-v-751ffc9f] {\n  text-decoration: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-78c8b551] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-78c8b551] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoicesModal[data-v-78c8b551] {\n  margin-top: 85px !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-78c8b551] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-78c8b551] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-78c8b551] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-78c8b551] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-78c8b551] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-78c8b551] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-80e255a4] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.list-container[data-v-80e255a4] {\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 11pt;\n}\n", ""]);

// exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-840fae58] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.list-container[data-v-840fae58] {\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 11pt;\n}\n", ""]);

// exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.alert-top[data-v-8e5c6624] {\n  position: absolute;\n  top: 58px;\n  z-index: 99;\n  border-radius: 0;\n  margin-left: 1px;\n  width: calc(100% - 2px);\n}\n", ""]);

// exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n@media (min-width: 1400px) {\n.container[data-v-8f341b20] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-8f341b20] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-8f341b20] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-8f341b20] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-8f341b20] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-8f341b20] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n.text-dark[data-v-8f341b20] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-a03f095e] {\n  background-color: #822023 !important;\n}\n.property-label[data-v-a03f095e] {\n  font-size: 11pt;\n  font-weight: 400;\n}\n.property-label-caption[data-v-a03f095e] {\n  font-size: 12pt;\n  font-weight: 600;\n}\n.text-dark[data-v-a03f095e] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.table-datepicker {\n  border: none !important;\n  border-bottom: 1px solid #455769 !important;\n  font-size: 10pt !important;\n}\n.table-datepicker-wrapper {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n", ""]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.table-holder[data-v-a5b31004] {\n  position: relative;\n  font-size: 14px;\n}\ntable.datatable[data-v-a5b31004] {\n  background-color: white;\n}\ntable.datatable .align-contents-center[data-v-a5b31004] {\n    text-align: center;\n}\ntable.datatable .align-contents-left[data-v-a5b31004] {\n    text-align: right;\n}\ntable.datatable .align-contents-right[data-v-a5b31004] {\n    text-align: left;\n}\ntable.datatable .contents-highlight[data-v-a5b31004] {\n    font-weight: 600;\n    font-size: 11pt;\n}\ntable.datatable tr:hover td[data-v-a5b31004] {\n    background-color: #f2f3f4;\n}\ntable.datatable td[data-v-a5b31004] {\n    vertical-align: middle;\n    border-bottom: 2px solid #f2f3f4;\n}\ntable.datatable td button[data-v-a5b31004] {\n      min-width: 110px;\n}\ntable.datatable th[data-v-a5b31004] {\n    border-bottom: 1px solid #455769;\n}\ntable.datatable th input[data-v-a5b31004], table.datatable th select[data-v-a5b31004] {\n      border: none;\n      border-radius: 0;\n      border-bottom: 1px solid #455769;\n      font-size: 10pt;\n}\ntable.datatable th .range-input-filter[data-v-a5b31004] {\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\ntable.datatable th .range-input-filter input[data-v-a5b31004] {\n        border: none;\n        border-radius: 0;\n        border-bottom: 1px solid #455769;\n        font-size: 10pt;\n}\ntable.datatable th .range-input-filter .input-group-prepend[data-v-a5b31004] {\n        border: none;\n        font-size: 10pt;\n        background-color: white;\n        font-weight: 300;\n}\ntable.datatable .header-column[data-v-a5b31004] {\n    background-color: #455769;\n    color: #eee;\n    vertical-align: middle;\n}\ntable.datatable .header-column-content[data-v-a5b31004] {\n    display: -ms-flexbox;\n    display: flex;\n}\ntable.datatable .header-column-content > *[data-v-a5b31004] {\n      display: block;\n}\ntable.datatable .header-column-content span[data-v-a5b31004] {\n      margin: 0 auto;\n}\ntable.datatable .header-column-content b[data-v-a5b31004] {\n      height: 25px;\n}\ntable.datatable .sort-icon[data-v-a5b31004] {\n    color: #cccccc;\n    /*outline: 1px solid red;*/\n    padding: 3px;\n    cursor: pointer;\n    width: 20px;\n}\ntable.datatable .sort-icon.active.up path[data-v-a5b31004]:first-child {\n      fill: #333333;\n}\ntable.datatable .sort-icon.active.down path[data-v-a5b31004]:last-child {\n      fill: #333333;\n}\ntable.datatable .table-footer[data-v-a5b31004] {\n    font-size: 14px;\n    line-height: 26px;\n}\ntable.datatable .table-footer .per-page-field label[data-v-a5b31004] {\n      margin-right: 5px;\n      margin-bottom: 0;\n      line-height: 24px;\n      display: inline-block;\n}\ntable.datatable .table-footer .per-page-field select.form-control[data-v-a5b31004] {\n      width: auto;\n      display: inline-block;\n}\ntable.datatable .datatable-footer tr:hover td[data-v-a5b31004] {\n    background-color: white !important;\n    cursor: default;\n}\ntable.datatable .datatable-footer .summary-label[data-v-a5b31004] {\n    font-weight: 600;\n    font-size: 11pt;\n}\ntable.datatable .split > div[data-v-a5b31004]:first-child, table.datatable .split-3 > div[data-v-a5b31004]:first-child {\n    float: left;\n    width: 50%;\n    text-align: left;\n}\ntable.datatable .split > div[data-v-a5b31004]:last-child, table.datatable .split-3 > div[data-v-a5b31004]:last-child {\n    float: left;\n    width: 50%;\n    text-align: right;\n}\ntable.datatable .split-3 > div[data-v-a5b31004] {\n    float: left;\n    width: 33.3% !important;\n    text-align: center;\n}\ntable.datatable .pagination[data-v-a5b31004] {\n    -ms-flex-pack: center;\n        justify-content: center;\n    margin-bottom: 0;\n}\ntable.datatable .highlight-row[data-v-a5b31004] {\n    background-color: rgba(250, 154, 75, 0.2) !important;\n}\ntable.datatable .highlight-row:hover td[data-v-a5b31004] {\n      background-color: rgba(250, 154, 75, 0.2) !important;\n}\ntable.datatable .alt-highlight-row[data-v-a5b31004] {\n    background-color: rgba(23, 162, 184, 0.2) !important;\n}\ntable.datatable .alt-highlight-row:hover td[data-v-a5b31004] {\n      background-color: rgba(23, 162, 184, 0.2) !important;\n}\ntable.datatable .invisible-row[data-v-a5b31004] {\n    display: none;\n}\ntable.datatable .invalid-row[data-v-a5b31004] {\n    background-color: #f8d7da !important;\n}\ntable.datatable .invalid-row:hover td[data-v-a5b31004] {\n      background-color: #f8d7da !important;\n}\ntable.datatable input[type=number][data-v-a5b31004]::-webkit-outer-spin-button,\n  table.datatable input[type=number][data-v-a5b31004]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\ntable.datatable input[type=number][data-v-a5b31004] {\n    -moz-appearance: textfield;\n}\ntable.datatable input[type=date][data-v-a5b31004]::-webkit-inner-spin-button,\n  table.datatable input[type=date][data-v-a5b31004]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\ntable.datatable .invisible-link[data-v-a5b31004] {\n    color: #000;\n}\ntable.datatable .invisible-link[data-v-a5b31004]:hover {\n      text-decoration: none;\n}\ntable.datatable .vdp-datepicker input[data-v-a5b31004] {\n    border: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-a5ce89e0] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-a5ce89e0] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.bg-primary[data-v-c1a7d0b2] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-c1a7d0b2] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoicesModal[data-v-c1a7d0b2] {\n  margin-top: 85px !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-c1a7d0b2] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-c1a7d0b2] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-c1a7d0b2] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.text-dark[data-v-ccd56e18] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.narrow-container[data-v-d13c8784] {\n  width: 800px;\n}\n.activation-info-label[data-v-d13c8784] {\n  font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nnav > ol[data-v-dcc03e3c] {\n  list-style: none;\n  margin: 10px 0 20px;\n  padding: 0;\n}\nnav > ol > li[data-v-dcc03e3c] {\n    margin: 2px 8px;\n}\nnav > ol > li > a[data-v-dcc03e3c] {\n      font-weight: 600;\n      font-size: 11pt;\n      color: rgba(0, 0, 0, 0.7);\n      background-color: #e6e7e8;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      text-align: left;\n      height: 64px;\n      max-width: 250px;\n      border: 1px solid rgba(206, 206, 206, 0.3);\n}\nnav > ol > li > a[data-v-dcc03e3c]:hover {\n        color: #822023;\n        text-decoration: none;\n}\nnav > ol > li > a.active[data-v-dcc03e3c], nav > ol > li > a[data-v-dcc03e3c]:focus {\n        color: #eee;\n        text-decoration: none;\n        background-color: #822023;\n}\nnav > ol > li > a span[data-v-dcc03e3c] {\n        text-align: center;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\nnav > ol > li > a i[data-v-dcc03e3c] {\n        margin-right: 0.25rem;\n        margin-left: 0.25rem;\n}\n#sidenav_id[data-v-dcc03e3c] {\n  border-bottom: 1px solid rgba(206, 206, 206, 0.3);\n}\n#sidenav_id .collapsed > .when-opened[data-v-dcc03e3c],\n  #sidenav_id :not(.collapsed) > .when-closed[data-v-dcc03e3c] {\n    display: none;\n}\n#sidenav_id > ul[data-v-dcc03e3c] {\n  list-style: none;\n  margin: 10px 0 10px;\n  padding: 0;\n}\n#sidenav_id > ul > li[data-v-dcc03e3c] {\n    margin: 8px;\n    height: 45px;\n}\n#sidenav_id > ul > li > a[data-v-dcc03e3c] {\n      font-weight: 600;\n      font-size: 11pt;\n      color: rgba(0, 0, 0, 0.7);\n      background-color: #e6e7e8;\n      display: block;\n      line-height: 45px;\n      text-align: center;\n      border: 1px solid rgba(206, 206, 206, 0.3);\n}\n#sidenav_id > ul > li > a[data-v-dcc03e3c]:hover {\n        color: #822023;\n        text-decoration: none;\n}\n#sidenav_id > ul > li > a.active[data-v-dcc03e3c], #sidenav_id > ul > li > a[data-v-dcc03e3c]:focus {\n        color: #eee;\n        text-decoration: none;\n        background-color: #822023;\n}\n.collapse-enter-active[data-v-dcc03e3c],\n.collapse-enter-to[data-v-dcc03e3c],\n.collapse-leave-active[data-v-dcc03e3c],\n.collapse-leave-to[data-v-dcc03e3c] {\n  transition: .5s ease-in-out;\n}\n@media (max-width: 800px) {\n.responsive-sidebar[data-v-dcc03e3c] {\n    display: block !important;\n}\n.sidebar[data-v-dcc03e3c] {\n    display: none !important;\n}\n.sidebar-collapsed[data-v-dcc03e3c] {\n    display: none !important;\n}\n.button-class[data-v-dcc03e3c] {\n    display: none !important;\n}\n.button-class-collapsed[data-v-dcc03e3c] {\n    display: none !important;\n}\n}\n.responsive-sidebar[data-v-dcc03e3c] {\n  display: none;\n}\n.sidebar-collapsed[data-v-dcc03e3c] {\n  width: 70px;\n}\n.main-sidebar img[data-v-dcc03e3c] {\n  width: 250px;\n  margin-top: 20%;\n}\n.treasury-logo[data-v-dcc03e3c] {\n  height: 75px;\n  margin-top: 75px;\n}\n.treasury-logo img[data-v-dcc03e3c] {\n    width: 55px !important;\n    height: 75px !important;\n}\n.treasury-logo label[data-v-dcc03e3c] {\n    display: block;\n    font-size: 8pt;\n    font-weight: 600;\n    margin: 0px;\n}\n#collapse-button[data-v-dcc03e3c] {\n  position: fixed;\n  bottom: 2rem;\n}\n.button-class[data-v-dcc03e3c] {\n  width: 250px;\n  margin-top: 15px;\n  margin-left: 10px;\n  border: none;\n  color: black;\n  background-color: #e6e7e8;\n  font-weight: 600;\n  font-size: 11pt;\n}\n.button-class[data-v-dcc03e3c]:hover {\n    color: #822023;\n    text-decoration: none;\n}\n.button-class-collapsed[data-v-dcc03e3c] {\n  width: 55px;\n  margin-top: 15px;\n  margin-left: 10px;\n}\n.material-icons.md-24[data-v-dcc03e3c] {\n  font-size: 24px;\n  vertical-align: middle;\n}\n", ""]);

// exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.container[data-v-de78e382] {\n  padding: 0px;\n}\n@media (min-width: 1400px) {\n.container[data-v-de78e382] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-de78e382] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-de78e382] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-de78e382] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-de78e382] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-de78e382] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.reset-password-link[data-v-e589e72e] {\n  color: #822023;\n  font-size: 11pt;\n  margin-left: 5px;\n}\n.initial-login-link[data-v-e589e72e] {\n  color: #6387AA;\n  margin: 10px;\n  font-weight: 600;\n}\n", ""]);

// exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-eba14a06], body[data-v-eba14a06] {\n  height: 100% !important;\n  background-color: white !important;\n}\n.clearfix[data-v-eba14a06]::after, .cf[data-v-eba14a06]::after {\n  content: ' ';\n  display: block;\n  clear: both;\n}\n.options-button[data-v-eba14a06] {\n  background-color: #822023;\n  border: 1px solid #822023;\n}\n.options-button[data-v-eba14a06]:hover {\n    opacity: .9;\n    cursor: pointer;\n}\n.generic-link[data-v-eba14a06] {\n  cursor: pointer;\n}\n.form-control.error[data-v-eba14a06] {\n  border-color: #d9534f;\n}\n.b-dropdown-form[data-v-eba14a06] {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n.user-info-label[data-v-eba14a06] {\n  font-weight: 600;\n}\n.text-dark[data-v-eba14a06] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.small-column {\n  width: 15%;\n}\n.tiny-column {\n  width: 5%;\n}\n", ""]);

// exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n@media (max-width: 800px) {\n.budget-info-container[data-v-f5607ae6] {\n    position: relative;\n    top: 0px;\n    right: 0px;\n    width: 100% !important;\n}\n}\n.property-label[data-v-f5607ae6] {\n  font-size: 11pt;\n  font-weight: 400;\n}\n.property-label-caption[data-v-f5607ae6] {\n  font-size: 12pt;\n  font-weight: 600;\n}\nfieldset label[data-v-f5607ae6], ul li[data-v-f5607ae6] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.group-settlement-cancelled-card[data-v-f5607ae6] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.group-settlement-active-card[data-v-f5607ae6] {\n  background-color: rgba(23, 162, 184, 0.1) !important;\n}\n.group-settlement-cancelled-list[data-v-f5607ae6], .group-settlement-settled-list[data-v-f5607ae6] {\n  background-color: inherit;\n}\n.group-settlement-settled-card[data-v-f5607ae6] {\n  background-color: rgba(40, 167, 69, 0.1) !important;\n}\n.text-dark[data-v-f5607ae6] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.monospace-input[data-v-f5607ae6] {\n  font-family: monospace;\n}\n.link-text[data-v-f5607ae6] {\n  font-weight: 600;\n  color: #cecece;\n}\n.invisible-link[data-v-f5607ae6] {\n  color: #000;\n}\n.invisible-link[data-v-f5607ae6]:hover {\n    text-decoration: none;\n}\n.report-image[data-v-f5607ae6] {\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n}\n", ""]);

// exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "\n.container[data-v-f70bb0cc] {\n  padding: 0px;\n}\n@media (min-width: 1400px) {\n.container[data-v-f70bb0cc] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-f70bb0cc] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-f70bb0cc] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-f70bb0cc] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-f70bb0cc] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-f70bb0cc] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n.invalid-notification[data-v-f70bb0cc] {\n  background-color: #f8d7da !important;\n}\n", ""]);

// exports


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 219,
	"./af.js": 219,
	"./ar": 226,
	"./ar-dz": 220,
	"./ar-dz.js": 220,
	"./ar-kw": 221,
	"./ar-kw.js": 221,
	"./ar-ly": 222,
	"./ar-ly.js": 222,
	"./ar-ma": 223,
	"./ar-ma.js": 223,
	"./ar-sa": 224,
	"./ar-sa.js": 224,
	"./ar-tn": 225,
	"./ar-tn.js": 225,
	"./ar.js": 226,
	"./az": 227,
	"./az.js": 227,
	"./be": 228,
	"./be.js": 228,
	"./bg": 229,
	"./bg.js": 229,
	"./bm": 230,
	"./bm.js": 230,
	"./bn": 231,
	"./bn.js": 231,
	"./bo": 232,
	"./bo.js": 232,
	"./br": 233,
	"./br.js": 233,
	"./bs": 234,
	"./bs.js": 234,
	"./ca": 235,
	"./ca.js": 235,
	"./cs": 236,
	"./cs.js": 236,
	"./cv": 237,
	"./cv.js": 237,
	"./cy": 238,
	"./cy.js": 238,
	"./da": 239,
	"./da.js": 239,
	"./de": 242,
	"./de-at": 240,
	"./de-at.js": 240,
	"./de-ch": 241,
	"./de-ch.js": 241,
	"./de.js": 242,
	"./dv": 243,
	"./dv.js": 243,
	"./el": 244,
	"./el.js": 244,
	"./en-au": 245,
	"./en-au.js": 245,
	"./en-ca": 246,
	"./en-ca.js": 246,
	"./en-gb": 247,
	"./en-gb.js": 247,
	"./en-ie": 248,
	"./en-ie.js": 248,
	"./en-il": 249,
	"./en-il.js": 249,
	"./en-in": 250,
	"./en-in.js": 250,
	"./en-nz": 251,
	"./en-nz.js": 251,
	"./en-sg": 252,
	"./en-sg.js": 252,
	"./eo": 253,
	"./eo.js": 253,
	"./es": 256,
	"./es-do": 254,
	"./es-do.js": 254,
	"./es-us": 255,
	"./es-us.js": 255,
	"./es.js": 256,
	"./et": 257,
	"./et.js": 257,
	"./eu": 258,
	"./eu.js": 258,
	"./fa": 259,
	"./fa.js": 259,
	"./fi": 260,
	"./fi.js": 260,
	"./fil": 261,
	"./fil.js": 261,
	"./fo": 262,
	"./fo.js": 262,
	"./fr": 265,
	"./fr-ca": 263,
	"./fr-ca.js": 263,
	"./fr-ch": 264,
	"./fr-ch.js": 264,
	"./fr.js": 265,
	"./fy": 266,
	"./fy.js": 266,
	"./ga": 267,
	"./ga.js": 267,
	"./gd": 268,
	"./gd.js": 268,
	"./gl": 269,
	"./gl.js": 269,
	"./gom-deva": 270,
	"./gom-deva.js": 270,
	"./gom-latn": 271,
	"./gom-latn.js": 271,
	"./gu": 272,
	"./gu.js": 272,
	"./he": 273,
	"./he.js": 273,
	"./hi": 274,
	"./hi.js": 274,
	"./hr": 275,
	"./hr.js": 275,
	"./hu": 276,
	"./hu.js": 276,
	"./hy-am": 277,
	"./hy-am.js": 277,
	"./id": 278,
	"./id.js": 278,
	"./is": 279,
	"./is.js": 279,
	"./it": 281,
	"./it-ch": 280,
	"./it-ch.js": 280,
	"./it.js": 281,
	"./ja": 282,
	"./ja.js": 282,
	"./jv": 283,
	"./jv.js": 283,
	"./ka": 284,
	"./ka.js": 284,
	"./kk": 285,
	"./kk.js": 285,
	"./km": 286,
	"./km.js": 286,
	"./kn": 287,
	"./kn.js": 287,
	"./ko": 288,
	"./ko.js": 288,
	"./ku": 289,
	"./ku.js": 289,
	"./ky": 290,
	"./ky.js": 290,
	"./lb": 291,
	"./lb.js": 291,
	"./lo": 292,
	"./lo.js": 292,
	"./lt": 293,
	"./lt.js": 293,
	"./lv": 294,
	"./lv.js": 294,
	"./me": 295,
	"./me.js": 295,
	"./mi": 296,
	"./mi.js": 296,
	"./mk": 297,
	"./mk.js": 297,
	"./ml": 298,
	"./ml.js": 298,
	"./mn": 299,
	"./mn.js": 299,
	"./mr": 300,
	"./mr.js": 300,
	"./ms": 302,
	"./ms-my": 301,
	"./ms-my.js": 301,
	"./ms.js": 302,
	"./mt": 303,
	"./mt.js": 303,
	"./my": 304,
	"./my.js": 304,
	"./nb": 305,
	"./nb.js": 305,
	"./ne": 306,
	"./ne.js": 306,
	"./nl": 308,
	"./nl-be": 307,
	"./nl-be.js": 307,
	"./nl.js": 308,
	"./nn": 309,
	"./nn.js": 309,
	"./oc-lnc": 310,
	"./oc-lnc.js": 310,
	"./pa-in": 311,
	"./pa-in.js": 311,
	"./pl": 312,
	"./pl.js": 312,
	"./pt": 314,
	"./pt-br": 313,
	"./pt-br.js": 313,
	"./pt.js": 314,
	"./ro": 315,
	"./ro.js": 315,
	"./ru": 316,
	"./ru.js": 316,
	"./sd": 317,
	"./sd.js": 317,
	"./se": 318,
	"./se.js": 318,
	"./si": 319,
	"./si.js": 319,
	"./sk": 320,
	"./sk.js": 320,
	"./sl": 321,
	"./sl.js": 321,
	"./sq": 322,
	"./sq.js": 322,
	"./sr": 324,
	"./sr-cyrl": 323,
	"./sr-cyrl.js": 323,
	"./sr.js": 324,
	"./ss": 325,
	"./ss.js": 325,
	"./sv": 326,
	"./sv.js": 326,
	"./sw": 327,
	"./sw.js": 327,
	"./ta": 328,
	"./ta.js": 328,
	"./te": 329,
	"./te.js": 329,
	"./tet": 330,
	"./tet.js": 330,
	"./tg": 331,
	"./tg.js": 331,
	"./th": 332,
	"./th.js": 332,
	"./tl-ph": 333,
	"./tl-ph.js": 333,
	"./tlh": 334,
	"./tlh.js": 334,
	"./tr": 335,
	"./tr.js": 335,
	"./tzl": 336,
	"./tzl.js": 336,
	"./tzm": 338,
	"./tzm-latn": 337,
	"./tzm-latn.js": 337,
	"./tzm.js": 338,
	"./ug-cn": 339,
	"./ug-cn.js": 339,
	"./uk": 340,
	"./uk.js": 340,
	"./ur": 341,
	"./ur.js": 341,
	"./uz": 343,
	"./uz-latn": 342,
	"./uz-latn.js": 342,
	"./uz.js": 343,
	"./vi": 344,
	"./vi.js": 344,
	"./x-pseudo": 345,
	"./x-pseudo.js": 345,
	"./yo": 346,
	"./yo.js": 346,
	"./zh-cn": 347,
	"./zh-cn.js": 347,
	"./zh-hk": 348,
	"./zh-hk.js": 348,
	"./zh-mo": 349,
	"./zh-mo.js": 349,
	"./zh-tw": 350,
	"./zh-tw.js": 350
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 707;

/***/ }),
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjMwNnB4IiBoZWlnaHQ9IjMwNnB4IiB2aWV3Qm94PSIwIDAgMzA2IDMwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzA2IDMwNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGcgaWQ9ImNoZXZyb24tcmlnaHQiPg0KCQk8cG9seWdvbiBwb2ludHM9Ijk0LjM1LDAgNTguNjUsMzUuNyAxNzUuOTUsMTUzIDU4LjY1LDI3MC4zIDk0LjM1LDMwNiAyNDcuMzUsMTUzIAkJIi8+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogPHRpdGxlLz4NCg0KIDxnPg0KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+DQogIDxyZWN0IGZpbGw9Im5vbmUiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgaGVpZ2h0PSI0MDIiIHdpZHRoPSI1ODIiIHk9Ii0xIiB4PSItMSIvPg0KIDwvZz4NCiA8Zz4NCiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPg0KICA8cGF0aCBmaWxsPSIjYjA1ZDY1IiBpZD0iT3ZhbCAyMDggY29weSIgZD0ibTcsMTFsMCwybDIsMGwwLC0ybC0yLDB6bTEsNWMtNC40MTgyOCwwIC04LC0zLjU4MTcyIC04LC04YzAsLTQuNDE4MjggMy41ODE3MiwtOCA4LC04YzQuNDE4MjgsMCA4LDMuNTgxNzIgOCw4YzAsNC40MTgyOCAtMy41ODE3Miw4IC04LDh6bS0xLC0xM2wwLDdsMiwwbDAsLTdsLTIsMHptMCwwIi8+DQogPC9nPg0KPC9zdmc+"

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjMwNnB4IiBoZWlnaHQ9IjMwNnB4IiB2aWV3Qm94PSIwIDAgMzA2IDMwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzA2IDMwNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGcgaWQ9ImV4cGFuZC1tb3JlIj4NCgkJPHBvbHlnb24gcG9pbnRzPSIyNzAuMyw1OC42NSAxNTMsMTc1Ljk1IDM1LjcsNTguNjUgMCw5NC4zNSAxNTMsMjQ3LjM1IDMwNiw5NC4zNSAJCSIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQoNCiA8Zz4NCiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPg0KICA8cmVjdCBmaWxsPSJub25lIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iNDAyIiB3aWR0aD0iNTgyIiB5PSItMSIgeD0iLTEiLz4NCiA8L2c+DQogPGc+DQogIDx0aXRsZT5MYXllciAxPC90aXRsZT4NCiAgPHBhdGggZmlsbD0iIzVkYTFhYiIgaWQ9InN2Z18xIiBkPSJtMTYsMGExNiwxNiAwIDAgMSAwLDMyYTE2LDE2IDAgMCAxIDAsLTMybTMsMTVsLTYsMGwwLDExbDYsMGwwLC0xMXptLTMsLTlhMywzIDAgMCAwIDAsNmEzLDMgMCAwIDAgMCwtNiIvPg0KIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgc3R5bGU9InZlcnRpY2FsLWFsaWduOiBtaWRkbGU7b3ZlcmZsb3c6IGhpZGRlbjsiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGw9IiNmZmE1MDAiIGQ9Ik00OTAuNjY2NjY3IDkzOC42NjY2NjdjNS45NzMzMzMgMCAxMS41MiAwIDE3LjA2NjY2Ni0xLjcwNjY2N0E4NS43NiA4NS43NiAwIDAgMCA1NzYgODUzLjMzMzMzM2gtMTcwLjY2NjY2N2E4NS4zMzMzMzMgODUuMzMzMzMzIDAgMCAwIDg1LjMzMzMzNCA4NS4zMzMzMzRNNzY4IDQ0OGMwLTEzMC45ODY2NjctOTEuMzA2NjY3LTI0MC42NC0yMTMuMzMzMzMzLTI2OS42NTMzMzNWMTQ5LjMzMzMzM0E2NCA2NCAwIDAgMCA0OTAuNjY2NjY3IDg1LjMzMzMzMyA2NCA2NCAwIDAgMCA0MjYuNjY2NjY3IDE0OS4zMzMzMzN2MjkuMDEzMzM0Yy0xMjIuNDUzMzMzIDI5LjAxMzMzMy0yMTMuMzMzMzMzIDEzOC42NjY2NjctMjEzLjMzMzMzNCAyNjkuNjUzMzMzVjY4Mi42NjY2NjdsLTg1LjMzMzMzMyA4NS4zMzMzMzN2NDIuNjY2NjY3aDcyNS4zMzMzMzN2LTQyLjY2NjY2N2wtODUuMzMzMzMzLTg1LjMzMzMzM204NC4wNTMzMzMtMjU2aDg1LjMzMzMzNGMtNi40LTEzNi45Ni03My44MTMzMzMtMjU3LjI4LTE3NS43ODY2NjctMzM0LjkzMzMzNGwtNjEuMDEzMzMzIDYxLjAxMzMzNEM3ODcuNjI2NjY3IDIxMy4zMzMzMzMgODQ1LjY1MzMzMyAzMTMuNiA4NTIuMDUzMzMzIDQyNi42NjY2NjdNMjgwLjc0NjY2NyAxNTIuNzQ2NjY3TDIxOS43MzMzMzMgOTEuNzMzMzMzQTQ1MS40MTMzMzMgNDUxLjQxMzMzMyAwIDAgMCA0Mi42NjY2NjcgNDI2LjY2NjY2N2g4NS4zMzMzMzNjNy42OC0xMTMuMDY2NjY3IDY1LjcwNjY2Ny0yMTMuMzMzMzMzIDE1Mi43NDY2NjctMjczLjkyeiIvPg0KPC9zdmc+"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgR2VuZXJhdG9yOiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIGZpbGw9IiMwMDAwMDAiIGhlaWdodD0iODAwcHgiIHdpZHRoPSI4MDBweCIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiANCgkgdmlld0JveD0iMCAwIDE5MCAxOTAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZD0iTTMuNTMsMGgxODIuOTR2NDQuNzhoLTMyLjQzOVYzMi40MzlINzMuMDE3TDEyNS40Miw5NWwtNTIuNDAzLDYyLjU2MWg4MS4wMTVWMTQ1LjIyaDMyLjQzOVYxOTBIMy41M2w3OS41NzQtOTVMMy41MywweiIvPg0KPC9zdmc+"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogPHRpdGxlLz4NCg0KIDxnPg0KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+DQogIDxyZWN0IGZpbGw9Im5vbmUiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgaGVpZ2h0PSI0MDIiIHdpZHRoPSI1ODIiIHk9Ii0xIiB4PSItMSIvPg0KIDwvZz4NCiA8Zz4NCiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPg0KICA8cGF0aCBmaWxsPSIjYjE5ODRhIiBpZD0iVHJpYW5nbGUgMjkiIGQ9Im0xNC40MjQyMyw2LjE0ODM5YzAuODcwMDcsLTEuNDA3NjYgMi4yODI4LC0xLjQwNDMxIDMuMTUwNzksMGwxMC43ODUwOSwxNy40NDg5OWMxLjE2MTUzLDEuODc5MjIgMC4zMTU0NCwzLjQwMjYyIC0xLjg4ODcsMy40MDI2MmwtMjAuOTQzNTYsMGMtMi4yMDQ2MywwIC0zLjA1Mzk5LC0xLjUxNzM0IC0xLjg4ODcxLC0zLjQwMjYybDEwLjc4NTA5LC0xNy40NDg5OXptMS41NzU3NywxMy44NTE2MWMwLjU1MjI4LDAgMSwtMC40NTMwNCAxLC0wLjk5NzAzbDAsLTYuMDA1OTRjMCwtMC41NTA2NCAtMC40NDM4NiwtMC45OTcwMyAtMSwtMC45OTcwM2MtMC41NTIyOCwwIC0xLDAuNDUzMDQgLTEsMC45OTcwM2wwLDYuMDA1OTRjMCwwLjU1MDY0IDAuNDQzODYsMC45OTcwMyAxLDAuOTk3MDN6bTAsNGMwLjU1MjI4LDAgMSwtMC40NDc3MiAxLC0xYzAsLTAuNTUyMjggLTAuNDQ3NzIsLTEgLTEsLTFjLTAuNTUyMjgsMCAtMSwwLjQ0NzcyIC0xLDFjMCwwLjU1MjI4IDAuNDQ3NzIsMSAxLDF6bTAsMCIvPg0KIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(817)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09aad170", Component.options)
  } else {
    hotAPI.reload("data-v-09aad170", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(831)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(784),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\NotFoundPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NotFoundPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-500c6df4", Component.options)
  } else {
    hotAPI.reload("data-v-500c6df4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(834)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\StartPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StartPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c8ae859", Component.options)
  } else {
    hotAPI.reload("data-v-5c8ae859", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(833)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58fd4992",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\activation\\Activation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Activation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58fd4992", Component.options)
  } else {
    hotAPI.reload("data-v-58fd4992", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(851)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(806),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d13c8784",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\activation\\Reset.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Reset.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d13c8784", Component.options)
  } else {
    hotAPI.reload("data-v-d13c8784", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(822)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(774),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f865bd7",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\header\\Header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f865bd7", Component.options)
  } else {
    hotAPI.reload("data-v-1f865bd7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(843)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(799),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e5c6624",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\header\\alert-container\\AlertContainer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AlertContainer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8e5c6624", Component.options)
  } else {
    hotAPI.reload("data-v-8e5c6624", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(854)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(809),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e589e72e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\header\\login\\Login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e589e72e", Component.options)
  } else {
    hotAPI.reload("data-v-e589e72e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(818)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(770),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11a3b220",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\header\\notification-container\\NotificationContainer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NotificationContainer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-11a3b220", Component.options)
  } else {
    hotAPI.reload("data-v-11a3b220", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(819)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\Home.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Home.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1328d797", Component.options)
  } else {
    hotAPI.reload("data-v-1328d797", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(845)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(801),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a03f095e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\dashboard\\Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a03f095e", Component.options)
  } else {
    hotAPI.reload("data-v-a03f095e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(789),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\group-settlement\\GroupSettlement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GroupSettlement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-684793b0", Component.options)
  } else {
    hotAPI.reload("data-v-684793b0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(824)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(776),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32dae221",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\group-settlement\\list-group-settlement\\ListGroupSettlement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ListGroupSettlement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32dae221", Component.options)
  } else {
    hotAPI.reload("data-v-32dae221", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(835)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(788),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62de2e97",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\group-settlement\\register-group-settlement\\RegisterGroupSettlement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RegisterGroupSettlement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62de2e97", Component.options)
  } else {
    hotAPI.reload("data-v-62de2e97", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(857)
  __webpack_require__(856)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(811),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5607ae6",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\group-settlement\\single-group-settlement\\SingleGroupSettlement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SingleGroupSettlement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f5607ae6", Component.options)
  } else {
    hotAPI.reload("data-v-f5607ae6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(838)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(793),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73f00188",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\intervention\\Interventions.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Interventions.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73f00188", Component.options)
  } else {
    hotAPI.reload("data-v-73f00188", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(841)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(797),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80e255a4",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\intervention\\activate-invoice\\ActivateInvoice.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ActivateInvoice.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-80e255a4", Component.options)
  } else {
    hotAPI.reload("data-v-80e255a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(826)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(778),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c557185",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\intervention\\closed-org-settlement\\ClosedOrgSettlement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClosedOrgSettlement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c557185", Component.options)
  } else {
    hotAPI.reload("data-v-3c557185", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(842)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(798),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-840fae58",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\intervention\\move-invoices\\MoveInvoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MoveInvoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-840fae58", Component.options)
  } else {
    hotAPI.reload("data-v-840fae58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(849)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(804),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1a7d0b2",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\invoices\\Invoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Invoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c1a7d0b2", Component.options)
  } else {
    hotAPI.reload("data-v-c1a7d0b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(840)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78c8b551",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\invoices\\sides\\AdminInvoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AdminInvoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78c8b551", Component.options)
  } else {
    hotAPI.reload("data-v-78c8b551", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(837)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(791),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b0d36d6",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\invoices\\sides\\CreditorInvoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CreditorInvoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b0d36d6", Component.options)
  } else {
    hotAPI.reload("data-v-6b0d36d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(832)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(785),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58862c20",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\invoices\\sides\\DebtorInvoices.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DebtorInvoices.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58862c20", Component.options)
  } else {
    hotAPI.reload("data-v-58862c20", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(839)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-751ffc9f",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\invoices\\single-invoice\\SingleInvoice.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SingleInvoice.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-751ffc9f", Component.options)
  } else {
    hotAPI.reload("data-v-751ffc9f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(858)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(812),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f70bb0cc",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\issues\\ReportedIssues.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ReportedIssues.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f70bb0cc", Component.options)
  } else {
    hotAPI.reload("data-v-f70bb0cc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(829)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(782),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b62da23",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\issues\\single-issue\\SingleIssue.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SingleIssue.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b62da23", Component.options)
  } else {
    hotAPI.reload("data-v-4b62da23", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(850)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ccd56e18",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\settlement\\SettleInvoice.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SettleInvoice.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ccd56e18", Component.options)
  } else {
    hotAPI.reload("data-v-ccd56e18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(852)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(807),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dcc03e3c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\side-nav\\SideNav.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SideNav.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dcc03e3c", Component.options)
  } else {
    hotAPI.reload("data-v-dcc03e3c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(848)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(803),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a5ce89e0",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\UserAdministration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserAdministration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a5ce89e0", Component.options)
  } else {
    hotAPI.reload("data-v-a5ce89e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(820)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(772),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c501716",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\local-user-management\\LocalUserManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LocalUserManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c501716", Component.options)
  } else {
    hotAPI.reload("data-v-1c501716", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(796),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\local-user-management\\local-user-information\\LocalUserInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LocalUserInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7908e0f6", Component.options)
  } else {
    hotAPI.reload("data-v-7908e0f6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(827)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(779),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-464e84b0",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\target-public-users\\TargetPublicUsers.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TargetPublicUsers.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-464e84b0", Component.options)
  } else {
    hotAPI.reload("data-v-464e84b0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(780),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\user-create\\UserCreate.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserCreate.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48d8bdc2", Component.options)
  } else {
    hotAPI.reload("data-v-48d8bdc2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(853)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(808),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-de78e382",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\user-management\\UserManagement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserManagement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-de78e382", Component.options)
  } else {
    hotAPI.reload("data-v-de78e382", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(792),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\user-management\\user-information\\UserInformation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserInformation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b9ce6cd", Component.options)
  } else {
    hotAPI.reload("data-v-6b9ce6cd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(815)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(767),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02ad1aff",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-administration\\user-notification\\UserNotification.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserNotification.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02ad1aff", Component.options)
  } else {
    hotAPI.reload("data-v-02ad1aff", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(844)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(800),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f341b20",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-registration\\UserRegistration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserRegistration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8f341b20", Component.options)
  } else {
    hotAPI.reload("data-v-8f341b20", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(821)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(773),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1eb7ca44",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-registration\\user-approval\\UserApproval.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserApproval.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eb7ca44", Component.options)
  } else {
    hotAPI.reload("data-v-1eb7ca44", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(823)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(775),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-211b1af0",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\home\\user-settlements\\UserSettlements.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserSettlements.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-211b1af0", Component.options)
  } else {
    hotAPI.reload("data-v-211b1af0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(830)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(783),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5009dc17",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\GitLab-Runner\\builds\\9EiswoDk\\0\\crf\\cir\\cir-web\\source\\src\\components\\register\\Register.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Register.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5009dc17", Component.options)
  } else {
    hotAPI.reload("data-v-5009dc17", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.notificationsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions,
      "hasRowDetails": false
    },
    on: {
      "rowSelected": _vm.onRowSelected
    },
    scopedSlots: _vm._u([{
      key: "validUntil",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.validUntil)))])]
      }
    }, {
      key: "created",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.created)))])]
      }
    }, {
      key: "priority",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.priority === _vm.Priority.LOW, 'btn-warning': props.row.priority === _vm.Priority.NORMAL, 'btn-danger': props.row.priority === _vm.Priority.HIGH
          }
        }, [_vm._v(_vm._s(_vm.$t('userAdministration.notificationPriorityStatus.' + props.row.priority)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.createNotificationModal",
      modifiers: {
        "createNotificationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.notificationCreate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "createNotificationModal",
      "title": _vm.$t('userAdministration.notificationCreate'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.createNotification
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.createNotification($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationPriority')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.notification.priority),
      callback: function($$v) {
        _vm.$set(_vm.notification, "priority", $$v)
      },
      expression: "notification.priority"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationValidUntil')
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true
    },
    model: {
      value: (_vm.notification.validUntil),
      callback: function($$v) {
        _vm.$set(_vm.notification, "validUntil", $$v)
      },
      expression: "notification.validUntil"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationText')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification.text),
      expression: "notification.text"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "max-rows": "6",
      "name": "notification.text"
    },
    domProps: {
      "value": (_vm.notification.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "text", $event.target.value)
      }
    }
  })])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "reviewNotificationModal",
    attrs: {
      "id": "reviewNotificationModal",
      "title": _vm.$t('userAdministration.notificationEdit'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('userAdministration.userNotificationCancel'),
      "cancel-variant": "warning"
    },
    on: {
      "ok": function($event) {
        return _vm.updateNotification(false)
      },
      "cancel": function($event) {
        return _vm.updateNotification(true)
      }
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateNotification($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationPriority')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.selectedNotification.priority),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "priority", $$v)
      },
      expression: "selectedNotification.priority"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationValidUntil')
    }
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true
    },
    model: {
      value: (_vm.selectedNotification.validUntil),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "validUntil", $$v)
      },
      expression: "selectedNotification.validUntil"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.notificationText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 5,
      "textarea": true
    },
    model: {
      value: (_vm.selectedNotification.text),
      callback: function($$v) {
        _vm.$set(_vm.selectedNotification, "text", $$v)
      },
      expression: "selectedNotification.text"
    }
  })], 1)], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02ad1aff", module.exports)
  }
}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showLoader) ? _c('span', {
    staticClass: "loader",
    class: _vm.cls
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-054a269e", module.exports)
  }
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09aad170", module.exports)
  }
}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    staticClass: "notification-top",
    attrs: {
      "variant": "secondary",
      "dismissible": "",
      "show": _vm.show
    },
    on: {
      "dismissed": _vm.dismiss
    }
  }, [_c('b-list-group', _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      key: item.notificationId,
      staticClass: "m-1",
      attrs: {
        "variant": _vm.priorityVariant[item.priority - 1]
      }
    }, [(item.priority === 3) ? _c('b-img', {
      staticClass: "danger-notification-icon",
      attrs: {
        "left": "",
        "src": __webpack_require__(717)
      }
    }) : (item.priority === 2) ? _c('b-img', {
      staticClass: "warning-notification-icon",
      attrs: {
        "left": "",
        "src": __webpack_require__(723)
      }
    }) : _c('b-img', {
      staticClass: "info-notification-icon",
      attrs: {
        "src": __webpack_require__(719),
        "left": ""
      }
    }), _vm._v("\n        " + _vm._s(item.text) + "\n      ")], 1)
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11a3b220", module.exports)
  }
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('side-nav')], 1), _vm._v(" "), _c('div', {
    staticClass: "main-right"
  }, [_c('b-container', {
    staticClass: "mt-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', [_c('h1', [_vm._v("Dashboard")])])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1328d797", module.exports)
  }
}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.usersUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.status === _vm.UserStatus.ACTIVE, 'btn-danger': props.row.status === _vm.UserStatus.REVOKED
          }
        }, [_vm._v(_vm._s(_vm.$t('userAdministration.userStatuses.' + props.row.status)))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.revokeUsers()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('userAdministration.userRevoke')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c501716", module.exports)
  }
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.registrationCancelled, 'user-approved-card': _vm.registrationApproved
    },
    attrs: {
      "border-variant": _vm.registrationCancelled ? 'danger' : null,
      "header-border-variant": _vm.registrationCancelled ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('userRegistration.registrationInstitution')))]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": _vm.priorityVariant[_vm.registration.status - 1]
    }
  }, [_vm._v(_vm._s(_vm.$t('userRegistration.registrationStatuses.' + _vm.registration.status)))])], 1), _vm._v(" "), _c('img', {
    ref: "imgToExport",
    staticClass: "p-1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": __webpack_require__(77)
    }
  }), _vm._v(" "), (_vm.registrationCancelled) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCancelledUser')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.cancelledUser))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.registration.status) ? _c('b-row', [(_vm.registrationApproved) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovedUser')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'userInformationPage',
        params: {
          userId: _vm.registration.approvedId
        }
      }
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_c('span'), _vm._v(_vm._s(_vm.registration.approvedUser))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationRegistrationDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.registration.creationDate)))])])], 1), _vm._v(" "), (_vm.registration.registrationDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovalDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.registration.registrationDate)))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationId')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.id))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.name))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editNameModal",
      modifiers: {
        "editNameModal": true
      }
    }],
    staticClass: "material-icons md-24",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.load
    }
  }, [_vm._v("edit")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationAddress')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.address))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editAddressModal",
      modifiers: {
        "editAddressModal": true
      }
    }],
    staticClass: "material-icons md-24",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.load
    }
  }, [_vm._v("edit")])])], 1)], 1), _vm._v(" "), (_vm.registrationPending) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.editRegistrationToken')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.registrationToken))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.budgetCompanyNumber))])])], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.taxIdNumber))])])], 1)], 1), _vm._v(" "), (_vm.registrationApproved) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegistrationLimit')
    }
  }, [(_vm.registration.invoiceLimit) ? _c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.invoiceLimit))]) : _c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.$t('userRegistration.noInvoiceLimitText')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editInvoiceLimitModal",
      modifiers: {
        "editInvoiceLimitModal": true
      }
    }],
    staticClass: "material-icons md-24",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.load
    }
  }, [_vm._v("edit")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.printRegistrationForm()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('register.printRequestForm')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mb-2",
    class: {
      'user-revoked-card': _vm.registrationCancelled, 'user-approved-card': _vm.registrationApproved
    },
    attrs: {
      "header": _vm.$t('userRegistration.registrationAdminActivate'),
      "border-variant": _vm.registrationCancelled ? 'danger' : null,
      "header-border-variant": _vm.registrationCancelled ? 'danger' : null
    }
  }, [_c('form', {
    ref: "accountApprovalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateAccountApproval($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "userLoginField",
      "disabled": !_vm.registrationPending
    },
    model: {
      value: (_vm.registration.adminLogin),
      callback: function($$v) {
        _vm.$set(_vm.registration, "adminLogin", $$v)
      },
      expression: "registration.adminLogin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.adminName))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.registration.adminEmail))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.registrationPending) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.approveRegistrationConfirmationModal",
      modifiers: {
        "approveRegistrationConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userRegistration.registrationActivate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.registrationPending) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelRegistrationConfirmationModal",
      modifiers: {
        "cancelRegistrationConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userRegistration.registrationCancel')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.registrationApproved) ? _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.printAdminForm()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('register.printForm')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "userLoginField",
      "placement": "bottom",
      "triggers": "focus"
    }
  }, [_c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.0')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.1')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.2')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.3')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.4')))])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "cancelRegistrationConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.cancelAccount
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userRegistration.registrationCancelConfirmationText')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "approveRegistrationConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.approveAccount
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userRegistration.registrationApproveConfirmationText')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editInvoiceLimitModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.editInvoiceLimit
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.invoiceLimitChangeText')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.invoiceLimit),
      callback: function($$v) {
        _vm.invoiceLimit = $$v
      },
      expression: "invoiceLimit"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editAddressModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.editAddress
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.addressChangeText')
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.companyAddress),
      callback: function($$v) {
        _vm.companyAddress = $$v
      },
      expression: "companyAddress"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editNameModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.editName
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.nameChangeText')
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1eb7ca44", module.exports)
  }
}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    class: _vm.headerClass
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('title')) + "\r\n                "), (_vm.isDevelopment) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.environment))]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav-collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav-collapse"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": "",
      "text": _vm.$t('message.externalLinks')
    }
  }, _vm._l((_vm.externalLinks), function(site) {
    return (site.name !== '-') ? _c('b-dropdown-item', {
      key: "site",
      attrs: {
        "href": site.link
      }
    }, [_vm._v(_vm._s(site.name))]) : _c('b-dropdown-divider')
  }), 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.documentationPath
    }
  }, [_vm._v(_vm._s(_vm.$t('message.documentation')))]), _vm._v(" "), (!_vm.isAuth) ? _c('b-nav-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.login_modal",
      modifiers: {
        "login_modal": true
      }
    }],
    staticClass: "heavier-text",
    attrs: {
      "id": "signin"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login')))]) : _vm._e(), _vm._v(" "), (_vm.isAuth) ? _c('b-nav-item-dropdown', {
    staticClass: "auth-user-menu",
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "header-username-link"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user-administration/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.profile')))]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.signout')))])], 2) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('notification-container'), _vm._v(" "), _c('alert-container'), _vm._v(" "), _c('login')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f865bd7", module.exports)
  }
}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "registerSettlementForm"
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Корисничко измирење фактура",
      "alternativeRoute": "invoices/user-settlement"
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Датотека са фактурама"
    }
  }, [_c('b-form-file', {
    ref: "settlementFileForm",
    attrs: {
      "accept": ".csv, .json",
      "no-drop": "",
      "browse-text": "Претражи",
      "placeholder": "Датотека није одабрана "
    },
    on: {
      "change": _vm.fileLoaded
    },
    model: {
      value: (_vm.settlementData),
      callback: function($$v) {
        _vm.settlementData = $$v
      },
      expression: "settlementData"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loadedSettlementData) ? _c('b-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-bg-variant": "success",
      "header": "Проверите податке о измирењу",
      "header-text-variant": "white"
    }
  }, [_c('div', [_c('b-list-group', [_c('b-table', {
    attrs: {
      "sticky-header": "",
      "striped": "",
      "hover": "",
      "items": _vm.loadedSettlementData
    }
  })], 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error.settlement.invoiceId
    }, [_vm._v(_vm._s(error.settlement.invoiceId) + " - " + _vm._s(_vm.$t('apiStatusCodes.' + error.settlementError.code)))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parsedSettlementData) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-modal', {
    ref: "settleInvoiceModal",
    attrs: {
      "no-title": "",
      "ok-title": _vm.$t('forms.submit'),
      "ok-only": ""
    },
    on: {
      "ok": function($event) {
        return _vm.submitSettlement(false)
      }
    }
  }, [_c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceUserSettle')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\r\n                        Да ли сте сигурни да желите да покренете корисничко измирење " + _vm._s(_vm.parsedSettlementData.length) + " фактура(e).\r\n                        ")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.loadedSettlementData
    },
    on: {
      "click": function($event) {
        return _vm.submitSettlement(true)
      }
    }
  }, [_vm._v("\r\n                Валидирај измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "warning",
      "disabled": _vm.load || !_vm.loadedSettlementData
    },
    on: {
      "click": _vm.confirmSettlement
    }
  }, [_vm._v("\r\n                Региструј измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-211b1af0", module.exports)
  }
}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementReview'),
      "alternativeRoute": "group-settlement/list"
    }
  })], 1), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.groupSettlementsUrl,
      "name": "group-settlements-table",
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.amount)))])]
      }
    }, {
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [(props.row.dueDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.dueDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "settledAmount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.settledAmount)))])]
      }
    }, {
      key: "settlementDate",
      fn: function(props) {
        return [(props.row.settlementDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.settlementDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "debtorName",
      fn: function(props) {
        return (props.row.debtorId !== 0) ? [_c('router-link', {
          attrs: {
            "to": {
              name: 'approvedUserPage',
              params: {
                registrationId: props.row.debtorId
              }
            }
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.debtorName))])])] : undefined
      }
    }, {
      key: "groupSettlementStatus",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: [{
              'btn-danger': [_vm.groupSettlementStatus.CANCELLED, _vm.groupSettlementStatus.INVALID].includes(props.row.groupSettlementStatus)
            },
            {
              'btn-success': _vm.groupSettlementStatus.SETTLED === props.row.groupSettlementStatus
            },
            {
              'btn-info': ![_vm.groupSettlementStatus.CANCELLED, _vm.groupSettlementStatus.INVALID, _vm.groupSettlementStatus.SETTLED].includes(props.row.groupSettlementStatus)
            }
          ]
        }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementStatus.' + props.row.groupSettlementStatus)))])]
      }
    }], null, true)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'registerGroupSettlementRoute'
      }
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('groupSettlement.createNew')) + "\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32dae221", module.exports)
  }
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.userRevoked
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.userRevoked ? 'danger' : null,
      "header-border-variant": _vm.userRevoked ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('userAdministration.userDetails')) + "\r\n            ")])]), _vm._v(" "), (_vm.globalUser) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userOrganizationName')
    }
  }, [_c('b-link', {
    staticClass: "user-info-label",
    attrs: {
      "to": _vm.organizationLink
    }
  }, [_vm._v(_vm._s(_vm.user.organizationName))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.globalUser) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user.status) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userStatus')
    }
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": _vm.priorityVariant[_vm.user.status - 1]
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.userStatuses.' + _vm.user.status)) + "\r\n                        ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])], 1)], 1), _vm._v(" "), (_vm.userRevoked) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userChangedId')
    }
  }, [_c('b-link', {
    staticClass: "user-info-label",
    attrs: {
      "to": _vm.userChangedLink
    }
  }, [_vm._v(_vm._s(_vm.user.changedId))])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLastChangeDate')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.user.lastChangeDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userChangedComments')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.changedComments))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateUserInformation($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetailsChange')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editUserInformationModal",
      modifiers: {
        "editUserInformationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                        " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    staticClass: "mb-3",
    class: {
      'user-revoked-card': _vm.userRevoked
    },
    attrs: {
      "header": _vm.$t('userAdministration.userRolesClaims'),
      "header-text-variant": "dark",
      "border-variant": _vm.userRevoked ? 'danger' : null,
      "header-border-variant": _vm.userRevoked ? 'danger' : null
    }
  }, [(!_vm.editModeActive) ? _c('div', [(_vm.user.creationRoles) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationRoles), function(role) {
    return _c('b-list-group-item', {
      key: role,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + role)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.creationClaims) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationClaims), function(claim) {
    return _c('b-list-group-item', {
      key: claim,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + claim)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e()], 1) : _c('div', [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t('userAdministration.userPermissionsTableFilter')
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-btn', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.userPermissionsTableFilterClear')))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.roleItems) ? _c('b-table', {
    attrs: {
      "items": _vm.roleItems,
      "fields": _vm.roleFields,
      "id": "roles-table",
      "filter": _vm.filter
    },
    scopedSlots: _vm._u([{
      key: "cell(selected_role)",
      fn: function(row) {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "1"
          },
          on: {
            "click": row.toggleDetails
          }
        }, [(row.detailsShowing) ? _c('b-img', {
          attrs: {
            "src": __webpack_require__(718),
            "width": "15",
            "height": "15"
          }
        }) : _c('b-img', {
          attrs: {
            "src": __webpack_require__(716),
            "width": "15",
            "height": "15"
          }
        })], 1), _vm._v(" "), _c('b-col', {
          attrs: {
            "cols": "1"
          }
        }, [(row.item.valid_role) ? _c('b-form-checkbox', {
          attrs: {
            "value": row.item.name,
            "indeterminate": _vm.indeterminate[row.item.name]
          },
          on: {
            "change": function($event) {
              return _vm.roleSelected(row.item)
            },
            "update:indeterminate": function($event) {
              return _vm.$set(_vm.indeterminate, row.item.name, $event)
            }
          },
          model: {
            value: (_vm.selectedRoles),
            callback: function($$v) {
              _vm.selectedRoles = $$v
            },
            expression: "selectedRoles"
          }
        }) : _vm._e()], 1)], 1)]
      }
    }, {
      key: "cell(localized_name)",
      fn: function(row) {
        return [_c('span', {
          staticClass: "contents-highlight",
          on: {
            "click": row.toggleDetails
          }
        }, [_vm._v("\r\n                            " + _vm._s(row.item.localized_name) + "\r\n                        ")])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('b-card', _vm._l((row.item.claims), function(claim, i) {
          return _c('b-row', {
            key: i
          }, [_c('b-col', {
            attrs: {
              "cols": "1"
            }
          }, [_c('b-form-checkbox', {
            staticClass: "mr-2",
            attrs: {
              "value": claim.value
            },
            on: {
              "change": function($event) {
                return _vm.claimSelected(claim)
              }
            },
            model: {
              value: (_vm.selectedClaims),
              callback: function($$v) {
                _vm.selectedClaims = $$v
              },
              expression: "selectedClaims"
            }
          })], 1), _vm._v(" "), _c('b-col', {
            attrs: {
              "cols": "5"
            }
          }, [_c('label', [_vm._v(_vm._s(claim.text))])])], 1)
        }), 1)]
      }
    }], null, false, 2011186232)
  }) : _vm._e()], 1), _vm._v(" "), (_vm.canChangeAuthority && !_vm.editModeActive) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.editRoles
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.edit')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : (_vm.editModeActive) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.updateChangedPermissions
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.save')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "info",
      "disabled": _vm.userRevoked || _vm.load
    },
    on: {
      "click": _vm.cancelEditRoles
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.cancel')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.hasUserResetPasswordClaim) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.resetUserPasswordConfirmationModal",
      modifiers: {
        "resetUserPasswordConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "disabled": _vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userResetPassword')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.revokeConfirmationModal",
      modifiers: {
        "revokeConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userRevoke')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.restoreConfirmationModal",
      modifiers: {
        "restoreConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": !_vm.userRevoked || _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.userActivate')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "revokeConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userRevoke'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.revokeUser
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.changedComments),
      expression: "user.changedComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": _vm.$t('userAdministration.userRevokeComments')
    },
    domProps: {
      "value": (_vm.user.changedComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "changedComments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "resetUserPasswordConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userResetPassword'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.resetUserPassword
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userResetPasswordConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "restoreConfirmationModal",
      "ok-title": _vm.$t('userAdministration.userActivate'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.restoreUser
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userActivateConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    ref: "permissionUpdateConfirmationModal",
    attrs: {
      "header-bg-variant": "warning",
      "title": _vm.$t('forms.warning'),
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.saveEditRoles
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userPermissionUpdateConfirmation')) + "\r\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editUserInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateUserInformation
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.personalInformationChangeConfirmation')) + "\r\n        ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3342773a", module.exports)
  }
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitActivation($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v("Сваки појединачни ИДФ фактуре мора бити у новом реду")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ИДФ фактура"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6"
    },
    model: {
      value: (_vm.invoiceIds),
      callback: function($$v) {
        _vm.invoiceIds = $$v
      },
      expression: "invoiceIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Разлог измирења"
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.settlementMessage),
      callback: function($$v) {
        _vm.settlementMessage = $$v
      },
      expression: "settlementMessage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.invoiceIds
    }
  }, [_vm._v("\r\n            Измири фактуре\r\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c557185", module.exports)
  }
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.targetPublicUsersUrl,
      "reportsUrl": _vm.targetPublicUsersReportsUrl,
      "columns": _vm.tColumns,
      "hasRowDetails": false,
      "options": _vm.tOptions
    },
    on: {
      "rowSelected": _vm.onRowSelected
    }
  }), _vm._v(" "), _c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.appendTargetBudgetUser",
      modifiers: {
        "appendTargetBudgetUser": true
      }
    }],
    attrs: {
      "variant": "info",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.targetPublicUsersAppend')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "appendTargetBudgetUser",
      "title": _vm.$t('userAdministration.targetPublicUsersAppend'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": "",
      "header-bg-variant": "info"
    },
    on: {
      "ok": _vm.appendTargetBudgetUser
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.appendTargetBudgetUser($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('autocomplete', {
    ref: "budgetIdAutocomplete",
    attrs: {
      "inputClass": _vm.autocompleteErrorClass(),
      "url": _vm.autoCompleteUrl_budgetId,
      "criteria": "budgetId",
      "description": "name",
      "name": "targetPublicUserModel.BudgetUserId",
      "hideDetails": ""
    },
    on: {
      "resolved": _vm.budgetNumberResolved
    },
    model: {
      value: (_vm.targetPublicUserModel.BudgetUserId),
      callback: function($$v) {
        _vm.$set(_vm.targetPublicUserModel, "BudgetUserId", $$v)
      },
      expression: "targetPublicUserModel.BudgetUserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.targetPublicUserModel.BudgetUserId) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.targetPublicUserModel.Name))])])], 1)], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "removeTargetBudgetUserModal",
    attrs: {
      "id": "removeTargetBudgetUserModal",
      "title": _vm.$t('userAdministration.targetPublicUsersRemove'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": "",
      "header-bg-variant": "warning"
    },
    on: {
      "ok": _vm.removeTargetBudgetUser
    }
  }, [_c('b-container', {
    staticClass: "p-2"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.removeTargetBudgetUser($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.targetPublicUserModel.BudgetUserId))])])], 1)], 1), _vm._v(" "), (_vm.targetPublicUserModel.BudgetUserId) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.targetPublicUserModel.Name))])])], 1)], 1) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-464e84b0", module.exports)
  }
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "createUserForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateBeforeCreateUser($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetails')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.login.$error
    },
    attrs: {
      "id": "userLoginField",
      "name": "user.login"
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": _vm.$t('userAdministration.userRoles')
    }
  }, [_c('div', {
    staticClass: "ml-2 custom-controls-stacked",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.availableRoles), function(role) {
    return (role.valid_role) ? _c('b-form-checkbox', {
      key: role.name,
      attrs: {
        "value": role.name
      },
      model: {
        value: (_vm.selectedRoles),
        callback: function($$v) {
          _vm.selectedRoles = $$v
        },
        expression: "selectedRoles"
      }
    }, [_vm._v(_vm._s(role.localized_name))]) : _vm._e()
  }), 1)]), _vm._v(" "), (_vm.availableClaims.length > 0) ? _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "header": _vm.$t('userAdministration.userClaims')
    }
  }, [_c('div', {
    staticClass: "ml-2 custom-controls-stacked",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.availableClaims), function(claim) {
    return _c('b-form-checkbox', {
      key: claim.text,
      attrs: {
        "value": claim.value
      },
      model: {
        value: (_vm.selectedClaims),
        callback: function($$v) {
          _vm.selectedClaims = $$v
        },
        expression: "selectedClaims"
      }
    }, [_vm._v(_vm._s(claim.text))])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "userLoginField",
      "placement": "bottom",
      "triggers": "focus"
    }
  }, [_c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.0')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.1')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.2')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.3')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.4')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.createLocalUserModal",
      modifiers: {
        "createLocalUserModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "createLocalUserModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateBeforeCreateUser
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userCreateConfirmation')) + "\r\n        ")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48d8bdc2", module.exports)
  }
}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', [(_vm.large) ? _c('b-col', [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("badges")], 2) : _c('b-col', [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _vm._t("badges")], 2), _vm._v(" "), _c('b-col'), _vm._v(" "), _c('b-col', [_c('a', {
    attrs: {
      "href": _vm.contextPath
    }
  }, [_c('b-img', {
    staticClass: "context-help-header",
    attrs: {
      "right": "",
      "src": __webpack_require__(721)
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-495033fa", module.exports)
  }
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "mb-2",
    class: {
      'issue-cancelled-card': _vm.issueCancelled || _vm.issueUnresolved, 'issue-resolved-card': _vm.issueResolved
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.issueCancelled || _vm.issueUnresolved ? 'danger' : null,
      "header-border-variant": _vm.issueCancelled || _vm.issueUnresolved ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('issues.reportIssueDetails'),
      "alternativeRoute": "issues/reported-issues"
    },
    scopedSlots: _vm._u([{
      key: "badges",
      fn: function(props) {
        return [_c('span', [(_vm.issueCancelled) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.2')))]) : _vm._e(), _vm._v(" "), (_vm.issueResolved) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.3')))]) : _vm._e(), _vm._v(" "), (_vm.issueUnresolved) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.4')))]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "6"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.resourceLink
    }
  }, [_vm._v(_vm._s(_vm.issueReport.resourceId))])], 1)], 1), _vm._v(" "), _c('b-col', [(_vm.issueActive) ? _c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('notifications.subscribe'),
      "right": "",
      "src": __webpack_require__(720)
    },
    on: {
      "click": _vm.subscribeToNotification
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.categoryCyr))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.data))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportColumnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.issueReport.creationDate)))])])], 1), _vm._v(" "), (_vm.issueReport.closingDate) ? _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportColumnClosingDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.issueReport.closingDate)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.issueUser) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.issueUser) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserLogin')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "col": "",
      "md": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssueUserOrganization')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueUser.organizationName))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.userComment))])])], 1)], 1), _vm._v(" "), (_vm.issueReport.operatorComment) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportOperatorComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.issueReport.operatorComment))])])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelIssueReportModal",
      "title": _vm.$t('issues.reportIssueCancelModal'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelIssueReport
    }
  }, [_c('p', [_vm._v("\r\n            " + _vm._s(_vm.$t('issues.reportIssueCancelModalConfirm')) + "\r\n        ")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "resolveIssueReportModal",
      "title": _vm.$t('issues.reportIssueResolveModal'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": "",
      "size": "lg"
    },
    on: {
      "ok": _vm.resolveIssueReport
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resolveIssueReport($event)
      }
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-form-group', {
    attrs: {
      "label": ""
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.resolveOptions,
      "stacked": "",
      "name": "radiosStacked"
    },
    model: {
      value: (_vm.resolveStatus),
      callback: function($$v) {
        _vm.resolveStatus = $$v
      },
      expression: "resolveStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-1 text-center"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolveComment),
      expression: "resolveComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "placeholder": _vm.$t('issues.reportIssueResolveComment')
    },
    domProps: {
      "value": (_vm.resolveComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resolveComment = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "subscribeToNotification",
    attrs: {
      "title": _vm.$t('notifications.title'),
      "ok-title": _vm.$t('notifications.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitNotificationSubscription
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('notifications.selectNotificationType')
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.formattedNotificationTypes,
      "plain": "",
      "stacked": ""
    },
    model: {
      value: (_vm.selectedNotificationTypes),
      callback: function($$v) {
        _vm.selectedNotificationTypes = $$v
      },
      expression: "selectedNotificationTypes"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b62da23", module.exports)
  }
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "registrationContainer",
    staticClass: "container mt-3"
  }, [_c('img', {
    ref: "imgToExport",
    staticClass: "p-1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": __webpack_require__(77)
    }
  }), _vm._v(" "), (!_vm.registrationAllowed) ? _c('b-card', {
    staticClass: "p-3"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('register.registrationForbidden')))])])], 1) : _c('form', {
    ref: "registerForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-2 pt-0 mt-0"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('register.title'),
      "large": ""
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('p', [_vm._v("\r\n                        " + _vm._s(_vm.$t('register.editRegistration')) + "\r\n                        "), _c('br'), _c('br'), _vm._v("\r\n                        " + _vm._s(_vm.$t('register.editRegistrationLine2')) + "\r\n                    ")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editRegistrationModal",
      modifiers: {
        "editRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.registrationLoad')))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.legalEntityInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.budgetIdNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.budgetNumber),
      expression: "register.budgetNumber"
    }],
    ref: "budgetIdNumber",
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.companyNumber.$error
    },
    attrs: {
      "name": "register.budgetIdNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.budgetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "budgetNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('register.budgetIdNumberFootnote')))])])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.companyName')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.name),
      expression: "register.name"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.name.$error
    },
    attrs: {
      "name": "register.name"
    },
    domProps: {
      "value": (_vm.register.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "name", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.companyNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.companyNumber),
      expression: "register.companyNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.companyNumber.$error
    },
    attrs: {
      "name": "register.companyNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.companyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "companyNumber", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.taxIdNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.taxIdNumber),
      expression: "register.taxIdNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.taxIdNumber.$error
    },
    attrs: {
      "name": "register.taxIdNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.taxIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "taxIdNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.address')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.address),
      expression: "register.address"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.address.$error
    },
    attrs: {
      "name": "register.address"
    },
    domProps: {
      "value": (_vm.register.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "address", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.email),
      expression: "register.email"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.email.$error
    },
    attrs: {
      "type": "email",
      "name": "register.email"
    },
    domProps: {
      "value": (_vm.register.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "email", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.phone')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.phoneNumber),
      expression: "register.phoneNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.phoneNumber.$error
    },
    attrs: {
      "name": "register.phoneNumber"
    },
    domProps: {
      "value": (_vm.register.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "phoneNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.adminInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminName),
      expression: "register.adminName"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminName.$error
    },
    attrs: {
      "name": "register.adminName"
    },
    domProps: {
      "value": (_vm.register.adminName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminName", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.identityNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminIdentityNumber),
      expression: "register.adminIdentityNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminIdentityNumber.$error
    },
    attrs: {
      "name": "register.adminIdentityNumber"
    },
    domProps: {
      "value": (_vm.register.adminIdentityNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminIdentityNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminEmail),
      expression: "register.adminEmail"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminEmail.$error
    },
    attrs: {
      "type": "email",
      "name": "register.adminEmail"
    },
    domProps: {
      "value": (_vm.register.adminEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminEmail", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.phone')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminPhoneNumber),
      expression: "register.adminPhoneNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminPhoneNumber.$error
    },
    attrs: {
      "name": "register.adminPhoneNumber"
    },
    domProps: {
      "value": (_vm.register.adminPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminPhoneNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.treasuryBranchInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.treasuryBranch')
    }
  }, [_c('autocomplete', {
    ref: "treasuryBranchAutocomplete",
    attrs: {
      "inputClass": _vm.autocompleteErrorClass(),
      "url": _vm.autoCompleteUrl_branches,
      "criteria": "branchCode",
      "description": "name",
      "name": "register.treasuryBranch"
    },
    model: {
      value: (_vm.register.treasuryBranch),
      callback: function($$v) {
        _vm.$set(_vm.register, "treasuryBranch", $$v)
      },
      expression: "register.treasuryBranch"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "1em",
      "color": "#bbb5b5"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.treasuryBranchNote')))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-link', {
    staticStyle: {
      "position": "absolute",
      "margin-top": "-1em"
    },
    attrs: {
      "href": _vm.ouLink
    }
  }, [_vm._v(_vm._s(_vm.$t('register.ouList')))])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.load,
      "type": "submit"
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('register.submit')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load || !_vm.registrationToExport,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.printRegistration()
      }
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('register.printRequestForm')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-right",
    attrs: {
      "align-h": "end",
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('register.infoText')))])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "registerConfirmationModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "header-bg-variant": "success",
      "header-text-variant": "light",
      "title": _vm.$t('forms.notification'),
      "centered": ""
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.registrationSuccess')))]), _vm._v(" "), (_vm.registrationConfirmation) ? _c('p', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._l((_vm.registrationConfirmation.split('\n')), function(line) {
    return [_vm._v(_vm._s(line)), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), _c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', [_vm._v("\r\n                    " + _vm._s(_vm.$t('register.registrationSuccessText')) + "\r\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    staticClass: "float-right m-1",
    attrs: {
      "variant": "success",
      "disabled": !_vm.registrationToExport
    },
    on: {
      "click": function($event) {
        return _vm.printRegistration()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('register.printRequestForm')))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "editRegistrationModalRef",
    attrs: {
      "id": "editRegistrationModal",
      "title": _vm.$t('register.editRegistrationLoad'),
      "centered": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('register.editRegistrationToken')
    },
    model: {
      value: (_vm.registrationToken),
      callback: function($$v) {
        _vm.registrationToken = $$v
      },
      expression: "registrationToken"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    staticClass: "float-right m-1",
    attrs: {
      "variant": "success",
      "disabled": _vm.load || !_vm.registrationToken
    },
    on: {
      "click": function($event) {
        return _vm.sendRegistrationToken()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.load')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5009dc17", module.exports)
  }
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3"
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('b-row', {
    staticClass: "treasury-logo p-1",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "p-1",
    attrs: {
      "src": __webpack_require__(77)
    }
  })]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "height": "35px"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.$t('notFound')))])]), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.changelogPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.changelog')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.supportPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.technicalSupport')))])])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-500c6df4", module.exports)
  }
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('datatable', {
    attrs: {
      "url": _vm.liabilitiesUrl,
      "name": "debtor-invoices-table",
      "reportsUrl": _vm.liabilitiesReportsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.amount)))])]
      }
    }, {
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [(props.row.dueDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.dueDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "settledAmount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.settledAmount)))])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.row.settled && props.row.amount > 0) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.ACTIVE || props.row.status === _vm.InvoiceStatus.PROINVOICE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.PARTIALLY_SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.ASSIGNED) ? _c('button', {
          staticClass: "btn btn-sm btn-warning"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : _c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-danger': props.row.status === _vm.InvoiceStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))])]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              return _vm.invoiceClicked(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.review')))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right"
  }, [_c('hr'), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": _vm.$t('invoices.invoiceExport'),
      "variant": "success",
      "split": "",
      "disabled": !_vm.hasInvoiceExportClaim || _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportCsv')))]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportJson')))])], 1), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelInvoicesModal",
      modifiers: {
        "cancelInvoicesModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": !_vm.hasInvoiceCancelClaim || _vm.load
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('invoices.cancelInvoices')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelInvoicesModal",
      "title": _vm.$t('invoices.cancelInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.cancelInvoices
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoice($event)
      }
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "type": "text",
      "rows": 5,
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    model: {
      value: (_vm.cancelComments),
      callback: function($$v) {
        _vm.cancelComments = $$v
      },
      expression: "cancelComments"
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58862c20", module.exports)
  }
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3 narrow-container"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('activation.title')))])]), _vm._v(" "), _c('form', {
    ref: "activateUserForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.activateUser($event)
      }
    }
  }, [(_vm.tokenValid) ? _c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.changePassword')
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "activation-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.password')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.confirmPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.0')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.1')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.2')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.3')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": !_vm.user.password || !_vm.user.newPassword || _vm.load
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('userAdministration.apply')) + "\n              "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58fd4992", module.exports)
  }
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container mt-3"
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('b-row', {
    staticClass: "treasury-logo p-1",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "p-1",
    attrs: {
      "src": __webpack_require__(77)
    }
  })]), _vm._v(" "), _c('b-col', [_c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticClass: "heavy-text"
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt-5 mb-3 heavier-text"
  }, [_vm._v("Централни регистар фактура")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "p-1"
  }, [_vm._v("\n            Министарство финансија спроводи мере и активности у вези са контролом преузетих обавеза у јавном сектору\n            што између осталог подразумева евидентирање, праћење и извештавање о неизмиреним обавезама.\n            За обављање поменутих активности успостављен је информациони систем под називом Централни регистар фактура (ЦРФ).\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "warning",
      "text-variant": "white"
    }
  }, [_c('b-card-text', [_c('span', {
    staticClass: "heavier-text"
  }, [_c('b-link', {
    attrs: {
      "href": "https://www.trezor.gov.rs/files/services/crf/Obave%C5%A1tenje%20subjektima%20javnog%20sektora%20koji%20pla%C4%87anja%20vr%C5%A1e%20preko%20ra%C4%8Duna%20koji%20se%20vode%20kod%20banaka%20-%2019.05.2026.%20godine.pdf"
    }
  }, [_vm._v("Обавештење субјектима јавног сектора који плаћање врше преко рачуна који се воде код банака")])], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "heavier-text",
    staticStyle: {
      "color": "#aaaaaa"
    }
  }, [_vm._v(" Погледајте "), _c('a', {
    staticStyle: {
      "color": "gray"
    },
    attrs: {
      "href": "/docs/user/register"
    }
  }, [_vm._v("документацију за регистровање")]), _vm._v(" правног лица")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.changelogPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.changelog')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5 heavier-text",
    attrs: {
      "align-h": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.supportPath
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('general.technicalSupport')))])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c8ae859", module.exports)
  }
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementRegister')
    }
  })], 1), _vm._v(" "), _c('form', {
    ref: "registerGroupSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateAndSubmit($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementNumber')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.groupSettlement.groupSettlementNumber.$error
    },
    attrs: {
      "name": "groupSettlement.groupSettlementNumber"
    },
    model: {
      value: (_vm.groupSettlement.groupSettlementNumber),
      callback: function($$v) {
        _vm.$set(_vm.groupSettlement, "groupSettlementNumber", $$v)
      },
      expression: "groupSettlement.groupSettlementNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('groupSettlement.massInput')
    }
  }, [_c('b-form-textarea', {
    staticClass: "monospace-input",
    class: {
      'error': _vm.$v.massInput.$error
    },
    attrs: {
      "rows": 15,
      "max-rows": 32
    },
    model: {
      value: (_vm.massInput),
      callback: function($$v) {
        _vm.massInput = $$v
      },
      expression: "massInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.registerSingleConfirmationModal",
      modifiers: {
        "registerSingleConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('groupSettlement.groupSettlementSubmit')) + "\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "registerSingleConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateAndSubmit
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('groupSettlement.groupSettlementConfirmation')) + "\n            ")])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62de2e97", module.exports)
  }
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-684793b0", module.exports)
  }
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-container"
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty),
      expression: "isDirty"
    }],
    staticClass: "fa fa-times",
    on: {
      "click": _vm.reset
    }
  })], _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    class: _vm.inputClass,
    attrs: {
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "name": _vm.name,
      "id": _vm.name,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": _vm.onInputSelect,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSelect($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset($event)
      }],
      "blur": _vm.reset,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.updateTimeout]
    }
  }), _vm._v(" "), (!_vm.hideDetails) ? _c('label', {
    staticClass: "indigo--text details-label text-none"
  }, [_vm._v(_vm._s(_vm.searchDescription))]) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items),
      expression: "items"
    }],
    staticClass: "pl-0"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "auto-label",
      class: _vm.activeClass(index),
      on: {
        "mousedown": _vm.onSelect,
        "mousemove": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('strong', {
      domProps: {
        "textContent": _vm._s(item[_vm.criteria])
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item[_vm.description])
      }
    })])
  }), 0)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-695689b4", module.exports)
  }
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('datatable', {
    attrs: {
      "url": _vm.liabilitiesUrl,
      "name": "creditor-invoices-table",
      "reportsUrl": _vm.liabilitiesReportsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.amount)))])]
      }
    }, {
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [(props.row.dueDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.dueDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "settledAmount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.settledAmount)))])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.row.settled && props.row.amount > 0) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.ACTIVE || props.row.status === _vm.InvoiceStatus.PROINVOICE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.PARTIALLY_SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.ASSIGNED) ? _c('button', {
          staticClass: "btn btn-sm btn-warning"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : _c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-danger': props.row.status === _vm.InvoiceStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))])]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              return _vm.invoiceClicked(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.review')))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right"
  }, [_c('hr'), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": _vm.$t('invoices.invoiceExport'),
      "variant": "success",
      "split": "",
      "disabled": !_vm.hasInvoiceExportClaim || _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportCsv')))]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportJson')))])], 1), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelInvoicesModal",
      modifiers: {
        "cancelInvoicesModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": !_vm.hasInvoiceCancelClaim || _vm.load
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('invoices.cancelInvoices')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelInvoicesModal",
      "title": _vm.$t('invoices.cancelInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.cancelInvoices
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoice($event)
      }
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "type": "text",
      "rows": 5,
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    model: {
      value: (_vm.cancelComments),
      callback: function($$v) {
        _vm.cancelComments = $$v
      },
      expression: "cancelComments"
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b0d36d6", module.exports)
  }
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-info', {
    attrs: {
      "userInformationUrl": _vm.userInformationUrl,
      "revokeUserUrl": _vm.revokeUserUrl,
      "restoreUserUrl": _vm.restoreUserUrl,
      "updateUserPermissionsUrl": _vm.updateUserPermissionsUrl,
      "globalUser": ""
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b9ce6cd", module.exports)
  }
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Интервенције"
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Активација фактура",
      "active": ""
    }
  }, [_c('activate-invoice')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Измирење угашене организације"
    }
  }, [_c('closed-org-settlement')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Пренос фактура"
    }
  }, [_c('move-invoices')], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73f00188", module.exports)
  }
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.load
    }
  }, [_c('b-card', {
    staticClass: "mb-2",
    class: {
      'invoice-cancelled-card': _vm.invoiceCancelled || _vm.invoiceInvalid || _vm.invoiceReportedInvalid, 'invoice-settled-card': _vm.invoiceSettled, 'invoice-partially-settled-card': _vm.invoicePartiallySettled, 'invoice-assigned-card': _vm.invoiceAssignedTo
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.invoiceCancelled || _vm.invoiceInvalid ? 'danger' : null,
      "header-border-variant": _vm.invoiceCancelled || _vm.invoiceInvalid ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('invoices.invoiceDetails'),
      "alternativeRoute": "invoices/invoice-information"
    },
    scopedSlots: _vm._u([{
      key: "badges",
      fn: function(props) {
        return [_c('span', [(_vm.invoiceCancelled) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceInvalid) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceInvalid')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceSettled) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceAssignedTo) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssigned')))]) : _vm._e(), _vm._v(" "), (_vm.invoicePartiallySettled) ? _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoicePartiallySettled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceActive) ? _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceActive')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceReportedInvalid) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceReportedInvalid')))]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoiceId))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssues')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [(_vm.reportedActiveIssues) ? _c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": '/reported-issues?resourceId=' + _vm.invoiceId + '&status=1'
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssuesActive')) + ": " + _vm._s(_vm.reportedActiveIssues))]) : _c('span', [_vm._v(_vm._s(_vm.$t('issues.reportIssuesActive')) + ": " + _vm._s(_vm.reportedActiveIssues))]), _vm._v("\r\n                           \r\n                        "), (_vm.reportedIssues) ? _c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": '/reported-issues?resourceId=' + _vm.invoiceId
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssuesAll')) + ": " + _vm._s(_vm.reportedIssues))]) : _c('span', [_vm._v(_vm._s(_vm.$t('issues.reportIssuesAll')) + ": " + _vm._s(_vm.reportedIssues))])], 1)])], 1), _vm._v(" "), (_vm.canReportIssue) ? _c('b-col', [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": __webpack_require__(159)
    },
    on: {
      "click": _vm.reportLiabilityIssue
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "mt-0"
  }), _vm._v(" "), _c('b-row', [(_vm.isCurrentUserAdmin && _vm.invoice.debtorId) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDebtorName')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.debtorLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.debtorName))])], 1)], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDebtorName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.debtorName))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnBudgetIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.debtorCompanyNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.isCurrentUserAdmin && _vm.invoice.creditorId) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorName')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.creditorLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.creditorName))])], 1)], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorName))])])], 1), _vm._v(" "), (_vm.invoice.isPublicCreditor) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorBudgetIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorCompanyNumber))])])], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorCompanyNumber))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorTaxId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorTaxIdNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnInvoiceNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.invoiceNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnInvoiceAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.invoice.amount)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnSettledAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.invoice.settledAmount)))])])], 1), _vm._v(" "), (_vm.hasInvoiceSettlements && _vm.lastActiveSettlement) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnSettlementDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.lastActiveSettlement)))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.invoice.creationDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.issueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.invoice.issueDate)))])])], 1), _vm._v(" "), (_vm.invoice.dueDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.invoice.dueDate)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.invoice.lifetime) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.registerProinvoiceLifetime')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.lifetime))])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceAssignedTo && _vm.invoice.comments) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.comments')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.comments))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceCancelled) ? _c('b-row', [_c('hr'), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationUser')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.cancelName))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.invoice.cancelDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.cancelComments))])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceEmpty()) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": _vm.$t('invoices.invoiceExport'),
      "variant": "success",
      "split": "",
      "disabled": _vm.exportDisabled
    },
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportCsv')))]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportJson')))]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), (_vm.canCancelInvoice) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelInvoiceModal",
      modifiers: {
        "cancelInvoiceModal": true
      }
    }],
    staticClass: "m-md-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.cancelDisabled
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('invoices.cancelInvoice')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSettleInvoice) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.settleInvoiceModal",
      modifiers: {
        "settleInvoiceModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('invoices.settleInvoice')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.invoiceEmpty()) ? _c('div', {
    attrs: {
      "role": "tablist"
    }
  }, [(!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.invoiceSettlements",
      modifiers: {
        "invoiceSettlements": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.settlementDetails')) + " "), (_vm.settlements.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.settlements.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "invoiceSettlements",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.invoice_settlements),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "invoice_settlements", $$v)
      },
      expression: "showCollapse.invoice_settlements"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [(_vm.canReportIssue) ? _c('div', {
    staticClass: "mb-5"
  }, [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": __webpack_require__(159)
    },
    on: {
      "click": _vm.reportSettlementIssue
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('b-table', {
    attrs: {
      "fields": _vm.fields,
      "items": _vm.settlements
    },
    scopedSlots: _vm._u([{
      key: "cell(settledAmount)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatAmount(data.item.settledAmount)))]
      }
    }, {
      key: "cell(settlementDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatDate(data.item.settlementDate)))]
      }
    }, {
      key: "cell(settlementStatus)",
      fn: function(data) {
        return [(data.item.status === _vm.SettlementStatus.ACTIVE) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "success",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.settlementStatus.1')))]) : _c('b-btn', {
          attrs: {
            "variant": "danger",
            "size": "sm",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.settlementStatus.2')))])]
      }
    }, {
      key: "cell(settlementComments)",
      fn: function(data) {
        return [(data.item.cancelComments) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelledComment')))]), _vm._v(" " + _vm._s(data.item.cancelComments))]) : _c('p', [_vm._v(_vm._s(data.item.settlementComments))])]
      }
    }, {
      key: "cell(cancelSettlement)",
      fn: function(data) {
        return [(data.item.status === _vm.SettlementStatus.ACTIVE && _vm.canCancelSettlement) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.validateBeforeCancel(data.item.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.cancel')))]) : _vm._e()]
      }
    }], null, false, 3437881335)
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.canAssignInvoice || _vm.canViewAssignement) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.invoiceAssignment",
      modifiers: {
        "invoiceAssignment": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssignment')))])], 1) : _vm._e(), _vm._v(" "), (_vm.canAssignInvoice || _vm.canViewAssignement) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "invoiceAssignment",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.invoiceAssignment),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "invoiceAssignment", $$v)
      },
      expression: "showCollapse.invoiceAssignment"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [(_vm.canAssignInvoice) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('registerInvoice.debtorBudgetId')
    }
  }, [_c('autocomplete', {
    ref: "budgetIdAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_budgetId,
      "criteria": "budgetId",
      "description": "name"
    },
    model: {
      value: (_vm.invoice.DebtorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "DebtorCompanyNumber", $$v)
      },
      expression: "invoice.DebtorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.invoice.AssignmentContractNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "AssignmentContractNumber", $$v)
      },
      expression: "invoice.AssignmentContractNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.assignInvoiceModal",
      modifiers: {
        "assignInvoiceModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.assignDisabled
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('forms.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), (_vm.assignDisabled) ? _c('b-row', {
    staticClass: "text-right mt-2",
    attrs: {
      "align-h": "end",
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssignValidDebtorWarning') + _vm.invoice.debtorCompanyNumber))])])])], 1) : _vm._e()], 1)], 1) : (_vm.invoiceAssignedTo) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignIdf')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "href": _vm.assignationLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.comments))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorName))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isPublicEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedBudgetNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorCompanyNumber))])]) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorCompanyNumber))])]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isPrivateEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorTaxIdNumber))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.assignmentContractNumber))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelAssignInvoiceModal",
      modifiers: {
        "cancelAssignInvoiceModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.assignDisabled
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('invoices.invoiceAssignCancel')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)], 1) : (_vm.invoiceAssignedFrom) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignOriginIdf')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "href": _vm.invoiceLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.assignedInvoiceId))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.assignmentContractNumber))])])], 1)], 1)], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.amountChange",
      modifiers: {
        "amountChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAmountChange')) + "  "), (_vm.invoiceDeltas.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.invoiceDeltas.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "amountChange",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.amountChange),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "amountChange", $$v)
      },
      expression: "showCollapse.amountChange"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-table', {
    attrs: {
      "fields": _vm.deltaFields,
      "items": _vm.invoiceDeltas
    },
    scopedSlots: _vm._u([{
      key: "cell(amount)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatAmount(data.item.amount)))]
      }
    }, {
      key: "cell(creationDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.status === _vm.DeltaStatus.ACTIVE || data.item.status === _vm.DeltaStatus.ACTIVATION ? _vm.formatDate(data.item.creationDate) : _vm.formatDate(data.item.cancelDate)))]
      }
    }, {
      key: "cell(comments)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.status === _vm.DeltaStatus.ACTIVE || data.item.status === _vm.DeltaStatus.ACTIVATION ? data.item.comments : data.item.cancelComments))]
      }
    }, {
      key: "cell(previousDueDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.previousDueDate ? _vm.formatShortDate(data.item.previousDueDate) : "-"))]
      }
    }, {
      key: "cell(cancelSlot)",
      fn: function(data) {
        return [(data.item.status === _vm.DeltaStatus.ACTIVE) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInvoiceDeltaSelected(data.item.id, data.item.amount)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceDeltaCancel')))]) : (data.item.status === _vm.DeltaStatus.ACTIVATION) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInvoiceDeltaSelected(data.item.id, data.item.amount)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceActivationCancel')))]) : _c('b-btn', {
          attrs: {
            "variant": "danger",
            "size": "sm",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelled')))])]
      }
    }], null, false, 1181245811)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.addAmountChangeModal",
      modifiers: {
        "addAmountChangeModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.invoiceSettled && !_vm.canActivateInvoice
    }
  }, [_vm._v("\r\n                        " + _vm._s(_vm.$t('invoices.invoiceAmountChangeAdd')) + "\r\n                    ")])], 1)])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelInvoiceModal",
      "title": _vm.$t('invoices.cancelInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelInvoice
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoice($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.cancelComments),
      expression: "invoice.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "type": "text",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoice.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoice, "cancelComments", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelSettlementModal",
    attrs: {
      "title": _vm.$t('invoices.cancelSettlement')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('b-button', {
          staticClass: "mt-3",
          attrs: {
            "disabled": _vm.invoiceSettlement.cancelComments === null
          },
          on: {
            "click": _vm.cancelSettlement
          }
        }, [_vm._v(_vm._s(_vm.$t('forms.apply')))])]
      },
      proxy: true
    }])
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceSettlement.cancelComments),
      expression: "invoiceSettlement.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "type": "text",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoiceSettlement.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceSettlement, "cancelComments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-modal', {
    ref: "settleInvoiceModal",
    attrs: {
      "id": "settleInvoiceModal",
      "title": _vm.$t('invoices.settleInvoice')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('b-button', {
          staticClass: "mt-3",
          on: {
            "click": _vm.validateBeforeSettle
          }
        }, [_vm._v(_vm._s(_vm.$t('forms.apply')))])]
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoiceId))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2",
    model: {
      value: (_vm.invoiceSettlement.IsCompensationSettlement),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "IsCompensationSettlement", $$v)
      },
      expression: "invoiceSettlement.IsCompensationSettlement"
    }
  }, [_vm._v("\r\n                    Компензација\r\n                ")])], 1)], 1), _vm._v(" "), (!_vm.invoiceSettlement.IsCompensationSettlement) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.bank')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.Bank.$error
    },
    attrs: {
      "name": "invoiceSettlement.Bank",
      "maxlength": "3"
    },
    model: {
      value: (_vm.invoiceSettlement.Bank),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "Bank", $$v)
      },
      expression: "invoiceSettlement.Bank"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.columnSettlementDate')
    }
  }, [_c('datepicker', {
    attrs: {
      "name": "invoiceSettlement.SettlementDate",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true,
      "clear-button": "",
      "input-class": {
        'form-control': true,
        'error': _vm.$v.invoiceSettlement.SettlementDate.$error && !_vm.invoiceSettlement.SettlementDate
      }
    },
    model: {
      value: (_vm.invoiceSettlement.SettlementDate),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettlementDate", $$v)
      },
      expression: "invoiceSettlement.SettlementDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.invoiceSettlement.IsCompensationSettlement) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementDebitAccount')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.DebitAccount.$error
    },
    attrs: {
      "name": "invoiceSettlement.DebitAccount"
    },
    model: {
      value: (_vm.invoiceSettlement.DebitAccount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "DebitAccount", $$v)
      },
      expression: "invoiceSettlement.DebitAccount"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceSettlement.IsCompensationSettlement) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementCreditAccount')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.CreditAccount.$error
    },
    attrs: {
      "name": "invoiceSettlement.CreditAccount"
    },
    model: {
      value: (_vm.invoiceSettlement.CreditAccount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "CreditAccount", $$v)
      },
      expression: "invoiceSettlement.CreditAccount"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementPaymentId')
    },
    scopedSlots: _vm._u([(!_vm.invoiceSettlement.IsCompensationSettlement) ? {
      key: "description",
      fn: function() {
        return [_c('small', {
          staticClass: "field-description"
        }, [_vm._v("За банку 840 - последњи сегмент податка за рекламацију, пр. ISP2018135100526")])]
      },
      proxy: true
    } : {
      key: "description",
      fn: function() {
        return [_c('small', {
          staticClass: "field-description"
        }, [_vm._v("Број документа компензације")])]
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), _c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.ReferenceNumber.$error
    },
    attrs: {
      "name": "invoiceSettlement.ReferenceNumber"
    },
    model: {
      value: (_vm.invoiceSettlement.ReferenceNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "ReferenceNumber", $$v)
      },
      expression: "invoiceSettlement.ReferenceNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    class: {
      'error': _vm.$v.invoiceSettlement.SettledAmount.$error
    },
    attrs: {
      "name": "invoiceSettlement.SettledAmount"
    },
    model: {
      value: (_vm.invoiceSettlement.SettledAmount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettledAmount", $$v)
      },
      expression: "invoiceSettlement.SettledAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "assignInvoiceModal",
      "title": _vm.$t('invoices.invoiceAssignment'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.assignInvoice
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('invoices.invoiceAssignmentModal')) + "\r\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelAssignInvoiceModal",
      "title": _vm.$t('invoices.invoiceAssignment'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.cancelInvoiceAssign
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('invoices.invoiceAssignmentCancelModal')) + "\r\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "addAmountChangeModal",
      "title": _vm.$t('invoices.invoiceAmountChangeAdd'),
      "ok-only": "",
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.addInvoiceAmountDelta
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('registerInvoice.amount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "invoiceDelta.amount"
    },
    model: {
      value: (_vm.invoiceDelta.amount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDelta, "amount", $$v)
      },
      expression: "invoiceDelta.amount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4",
      "align-self": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settlementDeltaSelected),
      expression: "settlementDeltaSelected"
    }],
    staticClass: "settle-input",
    attrs: {
      "type": "checkbox",
      "v": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.settlementDeltaSelected) ? _vm._i(_vm.settlementDeltaSelected, null) > -1 : (_vm.settlementDeltaSelected)
    },
    on: {
      "click": _vm.calculateSettlementsDelta,
      "change": [function($event) {
        var $$a = _vm.settlementDeltaSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settlementDeltaSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settlementDeltaSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settlementDeltaSelected = $$c
        }
      }, _vm.calculateSettlementsDeltaChange]
    }
  }), _vm._v(_vm._s(_vm.$t('invoices.invoiceAmountChangeSettle')))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.invoiceAmountChangeComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceDelta.comments),
      expression: "invoiceDelta.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "name": "invoiceDelta.comments"
    },
    domProps: {
      "value": (_vm.invoiceDelta.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceDelta, "comments", $event.target.value)
      }
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "cancelInvoiceDeltaModal",
    attrs: {
      "title": _vm.$t('invoices.invoiceDeltaCancel'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelInvoiceAmountDelta
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoiceAmountDelta($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceDelta.cancelComments),
      expression: "invoiceDelta.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoiceDelta.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceDelta, "cancelComments", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "reportIssueModal",
    attrs: {
      "title": _vm.currentIssue === this.IssueCategory[0] ? _vm.$t('issues.reportIssueLiability') : _vm.$t('issues.reportIssueSettlement'),
      "header-bg-variant": "warning",
      "ok-title": _vm.$t('forms.send'),
      "size": "lg",
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitIssueReport
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.currentIssueReport.resourceId),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "resourceId", $$v)
      },
      expression: "currentIssueReport.resourceId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.formattedIssueCategories
    },
    on: {
      "input": _vm.categoryChanged
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.requiresData) ? _c('div', [(_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 3) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 4 && _vm.hasInvoiceSettlements) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementId')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceSettlementIDs
    },
    model: {
      value: (_vm.currentIssueSettlementId),
      callback: function($$v) {
        _vm.currentIssueSettlementId = $$v
      },
      expression: "currentIssueSettlementId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[0].ID && _vm.currentIssueCategory.id === 1) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceFields,
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  })], 1)], 1)], 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "field-description"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.dataDescriptionCyr))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIssueReport.userComment),
      expression: "currentIssueReport.userComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentIssueReport.userComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIssueReport, "userComment", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.categoryHelp) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.categoryDescriptionCyr))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fa9a4b"
    },
    attrs: {
      "href": _vm.helpLink(_vm.currentIssueCategory.categoryHelp),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueHelpLink')))])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-751ffc9f", module.exports)
  }
}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('datatable', {
    attrs: {
      "url": _vm.liabilitiesUrl,
      "reportsUrl": _vm.liabilitiesReportsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.amount)))])]
      }
    }, {
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [(props.row.dueDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.dueDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "settledAmount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.settledAmount)))])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.row.settled && props.row.amount > 0) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (props.row.status === _vm.InvoiceStatus.ACTIVE || props.row.status === _vm.InvoiceStatus.PROINVOICE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.PARTIALLY_SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : (props.row.status === _vm.InvoiceStatus.ASSIGNED) ? _c('button', {
          staticClass: "btn btn-sm btn-warning"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))]) : _c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-danger': props.row.status === _vm.InvoiceStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + props.row.status)))])]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              return _vm.invoiceClicked(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.review')))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right"
  }, [_c('hr'), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": _vm.$t('invoices.invoiceExport'),
      "variant": "success",
      "split": "",
      "disabled": !_vm.hasInvoiceExportClaim || _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportCsv')))]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportJson')))])], 1), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelInvoicesModal",
      modifiers: {
        "cancelInvoicesModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": !_vm.hasInvoiceCancelClaim || _vm.load
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('invoices.cancelInvoices')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelInvoicesModal",
      "title": _vm.$t('invoices.cancelInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.cancelInvoices
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoice($event)
      }
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "type": "text",
      "rows": 5,
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    model: {
      value: (_vm.cancelComments),
      callback: function($$v) {
        _vm.cancelComments = $$v
      },
      expression: "cancelComments"
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78c8b551", module.exports)
  }
}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-info', {
    attrs: {
      "userInformationUrl": _vm.userInformationUrl,
      "revokeUserUrl": _vm.revokeUserUrl,
      "restoreUserUrl": _vm.restoreUserUrl,
      "updateUserPermissionsUrl": _vm.updateUserPermissionsUrl
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7908e0f6", module.exports)
  }
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitActivation($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v("Сваки појединачни ИДФ фактуре мора бити у новом реду")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ИДФ фактура"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6"
    },
    model: {
      value: (_vm.invoiceIds),
      callback: function($$v) {
        _vm.invoiceIds = $$v
      },
      expression: "invoiceIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.invoiceIds
    }
  }, [_vm._v("\r\n            Aктивирај фактуре\r\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80e255a4", module.exports)
  }
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitActivation($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v("Пренос активних фактура са једног правног лица на друго")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Са организације"
    }
  }, [_c('autocomplete', {
    ref: "sourceOrganizationAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_organization,
      "criteria": "companyNumber",
      "description": "name",
      "name": "sourceOrganization.companyNumber",
      "prepareResponseData": _vm.prepareResponseData,
      "hideDetails": ""
    },
    on: {
      "resolved": _vm.sourceOrganizationResolved
    },
    model: {
      value: (_vm.sourceOrganization.companyNumber),
      callback: function($$v) {
        _vm.$set(_vm.sourceOrganization, "companyNumber", $$v)
      },
      expression: "sourceOrganization.companyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.sourceOrganization.companyNumber) ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("ИД: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.id))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("МБ: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.companyNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("ПИБ: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.taxIdNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Назив: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.name))])])])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "На организацију"
    }
  }, [_c('autocomplete', {
    ref: "targetOrganizationAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_organization,
      "criteria": "companyNumber",
      "description": "name",
      "name": "targetOrganization.companyNumber",
      "prepareResponseData": _vm.prepareResponseData,
      "hideDetails": ""
    },
    on: {
      "resolved": _vm.targetOrganizationResolved
    },
    model: {
      value: (_vm.targetOrganization.companyNumber),
      callback: function($$v) {
        _vm.$set(_vm.targetOrganization, "companyNumber", $$v)
      },
      expression: "targetOrganization.companyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.targetOrganization.companyNumber) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("ИД: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.id))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("МБ: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.companyNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("ПИБ: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.taxIdNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Назив: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.name))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.sourceOrganization.id || !_vm.targetOrganization.id
    }
  }, [_vm._v("\r\n            Пренеси активне фактуре\r\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "success",
      "header": "Пренете фактуре",
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.transferredInvoices), function(invoice) {
    return _c('b-list-group-item', {
      key: invoice
    }, [_vm._v(_vm._s(invoice))])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-840fae58", module.exports)
  }
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    staticClass: "alert-top",
    attrs: {
      "variant": _vm.variant,
      "dismissible": "",
      "show": _vm.show
    },
    on: {
      "dismissed": function($event) {
        _vm.show = false
      }
    }
  }, [(_vm.variant === 'danger') ? _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _c('a', [_vm._v(" " + _vm._s(_vm.message) + " \n      "), (_vm.link) ? _c('b-link', {
    attrs: {
      "to": _vm.link
    },
    on: {
      "click": _vm.disposeNotification
    }
  }, [_vm._v(_vm._s(_vm.linkDescription))]) : _vm._e()], 1), _vm._v(" "), (_vm.showList) ? _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_c('b-link', {
      attrs: {
        "href": item.link
      },
      on: {
        "click": _vm.disposeNotification
      }
    }, [_vm._v(_vm._s(item.msg))])], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8e5c6624", module.exports)
  }
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('userRegistration.registrationHeader')
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.registrationsUrl,
      "reportsUrl": _vm.registrationsReportsUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.status === _vm.RegistrationStatus.PENDING, 'btn-success': props.row.status === _vm.RegistrationStatus.APPROVED, 'btn-danger': props.row.status === _vm.RegistrationStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('userRegistration.registrationStatuses.' + props.row.status)))])]
      }
    }, {
      key: "entityType",
      fn: function(props) {
        return [(props.row.entityType === 1000) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(props.row.entityType))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8f341b20", module.exports)
  }
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Dashboard"
    }
  })], 1), _vm._v(" "), (_vm.user) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('dashboard.welcome')) + " " + _vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), (_vm.registration) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationAddress')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.address))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationApprovedDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.registration.registrationDate)))])])], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.isPublicEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationBudgetId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.companyNumber))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('userRegistration.registrationTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.taxIdNumber))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [(_vm.registration.invoiceLimit) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegistrationLimit')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.registration.invoiceLimit))])])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.liabilitiesTotal && !_vm.isAdmin) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredTotal')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.debtorInvoices + _vm.liabilitiesTotal.creditorInvoices))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredDebtor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.debtorInvoices))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('dashboard.liabilitiesRegisteredCreditor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.liabilitiesTotal.creditorInvoices))])])], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a03f095e", module.exports)
  }
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-holder"
  }, [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "datatable table"
  }, [_c('thead', [_c('tr', [(_vm.opt.checkboxes) ? _c('th', {
    staticClass: "header-column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxAll),
      expression: "checkboxAll"
    }],
    attrs: {
      "type": "checkbox",
      "title": _vm.$t('datatable.toggleAll')
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxAll) ? _vm._i(_vm.checkboxAll, null) > -1 : (_vm.checkboxAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkboxAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxAll = $$c
        }
      }, _vm.checkAll]
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      staticClass: "header-column",
      class: 'column-' + column.columnName
    }, [_c('div', {
      staticClass: "header-column-content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.columnTitle(column))
      }
    }), _vm._v(" "), (_vm.opt.sortable && column.hideSort !== true) ? _c('b', {
      staticClass: "sort-icon",
      class: _vm.sortIconClasses(column),
      on: {
        "click": function($event) {
          return _vm.sort(column)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 32 32",
        "xmlns": "http://www.w3.org/2000/svg",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "1.414"
      }
    }, [_c('path', {
      attrs: {
        "d": "M16 0l12.5 12.55h-25L16 0z",
        "fill": "#cccccc"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M16 31.966L3.5 19.414h25L16 31.966z",
        "fill": "#cccccc"
      }
    })])]) : _vm._e()])])
  })], 2), _vm._v(" "), (_vm.opt.filter) ? _c('tr', [(_vm.opt.checkboxes) ? _c('th', [_vm._v("\r\n           \r\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [(column.hideFilter !== true && column.filterType === 'input') ? _c('div', [_c('b-dropdown', {
      ref: ("dropdown-" + (column.columnName)),
      refInFor: true,
      attrs: {
        "id": ("dropdown-" + (column.columnName)),
        "block": "",
        "variant": "text"
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function() {
          return [_c('b-form-input', {
            ref: "emailInput",
            refInFor: true,
            attrs: {
              "id": "input-1",
              "readonly": "",
              "type": "text",
              "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
            },
            model: {
              value: (_vm.filterModel[column.columnName]),
              callback: function($$v) {
                _vm.$set(_vm.filterModel, column.columnName, $$v)
              },
              expression: "filterModel[column.columnName]"
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('b-dropdown-form', {
      staticClass: "px-2",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.applyFilterInput(("dropdown-" + (column.columnName)))
        }
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "dropdown-form-email",
        "size": "sm"
      },
      model: {
        value: (_vm.filterModel[column.columnName]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnName, $$v)
        },
        expression: "filterModel[column.columnName]"
      }
    }), _vm._v(" "), _c('b-row', {
      staticClass: "mt-3 text-right",
      attrs: {
        "align-h": "end"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('b-btn', {
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.applyFilterInput(("dropdown-" + (column.columnName)))
        }
      }
    }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== true && column.filterType === 'autocomplete-input') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnName]),
        expression: "filterModel[column.columnName]"
      }, {
        name: "b-toggle",
        rawName: "v-b-toggle.sidebar-variant",
        modifiers: {
          "sidebar-variant": true
        }
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "align-self": "center",
        "type": "text",
        "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
      },
      domProps: {
        "value": (_vm.filterModel[column.columnName])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnName, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'range') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnRange[0].value]),
        expression: "filterModel[column.columnRange[0].value]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.filterModel[column.columnRange[0].value])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                  " + _vm._s(column.columnRange[1].text) + "\r\n                ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnRange[1].value]),
        expression: "filterModel[column.columnRange[1].value]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.filterModel[column.columnRange[1].value])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $event.target.value)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'rangeMoney') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                    " + _vm._s(column.columnRange[0].text) + "\r\n                ")]), _vm._v(" "), _c('money', _vm._b({
      staticClass: "form-control form-control-sm",
      nativeOn: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, function($event) {
          return _vm.filter($event)
        }]
      },
      model: {
        value: (_vm.filterModel[column.columnRange[0].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $$v)
        },
        expression: "filterModel[column.columnRange[0].value]"
      }
    }, 'money', _vm.currency, false))], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[1].text) + "\r\n              ")]), _vm._v(" "), _c('money', _vm._b({
      staticClass: "form-control form-control-sm",
      nativeOn: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, function($event) {
          return _vm.filter($event)
        }]
      },
      model: {
        value: (_vm.filterModel[column.columnRange[1].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $$v)
        },
        expression: "filterModel[column.columnRange[1].value]"
      }
    }, 'money', _vm.currency, false))], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'date-range') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[0].text) + "\r\n              ")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "table-datepicker",
        "language": _vm.dateLocale,
        "placeholder": _vm.dateFormat,
        "format": _vm.customFormatter,
        "inputFormat": _vm.inputFormat,
        "typeable": true,
        "clear-button": ""
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        },
        "input": _vm.filter
      },
      model: {
        value: (_vm.filterModel[column.columnRange[0].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $$v)
        },
        expression: "filterModel[column.columnRange[0].value]"
      }
    })], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[1].text) + "\r\n              ")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "table-datepicker",
        "language": _vm.dateLocale,
        "placeholder": _vm.dateFormat,
        "format": _vm.customFormatter,
        "inputFormat": _vm.inputFormat,
        "typeable": true,
        "clear-button": ""
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendRequest()
        },
        "input": _vm.filter
      },
      model: {
        value: (_vm.filterModel[column.columnRange[1].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $$v)
        },
        expression: "filterModel[column.columnRange[1].value]"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== true && column.filterType === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnName]),
        expression: "filterModel[column.columnName]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filterModel, column.columnName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.sendFilterRequest()
        }]
      }
    }, _vm._l((column.filterSelectOptions), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\r\n              " + _vm._s(option.key) + "\r\n            ")])
    }), 0) : _vm._e()])
  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.data.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('datatable.noData')))])]) : _vm._l((_vm.data), function(row) {
    return _c('tr', {
      class: {
        'invalid-row': _vm.isRowInvalid(row), 'invisible-row': _vm.isRowHidden(row), 'highlight-row': _vm.isRowHighlighted(row), 'alt-highlight-row': _vm.isRowAltHighlighted(row)
      }
    }, [(_vm.opt.checkboxes) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked[row[_vm.opt.checkboxValue]]),
        expression: "checked[row[opt.checkboxValue]]"
      }],
      staticClass: "chk",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row[_vm.opt.checkboxValue],
        "checked": Array.isArray(_vm.checked[row[_vm.opt.checkboxValue]]) ? _vm._i(_vm.checked[row[_vm.opt.checkboxValue]], row[_vm.opt.checkboxValue]) > -1 : (_vm.checked[row[_vm.opt.checkboxValue]])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checked[row[_vm.opt.checkboxValue]],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row[_vm.opt.checkboxValue],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$c)
          }
        }, _vm.checkedSingle]
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('td', {
        class: {
          'contents-highlight': column.highlight,
            'align-contents-right': column.align === 'right',
            'align-contents-center': column.align === 'center',
            'align-contents-left': column.align === 'left'
        },
        on: {
          "click": function($event) {
            return _vm.rowSelected(row)
          }
        }
      }, [(_vm.hasRowDetails) ? _c('b-link', {
        staticClass: "invisible-link",
        attrs: {
          "to": _vm.rowDetailsLink(row)
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(column.cell(row))
        }
      })]) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(column.cell(row))
        }
      }), _vm._v(" "), (_vm.hasRowDetails) ? _c('b-link', {
        staticClass: "invisible-link",
        attrs: {
          "to": _vm.rowDetailsLink(row)
        }
      }, [_vm._t(column.columnName, null, {
        "row": row
      })], 2) : _vm._t(column.columnName, null, {
        "row": row
      })], 2)
    })], 2)
  })], 2), _vm._v(" "), (_vm.data.length > 0) ? _c('tfoot', {
    staticClass: "datatable-footer"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('td', {
      class: {
        'align-contents-right': column.align === 'right', 'align-contents-center': column.align === 'center', 'align-contents-left': column.align === 'left'
      }
    }, [(column.showSummary) ? _c('label', {
      staticClass: "summary-label"
    }, [_vm._v(_vm._s(_vm.calculateSummary(column.columnName)))]) : _vm._e()])
  })], 2), _vm._v(" "), _c('tr', [(_vm.opt.checkboxes) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxAll),
      expression: "checkboxAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxAll) ? _vm._i(_vm.checkboxAll, null) > -1 : (_vm.checkboxAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkboxAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxAll = $$c
        }
      }, _vm.checkAll]
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "100%"
    }
  }, [_c('div', {
    staticClass: "table-footer split-3"
  }, [_c('div', [_vm._v("\r\n              " + _vm._s(_vm.paginationText) + "\r\n              "), (_vm.defaultOptions.partialCount && this.totalRows === 100) ? _c('b-img', {
    staticClass: "ml-2 generic-link",
    attrs: {
      "src": __webpack_require__(722),
      "width": "15",
      "height": "15"
    },
    on: {
      "click": _vm.retrieveCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "per-page-field"
  }, [_c('label', {
    attrs: {
      "for": "perPageControl"
    }
  }, [_vm._v(_vm._s(_vm.$t('datatable.perPage')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "perPageControl"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePerPage()
      }]
    }
  }, _vm._l((_vm.opt.per_page_options), function(perPageOption) {
    return _c('option', {
      domProps: {
        "value": perPageOption
      }
    }, [_vm._v(_vm._s(perPageOption) + "\r\n                  ")])
  }), 0)])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.generateReportVisible) ? _c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.generateReportModal",
      modifiers: {
        "generateReportModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n          " + _vm._s(_vm.$t('datatable.generateReport')) + "\r\n          "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-sidebar', {
    attrs: {
      "z-index": "1000",
      "id": "sidebar-variant",
      "title": "Sidebar",
      "bg-variant": "dark",
      "text-variant": "light",
      "shadow": ""
    }
  }, [_c('div', {
    staticClass: "px-3 py-2"
  }, [_c('p', [_vm._v("\r\n        Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis\r\n        in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.\r\n      ")]), _vm._v(" "), _c('b-img', {
    attrs: {
      "src": "https://picsum.photos/500/500/?image=54",
      "fluid": "",
      "thumbnail": ""
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "generateReportModal",
      "title": _vm.$t('datatable.generateReport'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.generateReport
    }
  }, [_vm._v("\r\n      " + _vm._s(_vm.$t('datatable.generateReportModalText')) + "\r\n  ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5b31004", module.exports)
  }
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('sidebar.userAdministration'),
      "tab": _vm.namedTab
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    ref: "tabs",
    attrs: {
      "card": "",
      "lazy": "",
      "pills": "",
      "variant": "danger"
    },
    on: {
      "input": function($event) {
        return _vm.tabChanged()
      }
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [(_vm.hasLocalUserCreatePermission) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[0].title
    }
  }, [_c('local-user-management')], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreatePermission) ? _c('b-tab', {
    ref: "tabs",
    attrs: {
      "title": _vm.headers[1].title
    }
  }, [_c('user-management')], 1) : _vm._e(), _vm._v(" "), (_vm.hasLocalUserCreatePermission) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[2].title
    }
  }, [_c('user-create')], 1) : _vm._e(), _vm._v(" "), (_vm.hasNotificationPermissions) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[3].title
    }
  }, [_c('user-notification')], 1) : _vm._e(), _vm._v(" "), (_vm.hasRegistrationReviewAllPermissions) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[4].title
    }
  }, [_c('target-public-users')], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5ce89e0", module.exports)
  }
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('invoices.invoiceReview'),
      "tab": _vm.namedTab
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    ref: "tabs",
    staticClass: "test-class",
    attrs: {
      "card": "",
      "lazy": "",
      "pills": "",
      "variant": "danger"
    },
    on: {
      "input": function($event) {
        return _vm.tabChanged()
      }
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [(!_vm.isAdmin) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[0].title
    }
  }, [_c('creditor-invoices')], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdmin) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[1].title
    }
  }, [_c('debtor-invoices')], 1) : _c('b-tab', {
    attrs: {
      "title": _vm.headers[2].title
    }
  }, [_c('admin-invoices')], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c1a7d0b2", module.exports)
  }
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitSettlement($event)
      }
    }
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Измирење фактуре"
    }
  })], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error.settlementError.description))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox1"
    },
    model: {
      value: (_vm.settleByIdf),
      callback: function($$v) {
        _vm.settleByIdf = $$v
      },
      expression: "settleByIdf"
    }
  }, [_vm._v("\r\n            Измирење по идентификатору фактуре\r\n        ")]), _vm._v(" "), (_vm.settleByIdf) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Идентификатор фактуре"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.InvoiceId"
    },
    model: {
      value: (_vm.invoiceSettlement.InvoiceId),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "InvoiceId", $$v)
      },
      expression: "invoiceSettlement.InvoiceId"
    }
  })], 1)], 1)], 1) : _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Број фактуре"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.InvoiceNumber"
    },
    model: {
      value: (_vm.invoiceSettlement.InvoiceNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "InvoiceNumber", $$v)
      },
      expression: "invoiceSettlement.InvoiceNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ЈБКЈС"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.DebtorCompanyNumber"
    },
    model: {
      value: (_vm.invoiceSettlement.DebtorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "DebtorCompanyNumber", $$v)
      },
      expression: "invoiceSettlement.DebtorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "МБ Повериоца"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.CreditorCompanyNumber",
      "maxlength": "8"
    },
    model: {
      value: (_vm.invoiceSettlement.CreditorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "CreditorCompanyNumber", $$v)
      },
      expression: "invoiceSettlement.CreditorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "ПИБ Повериоца"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.CreditorTaxIdNumber",
      "maxlength": "9"
    },
    model: {
      value: (_vm.invoiceSettlement.CreditorTaxIdNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "CreditorTaxIdNumber", $$v)
      },
      expression: "invoiceSettlement.CreditorTaxIdNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Банка"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "invoiceSettlement.Bank",
      "maxlength": "3"
    },
    model: {
      value: (_vm.invoiceSettlement.Bank),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "Bank", $$v)
      },
      expression: "invoiceSettlement.Bank"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "xl": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Измирени износ"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "invoiceSettlement.SettledAmount"
    },
    model: {
      value: (_vm.invoiceSettlement.SettledAmount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettledAmount", $$v)
      },
      expression: "invoiceSettlement.SettledAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.columnSettlementComments')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceSettlement.SettlementComments),
      expression: "invoiceSettlement.SettlementComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "name": "invoiceSettlement.SettlementComments"
    },
    domProps: {
      "value": (_vm.invoiceSettlement.SettlementComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceSettlement, "SettlementComments", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                Региструј измирење\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ccd56e18", module.exports)
  }
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-3 narrow-container"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('reset.title')))])]), _vm._v(" "), _c('form', {
    ref: "resetUserForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetUser($event)
      }
    }
  }, [(_vm.tokenValid) ? _c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.changePassword')
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "activation-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.newPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.confirmPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.0')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.1')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.2')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.3')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": !_vm.user.password || !_vm.user.newPassword || _vm.load
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('userAdministration.apply')) + "\n              "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d13c8784", module.exports)
  }
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-sidebar"
  }, [_c('b-navbar', {
    staticClass: "responsive-sidebar"
  }, [_c('b-navbar-toggle', {
    staticClass: "sidenav-toggle",
    attrs: {
      "target": "sidenav_id"
    }
  }), _vm._v(" "), _c('b-collapse', {
    ref: "sidenav_id",
    attrs: {
      "is-nav": "",
      "id": "sidenav_id"
    }
  }, [_c('b-navbar-nav', {
    on: {
      "click": _vm.hideNavigation
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "dashboard"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")]), _vm._v(" Dashboard\n                ")]), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.allInvoices')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.hasInvoiceUserSettlementClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/user-settlements"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("payment")]), _vm._v(_vm._s(_vm.$t('sidebar.invoiceUserSettlement')) + " "), _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Test")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.groupSettlement')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.userAdministration')) + "\n                ")]), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.userRegistration')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.reportedIssues')) + "\n                ")]), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('b-nav-item', {
    attrs: {
      "to": "/settle-invoice"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("monetization_on")]), _vm._v(_vm._s(_vm.$t('sidebar.invoiceSettlement')) + " "), _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Test")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/intervention"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("build")]), _vm._v(_vm._s(_vm.$t('sidebar.intervention')) + " "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Admin")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [(_vm.showCollapse) ? _c('div', [_c('nav', {
    staticClass: "sidebar"
  }, [_c('ol', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")]), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.allInvoices')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasInvoiceUserSettlementClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settlements"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("payment")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.invoiceUserSettlement')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim || _vm.hasInvoiceReviewAllClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.groupSettlement')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdministrativePrivileges) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.userAdministration')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.userRegistration')))])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.reportedIssues')))])])], 1), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settle-invoice"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("monetization_on")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.invoiceSettlement')) + " "), _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Test")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/intervention"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("build")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.intervention')) + " "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Admin")])], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('b-row', {
    staticClass: "treasury-logo ml-2 text-center",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(77)
    }
  })]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('div', {
    staticClass: "pb-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1)], 1)]) : _c('div', [_c('nav', {
    staticClass: "sidebar-collapsed"
  }, [_c('ol', [_c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/dashboard",
      "exact": "",
      "title": "Dashboard"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")])])], 1), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.allInvoices')),
      expression: "$t('sidebar.allInvoices')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasInvoiceUserSettlementClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settlements"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("payment")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.invoiceUserSettlement')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim || _vm.hasInvoiceReviewAllClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.groupSettlement')),
      expression: "$t('sidebar.groupSettlement')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdministrativePrivileges) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.userAdministration')),
      expression: "$t('sidebar.userAdministration')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.userRegistration')),
      expression: "$t('sidebar.userRegistration')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.reportedIssues')),
      expression: "$t('sidebar.reportedIssues')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])])], 1), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/settle-invoice",
      "title": "$t('sidebar.invoiceSettlement')"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("monetization_on")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/intervention",
      "title": "$t('sidebar.intervention')"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("build")])])], 1) : _vm._e()]), _vm._v(" "), _c('b-row', {
    staticClass: "treasury-logo ml-2 text-center",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(77)
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('b-btn', {
    class: {
      'button-class': _vm.showCollapse, 'button-class-collapsed': !_vm.showCollapse
    },
    attrs: {
      "id": "collapse-button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v(_vm._s(_vm.buttonLabel))])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dcc03e3c", module.exports)
  }
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.usersUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.status === _vm.UserStatus.ACTIVE, 'btn-danger': props.row.status === _vm.UserStatus.REVOKED
          }
        }, [_vm._v(_vm._s(_vm.$t('userAdministration.userStatuses.' + props.row.status)))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.revokeUsers()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('userAdministration.userRevoke')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de78e382", module.exports)
  }
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "login_modal",
    attrs: {
      "id": "login_modal",
      "title": _vm.$t('message.login')
    },
    on: {
      "shown": _vm.clearLoginData
    }
  }, [_c('form', {
    ref: "loginModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.login($event)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "login_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginPasswordId",
      "type": "password",
      "placeholder": _vm.$t('user.password')
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keyup": _vm.onPasswordInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "capsLockTooltip",
    attrs: {
      "target": "loginPasswordId",
      "placement": "bottom",
      "disabled": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('forms.capsLockOn')) + "                  \n            ")])], 1), _vm._v(" "), _c('a', {
    staticClass: "reset-password-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.passwordResetModal
    }
  }, [_vm._v(_vm._s(_vm.$t('user.passwordForgotten')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('a', {
    staticClass: "initial-login-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.initialLoginModal
    }
  }, [_vm._v(_vm._s(_vm.$t('user.firstTimeLogin')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "initial_login_modal",
    attrs: {
      "id": "initial_login_modal",
      "title": _vm.$t('message.login'),
      "ok-only": ""
    },
    on: {
      "shown": _vm.clearInitialLoginData
    }
  }, [_c('form', {
    ref: "initialLoginModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.initialLogin($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "initial_login_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.initialLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "password_reset_modal",
    attrs: {
      "id": "password_reset_modal",
      "title": _vm.$t('user.passwordForgotten'),
      "ok-only": ""
    },
    on: {
      "shown": _vm.clearPasswordResetData
    }
  }, [_c('form', {
    ref: "passwordResetModalForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.loginError.show
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loginError.message) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    ref: "password_reset_modal_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user.username')
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.load
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('forms.submit')) + "\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e589e72e", module.exports)
  }
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('userAdministration.userDetails')
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.login))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.name))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('label', {
    staticClass: "user-info-label"
  }, [_vm._v(_vm._s(_vm.user.email))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.userRoles",
      modifiers: {
        "userRoles": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.userRolesClaims')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "userRoles",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [(_vm.user.creationRoles) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationRoles), function(role) {
    return _c('b-list-group-item', {
      key: role,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + role)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.user.creationClaims) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-list-group', _vm._l((_vm.user.creationClaims), function(claim) {
    return _c('b-list-group-item', {
      key: claim,
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.' + claim)) + "\r\n                            ")])
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.passwordChange",
      modifiers: {
        "passwordChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.changePassword')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "passwordChange",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('form', {
    ref: "changePasswordForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.changeUserPassword($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.oldPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "oldPassword", $$v)
      },
      expression: "password.oldPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.newPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "newPassword", $$v)
      },
      expression: "password.newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.confirmNewPassword')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.confirmNewPassword),
      callback: function($$v) {
        _vm.$set(_vm.password, "confirmNewPassword", $$v)
      },
      expression: "password.confirmNewPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.0')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.1')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.2')))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-0"
  }, [_c('b-col', [_c('small', [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userPasswordRequirement.3')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.hasValidPasswords || _vm.load
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.personalInfoChange",
      modifiers: {
        "personalInfoChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userAdministration.personalInformationChange')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "personalInfoChange",
      "accordion": "info-accordion",
      "role": "tabpanel"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateUserInformation($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetails')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editUserInformationModal",
      modifiers: {
        "editUserInformationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.personalSettings",
      modifiers: {
        "personalSettings": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('userSettings.regionalHeader')))])], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "personalSettings",
      "role": "tabpanel"
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userSettings.regionalSubheader')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.language')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.language.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.language.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.language, "value", $$v)
      },
      expression: "personal.language.value"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.dateFormat')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.dateFormat.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.dateFormat.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.dateFormat, "value", $$v)
      },
      expression: "personal.dateFormat.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.decimalFormat')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.decimalFormat.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.decimalFormat.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.decimalFormat, "value", $$v)
      },
      expression: "personal.decimalFormat.value"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userSettings.csvSeparator')
    }
  }, [_c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.personal.csvDelimmeter.options,
      "size": "sm"
    },
    model: {
      value: (_vm.personal.csvDelimmeter.value),
      callback: function($$v) {
        _vm.$set(_vm.personal.csvDelimmeter, "value", $$v)
      },
      expression: "personal.csvDelimmeter.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": _vm.saveRegional
    }
  }, [_vm._v("\r\n                                " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.hiddenButtonCollapse",
      modifiers: {
        "hiddenButtonCollapse": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v("Додатне функције")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "hiddenButtonCollapse",
      "role": "tabpanel"
    }
  }, [_c('b-container', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "danger",
      "disabled": _vm.load
    },
    on: {
      "click": _vm.causeFatal
    }
  }, [_vm._v("\r\n                            \"Sentry\" - тест\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', [_c('b-modal', {
    attrs: {
      "id": "editUserInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateUserInformation
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.personalInformationChangeConfirmation')) + "\r\n            ")])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "editRegistrationInformationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateRegistrationInformation
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('userAdministration.registrationInformationChangeConfirmation')) + "\r\n            ")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eba14a06", module.exports)
  }
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.load
    }
  }, [(_vm.dataFetched) ? _c('b-card', {
    staticClass: "mb-2",
    class: {
      'group-settlement-cancelled-card': _vm.groupSettlementCancelled, 'group-settlement-settled-card': _vm.groupSettlementSettled, 'group-settlement-active-card': _vm.groupSettlementActive
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.groupSettlementCancelled || _vm.groupSettlementInvalid ? 'danger' : null,
      "header-border-variant": _vm.groupSettlementCancelled || _vm.groupSettlementInvalid ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementSingle'),
      "alternativeRoute": "group-settlement/group-settlement-information"
    }
  }, [_c('template', {
    slot: "badges"
  }, [_c('span', [(_vm.groupSettlementCancelled) ? _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeCancelled')))]) : _vm._e(), _vm._v(" "), (_vm.groupSettlementSettled) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeSettled')))]) : _vm._e(), _vm._v(" "), (_vm.groupSettlementInvalid) ? _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.badgeInvalid')))]) : _vm._e()], 1)])], 2)], 1), _vm._v(" "), (_vm.groupSettlementInvalid || _vm.groupSettlementFlagged) ? _c('b-card', {
    staticClass: "text-center mb-3",
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementInvalidBanner')) + "\n            "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "link-text",
    attrs: {
      "href": _vm.activationDocumentationLink
    }
  }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementActivateLink')))])])]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.groupSettlement.groupSettlementNumber) + "\n          ")])])], 1), _vm._v(" "), (!!_vm.groupSettlement.createdName) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementCreator')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'userInfoPage',
        params: {
          userId: _vm.groupSettlement.createdId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.createdName ? _vm.groupSettlement.createdName : _vm.groupSettlement.createdId) + "\n            ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.hasInvoiceReviewAllClaim) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnDebtor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'approvedUserPage',
        params: {
          registrationId: _vm.groupSettlement.debtorId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.debtorName ? _vm.groupSettlement.debtorName : _vm.groupSettlement.debtorId) + "\n            ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.canReportIssue) ? _c('b-col', [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": __webpack_require__(159)
    },
    on: {
      "click": _vm.reportSettlementIssue
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatAmount(_vm.groupSettlement.amount)) + "\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.groupSettlement.creationDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnCreditor')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'approvedUserPage',
        params: {
          registrationId: _vm.groupSettlement.creditorId
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.groupSettlement.creditorName ? _vm.groupSettlement.creditorName : _vm.groupSettlement.creditorId) + "\n            ")])], 1)])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnDueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatShortDate(_vm.groupSettlement.dueDate)) + "\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnInvoiceCount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.groupSettlement.invoiceCount) + "\n          ")])])], 1), _vm._v(" "), (_vm.groupSettlement.settlementDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnSettlementDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.formatShortDate(_vm.groupSettlement.settlementDate)) + "\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('groupSettlement.columnStatus')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('groupSettlement.groupSettlementStatus.' + _vm.groupSettlement.groupSettlementStatus)) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('span', {
    staticClass: "col-form-legend"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.invoiceTableHeader')) + "\n        ")]), _vm._v(" "), (!_vm.showMassAdditionInput && _vm.isGroupSettlementEditable && !_vm.hasInvalidInvoices) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementAddInvoices'),
      "disabled": !_vm.isGroupSettlementEditable || _vm.hasInvalidInvoices,
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.showAddInvoicesInput
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("playlist_add")])]) : _vm._e(), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementCancelAddInvoices'),
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.hideAddInvoicesInput
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "md-auto"
    }
  }, [(_vm.showTable && _vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowInput')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("list")])]) : _vm._e(), _vm._v(" "), (_vm.showTable && !_vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowText')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notes")])]) : _vm._e(), _vm._v(" "), (!_vm.showTable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementInvoicesShowTable')
    },
    on: {
      "click": _vm.toggleShowTable
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("table_chart")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-form-fieldset', [_c('b-form-textarea', {
    staticClass: "monospace-input",
    attrs: {
      "rows": 15,
      "max-rows": 32,
      "placeholder": _vm.$t('groupSettlement.massAdditionalInput')
    },
    model: {
      value: (_vm.massAdditionInput),
      callback: function($$v) {
        _vm.massAdditionInput = $$v
      },
      expression: "massAdditionInput"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.groupSettlementAddInvoice
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementAddInvoice')) + "\n          "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAdditionalErrorContainer && _vm.showMassAdditionInput) ? _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.additionalErrorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.showTable) ? _c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "mt-2"
  }, [_c('b-table', {
    attrs: {
      "hover": "",
      "responsive": "",
      "items": _vm.tableItems,
      "fields": _vm.invoiceTableFields
    },
    scopedSlots: _vm._u([{
      key: "settlementAmount",
      fn: function(data) {
        return [_vm._v("\n                " + _vm._s(_vm.formatAmount(data.item.settlementAmount)) + "\n              ")]
      }
    }, {
      key: "cell(status)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [(data.item.currentInvoiceStatus === _vm.invoiceStatus.SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.ACTIVE || data.item.currentInvoiceStatus === _vm.invoiceStatus.PROINVOICE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.PARTIALLY_SETTLED) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : (data.item.currentInvoiceStatus === _vm.invoiceStatus.ASSIGNED) ? _c('button', {
          staticClass: "btn btn-sm btn-warning"
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))]) : _c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-danger': data.item.currentInvoiceStatus === _vm.invoiceStatus.CANCELLED
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceStatus.' + data.item.currentInvoiceStatus)))])])]
      }
    }, {
      key: "cell(invoiceId)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(data.item.invoiceId) + "\n                ")])]
      }
    }, {
      key: "cell(settlementAmount)",
      fn: function(data) {
        return [_c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.formatAmount(data.item.settlementAmount)) + "\n                ")])]
      }
    }, {
      key: "cell(selected)",
      fn: function(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'checkbox' + data.index
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: (data.item.selected),
            callback: function($$v) {
              _vm.$set(data.item, "selected", $$v)
            },
            expression: "data.item.selected"
          }
        })]
      }
    }, {
      key: "cell(errorCode)",
      fn: function(data) {
        return [(data.item.errorCode !== null) ? _c('b-link', {
          staticClass: "invisible-link",
          attrs: {
            "to": {
              name: 'singleInvoiceRoute',
              params: {
                invoiceId: data.item.invoiceId
              }
            },
            "target": "_blank"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger",
          attrs: {
            "title": _vm.$t('apiStatusCodes.' + data.item.errorCode)
          }
        }, [_vm._v(_vm._s(_vm.$t('groupSettlement.invoiceError')))])]) : _vm._e()]
      }
    }], null, false, 2664991215)
  })], 1)], 1), _vm._v(" "), ((_vm.isGroupSettlementEditable && _vm.hasInvalidInvoices) || _vm.isGroupSettlementEditable) ? _c('b-row', [_c('b-col', [_c('div', [(_vm.isGroupSettlementEditable && _vm.hasInvalidInvoices) ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "title": _vm.$t('groupSettlement.selectInvalidInvoices'),
      "variant": "secondary"
    },
    on: {
      "click": _vm.selectInvalidInvoices
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("ballot")])]) : _vm._e(), _vm._v(" "), (_vm.isGroupSettlementEditable) ? _c('b-button', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementRemoveInvoice'),
      "variant": "danger",
      "disabled": !_vm.canRemoveInvocie
    },
    on: {
      "click": _vm.groupSettlementRemoveInvoice
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete_sweep")]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showTable && !_vm.isGroupSettlementEditable) ? _c('b-col', [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.groupSettlement.groupSettlementItems), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item",
      class: {
        'group-settlement-settled-card-list': _vm.groupSettlementSettled,
        'list-group-item-danger': [_vm.invoiceStatus.CANCELLED, _vm.invoiceStatus.INVALID].includes(item.status),
          'list-group-item-success': [_vm.invoiceStatus.SETTLED].includes(item.status)
      }
    }, [_vm._v("\n            " + _vm._s(item.invoiceId) + " " + _vm._s(item.settlementAmount) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.showTable && _vm.isGroupSettlementEditable) ? _c('b-col', [_c('b-row', [_c('b-col', [_c('b-form-fieldset', [_c('b-form-textarea', {
    staticClass: "monospace-input",
    attrs: {
      "rows": 15,
      "max-rows": 32
    },
    model: {
      value: (_vm.massInput),
      callback: function($$v) {
        _vm.massInput = $$v
      },
      expression: "massInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.isGroupSettlementEditable) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editSingleConfirmationModal",
      modifiers: {
        "editSingleConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('groupSettlement.groupSettlementEditSave')) + "\n              "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showActivateButton) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.groupSettlementActivateConfirmationModal",
      modifiers: {
        "groupSettlementActivateConfirmationModal": true
      }
    }],
    attrs: {
      "variant": _vm.showActivateButton ? 'primary' : 'secondary',
      "disabled": _vm.load || _vm.hasInvalidInvoices,
      "title": !_vm.hasInvalidInvoices ? _vm.$t('groupSettlement.groupSettlementActivateTitle') : _vm.$t('groupSettlement.groupSettlementActivateTitleDisabled')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementActivate')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showDeactivateButton) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.load,
      "title": _vm.$t('groupSettlement.groupSettlementDeactivateTitle')
    },
    on: {
      "click": _vm.groupSettlementDeactivate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementDeactivate')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.groupSettlementCancelConfirmationModal",
      modifiers: {
        "groupSettlementCancelConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load,
      "title": _vm.$t('groupSettlement.groupSettlementCancelTitle')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementCancel')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "groupSettlementActivateConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.groupSettlementActivate
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementActivationConfirmation')) + "\n      ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "groupSettlementCancelConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.groupSettlementCancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementCancelationConfirmation')) + "\n      ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editSingleConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('groupSettlement.groupSettlementEditConfirmation')) + "\n      ")])], 1)], 1) : (_vm.hasErrorWhenFetchingData) ? _c('b-card', [_c('b-row', [_c('b-col', [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementFetchingDataFailed')) + "\n        ")])])], 1)], 1) : _c('b-card', [_c('b-row', [_c('b-col', [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('groupSettlement.groupSettlementFetchingData')) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "reportIssueModal",
    attrs: {
      "title": _vm.currentIssue === this.IssueCategory[0] ? _vm.$t('issues.reportIssueLiability') : _vm.$t('issues.reportIssueSettlement'),
      "header-bg-variant": "warning",
      "ok-title": _vm.$t('forms.send'),
      "size": "lg",
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitIssueReport
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.currentIssueReport.resourceId),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "resourceId", $$v)
      },
      expression: "currentIssueReport.resourceId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.formattedIssueCategories
    },
    on: {
      "input": _vm.categoryChanged
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.requiresData) ? _c('div', [(_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 3) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 4 && _vm.hasInvoiceSettlements) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementId')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceSettlementIDs
    },
    model: {
      value: (_vm.currentIssueSettlementId),
      callback: function($$v) {
        _vm.currentIssueSettlementId = $$v
      },
      expression: "currentIssueSettlementId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[0].ID && _vm.currentIssueCategory.id === 1) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceFields,
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  })], 1)], 1)], 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "field-description"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.dataDescriptionCyr))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIssueReport.userComment),
      expression: "currentIssueReport.userComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentIssueReport.userComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIssueReport, "userComment", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.categoryHelp) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.categoryDescriptionCyr))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fa9a4b"
    },
    attrs: {
      "href": _vm.helpLink(_vm.currentIssueCategory.categoryHelp),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueHelpLink')))])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5607ae6", module.exports)
  }
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('sidebar.reportedIssues'),
      "alternativeRoute": "issues/reported-issues"
    }
  })], 1), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.pagedIssuesUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions,
      "reportsUrl": _vm.issuesReportsUrl
    },
    scopedSlots: _vm._u([{
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "closingDate",
      fn: function(props) {
        return [(props.row.closingDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.closingDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.row.status === _vm.IssueStatus.ACTIVE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.CANCELLED) ? _c('button', {
          staticClass: "btn btn-sm btn-danger"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.RESOLVED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.UNRESOLVED) ? _c('button', {
          staticClass: "btn btn-sm btn-danger"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : _vm._e()]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f70bb0cc", module.exports)
  }
}

/***/ }),
/* 813 */,
/* 814 */,
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(656);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("610a6e3a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-02ad1aff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserNotification.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-02ad1aff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserNotification.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("fc3d0c32", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-054a269e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loader.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-054a269e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(658);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1c484bee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-09aad170\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-09aad170\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("60694084", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11a3b220\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotificationContainer.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11a3b220\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotificationContainer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3f3e5fc6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1328d797\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1328d797\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("114d74f4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c501716\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LocalUserManagement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1c501716\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LocalUserManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(662);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("b623a13c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eb7ca44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserApproval.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eb7ca44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserApproval.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("48e2fe48", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f865bd7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f865bd7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("19107ad1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-211b1af0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserSettlements.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-211b1af0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserSettlements.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0de5a23c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32dae221\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListGroupSettlement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32dae221\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ListGroupSettlement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7517eafe", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3342773a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3342773a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserInfo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4188190a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c557185\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClosedOrgSettlement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c557185\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClosedOrgSettlement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7f33eb1c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-464e84b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TargetPublicUsers.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-464e84b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TargetPublicUsers.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(669);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("100df405", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-495033fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContextHeader.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-495033fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContextHeader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("241b0135", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b62da23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleIssue.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b62da23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleIssue.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(671);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5785d7f0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5009dc17\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Register.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5009dc17\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Register.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("544db9d9", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-500c6df4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFoundPage.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-500c6df4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFoundPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(673);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("01b4d02a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58862c20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DebtorInvoices.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58862c20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DebtorInvoices.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("489ffb8b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58fd4992\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Activation.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58fd4992\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Activation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5ccfd539", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c8ae859\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StartPage.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5c8ae859\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StartPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(676);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("c82cd81e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62de2e97\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegisterGroupSettlement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62de2e97\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegisterGroupSettlement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(677);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6acc1fde", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-695689b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Autocomplete.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-695689b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Autocomplete.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4effb452", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b0d36d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CreditorInvoices.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b0d36d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CreditorInvoices.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("74f9f103", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73f00188\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Interventions.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73f00188\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Interventions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3043f04c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-751ffc9f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleInvoice.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-751ffc9f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleInvoice.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(681);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1cf7b2a4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-78c8b551\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdminInvoices.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-78c8b551\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdminInvoices.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6e063cce", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-80e255a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ActivateInvoice.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-80e255a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ActivateInvoice.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("215e3e61", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-840fae58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MoveInvoices.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-840fae58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MoveInvoices.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4ce577ce", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8e5c6624\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AlertContainer.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8e5c6624\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AlertContainer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("462f7c1c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f341b20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRegistration.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f341b20\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRegistration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(686);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("78fccf3c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a03f095e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a03f095e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("13b89984", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5b31004\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./Datatable.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5b31004\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./Datatable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("774a5c46", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5b31004\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Datatable.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5b31004\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Datatable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(689);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7e7b7c31", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5ce89e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAdministration.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a5ce89e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserAdministration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(690);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6747b882", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c1a7d0b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Invoices.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c1a7d0b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Invoices.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("43c31db5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ccd56e18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SettleInvoice.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ccd56e18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SettleInvoice.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("354cde7e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d13c8784\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reset.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d13c8784\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reset.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(693);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("43ef6392", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dcc03e3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SideNav.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dcc03e3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SideNav.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(694);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("9bb169c0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-de78e382\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserManagement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-de78e382\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserManagement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("43eb1ca4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e589e72e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e589e72e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7b97c6f4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eba14a06\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserProfile.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eba14a06\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserProfile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(697);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("e3be636c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f5607ae6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./SingleGroupSettlement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f5607ae6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./SingleGroupSettlement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6b0c2216", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f5607ae6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleGroupSettlement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f5607ae6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleGroupSettlement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(699);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("76d51068", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f70bb0cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReportedIssues.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f70bb0cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ReportedIssues.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160);
module.exports = __webpack_require__(361);


/***/ })
],[881]);


// WEBPACK FOOTER //
// static/js/app.e6de26367d4d667270f1.js